  (function() {
    var CONFIG = window.COHORT_ADMIN_CONFIG || {};
    var CREATE_WEBHOOK_URL = CONFIG.createWebhookUrl || '';
    var UPDATE_ROSTER_WEBHOOK_URL = CONFIG.updateRosterWebhookUrl || '';
    var UPDATE_COHORT_LABEL_WEBHOOK_URL = CONFIG.updateCohortLabelWebhookUrl || '';
    var UPDATE_EMAIL_SETTINGS_WEBHOOK_URL = CONFIG.updateEmailSettingsWebhookUrl || '';
    var REMOVE_STUDENT_WEBHOOK_URL = CONFIG.removeStudentWebhookUrl || '';
    var SAVE_STUDENT_NOTE_WEBHOOK_URL = CONFIG.saveStudentNoteWebhookUrl || '';
    var ARCHIVE_WEBHOOK_URL = CONFIG.archiveWebhookUrl || '';
    var DELETE_COHORT_WEBHOOK_URL = CONFIG.deleteCohortWebhookUrl || '';
    var SEND_REMINDERS_WEBHOOK_URL = CONFIG.sendCohortRemindersWebhookUrl || '';
    /*
      Phase 8, edit C (2026-08-16) — the one letter that reaches a student who
      has answered the form and not paid for delivery. Empty until the webhook
      is configured, and the button stays hidden while it is.
    */
    var SEND_PAYMENT_REMINDER_WEBHOOK_URL = CONFIG.sendPaymentReminderWebhookUrl || '';
    /*
      2026-10-14 (owner) - free-shipping codes a school's mail filter kept
      from the students. The webhook moves their end dates forward (Cohort:
      Extend Free Shipping Codes); the cache address is where that task and
      Cohort: Free Shipping After Payment keep each code's end. Either empty:
      the screen says it is not set up.
    */
    var EXTEND_FREE_SHIPPING_WEBHOOK_URL = CONFIG.extendFreeShippingWebhookUrl || '';
    var FREE_SHIPPING_CACHE_URL = CONFIG.freeShippingCacheUrl || '';
    /* the codes screen is for the shop's own team only, decided in the section (owner, 2026-10-14) */
    var FREE_SHIP_SCREEN = CONFIG.freeShipScreen === true;
    /* 2026-10-15 (owner) - Decline under Requests to join; empty hides Decline, Add still works. */
    var JOIN_REQUEST_WEBHOOK_URL = CONFIG.joinRequestWebhookUrl || '';
    /* 2026-10-16 (owner) - which student addresses our Postmark refuses; empty: no marks. */
    var MAIL_FAILURES_CACHE_URL = CONFIG.mailFailuresCacheUrl || '';
    /* 2026-10-17 (owner) - the cross on "Letter not delivered"; empty: no cross. */
    var DISMISS_MAIL_NOTICE_WEBHOOK_URL = CONFIG.dismissMailNoticeWebhookUrl || '';
    /* 2026-10-17 (owner) - our own team: the purple Note icon on cohort cards. Decided in Liquid. */
    var IS_TEAM = CONFIG.isTeam === true;
    /* TEMP: archive button hidden on dashboard; restore: CONFIG.showArchiveTestButton === true */
    var SHOW_ARCHIVE_TEST_BUTTON = false;
    var TEAM_NOTIFICATION_EMAIL = CONFIG.teamNotificationEmail || '';
    var STUDENT_FORM_PATH = CONFIG.studentFormPath || '/pages/cohort-student';
    var STATUS_PAGE_PATH = CONFIG.statusPagePath || '/pages/cohort-status';

    var SHOP_ORIGIN = window.location.origin;
    var SCHOOLS = window.COHORT_ADMIN_SCHOOLS || [];
    var CAMPUSES = window.COHORT_CAMPUSES || [];
    var PROGRAMS = window.COHORT_PROGRAMS || [];
    var CUSTOMER = window.COHORT_ADMIN_CUSTOMER_CONTEXT || {};
    var MY_COHORTS = window.COHORT_ADMIN_MY_COHORTS || [];
    var STATUS_CACHES = window.COHORT_ADMIN_STATUS_CACHES || [];

    var currentStep = 1;
    var currentCohortCode = '';
    var selectedSchoolCode = '';
    var selectedCampusHandles = [];
    /* Starts on the default rather than empty (2026-08-11): an empty state read
       as "an address was promised" everywhere that asks. */
    var selectedShipToCampusHandle = '__campus_from_items__';
    var shipToChosenByAdmin = false;
    var productCopies = {};
    var nextCopyId = 1;
    var CUSTOM_SHIP_TO_VALUE = '__custom__';
    /*
      2026-08-11, phase 2 — "each order goes to the campus it was chosen under".
      The default now that campuses are picked on Step 3: there is no single
      address to name here, because there may be several, one per campus.
    */
    var CAMPUS_FROM_ITEMS_VALUE = '__campus_from_items__';
    var parsedEmails = [];
    var currentFinalStudentFormUrl = '';
    var currentFinalStatusPageUrl = '';
    var currentFinalSchoolName = '';
    var currentFinalCohortCode = '';
    var editingCohortCode = '';
    var editingCohortLocked = false;
    var editingCohortFinalized = false;
    var editingLateStudentsTrack = false;
    var editingLateBatchCode = '';
    var editingReadOnly = false;
    var pendingEmailFixNotices = {};
    var SESSION_COHORT_KEY = 'cohort_admin_session_cohorts';
    var COHORT_META_STORAGE_KEY = 'cohort_admin_cohort_meta';
    var resolvedAccountEmail = '';
    var accountEmailResolvePromise = null;
    var initialAccountEmail = '';
    var pendingEmailMutation = null;
    var emailPanelSyncTimer = null;
    var emailPanelIdleSyncInterval = null;
    var panelBlockingMinUntil = 0;
    /*
      Raised from 60s to 120s on 2026-08-05, in step with the retry ladder: the
      cap is the point where the page stops waiting for confirmation and reloads
      to show whatever is true. Ending it before the ladder finishes would cut
      the wait short for exactly the slow batches it exists to cover.
    */
    var PANEL_CONFIRM_CAP_MS = 120000;
    var panelConfirmTimer = null;
    var panelConfirmCapAt = 0;
    var emailMutationUnconfirmed = false;

    /*
      Roster draft (2026-08-05, see docs/roster-editing-rework-plan.md).

      Every roster change now collects here first and nothing reaches Mechanic
      until the admin presses Apply. The old per-row Save/× buttons fired a
      separate task each, so two clicks a few seconds apart raced inside
      Mechanic and each run rewrote the whole student_emails list from its own
      stale snapshot — that is the lost-update pattern behind most of the
      2026-08-04 findings.

      removals: emails marked for removal
      edits:    { currentEmail: newEmail }
      Additions are read from the textarea when Apply runs, so there is no
      third place to keep in sync.
    */
    var rosterDraft = { cohortCode: '', removals: [], edits: {} };

    /*
      Selection is separate from the draft on purpose (2026-08-05, owner
      feedback). Ticking a row used to mean "delete this", which read as a
      verdict rather than a choice. Now a tick only selects; the action bar then
      offers what to do with the selection. Selection is transient and never
      leaves the browser — only the draft does.
    */
    var rosterSelection = [];

    /*
      '' | 'remove' | 'edit' | 'remind' — which verb the admin is currently
      performing (2026-08-05, owner decision). Rows show the control for this
      mode and nothing else. Marks already staged stay visible in every mode:
      switching to Edit must not make two students the admin just removed look
      untouched.
    */
    var rosterEditMode = '';
    /*
      2026-08-17 — '' until the admin has chosen. Reminder mode shows a picker
      before it shows a list; see entryPassesAudience and
      renderReminderAudiencePicker.

      2026-10-13 (owner, prototype flow 5) - the screens of
      Send reminders:
        ''         step 1, "What do you need?"
        'form'     students who have not filled in the form, with ticks
        'pay'      students who owe for delivery, with ticks
        'own'      "Our letters do not arrive": which group
        'own-form' one letter to everyone who has not filled in the form
        'own-pay'  one letter per student who owes, chosen one at a time
    */
    var reminderAudience = '';

    /* own-pay: the student whose letter is open. own-*: letters the admin has
       marked as sent from her own mailbox - this page cannot see her mailbox,
       so it is only her note, and it lasts until the page is reloaded. */
    var remindLetterEmail = '';
    var remindOwnSent = {};

    /* own-codes: each paid student's code end, read from the cache.
       null = not read yet; email -> epoch seconds, -1 used, 0 not found. */
    var freeShipEnds = null;
    var freeShipLoading = false;
    var freeShipDays = '7';
    var freeShipMessage = '';
    var freeShipExtending = false;
    /* 2026-10-16 (owner) - Email the codes asks once before writing to students. */
    var freeShipEmailConfirm = false;

    /* true from the confirmed press until both kinds of request have answered:
       the Send button stays disabled, so a second press cannot send twice. */
    var remindSending = false;

    var ROSTER_MODE_COPY = {
      '': 'Pick one thing to do. Removing, correcting emails and adding students are collected first and applied together; reminders go out straight away.',
      remove: 'Click the × next to every student you want to remove. Nobody is removed until you press Apply changes.',
      edit: 'Click an email to correct it. Corrections are applied when you press Apply changes.',
      /* 2026-08-24 — "select", not "tick" (owner). The word had to describe a
         checkbox to somebody who may never have called one a tick. */
      remind: 'Remind students to fill in the form or to pay for delivery. Reminders go out straight away and are not part of Apply changes.',
      add: 'Type the new addresses below, one per line. They are invited when you press Apply changes.'
    };

    var ROSTER_MODE_HINT = {
      remove: 'Already-confirmed students in a finalized cohort cannot be removed.',
      edit: 'Students marked for removal cannot be edited.',
      remind: ''
    };

    function resetRosterDraft(cohortCode) {
      rosterDraft = { cohortCode: normalizeKey(cohortCode || ''), removals: [], edits: {} };
      rosterSelection = [];
      rosterEditMode = '';
    }

    /*
      Which single kind of change is staged right now, derived rather than
      stored: switching modes clears the draft, so only one of the three can
      ever be non-empty. '' means nothing is staged.
    */
    function getDraftKind() {
      var summary = getDraftSummary();

      if (summary.removals.length) return 'remove';
      if (summary.edits.length) return 'edit';
      if (summary.additions.length) return 'add';

      return '';
    }

    var DRAFT_KIND_LABEL = {
      remove: 'removals',
      edit: 'email corrections',
      add: 'students to add'
    };

    var ROSTER_MODE_LABEL = {
      remove: 'Remove',
      edit: 'Edit emails',
      remind: 'Send reminders',
      add: 'Add students'
    };

    var ROSTER_MODE_BUTTONS = [
      { id: 'cohort-mode-add', mode: 'add' },
      { id: 'cohort-mode-remove', mode: 'remove' },
      { id: 'cohort-mode-edit', mode: 'edit' },
      { id: 'cohort-mode-remind', mode: 'remind' }
    ];

    function setRosterEditMode(mode) {
      /* Clicking the active button turns it off — no dead end. */
      var nextMode = (rosterEditMode === mode) ? '' : mode;
      var stagedKind = getDraftKind();

      /*
        Leaving a staged change behind to start a different one is the only way
        two kinds could end up in one Apply. Ask, and clear on confirmation —
        never silently carry the old draft into the new action.
      */
      if (nextMode && stagedKind && stagedKind !== nextMode) {
        openModeSwitchModal(nextMode, stagedKind);
        return;
      }

      commitRosterEditMode(nextMode);
    }

    function commitRosterEditMode(nextMode) {
      rosterEditMode = nextMode;

      /* Selection belongs to reminders alone; leaving it behind would send a
         reminder to somebody the admin ticked while doing something else. */
      if (rosterEditMode !== 'remind') clearSelection();

      /* And the audience belongs to reminder mode alone. Leaving it set would
         mean re-entering the mode later with a list already filtered by a
         choice made minutes ago and long forgotten. */
      reminderAudience = '';
      remindLetterEmail = '';
      freeShipEnds = null;
      freeShipMessage = '';
      freeShipEmailConfirm = false;

      /* Adding is now the fourth mode rather than a separate toggle, so the
         panel simply follows the mode. Leaving the mode never clears what was
         typed — switching away with text in the box goes through the discard
         confirmation first, exactly like the other three. */
      setAddStudentsPanelOpen(rosterEditMode === 'add');

      renderRosterModeChrome();
      syncRosterFilter();
      renderEditStudentsList(editingCohortCode);
      updateDraftBar();
    }

    function setAddStudentsPanelOpen(open) {
      var panel = document.getElementById('cohort-add-students-panel');
      var toggle = document.getElementById('cohort-add-students-toggle');
      if (!panel) return;

      if (open) {
        /* 2026-10-09 - the panel now sits below the list, so on opening it is
           brought into view and the field is ready to type into. */
        var wasClosed = panel.hasAttribute('hidden');
        panel.removeAttribute('hidden');
        if (wasClosed) {
          window.setTimeout(function() {
            if (panel.scrollIntoView) panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
            var field = document.getElementById('cohort-edit-add-textarea');
            if (field && !field.disabled) field.focus({ preventScroll: true });
          }, 60);
        }
      } else {
        panel.setAttribute('hidden', '');
      }

      if (toggle) {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.classList.toggle('is-open', open);
      }

      if (open) {
        var field = document.getElementById('cohort-edit-add-textarea');
        if (field) field.focus();
      }
    }

    var pendingModeSwitch = '';

    function openModeSwitchModal(nextMode, stagedKind) {
      var overlay = document.getElementById('cohort-mode-switch-modal');
      var textEl = document.getElementById('cohort-mode-switch-text');
      var summary = getDraftSummary();
      var stagedCount = summary.removals.length + summary.edits.length + summary.additions.length;

      /* No modal in the markup yet — clearing is still the correct behaviour,
         so do it rather than let two kinds merge into one Apply. */
      if (!overlay) {
        discardRosterDraft();
        commitRosterEditMode(nextMode);
        return;
      }

      pendingModeSwitch = nextMode;

      if (textEl) {
        textEl.textContent =
          'You are switching to ' + (ROSTER_MODE_LABEL[nextMode] || nextMode) + '. Your ' +
          stagedCount + ' pending ' + (DRAFT_KIND_LABEL[stagedKind] || 'changes') +
          ' have not been applied yet and will be discarded. Each kind of change is applied on its own.';
      }

      overlay.classList.add('is-open', 'show');
      overlay.setAttribute('aria-hidden', 'false');
    }

    function closeModeSwitchModal() {
      var overlay = document.getElementById('cohort-mode-switch-modal');
      pendingModeSwitch = '';

      if (!overlay) return;

      overlay.classList.remove('is-open', 'show');
      overlay.setAttribute('aria-hidden', 'true');
    }

    function confirmModeSwitch() {
      var nextMode = pendingModeSwitch;
      closeModeSwitchModal();
      discardRosterDraft();

      commitRosterEditMode(nextMode);
    }

    function renderRosterModeChrome() {
      /*
        2026-08-05 — a read-only cohort shows no editing controls at all. The
        panel already knew it was read-only (validateRosterDraft refuses on the
        same flag), but the buttons stayed on screen, so the admin filled in a
        deadline and only then met "This cohort is read-only". Offering an action
        that is going to be refused is the bug; refusing it politely is not a fix.

        Driven only by editingReadOnly, which is set by exactly one control —
        the "View students" button on a finalized cohort. "Edit Cohort" and the
        late-track "Add students" never set it, so normal editing is untouched.
      */
      var modeBar = document.querySelector('.cohort-mode-bar');
      var addPanel = document.getElementById('cohort-add-students-panel');

      if (editingReadOnly) {
        rosterEditMode = '';
        clearSelection();

        if (modeBar) {
          modeBar.hidden = true;
          modeBar.setAttribute('aria-hidden', 'true');
        }
        if (addPanel) addPanel.setAttribute('hidden', '');

        var toolbarReadOnly = document.getElementById('cohort-list-toolbar');
        if (toolbarReadOnly) {
          toolbarReadOnly.hidden = true;
          toolbarReadOnly.setAttribute('aria-hidden', 'true');
        }

        var barReadOnly = document.getElementById('cohort-draft-bar');
        if (barReadOnly) {
          barReadOnly.hidden = true;
          barReadOnly.setAttribute('aria-hidden', 'true');
        }

        return;
      }

      if (modeBar) {
        modeBar.hidden = false;
        modeBar.setAttribute('aria-hidden', 'false');
      }

      /*
        ── One reminder button at a time (owner's model, 2026-08-06) ──────────

        Two controls used to be able to send: this one, and the late round
        block's own button. They send different things — the block's asks for a
        deadline and reaches every student who has not submitted, this one
        reaches the ticked few — and pressing both sent two emails carrying two
        different deadlines to the same students. That happened.

        So they can no longer both exist. A deadline belongs to a round, and a
        round has exactly one:

          no round open   -> only the block's "Start late round". It sets the
                             deadline and invites EVERY pending student, so
                             nobody is left behind by starting one.
          round open      -> only "Send reminders", carrying that round's
                             deadline. Ticking chooses who gets a nudge; the
                             date is not up for discussion.

        Changing the date therefore means finalizing the current round and
        starting another — which is the honest description of what a new
        deadline is anyway.

        Before finalization none of this applies: reminders are ordinary
        reminders about the cohort's own deadline.
      */
      var modeBarCohort = findCohortByCode(editingCohortCode);
      var modeBarFinalized = !!modeBarCohort && isCohortFinalized(modeBarCohort);
      var modeBarLateRound = getReusableLateBatchInfo(editingCohortCode);
      var remindAvailable = !modeBarFinalized || !!modeBarLateRound;

      if (!remindAvailable && rosterEditMode === 'remind') {
        rosterEditMode = '';
        clearSelection();
      }

      ROSTER_MODE_BUTTONS.forEach(function(entry) {
        var button = document.getElementById(entry.id);
        if (!button) return;

        if (entry.mode === 'remind') {
          button.hidden = !remindAvailable;
          button.setAttribute('aria-hidden', remindAvailable ? 'false' : 'true');
        }

        var active = rosterEditMode === entry.mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      var bannerText = document.getElementById('cohort-mode-banner-text');
      if (bannerText) {
        bannerText.textContent = ROSTER_MODE_COPY[rosterEditMode] || ROSTER_MODE_COPY[''];
      }

      var banner = document.getElementById('cohort-mode-banner');
      if (banner) {
        banner.classList.toggle('is-active', !!rosterEditMode);
      }

      /* Select all is a reminder tool only. */
      var toolbar = document.getElementById('cohort-list-toolbar');
      if (toolbar) {
        /*
          2026-08-17 — not until the audience is chosen, and never for debtors.

          Reported by the owner: with the picker on screen and no list under
          it, Select all was still there, and pressing it selected people she
          could not see. It ticks whatever getSelectableEmails returns, which
          at that moment is the whole cohort.

          Hidden for the delivery audience too — those rows have a button each
          and no ticks, so a Select all there controls nothing.
        */
        var showToolbar = rosterEditMode === 'remind' &&
          (reminderAudience === 'form' || reminderAudience === 'pay');

        toolbar.hidden = !showToolbar;
        toolbar.setAttribute('aria-hidden', showToolbar ? 'false' : 'true');
      }

      var hint = document.getElementById('cohort-list-hint');
      if (hint) {
        hint.textContent = ROSTER_MODE_HINT[rosterEditMode] || '';
      }
    }

    function isSelected(email) {
      return rosterSelection.indexOf(String(email || '').trim().toLowerCase()) !== -1;
    }

    function toggleSelection(email, on) {
      var normalized = String(email || '').trim().toLowerCase();
      var index = rosterSelection.indexOf(normalized);

      if (on && index === -1) rosterSelection.push(normalized);
      if (!on && index !== -1) rosterSelection.splice(index, 1);
    }

    function clearSelection() {
      rosterSelection = [];
    }

    /*
      Selection now exists only to address reminders, so the eligible rows are
      the ones a reminder makes sense for: still waiting on their form. A
      student who already submitted has nothing to be reminded about, and one
      staged for removal is on their way out.

      ── 2026-08-17 — except one kind of student who has submitted ────────

      Someone in awaiting_payment answered the form and owes for delivery. They
      have exactly one thing left to be reminded about, and until today they
      could not even be ticked: the rule above predates phase 8, when "has
      submitted" really did mean "nothing left to say".

      This is what kept the delivery-reminder button off the screen after its
      task and its webhook were both in place — the button reads the selection,
      and they could never be in one. The webhook was necessary and not
      sufficient.

      Each letter still goes only to its own group: collectReminderTargets
      gives the form to whoever has not submitted and the payment link only
      to those who owe.
    */
    /*
      2026-08-19 — Select all obeys the chosen audience.

      Reported: seventeen pending students ticked, and the manual panel opened
      with every field empty and a line saying three of them owed for delivery.

      Both came from here. Select all gathered everyone a reminder could go to
      — students who have not submitted AND students who owe postage — because
      it was written before the audiences existed and nobody taught it about
      them. The three debtors joined the seventeen, the panel saw a mixed
      selection, refused it, and cleared the boxes. The three she read were the
      refusal counting them.

      A refusal that is correct about a selection the admin never made is worse
      than no refusal: it explains a decision she did not take.

      Outside reminder mode nothing has an audience, and the old behaviour
      stands.
    */
    function getSelectableEmails() {
      var students = dedupeStudentsByEmail(getStudentsForCohort(editingCohortCode));

      return getEditPanelRosterEmails(editingCohortCode).map(function(email) {
        return String(email || '').trim().toLowerCase();
      }).filter(function(email) {
        if (!email || isMarkedForRemoval(email)) return false;

        var student = findStudentForRosterEmail(students, email);
        var owing = student ? isAwaitingPaymentStudent(student) : false;
        var submitted = student ? hasSubmittedSizes(student) : false;

        /* 2026-10-13 (owner) - one group on screen at a time: Select all
           reaches exactly the students that screen lists. */
        if (rosterEditMode === 'remind' && reminderAudience === 'form') return !owing && !submitted;
        if (rosterEditMode === 'remind' && reminderAudience === 'pay') return owing;

        if (!student) return true;
        if (owing) return true;

        return !submitted;
      });
    }

    function draftIsForCohort(cohortCode) {
      return normalizeKey(rosterDraft.cohortCode || '') === normalizeKey(cohortCode || '');
    }

    function isMarkedForRemoval(email) {
      return rosterDraft.removals.indexOf(String(email || '').trim().toLowerCase()) !== -1;
    }

    function toggleDraftRemoval(email, on) {
      var normalized = String(email || '').trim().toLowerCase();
      var index = rosterDraft.removals.indexOf(normalized);

      if (on && index === -1) rosterDraft.removals.push(normalized);
      if (!on && index !== -1) rosterDraft.removals.splice(index, 1);

      /* A row marked for removal must not also carry a pending rename. */
      if (on) delete rosterDraft.edits[normalized];
    }

    function getDraftEdit(email) {
      return rosterDraft.edits[String(email || '').trim().toLowerCase()] || '';
    }

    function setDraftEdit(currentEmail, nextEmail) {
      var from = String(currentEmail || '').trim().toLowerCase();
      var to = String(nextEmail || '').trim().toLowerCase();

      if (!to || to === from) {
        delete rosterDraft.edits[from];
        return;
      }

      rosterDraft.edits[from] = to;
    }

    function getDraftAdditions() {
      var textarea = document.getElementById('cohort-edit-add-textarea');
      if (!textarea) return [];

      /*
        Compared against the WHOLE cohort roster, not the list on screen. In a
        late-students view the panel shows a subset, and an address already
        sitting on the main roster would otherwise read as a new student.
      */
      var rosterEmails = getRosterEmailsOrdered(findCohortByCode(editingCohortCode)).map(function(email) {
        return String(email || '').trim().toLowerCase();
      });

      var seen = {};

      return String(textarea.value || '')
        .split(/[\s,;]+/)
        .map(function(value) { return String(value || '').trim().toLowerCase(); })
        .filter(function(value) {
          if (!value || value.indexOf('@') === -1) return false;
          if (rosterEmails.indexOf(value) !== -1) return false;
          if (seen[value]) return false;
          seen[value] = true;
          return true;
        });
    }

    function getDraftSummary() {
      var edits = Object.keys(rosterDraft.edits);
      var additions = getDraftAdditions();

      return {
        removals: rosterDraft.removals.slice(),
        edits: edits.map(function(from) {
          return { from: from, to: rosterDraft.edits[from] };
        }),
        additions: additions,
        total: rosterDraft.removals.length + edits.length + additions.length
      };
    }

    /*
      The whole point of the rework: the request carries the intended roster,
      not the sequence of clicks that produced it. Sending the same list twice
      therefore changes nothing the second time.

      Built from the FULL cohort roster every time — never from the rows on
      screen. A late-students view shows a subset, and sending that subset as
      "the intended roster" would tell the server every main-track student had
      been deleted.
    */
    /*
      ── 2026-08-18 — удаление того, кого в списке школы нет ─────────────

      Найдено владелицей на живой когорте. Она заполнила форму адресом не из
      списка, отметила себя на удаление, нажала Apply — и ничего не произошло.
      Задача отчиталась «список обновлён», ошибок ноль, `removal_candidates: 0`.

      Причина в способе. Удаление выражается **вычитанием из списка школы**:
      панель шлёт новый список, задача перебирает старый и удаляет тех, кого в
      новом не стало. Студента «не из списка» нет ни в старом, ни в новом —
      вычитать нечего, и его отсутствие неотличимо от обычного состояния.

      Хуже поломки была тишина: панель показала загрузку, вебхук ответил 200,
      задача написала «готово». Никто не сказал, что удаление не состоялось.

      Для таких есть отдельная задача — Cohort: Remove Student. Она ищет
      студента по записи (`node_cohort_code` + `node_email`), а не по списку,
      и списка ей не нужно вовсе. Функция для неё в панели тоже была написана,
      но не вызывалась ниоткуда: объявление есть, вызовов ноль.

      Здесь эти два пути наконец расходятся по назначению.
    */
    function isOnCohortRoster(cohortCode, email) {
      var normalized = String(email || '').trim().toLowerCase();
      if (!normalized) return false;

      return getRosterEmailsOrdered(findCohortByCode(cohortCode))
        .some(function(rosterEmail) {
          return String(rosterEmail || '').trim().toLowerCase() === normalized;
        });
    }

    function splitRemovalsByRoster(cohortCode, removals) {
      var onRoster = [];
      var offRoster = [];

      (removals || []).forEach(function(email) {
        (isOnCohortRoster(cohortCode, email) ? onRoster : offRoster).push(email);
      });

      return { onRoster: onRoster, offRoster: offRoster };
    }

    function buildFinalRosterEmails() {
      var summary = getDraftSummary();
      var base = getRosterEmailsOrdered(findCohortByCode(editingCohortCode));

      var removed = {};
      summary.removals.forEach(function(email) {
        removed[email] = true;
      });

      var renamed = {};
      summary.edits.forEach(function(pair) {
        renamed[pair.from] = pair.to;
      });

      var out = [];
      var seen = {};

      base.forEach(function(rawEmail) {
        var email = String(rawEmail || '').trim().toLowerCase();
        if (!email || removed[email]) return;

        var next = renamed[email] || email;
        if (seen[next]) return;

        seen[next] = true;
        out.push(next);
      });

      summary.additions.forEach(function(email) {
        if (seen[email]) return;
        seen[email] = true;
        out.push(email);
      });

      return out;
    }

    /*
      Mirrors the status set Cohort: Update Roster Emails treats as "already in
      an order". Deliberately a plain status check rather than
      canEditStudentEmail: the server rule is the coarser of the two, and a
      client that allows more than the server would show success for a change
      that is about to be refused — and the refusal never reaches the browser.
    */
    function isStudentCountedAsConfirmed(student) {
      var status = String((student && student.status) || '').trim().toLowerCase();

      return (
        status === 'confirmed' ||
        status === 'submitted' ||
        status === 'complete' ||
        status === 'completed' ||
        status === 'draft_order_queued' ||
        status === 'draft_order_created'
      );
    }

    /* Returns a plain-language problem, or '' when the draft is safe to send. */
    function validateRosterDraft(summary) {
      var cohort = findCohortByCode(editingCohortCode);
      var students = dedupeStudentsByEmail(getStudentsForCohort(editingCohortCode));
      var finalized = isCohortFinalized(cohort);

      if (editingReadOnly) {
        return 'This cohort is read-only.';
      }

      /*
        The demo holds ten. Checked here rather than in the task behind it,
        because a refusal raised in Mechanic never reaches the browser - the
        webhook answers 200 before the task runs (trap 3). A cap the person
        cannot see is not a cap, it is a silence.
      */
      if (CONFIG.demoMode) {
        var demoCap = Number(CONFIG.demoMaxStudents) || 5;
        var afterChange = students.length - summary.removals.length + summary.additions.length;
        if (afterChange > demoCap) {
          return 'A demo cohort holds up to ' + demoCap + ' students, and this one would have ' + afterChange + '. The live system has no limit.';
        }
      }

      var blockedRemovals = summary.removals.filter(function(email) {
        var student = findStudentForRosterEmail(students, email);
        if (finalized && isStudentCountedAsConfirmed(student)) return true;
        return !canEditStudentEmail(cohort, student || { email: email, status: 'pending' });
      });

      if (blockedRemovals.length) {
        return blockedRemovals.length === 1
          ? blockedRemovals[0] + ' is already part of the school order and cannot be removed.'
          : blockedRemovals.length + ' of the selected students are already part of the school order and cannot be removed.';
      }

      for (var i = 0; i < summary.edits.length; i += 1) {
        var pair = summary.edits[i];
        var student = findStudentForRosterEmail(students, pair.from);

        /*
          2026-10-07 - a real format check, not just "has an @". The corrected
          address now carries the student's token and payment link (Cohort:
          Fix Student Email), so a typo here sends the student a letter they
          never receive. Refused here because a Mechanic refusal never reaches
          the browser (trap 3).
        */
        if (!looksLikeEmailAddress(pair.to)) {
          return 'This does not look like an email address: ' + pair.to;
        }

        if (finalized && isStudentCountedAsConfirmed(student)) {
          return pair.from + ' is already part of the school order, so this email cannot be changed.';
        }

        if (!canEditStudentEmail(cohort, student || { email: pair.from, status: 'pending' })) {
          return pair.from + ' can no longer be edited.';
        }

        if (isEmailTakenByAnotherStudent(editingCohortCode, pair.to, student)) {
          return pair.to + ' already belongs to another student in this cohort.';
        }
      }

      /*
        Additions that need a deadline of their own are not refused here — the
        review modal asks for the date instead. Pointing at the old Add students
        button would be a dead end: it has been hidden since step 1 of the
        rework, so it is no longer a place the admin can go.
      */

      if (!buildFinalRosterEmails().length) {
        return 'A cohort cannot be left with no students. Delete the cohort instead.';
      }

      return '';
    }
    var panelLoadingProgressRaf = null;
    /*
      30s (owner decision, 2026-08-03): adding students runs the longest
      Mechanic task on the dashboard — roster rewrite, entry creation and invite
      emails — and 20s regularly ended before the new student existed, leaving
      the admin looking at a stale list.
    */
    var PANEL_BLOCKING_ADD_MS = 30000;
    /* 25s (owner decision, 2026-08-04): removal also releases submission locks
       and rebuilds the cache, and 15s regularly ended before that finished. */
    var PANEL_BLOCKING_REMOVE_MS = 25000;
    /*
      Deleting waits for the server to stop listing the cohort, and that ladder
      can run to about 45s. The lock and the ring have to outlast it: an action
      lock that expires mid-wait would hand the buttons back while Mechanic is
      still deleting, and a ring that finishes early says the job is done when
      it is not — which is how this looked before, only sooner.
    */
    var PANEL_BLOCKING_DELETE_MS = 50000;
    /*
      Apply does in one run what used to take several: roster rewrite, removals,
      restores, new entries, invitations and any renames handed off to a second
      task. 35s is the add-students block plus room for that hand-off. It is a
      MINIMUM, not a deadline — finishPanelBlockingLoad keeps holding until the
      server actually confirms.
    */
    var PANEL_BLOCKING_APPLY_MS = 35000;
    /*
      Said in the modal and again in the page message, because a Mechanic
      webhook answers 200 before the task has done anything: "sent" is the only
      thing the browser truly knows at that moment.
    */
    var APPLY_PENDING_MESSAGE = 'Changes sent. They usually appear within 1-2 minutes — this page updates by itself.';
    var APPLY_STALE_MESSAGE = 'Your changes were sent but are taking longer than usual. Reloading to show the current list.';
    /* 2 * PI * r, with r = 52 from the progress ring SVG markup. */
    var PANEL_RING_CIRCUMFERENCE = 326.73;
    var panelRingLabelText = 'Updating';
    var ADMIN_NO_CONFIRMED_MESSAGE = 'No student from your list has confirmed the uniform size selection form yet.';
    /*
      Cross-page action lock — same key and shape as in cohort-status.js, so the
      dashboard and the status page block each other. localStorage, not
      sessionStorage: the block has to survive a manual browser refresh and
      apply in every tab, because the Mechanic task keeps running regardless.
      Each record carries its own expiry so a hung task can never brick the
      page. See the longer note in cohort-status.js.
    */
    var ACTION_LOCK_KEY = 'cohort_action_lock';
    /*
      2026-08-24 — the cap stays at five minutes although nothing on this page
      writes a five-minute lock any more.

      Finalizing moved to the status page entirely, and that page writes the
      long finalize lock under this same key. This page restores and honours
      those locks, and a restored lock is timed from the record rather than
      from the cap — but the two files are read together, and a cap here that
      contradicted the duration there would invite somebody to "fix" one of
      them. Every action this page does write passes its own shorter duration.
    */
    var ACTION_LOCK_MAX_MS = 300000;
    var ACTION_LOCK_RESUMED_NOTE = 'Your last change is still being applied. This page unlocks automatically as soon as it finishes.';
    var actionLockReleaseTimer = null;
    var actionLockPollTimer = null;
    var CREATE_ACTION_LOCK_MS = 60000;
    /*
      Browsers cap the total body of keepalive requests at roughly 64 KB and
      reject the fetch outright above it, so stay well under and fall back to a
      normal request for anything larger. That matters most here: the cohort
      create payload carries products, pricing and the whole email list, so it
      is the one request that can realistically exceed the cap. keepalive is a
      bonus, never the primary protection — the beforeunload guard is.
    */
    var KEEPALIVE_MAX_BYTES = 50000;
    var allowNextUnload = false;

    function isCohortFinalized(cohort) {
      /* Keep in step with the same function in cohort-status.js (2026-08-02 fix — the two used to disagree on which statuses/lock values count as finalized). */
      if (!cohort) return false;

      var draftOrderId = String(cohort.schoolDraftOrderId || '').trim();
      var status = String(cohort.status || '').toLowerCase();
      var finalizeLock = String(cohort.finalizeLock || '').toLowerCase();

      return !!(
        draftOrderId ||
        status === 'closed' ||
        status === 'completed' ||
        status === 'delivered' ||
        finalizeLock === 'complete' ||
        finalizeLock === 'locked' ||
        finalizeLock === 'true'
      );
    }

    function getCohortDeadlineValue(cohort) {
      if (!cohort) return '';
      return String(cohort.deadline || cohort.deadlineDisplay || '').trim();
    }

    /*
      2026-08-11 — a date is asked for only when the student is joining a round
      that is already running.

      Adding to a finalized cohort used to demand one every time, and the date
      made a round on the spot: reported after adding one student produced
      LATE-01 for them alone while another student, who should have been in the
      same round, was left behind in the finalized cohort with no round at all.

      Joining the waiting room needs no date. The date is set once, for the
      whole room, by Start late round — which is the only thing that turns it
      into a real round, and turns it into one for everybody in it.
    */
    /*
      2026-08-25 — an open cohort never asks for a new date (owner).

      This used to demand one the moment the cohort's own date had passed, and
      then send the invitation as "open a late round" — so a student added to a
      cohort that was still open landed in a round of their own, apart from
      everybody else in it.

      That made sense while a passed date meant a closed door. It has not meant
      that since 2026-08-02 in the browser and 2026-08-24 on the server: an
      open cohort takes submissions whatever its date says. So an open cohort
      invites normally, and only a finalized one — where the main track really
      is shut — routes new students into a round.
    */
    function needsLateDeadlineForNewEmails(cohort) {
      if (!cohort) return false;
      if (isCohortFinalized(cohort)) return !!getReusableLateBatchInfo(cohort.cohortCode);
      return false;
    }

    function parseLateBatchesForCohort(cohortCode) {
      var normalized = normalizeKey(cohortCode);
      var cache = STATUS_CACHES.find(function(entry) {
        return normalizeKey(entry.cohortCode) === normalized;
      });
      if (!cache || !cache.lateBatchesJson) return [];
      try {
        var parsed = JSON.parse(cache.lateBatchesJson);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    /*
      The school's invoices, one per campus, lived here from 2026-08-11 until
      later the same day: the owner moved them to the status page alone, where
      the person who pays them looks. The dashboard is where a cohort is built
      and its students managed; the invoices are the end of that story, told in
      one place instead of two. cohort-status.js holds the only copy now.
    */
    // Wave 2 / Phase 1 — structured decision (cohort_late_batch is the source of
    // truth): tells the UI whether adding emails now will land in an existing
    // open batch or must start the next one. Computed client-side from the same
    // cache data the backend already writes (late_batches_json), since Mechanic
    // webhooks here are fire-and-forget and don't return a synchronous body.
    function getLateBatchAddEmailsDecision(cohortCode) {
      var batches = parseLateBatchesForCohort(cohortCode).slice().sort(function(a, b) {
        return Number(b.late_batch_index || 0) - Number(a.late_batch_index || 0);
      });
      var openBatch = batches.filter(function(b) { return b.status === 'open'; })[0] || null;
      var mostRecent = batches[0] || null;

      return {
        late_batch_finalized: !openBatch && !!mostRecent && mostRecent.status === 'finalized',
        previous_batch_code: mostRecent ? mostRecent.late_batch_code : null,
        next_batch_required: !openBatch,
        requires_new_deadline: !openBatch,
        open_batch_code: openBatch ? openBatch.late_batch_code : null,
        open_batch_deadline: openBatch ? openBatch.late_deadline : null,
        open_batch_deadline_display: openBatch ? (openBatch.late_deadline_display || openBatch.late_deadline) : null
      };
    }

    function lateBatchDisplayLabel(code) {
      var match = /(\d+)\s*$/.exec(String(code || '').trim());
      return match ? 'Late ' + match[1].replace(/^0+(?=\d)/, '').padStart(2, '0') : String(code || '');
    }

    function lateBatchFinalizedWarningText(previousBatchCode) {
      var previousLabel = lateBatchDisplayLabel(previousBatchCode);
      var nextIndex = (parseInt((/(\d+)\s*$/.exec(previousBatchCode) || [])[1], 10) || 0) + 1;
      var nextLabel = 'Late ' + String(nextIndex).padStart(2, '0');
      return previousLabel + ' has already been finalized. To add these students, create ' + nextLabel + ' with a new deadline.';
    }

    function isCohortArchived(cohort) {
      if (!cohort) return false;
      return String(cohort.status || '').toLowerCase() === 'archived';
    }

    function setCohortEmailEditorLockState(cohort) {
      editingCohortFinalized = isCohortFinalized(cohort);
      editingCohortLocked = editingCohortFinalized;
      var notice = document.getElementById('cohort-edit-locked-notice');
      var addTextarea = document.getElementById('cohort-edit-add-textarea');
      var addButton = document.getElementById('cohort-edit-add-emails-button');
      var rosterCard = document.getElementById('cohort-edit-roster-list');
      rosterCard = rosterCard ? rosterCard.closest('.cohort-edit-card') : null;

      /*
        2026-08-06 — the notice used to read the same on the late track, where
        everything on screen IS editable. An admin opening an open late round
        met "This cohort is finalized" and reasonably concluded they could not
        touch it. The late track says nothing at all now: the controls are right
        there and they work, so the only honest message is none.
      */
      if (notice) {
        var showLockedNotice = editingCohortFinalized && !isEditingLateStudentsTrack();

        notice.style.display = showLockedNotice ? '' : 'none';
        notice.textContent = showLockedNotice
          ? 'The main cohort is finalized, so its student list can no longer be changed. Students who missed the deadline can still be invited to a late round.'
          : '';
      }

      if (addTextarea) {
        addTextarea.readOnly = false;
        addTextarea.disabled = false;
      }

      if (addButton) {
        addButton.disabled = false;
      }

      if (rosterCard) {
        rosterCard.classList.toggle('is-locked', false);
      }
    }

    function setManagePanelsVisible(mode) {
      var managePanel = document.getElementById('cohort-manage-panel');
      var editPanel = document.getElementById('cohort-email-edit-panel');
      var createPanel = document.getElementById('cohort-create-panel');
      var createHero = document.getElementById('cohort-create-hero');

      if (managePanel) {
        managePanel.style.display = mode === 'manage' ? '' : 'none';
      }

      if (editPanel) {
        editPanel.style.display = mode === 'edit' ? '' : 'none';
      }

      /* 2026-10-09 - the Edit Cohort design (9B) is scoped to this class, so the
         cohort list and the create form keep their look. */
      var adminShell = document.querySelector('.cohort-admin-shell');
      if (adminShell) adminShell.classList.toggle('is-editing-cohort', mode === 'edit');

      if (createPanel) {
        createPanel.style.display = mode === 'create' ? '' : 'none';
      }

      if (createHero) {
        createHero.style.display = mode === 'create' ? '' : 'none';
      }

      /*
        Only offer the way back when there is something to go back to. With no
        cohorts yet the create form is the whole dashboard, and a button
        leading to an empty list would be a dead end.
      */
      var createBackButton = document.getElementById('cohort-create-back-button');
      if (createBackButton) {
        var canGoBack = mode === 'create' && MY_COHORTS.length > 0;
        createBackButton.hidden = !canGoBack;
        createBackButton.setAttribute('aria-hidden', canGoBack ? 'false' : 'true');
      }
    }

    function setCreatePanelVisible(visible) {
      setManagePanelsVisible(visible ? 'create' : 'manage');
    }

    /*
      2026-10-17 (owner) - creating a cohort needs a signed-in visitor.

      The page prints the create webhook only for a signed-in visitor (the
      section's viewer_can_act). A signed-out visitor of the demo could still
      open the form, fill in every step, and be told at the very end that a
      "webhook URL is missing in section settings" - true, and meaningless to
      them. So the form is not opened for them at all: the button reads
      "Sign in to create a cohort" and leads to the sign-in page, which brings
      them back here afterwards.
    */
    function mustSignInToCreate() {
      return !CUSTOMER.loggedIn;
    }

    function goToSignInToCreate() {
      window.location.href = '/account/login?return_url=' +
        encodeURIComponent(window.location.pathname + window.location.search);
    }

    function findCohortByCode(code) {
      var normalized = normalizeKey(code);
      return MY_COHORTS.find(function(cohort) {
        return normalizeKey(cohort.cohortCode) === normalized;
      }) || null;
    }

    function getCohortDisplayTitle(cohort) {
      return getCohortLabel(cohort) || (cohort && cohort.cohortCode ? cohort.cohortCode : 'Cohort');
    }

    function stripCohortLabelSuffix(label, cohortCode) {
      var text = String(label || '').trim();
      var code = String(cohortCode || '').trim();
      if (!text || !code) return text;

      var suffix = ' (' + code + ')';
      if (text.length > suffix.length && text.slice(-suffix.length).toUpperCase() === suffix.toUpperCase()) {
        return text.slice(0, -suffix.length).trim();
      }

      return text;
    }

    function parseCohortLabelFromSnapshot(raw) {
      if (!raw) return '';

      try {
        var parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        return String(parsed.cohort_label || parsed.cohortLabel || '').trim();
      } catch (error) {
        return '';
      }
    }

    /*
      The campuses named under a cohort's title. campuses_snapshot holds them
      all as plain names; the single campus reference is kept as the fallback
      for cohorts created before that field existed, and the school name as the
      last resort so the line is never empty.
    */
    function getCohortCampusLabel(cohort) {
      var raw = cohort && cohort.campusesSnapshotRaw;
      var names = [];

      try {
        var parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (Array.isArray(parsed)) {
          names = parsed.map(function(name) {
            return String(name || '').trim();
          }).filter(Boolean);
        }
      } catch (error) {
        names = [];
      }

      if (names.length) return names.join(' · ');

      return (cohort && (cohort.campusName || cohort.schoolName)) || '';
    }

    function getCohortLabel(cohort) {
      if (!cohort) return '';

      var label = stripCohortLabelSuffix(cohort.cohortLabel || cohort.cohort_label || '', cohort.cohortCode);
      if (label) return label;

      label = stripCohortLabelSuffix(
        parseCohortLabelFromSnapshot(cohort.campusAddressSnapshot || cohort.campus_address_snapshot || ''),
        cohort.cohortCode
      );
      if (label) return label;

      var meta = getCohortMetaForCode(cohort.cohortCode);
      if (meta && meta.cohortLabel) {
        label = stripCohortLabelSuffix(meta.cohortLabel, cohort.cohortCode);
        if (label) return label;
      }

      var summary = getCacheSummaryForCohort(cohort.cohortCode) || {};
      label = stripCohortLabelSuffix(summary.cohort_label || summary.cohortLabel || '', cohort.cohortCode);
      if (label) return label;

      return stripCohortLabelSuffix(cohort.displayName || cohort.display_name || '', cohort.cohortCode);
    }

    function dedupeCohortsByCode(cohorts) {
      var seen = {};
      var result = [];

      (cohorts || []).forEach(function(cohort) {
        var key = normalizeKey(cohort.cohortCode);
        if (!key || seen[key]) return;
        seen[key] = true;
        result.push(cohort);
      });

      return result;
    }

    function isRemovedStudent(student) {
      var status = String(student && student.status ? student.status : '').toLowerCase();
      return status === 'removed' || status === 'archived';
    }

    /*
      Phase 8 (2026-08-12) — answered the form, has not paid for delivery.

      Twin of the same function in cohort-status.js. Not folded into the
      submitted checks: they owe nobody a form, only a payment, and chasing
      them for sizes already in would be wrong.
    */
    function isAwaitingPaymentStudent(student) {
      var status = String(student && student.status ? student.status : '').toLowerCase();
      return status === 'awaiting_payment';
    }

    /*
      Paid for their own delivery (2026-08-12) — read from the order written on
      their record when the payment landed, never guessed from the status.

      "confirmed" cannot answer this: in cohorts made before phase 8 it only
      ever meant "answered the form", so reading it as proof of payment would
      paint every old cohort as paid. The order id is written by one task, in
      one place, and only after money actually arrived.

      Twin of the same function in cohort-status.js.
    */
    function isPaidStudent(student) {
      return String(student && student.paid_order_id ? student.paid_order_id : '').trim() !== '';
    }

    function findStudentByEmail(students, email) {
      return findStudentForRosterEmail(students, email);
    }

    function isStudentTrackFinalized(cohort, student) {
      var batchCode = String(student && student.late_batch_code || '').trim().toUpperCase();

      if (!batchCode) {
        if (!isCohortFinalized(cohort)) return false;

        /*
          Keep in step with the same function in cohort-status.js. Main is
          finalized, but this student is not in any late batch yet — they never
          confirmed and have no order, so nothing about them went into the school
          invoice and the admin must still be able to correct or remove them.
        */
        if (!hasSubmittedSizes(student) && String(student.draft_order_id || '').trim() === '') {
          return false;
        }

        return true;
      }

      var batches = parseLateBatchesForCohort(cohort && cohort.cohortCode);
      var batch = batches.find(function(b) {
        return String(b.late_batch_code || '').trim().toUpperCase() === batchCode;
      });

      /*
        'finalizing' means the run is in flight and the batch's students are
        already being built into the school invoice — everything is locked
        (2026-08-02 fix). Keep in step with cohort-status.js.
      */
      if (batch && batch.status === 'finalizing') return true;

      var batchFinalized = !!(
        batch &&
        (batch.status === 'finalized' || String(batch.school_draft_order_id || '').trim())
      );

      if (!batchFinalized) return false;

      /*
        Same carve-out the Main track above already has (2026-08-03): the batch
        is finalized, but this student never confirmed and has no order, so
        nothing about them went into the school invoice. The admin must still be
        able to remove them instead of being stuck resending the form forever.
        cohort-remove-student.liquid already permits exactly this — it gates on
        the student's status, not on the batch — so the UI was the only thing
        blocking it.
      */
      if (!hasSubmittedSizes(student) && String(student.draft_order_id || '').trim() === '') {
        return false;
      }

      return true;
    }

    function canEditStudentEmail(cohort, student) {
      /* Keep in step with the same function in cohort-status.js (2026-08-02 fix). */
      if (isRemovedStudent(student)) return false;
      if (!student) return !isCohortFinalized(cohort);
      return !isStudentTrackFinalized(cohort, student);
    }

    /*
      True when `email` already identifies a different, still-active student in
      this cohort. Mirrors isEmailTakenByAnotherStudent in cohort-status.js — the
      Mechanic task rejects such a rename, but its error can never reach the
      browser (the webhook returns 200 before the task runs), so both entry points
      have to catch it client-side.
    */
    function isEmailTakenByAnotherStudent(cohortCode, email, exceptStudent) {
      var normalized = String(email || '').trim().toLowerCase();
      if (!normalized) return false;

      var exceptIdentity = exceptStudent ? getStudentIdentityEmail(exceptStudent) : '';

      return getStudentsForCohort(cohortCode).some(function(student) {
        if (isRemovedStudent(student)) return false;
        if (exceptStudent && student === exceptStudent) return false;
        if (exceptIdentity && getStudentIdentityEmail(student) === exceptIdentity) return false;

        return [
          student.email,
          student.roster_email,
          student.submitted_email,
          student.contact_email
        ].some(function(candidate) {
          return String(candidate || '').trim().toLowerCase() === normalized;
        });
      });
    }

    function hasSubmittedSizes(student) {
      if (!student) return false;

      var status = String(student.status || '').toLowerCase();
      var orderStatus = String(student.order_status || '').toLowerCase();

      if (
        status === 'confirmed' ||
        status === 'submitted' ||
        status === 'complete' ||
        status === 'completed' ||
        status === 'draft_order_queued' ||
        status === 'draft_order_created' ||
        orderStatus === 'draft_order_queued' ||
        orderStatus === 'draft_order_created'
      ) {
        return true;
      }

      if (student.draft_order_id || student.draft_order_name || student.draft_order_invoice_url) {
        return true;
      }

      try {
        var items = student.items;
        if (typeof items === 'string') items = JSON.parse(items);
        if (Array.isArray(items) && items.length) return true;
      } catch (error) {}

      try {
        var sizes = student.sizes;
        if (typeof sizes === 'string') sizes = JSON.parse(sizes);
        if (sizes && typeof sizes === 'object' && Object.keys(sizes).length) return true;
      } catch (error) {}

      return false;
    }

    /*
      2026-08-11, phase 6 — mirrors getStudentCampusName in cohort-status.js.
      A student's campus is the one their submitted items carry; the two files
      keep their own copy of the shared rules and both move together.
    */
    function getStudentCampusName(student) {
      var items = student && student.items;

      try {
        if (typeof items === 'string') items = JSON.parse(items);
      } catch (error) {
        return '';
      }

      if (!Array.isArray(items)) return '';

      for (var i = 0; i < items.length; i += 1) {
        var name = String((items[i] && items[i].campus_name) || '').trim();
        if (name) return name;
      }

      return '';
    }

    function isUnmatchedStudent(student) {
      return String(student && student.email_match_status ? student.email_match_status : '').toLowerCase() === 'unmatched';
    }

    function rosterEmailsToText(raw) {
      return normalizeStudentEmailsRaw(raw).join('\n');
    }

    function getStudentIdentityEmail(student) {
      if (!student) return '';

      return String(
        student.email ||
        student.roster_email ||
        student.contact_email ||
        student.submitted_email ||
        ''
      ).trim().toLowerCase();
    }

    function normalizeStudentRecord(student) {
      if (!student || typeof student !== 'object') return student;

      var next = Object.assign({}, student);
      var identityEmail = getStudentIdentityEmail(next);

      if (identityEmail) {
        next.email = identityEmail;
      }

      return next;
    }

    function parseStudentsJson(value) {
      if (value == null || value === '') return [];

      var parsed = value;

      try {
        if (typeof parsed === 'string') {
          parsed = JSON.parse(parsed);
        }
      } catch (error) {
        return [];
      }

      var guard = 0;
      while (typeof parsed === 'string' && guard < 3) {
        try {
          parsed = JSON.parse(parsed);
        } catch (error) {
          return [];
        }
        guard += 1;
      }

      if (!Array.isArray(parsed)) return [];

      return parsed
        .map(normalizeStudentRecord)
        .filter(function(student) {
          return student && !isRemovedStudent(student);
        });
    }

    function studentSubmissionPriority(student) {
      if (hasSubmittedSizes(student)) return 2;
      return 1;
    }

    function dedupeStudentsByEmail(students) {
      var byEmail = {};

      (students || []).forEach(function(student) {
        var email = getStudentIdentityEmail(student);
        if (!email) return;

        var normalizedStudent = normalizeStudentRecord(student);
        var existing = byEmail[email];

        if (!existing || studentSubmissionPriority(normalizedStudent) > studentSubmissionPriority(existing)) {
          byEmail[email] = normalizedStudent;
        }
      });

      return Object.keys(byEmail).map(function(key) {
        return byEmail[key];
      });
    }

    function studentIdentityEmails(student) {
      var emails = [];
      ['email', 'roster_email', 'contact_email', 'submitted_email'].forEach(function(key) {
        var value = String(student && student[key] ? student[key] : '').trim().toLowerCase();
        if (value && emails.indexOf(value) === -1) {
          emails.push(value);
        }
      });
      return emails;
    }

    function expandStudentsWithRosterPlaceholders(students, cohort) {
      var merged = dedupeStudentsByEmail(students || []);
      var roster = getRosterEmailsOrdered(cohort);

      roster.forEach(function(rosterEmail) {
        if (!findStudentForRosterEmail(merged, rosterEmail)) {
          merged.push({
            email: rosterEmail,
            roster_email: rosterEmail,
            status: 'pending',
            email_match_status: 'matched'
          });
        }
      });

      return merged;
    }

    function getStudentsForCohort(code) {
      var normalized = normalizeKey(code);
      var cache = STATUS_CACHES.find(function(entry) {
        return normalizeKey(entry.cohortCode) === normalized;
      });

      if (!cache || !cache.studentsJson) {
        return [];
      }

      try {
        var cohort = findCohortByCode(code);
        var parsed = parseStudentsJson(cache.studentsJson);
        return pruneDuplicateRosterPlaceholders(
          expandStudentsWithRosterPlaceholders(parsed, cohort),
          cohort
        );
      } catch (error) {
        return [];
      }
    }

    function getRosterEmailsOrdered(cohort) {
      return normalizeStudentEmailsRaw(cohort && cohort.studentEmailsRaw);
    }

    function findStudentForRosterEmail(students, email) {
      var normalized = String(email || '').trim().toLowerCase();
      if (!normalized) return null;

      var matches = (students || []).filter(function(student) {
        var studentEmail = String(student.email || '').trim().toLowerCase();
        var rosterEmail = String(student.roster_email || '').trim().toLowerCase();
        var submittedEmail = String(student.submitted_email || '').trim().toLowerCase();
        var contactEmail = String(student.contact_email || '').trim().toLowerCase();
        return (
          studentEmail === normalized ||
          rosterEmail === normalized ||
          submittedEmail === normalized ||
          contactEmail === normalized
        );
      });

      if (!matches.length) return null;

      matches.sort(function(a, b) {
        return studentSubmissionPriority(b) - studentSubmissionPriority(a);
      });

      return matches[0];
    }

    function studentMatchesRosterEmail(student, email) {
      return !!findStudentForRosterEmail([student], email);
    }

    function pruneDuplicateRosterPlaceholders(students, cohort) {
      var roster = getRosterEmailsOrdered(cohort);
      var submittedByRoster = {};

      roster.forEach(function(rosterEmail) {
        var submitted = (students || []).find(function(student) {
          return hasSubmittedSizes(student) && studentMatchesRosterEmail(student, rosterEmail);
        });

        if (submitted) {
          submittedByRoster[rosterEmail] = submitted;
          studentIdentityEmails(submitted).forEach(function(identityEmail) {
            submittedByRoster[identityEmail] = submitted;
          });
        }
      });

      return (students || []).filter(function(student) {
        if (hasSubmittedSizes(student)) return true;

        var identities = studentIdentityEmails(student);
        if (!identities.length) return true;

        return !identities.some(function(identityEmail) {
          return submittedByRoster[identityEmail];
        });
      });
    }

    function isEmailManagementDirty() {
      var editPanel = document.getElementById('cohort-email-edit-panel');
      if (editPanel && editPanel.classList.contains('is-saving')) return true;

      var inputs = document.querySelectorAll('.em-row-input');
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        if (input === document.activeElement) return true;

        var saved = String(input.getAttribute('data-current-email') || '').trim().toLowerCase();
        var current = String(input.value || '').trim().toLowerCase();
        if (current !== saved) return true;
      }

      var addTextarea = document.getElementById('cohort-edit-add-textarea');
      if (addTextarea && addTextarea === document.activeElement) return true;
      if (addTextarea && String(addTextarea.value || '').trim()) return true;

      return false;
    }

    function persistEmailEditState(cohortCode) {
      try {
        if (cohortCode) {
          sessionStorage.setItem('cohort_admin_email_edit', JSON.stringify({
            code: normalizeKey(cohortCode),
            lateTrack: !!editingLateStudentsTrack,
            lateBatchCode: editingLateBatchCode || '',
            readOnly: !!editingReadOnly
          }));
        } else {
          sessionStorage.removeItem('cohort_admin_email_edit');
        }
      } catch (error) {}
    }

    function restoreEmailEditState() {
      try {
        var raw = sessionStorage.getItem('cohort_admin_email_edit');
        if (!raw) return;

        var parsed = null;
        try {
          parsed = JSON.parse(raw);
        } catch (error) {
          parsed = { code: raw, lateTrack: false };
        }

        var code = parsed && parsed.code ? parsed.code : raw;
        if (!findCohortByCode(code)) return;

        openCohortEmailEditor(code, {
          lateTrack: !!(parsed && parsed.lateTrack),
          lateBatchCode: parsed && parsed.lateBatchCode ? parsed.lateBatchCode : '',
          readOnly: !!(parsed && parsed.readOnly)
        });
      } catch (error) {}
    }

    function syncManagePanelVisibility() {
      if (editingCohortCode) {
        setManagePanelsVisible('edit');
        return;
      }

      if (!isCreateFlowLoading()) {
        setCreatePanelVisible(false);
      }
    }

    function setEmailPanelLoading(active) {
      var panel = document.getElementById('cohort-email-edit-panel');
      var progress = document.getElementById('cohort-email-edit-progress');
      var addProgress = document.getElementById('cohort-edit-add-progress');
      var addButton = document.getElementById('cohort-edit-add-emails-button');
      var addTextarea = document.getElementById('cohort-edit-add-textarea');

      if (panel) {
        panel.classList.toggle('is-saving', !!active);
      }

      if (progress) {
        progress.hidden = !active;
        progress.setAttribute('aria-hidden', active ? 'false' : 'true');
      }

      if (addProgress) {
        addProgress.hidden = !active;
        addProgress.setAttribute('aria-hidden', active ? 'false' : 'true');
      }

      if (addButton) {
        addButton.disabled = !!active;
      }

      if (addTextarea) {
        addTextarea.disabled = !!active;
      }
    }

    function clearStaleEmailPanelStatuses(excludeEl) {
      var rosterStatus = document.getElementById('cohort-edit-roster-status');
      if (rosterStatus && rosterStatus !== excludeEl) {
        rosterStatus.textContent = '';
        rosterStatus.classList.remove('is-success');
      }

      document.querySelectorAll('.em-row-status').forEach(function(el) {
        if (el === excludeEl) return;
        el.textContent = '';
        el.classList.remove('is-success');
      });
    }

    /*
      The blocking add/remove load shows a circular progress ring instead of the
      thin bar. The percent lives inside the ring, so the text label next to it
      is left as plain "Updating..." while the ring is running.
    */
    function setPanelRingProgress(pct) {
      var ringValue = document.getElementById('cohort-email-edit-ring-value');
      var ringPercent = document.getElementById('cohort-email-edit-ring-percent');
      var clamped = Math.max(0, Math.min(100, pct));

      if (ringValue) {
        ringValue.style.strokeDashoffset = String(PANEL_RING_CIRCUMFERENCE * (1 - clamped / 100));
      }
      if (ringPercent) ringPercent.textContent = clamped + '%';
    }

    /*
      The standing instruction, always on screen while a batch is in flight.
      Reloading mid-flight is the one thing that can leave the admin looking at
      a half-applied list, and starting a second action while the first is
      running is what the cross-page lock exists to prevent.
    */
    var PANEL_WAIT_NOTE =
      'Please wait — your changes are being applied. This can take 1–2 minutes. ' +
      'Please do not reload this page or make other changes to this cohort until it finishes.';

    /*
      Rotating captions so a two-minute wait is not a frozen screen. They
      describe what the wait IS, never how far along the server is — the browser
      cannot see a Mechanic task's progress, and inventing a step-by-step
      commentary would be a confident guess dressed up as fact.
    */
    var PANEL_WAIT_CAPTIONS = [
      'Applying your changes',
      'Usually 1–2 minutes',
      'Keep this page open',
      'Waiting for confirmation'
    ];
    var panelCaptionTimer = null;

    function startPanelLoadingProgress(duration) {
      stopPanelLoadingProgress();

      var bar = document.querySelector('#cohort-email-edit-progress .cohort-email-edit-progress-bar');
      var label = document.getElementById('cohort-email-edit-progress-label');
      var percentEl = document.getElementById('cohort-email-edit-progress-percent');
      var ring = document.getElementById('cohort-email-edit-ring');
      var ringLabel = document.getElementById('cohort-email-edit-ring-label');
      var ringNote = document.getElementById('cohort-email-edit-ring-note');
      var ringValue = document.getElementById('cohort-email-edit-ring-value');
      var startedAt = Date.now();

      if (bar) {
        bar.classList.add('is-determinate');
        bar.style.width = '0%';
      }
      if (label) label.hidden = false;
      if (percentEl) percentEl.textContent = '';
      if (ring) {
        ring.hidden = false;
        ring.setAttribute('aria-hidden', 'false');
        ring.classList.remove('is-waiting');
      }
      if (ringValue) ringValue.classList.remove('is-indeterminate');
      if (ringLabel) ringLabel.textContent = panelRingLabelText || 'Updating';
      if (ringNote) {
        ringNote.textContent = PANEL_WAIT_NOTE;
        ringNote.style.display = '';
      }
      setPanelRingProgress(0);

      var captionIndex = 0;
      panelCaptionTimer = window.setInterval(function() {
        captionIndex = (captionIndex + 1) % PANEL_WAIT_CAPTIONS.length;
        var el = document.getElementById('cohort-email-edit-ring-label');
        if (!el) return;

        /* Fade out, swap, fade back in — a hard text swap reads as a glitch. */
        el.classList.add('is-fading');
        window.setTimeout(function() {
          el.textContent = PANEL_WAIT_CAPTIONS[captionIndex];
          el.classList.remove('is-fading');
        }, 260);
      }, 3200);

      function tick() {
        var elapsed = Date.now() - startedAt;
        var pct = Math.min(100, Math.round((elapsed / duration) * 100));
        if (bar) bar.style.width = pct + '%';
        setPanelRingProgress(pct);

        if (elapsed < duration) {
          panelLoadingProgressRaf = window.requestAnimationFrame(tick);
          return;
        }

        panelLoadingProgressRaf = null;

        /*
          The estimate has run out but the server has not confirmed yet — the
          page keeps holding. A ring frozen at 100% reads as a hung screen, so
          hand over to an endless sweep and say plainly that it is still going.
        */
        if (ring) ring.classList.add('is-waiting');
        if (ringValue) ringValue.classList.add('is-indeterminate');

        var percentLabel = document.getElementById('cohort-email-edit-ring-percent');
        if (percentLabel) percentLabel.textContent = '';
      }

      panelLoadingProgressRaf = window.requestAnimationFrame(tick);
    }

    function stopPanelLoadingProgress() {
      if (panelLoadingProgressRaf) {
        window.cancelAnimationFrame(panelLoadingProgressRaf);
        panelLoadingProgressRaf = null;
      }

      if (panelCaptionTimer) {
        window.clearInterval(panelCaptionTimer);
        panelCaptionTimer = null;
      }

      var bar = document.querySelector('#cohort-email-edit-progress .cohort-email-edit-progress-bar');
      var label = document.getElementById('cohort-email-edit-progress-label');
      var ring = document.getElementById('cohort-email-edit-ring');
      var ringNote = document.getElementById('cohort-email-edit-ring-note');
      var ringValue = document.getElementById('cohort-email-edit-ring-value');
      var ringLabel = document.getElementById('cohort-email-edit-ring-label');

      if (bar) {
        bar.classList.remove('is-determinate');
        bar.style.width = '';
      }
      if (label) label.hidden = true;
      if (ring) {
        ring.hidden = true;
        ring.setAttribute('aria-hidden', 'true');
        ring.classList.remove('is-waiting');
      }
      if (ringValue) ringValue.classList.remove('is-indeterminate');
      if (ringLabel) ringLabel.classList.remove('is-fading');
      if (ringNote) {
        ringNote.textContent = '';
        ringNote.style.display = 'none';
      }
      setPanelRingProgress(0);
    }

    function writeActionLock(label, durationMs, details) {
      var duration = Math.min(durationMs || ACTION_LOCK_MAX_MS, ACTION_LOCK_MAX_MS);
      var record = {
        cohortCode: normalizeKey((details && details.cohortCode) || editingCohortCode || ''),
        label: label || 'Please wait',
        action: (details && details.action) || 'edit',
        lateBatchCode: (details && details.lateBatchCode) || '',
        expiresAt: Date.now() + duration
      };

      try {
        window.localStorage.setItem(ACTION_LOCK_KEY, JSON.stringify(record));
      } catch (error) {}

      return record;
    }

    function readActionLock() {
      var raw = null;

      try {
        raw = window.localStorage.getItem(ACTION_LOCK_KEY);
      } catch (error) {
        return null;
      }

      if (!raw) return null;

      var parsed = null;

      try {
        parsed = JSON.parse(raw);
      } catch (error) {
        clearActionLock();
        return null;
      }

      if (!parsed || !parsed.expiresAt || Date.now() >= parsed.expiresAt) {
        clearActionLock();
        return null;
      }

      return parsed;
    }

    function clearActionLock() {
      try {
        window.localStorage.removeItem(ACTION_LOCK_KEY);
      } catch (error) {}

      if (actionLockReleaseTimer) {
        window.clearTimeout(actionLockReleaseTimer);
        actionLockReleaseTimer = null;
      }

      if (actionLockPollTimer) {
        window.clearInterval(actionLockPollTimer);
        actionLockPollTimer = null;
      }
    }

    /*
      Whole-page block, not just the edit panel: the manage list behind it holds
      Finalize / Edit / Delete for every other cohort, and those write the same
      records from separate Mechanic tasks. While one write is in flight none of
      them may start. Mirrors setStatusPageBlocked in cohort-status.js.
    */
    function setAdminPageBlocked(active) {
      var wrap = document.querySelector('.cohort-admin-wrap');
      if (wrap) wrap.classList.toggle('is-page-blocked', !!active);
    }

    function beginPanelBlockingLoad(durationMs, labelText, lockDetails) {
      var duration = durationMs || PANEL_BLOCKING_ADD_MS;
      panelRingLabelText = labelText || 'Updating';
      panelBlockingMinUntil = Date.now() + duration;
      setEmailPanelLoading(true);
      var panel = document.getElementById('cohort-email-edit-panel');
      if (panel) panel.classList.add('is-blocking');
      setAdminPageBlocked(true);
      writeActionLock(panelRingLabelText, duration, lockDetails);
      startPanelLoadingProgress(duration);
      clearStaleEmailPanelStatuses();
    }

    function finishPanelBlockingLoad(force) {
      var panel = document.getElementById('cohort-email-edit-panel');

      function release() {
        /*
          Lock cleared here, not at the top: the visible block runs out its
          minimum duration on purpose and the Mechanic task is still writing
          during that tail, so clearing early would let a refresh in that window
          hand the buttons back too soon.
        */
        clearActionLock();
        setEmailPanelLoading(false);
        stopPanelLoadingProgress();
        if (panel) panel.classList.remove('is-blocking');
        setAdminPageBlocked(false);

        /*
          One last read straight after unblocking (2026-08-03). Without it the
          admin could be handed back a list that the retry ladder had not caught
          up with yet — the whole point of waiting out the block is to see the
          result, not to refresh the page by hand.
        */
        if (editingCohortCode) {
          backgroundSyncEmailPanel(editingCohortCode);
        } else {
          renderManageCohorts();
        }
      }

      /*
        2026-08-04 — the timer is only a MINIMUM now. pendingEmailMutation is the
        real signal: scheduleEmailPanelSync clears it once the server confirms.
        Confirmed early -> release early. Not confirmed when the timer ends ->
        keep holding rather than handing back a list we know is stale (a removed
        student used to stay on screen until a manual reload), up to a hard cap,
        then reload so the admin always ends up seeing the truth.
        Keep in step with finishStatusActionBlockingLoad in cohort-status.js.
      */
      function releaseWhenConfirmed() {
        stopPanelConfirmWatch();

        if (!pendingEmailMutation && !emailMutationUnconfirmed) {
          release();
          return;
        }

        if (!emailMutationUnconfirmed && Date.now() < panelConfirmCapAt) {
          panelConfirmTimer = window.setTimeout(releaseWhenConfirmed, 2000);
          return;
        }

        /* Clear the lock first so the reloaded page does not re-block itself.
           The open editor panel is restored from sessionStorage on load. */
        emailMutationUnconfirmed = false;
        clearActionLock();
        stopPanelLoadingProgress();
        allowNextUnload = true;
        window.location.reload();
      }

      if (!panelBlockingMinUntil) {
        stopPanelConfirmWatch();
        release();
        return;
      }

      var remaining = force ? 0 : (panelBlockingMinUntil - Date.now());
      panelBlockingMinUntil = 0;

      if (!panelConfirmCapAt) {
        panelConfirmCapAt = Date.now() + PANEL_CONFIRM_CAP_MS;
      }

      /* force means already confirmed, or the request failed outright. */
      if (force) {
        panelConfirmCapAt = 0;
        emailMutationUnconfirmed = false;
        stopPanelConfirmWatch();
        release();
        return;
      }

      if (remaining > 0) {
        panelConfirmTimer = window.setTimeout(releaseWhenConfirmed, remaining);
      } else {
        releaseWhenConfirmed();
      }
    }

    function stopPanelConfirmWatch() {
      if (panelConfirmTimer) {
        window.clearTimeout(panelConfirmTimer);
        panelConfirmTimer = null;
      }
    }

    /*
      Re-apply the block after a manual browser refresh (or in a second tab):
      if a live lock record is present the dashboard comes back up already
      blocked, with the ring showing the time left.
    */
    function restoreActionLockUi() {
      var lock = readActionLock();
      if (!lock) return;

      var remaining = lock.expiresAt - Date.now();
      if (remaining <= 0) {
        clearActionLock();
        return;
      }

      /*
        Nothing to wait for: the finalize already landed before this reload, so
        do not make the admin sit through a block for work that is done.
      */
      if (lock.action === 'finalize' && finalizeLooksComplete(findCohortByCode(lock.cohortCode))) {
        clearActionLock();
        return;
      }

      /*
        A reload during cohort creation almost certainly killed the POST before
        it reached Mechanic, so there is nothing left to wait for — blocking the
        page would only stop the admin from retrying. Tell them what to check
        instead. (beforeunload now asks first, so getting here means they
        deliberately confirmed the reload.)
      */
      if (lock.action === 'create') {
        clearActionLock();
        setMessage(
          'The page was reloaded while a cohort was still being created, so it may not have gone through. ' +
          'Check the cohort list below — if the new cohort is not there, nothing was created and it is safe to create it again.',
          'error'
        );
        return;
      }

      panelBlockingMinUntil = 0;
      panelRingLabelText = lock.label;
      setAdminPageBlocked(true);
      startPanelLoadingProgress(remaining);
      showAdminRingNote(ACTION_LOCK_RESUMED_NOTE);
      armActionLockWatchdog(lock, remaining);
    }

    /*
      Owns the two ways a lock ends: the hard expiry (so a hung or failed
      Mechanic task can never leave the page blocked forever) and, for finalize,
      an early exit once the cohort really reads as finalized — otherwise every
      finalize would sit out the full two minutes even when it took ten seconds.
    */
    function armActionLockWatchdog(lock, remaining) {
      if (actionLockReleaseTimer) window.clearTimeout(actionLockReleaseTimer);
      if (actionLockPollTimer) window.clearInterval(actionLockPollTimer);

      actionLockReleaseTimer = window.setTimeout(releaseRestoredActionLock, remaining);

      if (lock.action !== 'finalize') return;

      actionLockPollTimer = window.setInterval(function() {
        var code = lock.cohortCode;
        if (!code) return;

        backgroundSyncEmailPanel(code).then(function() {
          if (finalizeLooksComplete(findCohortByCode(code))) releaseRestoredActionLock();
        });
      }, 5000);
    }

    /*
      "The finalize run actually finished" — deliberately NOT isCohortFinalized(),
      which already returns true on finalize_lock === 'locked', i.e. while the run
      is still in progress. Releasing the block on that would defeat the whole
      point. Completion means the school draft order exists, or finalize_lock has
      flipped to 'complete' (written by cohort-capture-draft-order.liquid once the
      order is confirmed). If neither ever lands, the lock's own expiry still
      unblocks the page — this check only makes the common case faster.
      Keep in step with the same function in cohort-status.js.
    */
    function finalizeLooksComplete(cohort) {
      if (!cohort) return false;

      var draftOrderId = String(cohort.schoolDraftOrderId || '').trim();
      var finalizeLock = String(cohort.finalizeLock || '').toLowerCase();

      return !!(draftOrderId || finalizeLock === 'complete');
    }

    /*
      ── Waiting for a deletion to actually happen (2026-08-06) ────────────────

      Reported: press Delete, the overlay clears after about a second, the
      cohort is still there. Press again, same thing. Eventually it goes.

      The overlay was released in .finally(), which runs as soon as the webhook
      answers — and a webhook answers 200 the moment it accepts the request,
      long before Mechanic has deleted anything. So the page announced a
      finished deletion roughly a second into a job taking tens of seconds, and
      the admin, seeing the cohort still listed, quite reasonably pressed again.

      Now the block holds until the server stops listing the cohort. Deleting is
      irreversible, so the wait is worth more here than anywhere else: nothing
      is worse than being unsure whether a delete went through.

      Trusting an answer only when the fetched page was signed in matters
      doubly here — for an unrecognised viewer the access filter prints no
      cohorts at all, which would read as "deleted" for every cohort at once.
    */
    function waitForMs(ms) {
      return new Promise(function(resolve) { window.setTimeout(resolve, ms); });
    }

    function fetchAdminCohortsSnapshot() {
      var url = window.location.pathname + window.location.search;
      url += (url.indexOf('?') >= 0 ? '&' : '?') + '_sync=' + Date.now();

      return fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Accept': 'text/html' }
      })
        .then(function(response) { return response.text(); })
        .then(function(html) {
          return {
            signedIn: /COHORT_ADMIN_CUSTOMER_CONTEXT\s*=\s*\{[^}]*loggedIn:\s*true/.test(html),
            cohorts: extractWindowArrayFromHtml(html, 'COHORT_ADMIN_MY_COHORTS')
          };
        });
    }

    function waitForCohortGone(cohortCode) {
      var delays = [1500, 2500, 3500, 4500, 5000, 6000, 6000, 8000, 8000];
      var attempt = 0;
      var target = normalizeKey(cohortCode);

      function poll() {
        if (attempt >= delays.length) return Promise.resolve(false);

        var wait = delays[attempt];
        attempt += 1;

        return waitForMs(wait)
          .then(fetchAdminCohortsSnapshot)
          .then(function(snapshot) {
            /* Unreadable, or read as a stranger: says nothing either way. */
            if (!snapshot.signedIn || !Array.isArray(snapshot.cohorts)) return poll();

            var stillListed = snapshot.cohorts.some(function(entry) {
              return normalizeKey(entry && entry.cohortCode) === target;
            });

            return stillListed ? poll() : true;
          })
          .catch(function() { return poll(); });
      }

      return poll();
    }

    function releaseRestoredActionLock() {
      clearActionLock();
      stopPanelLoadingProgress();
      showAdminRingNote('');
      setAdminPageBlocked(false);
      renderManageCohorts();
    }

    /*
      A page reload aborts any request still in flight. Losing a cohort creation
      that way is exactly how the 2026-08-02 "no events in Mechanic at all" bug
      happened: the browser cancelled the POST before it reached Mechanic, so the
      task never ran and nothing was created. A live action lock means a write is
      still in the air, so make the browser ask before leaving.
      Keep in step with bindUnloadGuard in cohort-status.js.
    */
    function bindUnloadGuard() {
      window.addEventListener('beforeunload', function(event) {
        if (allowNextUnload) {
          allowNextUnload = false;
          return;
        }

        if (!readActionLock()) return;

        event.preventDefault();
        /* Legacy browsers need returnValue set; the text itself is browser-controlled. */
        event.returnValue = '';
        return '';
      });
    }

    function showAdminRingNote(text) {
      var noteEl = document.getElementById('cohort-email-edit-ring-note');
      if (!noteEl) return;

      noteEl.textContent = text || '';
      noteEl.style.display = text ? '' : 'none';
    }

    function getAddEmailsModalConfirmLabel(needsLateDeadline, loading) {
      if (loading) {
        return needsLateDeadline ? 'Adding late students...' : 'Sending invitations...';
      }
      return needsLateDeadline ? 'Add late students' : 'Send invitations';
    }

    function setAddEmailsDeadlineMin() {
      var input = document.getElementById('cohort-add-emails-late-deadline');
      if (!input) return;

      var today = new Date();
      var yyyy = today.getFullYear();
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var dd = String(today.getDate()).padStart(2, '0');
      input.min = yyyy + '-' + mm + '-' + dd;
    }

    function setAddEmailsModalLoading(active) {
      var modal = document.getElementById('cohort-add-emails-modal');
      var dialog = modal ? modal.querySelector('.finalize-modal') : null;
      var progress = document.getElementById('cohort-add-emails-modal-progress');
      var progressText = document.getElementById('cohort-add-emails-modal-progress-text');
      var confirmButton = document.getElementById('cohort-add-emails-modal-confirm');
      var cancelButton = document.getElementById('cohort-add-emails-modal-cancel');
      var cohort = findCohortByCode(editingCohortCode);
      var needsLateDeadline = needsLateDeadlineForNewEmails(cohort);

      if (dialog) {
        dialog.classList.toggle('is-sending', !!active);
      }

      if (progress) {
        progress.hidden = !active;
        progress.setAttribute('aria-hidden', active ? 'false' : 'true');
      }

      if (progressText) {
        progressText.hidden = !active;
        progressText.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) {
          progressText.textContent = needsLateDeadline ? 'Adding late students...' : 'Sending invitations...';
        }
      }

      if (confirmButton) {
        confirmButton.disabled = !!active;
        confirmButton.textContent = getAddEmailsModalConfirmLabel(needsLateDeadline, !!active);
      }

      if (cancelButton) {
        cancelButton.disabled = !!active;
      }
    }

    function clearEmailInviteLoading(force) {
      finishPanelBlockingLoad(force);
      setAddEmailsModalLoading(false);
      var confirmButton = document.getElementById('cohort-add-emails-modal-confirm');
      var cohort = findCohortByCode(editingCohortCode);
      var needsLateDeadline = needsLateDeadlineForNewEmails(cohort);
      if (confirmButton) {
        confirmButton.disabled = false;
        confirmButton.textContent = getAddEmailsModalConfirmLabel(needsLateDeadline, false);
      }
    }

    function setEmailRowLoading(row, active) {
      if (!row) return;
      row.classList.toggle('is-saving', !!active);
    }

    function persistStudentsToCache(cohortCode, students) {
      var normalized = normalizeKey(cohortCode);
      var cache = STATUS_CACHES.find(function(entry) {
        return normalizeKey(entry.cohortCode) === normalized;
      });

      if (cache) {
        cache.studentsJson = JSON.stringify(students || []);
      }

      rebuildCacheSummaryFromState(cohortCode);
    }

    function persistRosterToCohort(cohortCode, emails) {
      var cohort = findCohortByCode(cohortCode);
      if (!cohort) return;
      cohort.studentEmailsRaw = JSON.stringify(dedupeEmailList(emails || []));
      rebuildCacheSummaryFromState(cohortCode);
    }

    function rebuildCacheSummaryFromState(cohortCode) {
      var normalized = normalizeKey(cohortCode);
      var cache = STATUS_CACHES.find(function(entry) {
        return normalizeKey(entry.cohortCode) === normalized;
      });
      if (!cache) return;

      var cohort = findCohortByCode(cohortCode);
      var roster = getRosterEmailsOrdered(cohort);
      var students = dedupeStudentsByEmail(getStudentsForCohort(cohortCode));
      var submitted = students.filter(hasSubmittedSizes).length;
      var unmatched = students.filter(function(student) {
        return isUnmatchedStudent(student) && hasSubmittedSizes(student);
      }).length;
      var confirmed = students.filter(function(student) {
        return String(student.status || '').toLowerCase() === 'confirmed';
      }).length;
      var waiting = 0;

      roster.forEach(function(email) {
        var student = findStudentForRosterEmail(students, email);
        if (!student || !hasSubmittedSizes(student)) {
          waiting += 1;
        }
      });

      var summary = {
        total_students: Math.max(students.length, roster.length),
        submitted: submitted,
        confirmed: confirmed,
        pending: Math.max(waiting, students.length - submitted),
        unmatched: unmatched
      };

      cache.summaryJson = JSON.stringify(summary);
    }

    function beginEmailMutation(cohortCode, type, details) {
      pendingEmailMutation = {
        cohortCode: normalizeKey(cohortCode),
        type: type,
        details: details || {},
        startedAt: Date.now()
      };
    }

    /* Late batches out of a raw status-cache record, in whichever shape it holds. */
    function parseLateBatchesJson(cacheRecord) {
      if (!cacheRecord) return [];

      var raw = cacheRecord.lateBatchesJson;

      try {
        var parsed = Array.isArray(raw) ? raw : JSON.parse(raw || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    /*
      2026-08-06 — the apply overlay waits for the server to show the change,
      and when it does not, the page gives no clue which half is missing: the
      roster comes from the cohort record, the student list from the status
      cache, and those are written by two different Mechanic tasks. Every poll
      now says out loud what it was looking for and what it actually saw, so a
      hang can be read off the console instead of guessed at.
    */
    function logSettleDiagnostics(cohortCode, mutation, freshCohorts, freshCaches, pristineCohort, pristineCache, serverRoster, serverStudents) {
      if (!window.console || !console.info) return;

      var details = mutation.details || {};
      var wanted = []
        .concat((details.added || []).map(function(e) { return { email: e, need: 'added' }; }))
        .concat((details.removed || []).map(function(e) { return { email: e, need: 'removed' }; }))
        .concat((details.emails || []).map(function(e) { return { email: e, need: 'added' }; }))
        .concat(details.email ? [{ email: details.email, need: 'removed' }] : []);

      var report = wanted.map(function(item) {
        var inRoster = serverRoster.indexOf(String(item.email || '').trim().toLowerCase()) !== -1;
        var inStudents = !!findStudentForRosterEmail(serverStudents, item.email);
        var ok = item.need === 'added' ? (inRoster && inStudents) : (!inRoster && !inStudents);
        return (ok ? 'OK  ' : 'WAIT') + ' ' + item.need + ' ' + item.email +
          ' | roster:' + (inRoster ? 'yes' : 'no') + ' students:' + (inStudents ? 'yes' : 'no');
      });

      console.info(
        '[cohort] settle check — ' + mutation.type + ' on ' + (cohortCode || '(list)') + '\n' +
        '  cohorts from server: ' + (freshCohorts ? freshCohorts.length : 'COULD NOT READ') + '\n' +
        '  caches from server: ' + (freshCaches ? freshCaches.length : 'COULD NOT READ') + '\n' +
        '  this cohort found: ' + (pristineCohort ? 'yes' : 'NO') + ', its cache found: ' + (pristineCache ? 'yes' : 'NO') + '\n' +
        '  roster on server: ' + serverRoster.length + ' emails, students in cache: ' + serverStudents.length + '\n' +
        (report.length ? '  ' + report.join('\n  ') : '  (nothing specific to wait for)')
      );
    }

    function mutationLooksApplied(mutation, serverRoster, serverStudents, serverBatches) {
      if (!mutation) return true;

      var details = mutation.details || {};
      var roster = serverRoster || [];
      var students = serverStudents || [];

      /*
        A late round's only observable result is the late batch itself. When one
        is expected, wait for it; when an existing open batch is being reused the
        run only sends emails, and there is nothing in the data to wait for.
      */
      if (mutation.type === 'late_round') {
        if (!details.expectNewBatch) return true;

        return (serverBatches || []).some(function(batch) {
          return String(batch.status || '').toLowerCase() === 'open' &&
            String(batch.late_deadline || '').trim().slice(0, 10) === String(details.deadline || '').trim().slice(0, 10);
        });
      }

      function rosterHas(email) {
        return roster.indexOf(String(email || '').trim().toLowerCase()) !== -1;
      }

      function studentsHave(email) {
        return !!findStudentForRosterEmail(students, email);
      }

      if (mutation.type === 'remove') {
        return !rosterHas(details.email) && !studentsHave(details.email);
      }

      if (mutation.type === 'fix') {
        var current = String(details.current || '').trim().toLowerCase();
        var corrected = String(details.corrected || '').trim().toLowerCase();

        if (!rosterHas(corrected) || rosterHas(current)) {
          return false;
        }

        if (studentsHave(current)) {
          return false;
        }

        if (details.hadSubmittedStudent) {
          return students.some(function(student) {
            return String(student.email || '').trim().toLowerCase() === corrected && hasSubmittedSizes(student);
          });
        }

        return true;
      }

      if (mutation.type === 'add') {
        return (details.emails || []).every(function(email) {
          return rosterHas(email) && studentsHave(email);
        });
      }

      /*
        Batch Apply. Every part has to be visible on the server before the page
        is handed back — the roster comes from the cohort record and the student
        list from the status cache, and those two refresh at different speeds.
        Confirming on the roster alone is what used to leave a deleted student
        on screen until a manual reload.
      */
      if (mutation.type === 'apply') {
        var removalsDone = (details.removed || []).every(function(email) {
          return !rosterHas(email) && !studentsHave(email);
        });
        if (!removalsDone) return false;

        var editsDone = (details.edits || []).every(function(pair) {
          return rosterHas(pair.to) && !rosterHas(pair.from) && !studentsHave(pair.from);
        });
        if (!editsDone) return false;

        return (details.added || []).every(function(email) {
          return rosterHas(email) && studentsHave(email);
        });
      }

      return true;
    }

    function mergeEmailPanelServerData(freshCaches, freshCohorts, cohortCode) {
      if (!pendingEmailMutation || normalizeKey(pendingEmailMutation.cohortCode) !== normalizeKey(cohortCode)) {
        return { caches: freshCaches, cohorts: freshCohorts };
      }

      var localCache = STATUS_CACHES.find(function(entry) {
        return normalizeKey(entry.cohortCode) === normalizeKey(cohortCode);
      });
      var localCohort = findCohortByCode(cohortCode);
      var localRoster = getRosterEmailsOrdered(localCohort);
      var localStudents = getStudentsForCohort(cohortCode);

      var freshCache = (freshCaches || []).find(function(entry) {
        return normalizeKey(entry.cohortCode) === normalizeKey(cohortCode);
      });
      var freshCohort = (freshCohorts || []).find(function(entry) {
        return normalizeKey(entry.cohortCode) === normalizeKey(cohortCode);
      });

      var serverRoster = getRosterEmailsOrdered(freshCohort || {});
      var serverStudents = [];

      try {
        var rawStudents = freshCache && freshCache.studentsJson;
        serverStudents = dedupeStudentsByEmail(
          Array.isArray(rawStudents) ? rawStudents : JSON.parse(rawStudents || '[]')
        );
      } catch (error) {
        serverStudents = [];
      }

      if (!mutationLooksApplied(pendingEmailMutation, serverRoster, serverStudents, parseLateBatchesJson(freshCache))) {
        if (freshCache && localCache) {
          freshCache.studentsJson = localCache.studentsJson;
          freshCache.summaryJson = localCache.summaryJson;
        }
        if (freshCohort && localCohort) {
          freshCohort.studentEmailsRaw = localCohort.studentEmailsRaw;
        }
      }

      return { caches: freshCaches, cohorts: freshCohorts };
    }

    function scheduleEmailPanelSync(cohortCode, attempt) {
      if (emailPanelSyncTimer) {
        window.clearTimeout(emailPanelSyncTimer);
        emailPanelSyncTimer = null;
      }

      /*
        Ladder extended to ~45s (2026-08-03) and to ~110s (2026-08-05). A batch
        Apply can rewrite the roster, soft-delete entries, restore others, create
        new ones, hand renames to a second task and rebuild the cache; 45s ran
        out in the middle of that and handed the admin a list the server had not
        caught up with. The ceiling is the action lock's own two-minute life —
        holding longer than the lock would mean guarding a page nothing else
        considers busy any more.
      */
      /*
        2026-08-06 — same ~110s budget, spent in more, smaller steps.

        Measured on a real add-then-remove: the roster landed between the 13s
        and 21s polls, the rebuilt cache between 21s and 31s, and the removal
        somewhere between 31s and 43s. The work itself takes that long — two
        Mechanic tasks, the second triggered by an event from the first — but
        the old rungs grew to 15 and 18 seconds, so the page could sit blocked
        for a quarter of a minute after the server was already showing the
        answer. Most of the wait the admin saw was the gap, not the work.

        Nothing here is faster than Mechanic. It just stops missing the moment.
      */
      var delays = [
        1000, 2000, 3000, 3000, 3000, 3000, 4000, 4000, 4000, 4000,
        5000, 5000, 5000, 6000, 6000, 6000, 8000, 8000, 10000, 10000, 12000
      ];
      if (attempt >= delays.length) {
        /*
          Ladder ran out without the server ever confirming. Record that
          explicitly: pendingEmailMutation has to be cleared (otherwise idle
          sync stays paused forever), but the release path still needs to know
          the change was never verified so it reloads instead of showing a list
          it could not confirm.
        */
        emailMutationUnconfirmed = true;
        /*
          Say it out loud (2026-08-05). The release path reloads the page a
          moment later, and an unannounced reload reads as a crash rather than
          as the page catching up with a task that is still finishing.
        */
        setRosterPanelMessage(APPLY_STALE_MESSAGE, true);
        pendingEmailMutation = null;
        clearEmailInviteLoading();
        renderManageCohorts();
        return;
      }

      emailPanelSyncTimer = window.setTimeout(function() {
        backgroundSyncEmailPanel(cohortCode).then(function(settled) {
          if (!settled) {
            scheduleEmailPanelSync(cohortCode, attempt + 1);
            return;
          }

          pendingEmailMutation = null;
          /* Server confirmed — force so the block ends now instead of sitting
             out the rest of its minimum duration. */
          clearEmailInviteLoading(true);
          renderManageCohorts();
        });
      }, delays[attempt]);
    }

    /*
      ── Keeping the cohort list current (Этап 5, 2026-08-06) ──────────────────

      backgroundSyncEmailPanel already refetches this page and re-renders the
      list, but it only ran while a cohort's edit panel was open. Looking at the
      dashboard itself showed a frozen picture: sizes submitted since the page
      loaded, a cohort a colleague created, a finalize done on another machine —
      none of it appeared without a manual reload. That mattered little while a
      dashboard was one person's; now the access list gives a whole school the
      same page, it matters a lot.

      Fifteen seconds, not the status page's four: this refetch carries every
      cohort and every cache of the school, where the status page carries one
      cohort. The interval is the cheap knob to turn if it ever feels heavy.

      Every guard below answers the same question — could a refresh overwrite or
      interrupt something the admin is in the middle of? Editing, applying,
      creating, a modal, a lock held from another tab: all of them wait.
    */
    var DASHBOARD_IDLE_SYNC_MS = 15000;
    var dashboardIdleSyncInterval = null;

    function dashboardIdleSyncBlocked() {
      if (document.hidden) return true;
      /* The edit panel runs its own, tighter sync — two would fight. */
      if (editingCohortCode) return true;
      if (pendingEmailMutation) return true;
      if (isCreateFlowLoading()) return true;
      if (isFinalScreenActive()) return true;
      if (rosterEditMode) return true;
      if (readActionLock()) return true;
      if (document.querySelector('.cohort-email-modal-backdrop.is-open')) return true;

      /*
        2026-08-06 — the create wizard counts as "mid-action" too.

        Found by the owner within a day of the idle sync shipping: she got as
        far as step 2, the fifteen seconds ran out, and the whole form was
        replaced by the cohort list. The refresh itself was harmless — what did
        the damage was renderManageCohorts calling syncManagePanelVisibility,
        which switches the view back to the list whenever nothing is being
        edited. Filling in the create form was not on that list of "being
        edited", because before this sync existed nothing ever re-rendered
        underneath someone typing.

        isCreateFlowLoading() only covers the brief submitting state, so it
        could not have caught this: the wizard is open and idle for minutes.
      */
      if (isCreateWizardOpen()) return true;

      return false;
    }

    function isCreateWizardOpen() {
      var createPanel = document.getElementById('cohort-create-panel');
      return !!(createPanel && createPanel.style.display !== 'none');
    }

    function startDashboardIdleSync() {
      stopDashboardIdleSync();

      dashboardIdleSyncInterval = window.setInterval(function() {
        if (dashboardIdleSyncBlocked()) return;

        /*
          No cohort code: this is the list-level refresh, so there is no pending
          change to judge and nothing to hold the page for. Errors are swallowed
          — a failed background refresh must never surface as an admin-facing
          error, the next tick simply tries again.
        */
        backgroundSyncEmailPanel('').catch(function() {});
      }, DASHBOARD_IDLE_SYNC_MS);
    }

    function stopDashboardIdleSync() {
      if (dashboardIdleSyncInterval) {
        window.clearInterval(dashboardIdleSyncInterval);
        dashboardIdleSyncInterval = null;
      }
    }

    function startEmailPanelIdleSync(cohortCode) {
      stopEmailPanelIdleSync();

      emailPanelIdleSyncInterval = window.setInterval(function() {
        if (document.hidden || !editingCohortCode) return;
        if (normalizeKey(editingCohortCode) !== normalizeKey(cohortCode)) return;
        if (pendingEmailMutation) return;
        if (isEmailManagementDirty()) return;

        var editPanel = document.getElementById('cohort-email-edit-panel');
        if (!editPanel || editPanel.style.display === 'none') return;

        backgroundSyncEmailPanel(cohortCode);
      }, 4000);
    }

    function stopEmailPanelIdleSync() {
      if (emailPanelIdleSyncInterval) {
        window.clearInterval(emailPanelIdleSyncInterval);
        emailPanelIdleSyncInterval = null;
      }
    }

    function setEmailRowStatus(statusEl, message, isSuccess) {
      if (!statusEl) return;

      var row = statusEl.closest('.em-row');
      statusEl.textContent = message || '';
      statusEl.classList.toggle('is-success', !!isSuccess);
      if (row) {
        row.classList.toggle('has-status', !!String(message || '').trim());
      }

      window.requestAnimationFrame(function() {
        syncEmailRowHeights();
      });
    }

    /*
      2026-08-06 — holes and blanks are dropped before anyone reads the array.

      A Liquid array that emits both a leading and a trailing comma prints
      [{a},,{b}], which is legal JavaScript: an array with holes. The page runs,
      and every render path survives it because forEach/map/filter skip holes —
      but Array.prototype.find does not, so the settle check threw on
      entry.cohortCode, the catch turned that into "not settled yet", and the
      apply overlay hung until the stale timeout. A silent permanent wait is the
      worst failure this page has, so it does not get to happen twice: whatever
      the markup does, what comes back from here is a list of real objects.
    */
    function sanitizeParsedArray(parsed) {
      if (!Array.isArray(parsed)) return parsed;

      return parsed.filter(function(entry) {
        return !!entry && typeof entry === 'object';
      });
    }

    function extractWindowArrayFromHtml(html, varName) {
      var marker = 'window.' + varName + ' = ';
      var start = html.indexOf(marker);
      if (start === -1) return null;

      start += marker.length;
      if (html.charAt(start) !== '[') return null;

      var depth = 0;
      for (var i = start; i < html.length; i += 1) {
        if (html.charAt(i) === '[') depth += 1;
        if (html.charAt(i) === ']') {
          depth -= 1;
          if (depth === 0) {
            var literal = html.slice(start, i + 1);

            try {
              return sanitizeParsedArray(JSON.parse(literal));
            } catch (error) {
              /*
                Older deployed sections write these arrays with bare JavaScript
                keys (cohortCode: "..."), which JSON.parse cannot read — it threw
                every time and this helper returned null silently, so the
                background sync never saw fresh server data at all. The theme is
                deployed file by file, so the section may still be the old one;
                fall back to evaluating the literal, which is same-origin markup
                this very page already executed as script.
              */
              try {
                return sanitizeParsedArray((new Function('return (' + literal + ');'))());
              } catch (fallbackError) {
                if (window.console && console.warn) {
                  console.warn('[cohort] could not read ' + varName + ' from the synced page', fallbackError);
                }
                return null;
              }
            }
          }
        }
      }

      return null;
    }

    function backgroundSyncEmailPanel(cohortCode) {
      var syncUrl = window.location.pathname + window.location.search;
      var joiner = syncUrl.indexOf('?') >= 0 ? '&' : '?';
      syncUrl += joiner + '_sync=' + Date.now();

      /*
        2026-08-06 — ask for it the way a browser asks for a page.

        A bare fetch sends Accept: *​/*, which is not what a document request
        looks like, and leaves the response eligible for the HTTP cache. Both
        are plausible ways to be handed something other than this admin's
        freshly rendered page — and being handed the wrong page is what wiped
        the list. no-store also stops a stale copy being replayed after the
        cohort has changed.
      */
      return fetch(syncUrl, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Accept': 'text/html' }
      })
        .then(function(response) { return response.text(); })
        .then(function(html) {
          var freshCaches = extractWindowArrayFromHtml(html, 'COHORT_ADMIN_STATUS_CACHES');
          var freshCohorts = extractWindowArrayFromHtml(html, 'COHORT_ADMIN_MY_COHORTS');

          /*
            2026-08-05 — snapshot the server's answer BEFORE merging, and judge
            "has it applied yet?" against this snapshot only.

            mergeEmailPanelServerData deliberately paints the local optimistic
            values back over the fresh data while a change is still pending, so
            the list does not flicker. The settled check used to run AFTER that
            merge, on the merged globals — so it was reading our own guess and
            agreeing with itself. The block ended after a couple of seconds, the
            dashboard showed the student gone, and the status page still showed
            them because Mechanic had not finished. Exactly the class of bug this
            rework exists to remove: an optimistic guess acting as confirmation.
          */
          var pristineCohort = (freshCohorts || []).find(function(entry) {
            return normalizeKey(entry.cohortCode) === normalizeKey(cohortCode);
          });
          var pristineCache = (freshCaches || []).find(function(entry) {
            return normalizeKey(entry.cohortCode) === normalizeKey(cohortCode);
          });

          var serverRoster = getRosterEmailsOrdered(pristineCohort || {});
          var serverStudents = [];

          try {
            var rawServerStudents = pristineCache && pristineCache.studentsJson;
            serverStudents = dedupeStudentsByEmail(
              Array.isArray(rawServerStudents) ? rawServerStudents : JSON.parse(rawServerStudents || '[]')
            );
          } catch (error) {
            serverStudents = [];
          }

          /*
            2026-08-06 — an empty answer is not news that everything was deleted.

            Reported the day the idle sync shipped: a cohort with an open late
            round looked fine on load, then ~30s later its students vanished
            from the list and "Start late round" came back — because
            getOpenLateBatchInfo could no longer see the open batch. Pressing it
            opened a SECOND round and moved every pending student into it. A
            background refresh caused a real, hard-to-undo change to the data.

            The fetched page had come back with nothing in it. Whatever the
            reason — the request rendering without the customer session, so the
            access filter printed nothing for an unknown viewer, a partial
            response, a page served mid-deploy — the response says "I could not
            read this", and that must never be mistaken for "there is nothing
            there". We already hold data the server gave us; we keep it.

            Deliberately asymmetric: going from some to none is always treated
            as a failed read, while none to some is accepted normally, because
            an admin whose first cohort has just appeared must see it.
          */
          /*
            Corrected 2026-08-06, same day: the first version of this guard was
            too blunt and broke deleting a cohort.

            "Everything is gone" is a perfectly good answer when the admin has
            just deleted their only cohort — refusing it left the delete overlay
            waiting for a confirmation that could never arrive, and it only went
            away on a manual refresh.

            What separates a real emptiness from a failed read is whether the
            page we fetched knew who was looking: the access filter prints
            nothing for an unrecognised viewer, so a signed-out response is
            empty for a reason that has nothing to do with the data. The page
            already publishes that fact, so it is asked rather than guessed at.

            Signed in and empty  -> true, and accepted.
            Not signed in, empty -> a failed read, and the screen is kept.
          */
          var signedInMatch = html.match(/COHORT_ADMIN_CUSTOMER_CONTEXT\s*=\s*\{[^}]*loggedIn:\s*(true|false)/);
          var refreshWasSignedIn = !!signedInMatch && signedInMatch[1] === 'true';

          var cachesUsable = Array.isArray(freshCaches) && (freshCaches.length > 0 || STATUS_CACHES.length === 0 || refreshWasSignedIn);
          var cohortsUsable = Array.isArray(freshCohorts) && (freshCohorts.length > 0 || MY_COHORTS.length === 0 || refreshWasSignedIn);

          if (!cachesUsable || !cohortsUsable) {
            if (window.console && console.warn) {
              /*
                Say WHY, not just that. The access filter prints nothing for a
                viewer it does not recognise, so a background request that
                arrives without the customer session produces exactly this —
                two empty arrays — and would otherwise look identical to a
                shop that really is empty. The page already publishes whether
                it rendered signed in, so the fetched copy can be asked.
              */
              var reason = signedInMatch
                ? 'the refreshed page came back SIGNED OUT — the access filter printed nothing for an unrecognised viewer'
                : 'could not tell whether the refreshed page was signed in';

              console.warn(
                '[cohort] ignoring an empty background refresh — keeping what is on screen. ' +
                'cohorts: ' + (freshCohorts ? freshCohorts.length : 'unreadable') + ' (had ' + MY_COHORTS.length + '), ' +
                'caches: ' + (freshCaches ? freshCaches.length : 'unreadable') + ' (had ' + STATUS_CACHES.length + '). ' +
                reason
              );
            }

            /* Not settled: a read we refused to trust cannot confirm anything. */
            return false;
          }

          /*
            2026-08-11 — from here the round data is the server's, not the
            page's first paint. Only now may "Start late round" be offered.

            The button is the one control on this panel that creates something
            irreversible, and the note further up records what a stale answer
            already cost once: it reappeared after a refresh could not see the
            open batch, and pressing it opened a SECOND round and moved every
            pending student into it. Showing it a second late is free; showing
            it a second early is not.
          */
          lateRoundDataConfirmed = true;

          var merged = mergeEmailPanelServerData(freshCaches, freshCohorts, cohortCode);

          if (merged.caches) {
            STATUS_CACHES = merged.caches;
          }

          if (merged.cohorts) {
            MY_COHORTS = dedupeCohortsByCode(merged.cohorts).map(function(cohort) {
              return enrichCohortRecord(cohort);
            });
          }

          if (editingCohortCode && normalizeKey(editingCohortCode) === normalizeKey(cohortCode) && !isEmailManagementDirty()) {
            refreshEmailManagementUI(cohortCode);
          }

          renderManageCohorts();

          /*
            No usable answer from the server (page markup changed, parse failed,
            partial response) is not the same as "the change landed". Treat it as
            not settled so the block keeps holding rather than releasing on a
            page we could not actually read.
          */
          if (pendingEmailMutation && (!freshCohorts || !freshCaches)) {
            return false;
          }

          if (pendingEmailMutation) {
            logSettleDiagnostics(cohortCode, pendingEmailMutation, freshCohorts, freshCaches, pristineCohort, pristineCache, serverRoster, serverStudents);
          }

          if (pendingEmailMutation && !mutationLooksApplied(pendingEmailMutation, serverRoster, serverStudents, parseLateBatchesJson(pristineCache))) {
            return false;
          }

          return true;
        })
        .catch(function() {
          return false;
        });
    }

    function refreshEmailManagementUI(cohortCode) {
      renderEditRosterList(cohortCode);
      renderEditStudentsList(cohortCode);
      renderLateRoundSection(cohortCode);
      updateEmailMgmtStats(cohortCode);
      syncEmailRowHeights();
    }

    function syncEmailRowHeights() {
      var leftRows = document.querySelectorAll('#cohort-edit-roster-list .admin-edit-roster-row');
      var rightRows = document.querySelectorAll('#cohort-edit-approved-students-list .em-row');
      var count = Math.min(leftRows.length, rightRows.length);

      for (var i = 0; i < count; i++) {
        leftRows[i].style.minHeight = '';
        rightRows[i].style.minHeight = '';
      }

      for (var j = 0; j < count; j++) {
        var rightStatus = rightRows[j].querySelector('.em-row-status');
        var rightHasStatus = !!(rightStatus && String(rightStatus.textContent || '').trim());

        var height = Math.max(leftRows[j].offsetHeight, rightRows[j].offsetHeight);
        var px = height + 'px';
        leftRows[j].style.minHeight = px;
        rightRows[j].style.minHeight = px;

        if (rightHasStatus && rightRows[j].offsetHeight > height) {
          px = rightRows[j].offsetHeight + 'px';
          leftRows[j].style.minHeight = px;
          rightRows[j].style.minHeight = px;
        }
      }
    }

    function updateEmailMgmtStats(cohortCode) {
      var cohort = findCohortByCode(cohortCode);
      var rosterEmails = getEditPanelRosterEmails(cohortCode);
      var students = dedupeStudentsByEmail(getStudentsForCohort(cohortCode));
      /*
        2026-08-11 — the same walk renderEditStudentsList does, so a tile can
        never disagree with the list under it. Invite lines first, then the
        students that walk cannot reach; a student collecting answers in an open
        round is counted in that round, not here.

        In a round, rosterEmails is already that round's membership, so the same
        walk counts it correctly — the previous version simply called every
        member "waiting", which stopped being true as soon as one submitted.
      */
      var confirmed = 0;
      var waiting = 0;
      var awaitingPayment = 0;
      var confirmedUnmatched = 0;
      var counted = {};

      /*
        Phase 8 (2026-08-12) — a form that is in is no longer the same as a
        student the school can be billed for. Counting them together read as
        "Confirmed 5" for a cohort where four still owed a delivery payment,
        which is the number an admin would have finalized on. The status page
        separated them first; this follows it.
      */
      function tallyStudent(student) {
        if (student && isAwaitingPaymentStudent(student)) {
          awaitingPayment += 1;
        } else if (student && hasSubmittedSizes(student)) {
          confirmed += 1;
          if (isUnmatchedStudent(student)) confirmedUnmatched += 1;
        } else {
          waiting += 1;
        }
      }

      rosterEmails.forEach(function(email) {
        var student = findStudentForRosterEmail(students, email);

        if (student) {
          studentIdentityEmails(student).forEach(function(identity) {
            counted[identity] = true;
          });
        }

        if (!isEditingLateStudentsTrack() && student && isOpenRoundStudent(cohort, student)) return;

        tallyStudent(student);
      });

      if (!isEditingLateStudentsTrack()) {
        students.forEach(function(student) {
          if (isRemovedStudent(student)) return;
          if (isOpenRoundStudent(cohort, student)) return;

          var alreadyCounted = studentIdentityEmails(student).some(function(identity) {
            return counted[identity];
          });
          if (alreadyCounted) return;
          if (!getStudentIdentityEmail(student)) return;

          tallyStudent(student);
        });
      }

      var unmatched = confirmedUnmatched;

      /*
        2026-08-11, owner's model — these tiles describe THIS BLOCK, not the
        whole cohort. The status page answers the cohort-wide question; here,
        the main cohort and each round count their own people, so the number
        always matches the list directly beneath it.

        That is also why the upload count is no longer shown next to the total
        once a round exists: the main block is then a subset, and putting the
        cohort's upload beside a block's total invited exactly the comparison
        that does not hold. Reported as "3, 5 uploaded" against 5 on the status
        page.
      */
      var uploadedCount = getRosterEmailsOrdered(cohort).length;
      /* Awaiting payment joins the total: they are in this block, they simply
         are not billable yet. Leaving them out would make the tiles stop
         adding up to the list underneath. */
      var totalStudents = isEditingLateStudentsTrack() ? rosterEmails.length : confirmed + awaitingPayment + waiting;

      [
        ['cohort-edit-stat-uploaded', totalStudents],
        ['cohort-edit-stat-confirmed', confirmed],
        ['cohort-edit-stat-awaiting', awaitingPayment],
        ['cohort-edit-stat-waiting', waiting]
      ].forEach(function(pair) {
        var el = document.getElementById(pair[0]);
        if (el) el.textContent = String(pair[1]);
      });

      /* Hidden where nobody pays for delivery — a tile reading zero on every
         school-delivery cohort is noise, not information. */
      var awaitingWrap = document.getElementById('cohort-edit-stat-awaiting-wrap');
      if (awaitingWrap) {
        awaitingWrap.style.display = awaitingPayment > 0 ? '' : 'none';
      }

      var uploadedNote = document.getElementById('cohort-edit-stat-uploaded-note');
      if (uploadedNote) {
        var blockIsWholeCohort = !isEditingLateStudentsTrack() && !isCohortFinalized(cohort);

        /* 2026-10-09 (design 9B) - said as a sentence: who came from the
           school's list and who joined by the shared link. */
        var joinedByLink = totalStudents - uploadedCount;
        uploadedNote.textContent = (blockIsWholeCohort && joinedByLink > 0)
          ? uploadedCount + ' from your list · ' + joinedByLink + ' joined by link'
          : (blockIsWholeCohort ? 'From your list' : '');
      }

      /* Confirmed, with the outside-list share under it rather than beside it:
         those students are part of this number, not an alternative to it. */
      var confirmedNote = document.getElementById('cohort-edit-stat-confirmed-note');
      if (confirmedNote) {
        /* 2026-10-09 (design 9B) - what "confirmed" means here first; the
           outside-list share follows only when there is one. */
        var confirmedMeaning = cohortPaysForDelivery(cohort) === true ? 'Paid for delivery' : 'Form submitted';
        confirmedNote.textContent = confirmedMeaning +
          (unmatched > 0 ? ' · ' + unmatched + ' not on your list' : '');
      }
    }

    function applyOptimisticRemove(cohortCode, email) {
      var normalized = String(email || '').trim().toLowerCase();
      var students = getStudentsForCohort(cohortCode).filter(function(student) {
        return String(student.email || '').trim().toLowerCase() !== normalized;
      });
      var roster = getRosterEmailsOrdered(findCohortByCode(cohortCode)).filter(function(item) {
        return item !== normalized;
      });

      persistStudentsToCache(cohortCode, students);
      persistRosterToCohort(cohortCode, roster);
    }

    function applyOptimisticAddEmails(cohortCode, emails) {
      var cohort = findCohortByCode(cohortCode);
      var roster = getRosterEmailsOrdered(cohort).slice();
      var students = getStudentsForCohort(cohortCode).slice();
      var lateBatchCodeForAdd = isEditingLateStudentsTrack() ? (editingLateBatchCode || '') : '';

      (emails || []).forEach(function(rawEmail) {
        var email = String(rawEmail || '').trim().toLowerCase();
        if (!email || roster.indexOf(email) !== -1) return;

        roster.push(email);

        if (!findStudentForRosterEmail(students, email)) {
          students.push({
            email: email,
            status: 'pending',
            email_match_status: 'matched',
            roster_email: email,
            first_name: '',
            last_name: '',
            student_id: '',
            late_batch_code: lateBatchCodeForAdd
          });
        }
      });

      persistStudentsToCache(cohortCode, students);
      persistRosterToCohort(cohortCode, roster);
    }

    function finishEmailPanelMutation(cohortCode, focusEmail) {
      refreshEmailManagementUI(cohortCode);
      renderManageCohorts();

      if (!pendingEmailMutation) {
        finishPanelBlockingLoad();
      } else {
        setEmailPanelLoading(true);
      }

      if (focusEmail) {
        var selector = '[data-current-email="' + String(focusEmail).replace(/"/g, '\\"') + '"]';
        var target = document.querySelector(selector);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      scheduleEmailPanelSync(cohortCode, 0);
    }

    function updateEditRosterCount(cohort) {
      var countEl = document.getElementById('cohort-edit-roster-count');
      if (!countEl) return;
      var emails = getRosterEmailsOrdered(cohort || findCohortByCode(editingCohortCode));
      countEl.textContent = String(emails.length);
    }

    function renderEditRosterList(cohortCode) {
      var list = document.getElementById('cohort-edit-roster-list');
      if (!list) return;

      var cohort = findCohortByCode(cohortCode);
      var rosterEmails = getEditPanelRosterEmails(cohortCode);
      var students = dedupeStudentsByEmail(getStudentsForCohort(cohortCode));

      if (!rosterEmails.length) {
        list.innerHTML = '<p class="admin-edit-empty-note">' +
          (isEditingLateStudentsTrack() ? 'No late students.' : 'No emails yet.') +
          '</p>';
        updateEditRosterCount(cohort);
        updateEmailMgmtStats(cohortCode);
        return;
      }

      list.innerHTML = rosterEmails.map(function(email, index) {
        var student = findStudentForRosterEmail(students, email);
        var submitted = student ? hasSubmittedSizes(student) : false;
        var rowClass = submitted ? 'is-confirmed' : 'is-pending';
        var fullName = student
          ? [student.first_name || '', student.last_name || ''].join(' ').trim()
          : '';
        var titleText = fullName ? (email + ' · ' + fullName) : email;

        return (
          '<div class="admin-edit-roster-row ' + rowClass + '" data-roster-email="' + esc(email) + '">' +
            '<span class="admin-edit-roster-num">' + String(index + 1) + '</span>' +
            '<p class="admin-edit-roster-email" title="' + esc(titleText) + '">' + esc(email) + '</p>' +
          '</div>'
        );
      }).join('');

      updateEditRosterCount(cohort);
      updateEmailMgmtStats(cohortCode);
    }

    /*
      2026-08-06 — the row's colour, decided from the student rather than from
      which list is drawing them.

      The badge inside renderCompactEmailRow has always read the student, so it
      said "outside list" correctly. The row class did not: every caller passed
      a literal, and two of them passed "is-confirmed" for anyone who had
      submitted. Before finalization that was invisible, because an outside-list
      student was only ever drawn by the block that passes "is-unmatched". After
      finalization the "Already in the school order" block draws them too — and
      painted them plain green, so a student the admin needs to look at became
      indistinguishable from one they do not.

      The status page had it right all along, which is what made this findable:
      the same student showed there as not on the approved list.
    */
    /*
      2026-08-17 — money gets its own row state (owner).

      A confirmed student who has paid and one who has not looked identical:
      both green, both "Confirmed", the money mentioned only in a small grey
      chip further down. Those are the two rows an admin treats differently —
      one is finished, the other has to be chased — so they are now told apart
      by the row itself, not by squinting at a chip.

      is-unmatched still wins: being on nobody's list is the thing that has to
      be fixed before anything else about that row means anything.
    */
    /*
      ── 2026-08-18 — «вне списка» перестало вытеснять состояние (владелица) ──

      Раньше первая же строка возвращала is-unmatched и обрывала проверку.
      Студент, который заполнил форму и заплатил, но пришёл не из списка,
      терял и зелёный, и признак оплаты — на экране он выглядел бледнее
      всех, хотя сделал больше многих.

      Теперь состояние считается всегда, а «вне списка» добавляется к нему.
      Строка говорит две вещи сразу: подтверждён и оплатил — и при этом его
      нет в списке школы.
    */
    function getStudentRowStateClass(student, submitted) {
      var outside = student && isUnmatchedStudent(student) ? ' is-unmatched' : '';

      if (!submitted) return 'is-pending' + outside;
      if (isAwaitingPaymentStudent(student)) return 'is-confirmed is-unpaid' + outside;
      if (isPaidStudent(student)) return 'is-confirmed is-paid' + outside;

      return 'is-confirmed' + outside;
    }

    function renderCompactEmailRow(options) {
      var cohort = findCohortByCode(options.cohortCode);
      var student = options.student || null;
      var email = String(options.email || '').trim().toLowerCase();
      var editable = options.editable !== false && canEditStudentEmail(cohort, student || { email: email, status: student ? student.status : 'pending' });
      var removable = options.removable !== false && canEditStudentEmail(cohort, student || { email: email, status: student ? student.status : 'pending' });

      if (editingCohortFinalized && student && !canEditStudentEmail(cohort, student)) {
        editable = false;
        removable = false;
      }

      /*
        Draft controls (2026-08-05). No per-row Save/× any more — a checkbox
        stages a removal and the input stages a rename, and nothing leaves the
        browser until Apply. See the row-state matrix in
        docs/roster-editing-rework-plan.md.
      */
      var submitted = !!(student && hasSubmittedSizes(student));
      var markedForRemoval = isMarkedForRemoval(email);
      /*
        2026-08-10 (owner decision: "the student mistyped") — which address the
        edit box carries.

        Normally the row is labelled with the invite line and that is also the
        student's address, so there is nothing to choose. For an outside-list
        student the two differ: the row is labelled with the address they were
        invited on, while the wrong one — the one the admin wants to correct —
        is the address they typed. Editing the row therefore renamed the
        INVITATION and left the student's own address untouched, which is the
        opposite of the intent and left the admin with no way out at all.

        Keying the box on the student's own address makes the whole chain do
        the right thing without further changes: the typed address is on no
        invite line, so buildFinalRosterEmails leaves the roster alone, and
        Cohort: Fix Student Email finds the entry by it and keeps roster_email.
        The invitation survives, the student's address is corrected.

        The row keeps its own label as the removal key — removing such a
        student still has to take their invite line with them.
      */
      var editKey = email;
      if (student && isUnmatchedStudent(student)) {
        editKey = getStudentIdentityEmail(student) || email;
      }

      var pendingEdit = getDraftEdit(editKey);

      var badgeLabel = submitted ? 'Confirmed' : 'Waiting';
      var badgeClass = submitted ? 'is-confirmed' : 'is-waiting';

      /*
        2026-08-06 — say it on the row itself. De-duplicating the two lists put
        these students in the approved list and out of the "Outside list" block,
        which fixed the double entry but took away the only thing that said they
        had submitted with an address the admin never uploaded. The fact belongs
        to the student, not to which box they happen to be drawn in.
      */
      var outsideList = !!(student && isUnmatchedStudent(student));

      /*
        Phase 8 (2026-08-12, owner) — money on the row.

        "Confirmed" told the admin the sizes were in and stopped there, so a
        student who still owed a delivery payment looked exactly like one who
        had paid. Those are the two states an admin acts on differently: one
        gets chased, the other gets invoiced to the school.
      */
      var awaitingPayment = !!(student && isAwaitingPaymentStudent(student));
      var paid = !!(student && isPaidStudent(student));

      if (awaitingPayment) {
        badgeLabel = 'Not paid yet';
        badgeClass = 'is-awaiting-payment';
      } else if (paid) {
        badgeLabel = 'Paid';
        badgeClass = 'is-paid';
      }

      /*
        ── 2026-08-19 — состояние и примечание разъехались (владелица) ──────

        Три захода подряд я красила строку, и владелице всё не нравилось. Она
        была права, а ошибка была в самой мысли: красный на строке читается
        как «с этим студентом что-то не так». Студент же всё сделал —
        заполнил, заплатил. Вопрос к СПИСКУ ШКОЛЫ, а не к нему.

        Значит «не из списка» — не состояние строки, а примечание к ней.
        Состояние красят цветом, примечание пишут словами.

        Поэтому строка целиком выглядит как обычная подтверждённая, а рядом
        встаёт вторая таблетка со словами. Янтарная — тем же янтарным, что и
        третий блок на складе, где он уже означает «подтверждён, но придержи
        до решения». Тот же смысл, тот же цвет: два экрана начинают говорить
        на одном языке.
      */
      /*
        ── 2026-08-27 — «Not on approved list» переехало вниз (владелица) ────

        Раньше это была плашка справа в строке студента. Плашка умела только
        сообщить факт, а действовать с ней было нечем: чтобы добавить студента
        в список, приходилось идти в список почт и вписывать адрес руками.

        Теперь факт и действие лежат вместе, отдельным блоком под строкой, и
        плашка убрана — иначе одно и то же было бы сказано дважды в одной
        строке. Пустая строка ниже оставлена намеренно: две точки вывода этой
        плашки (обе ниже по файлу) продолжают работать, просто печатать им
        больше нечего.
      */
      var outsideNote = '';

      if (markedForRemoval) {
        badgeLabel = 'Will be removed';
        badgeClass = 'is-removing';
      } else if (pendingEdit) {
        badgeLabel = 'Email will change';
        badgeClass = 'is-editing';
      } else if (!removable && submitted && editingCohortFinalized) {
        /* Keep the outside-list fact: being in the school order and never
           having been on the approved list are both true, and the second is
           the one the admin needs to act on. */
        if (awaitingPayment) {
          /*
            2026-08-17 — and this student is NOT in the school order.

            This line used to say they were, because a finalized cohort and a
            submitted form were taken to mean billed. They are not:
            awaiting_payment is in none of the billable status lists at
            finalization, so the school paid nothing for them. Saying "in
            school order" told the admin the money was settled when it was not,
            and the badge is exactly where they look to decide whether to chase.

            badgeClass is left as it was set above — amber, not green — so the
            colour and the words now agree.
          */
          badgeLabel = outsideList
            ? 'Confirmed · not paid yet · outside list'
            : 'Confirmed · not paid yet';
        } else {
          badgeLabel = outsideList ? 'In school order · outside list' : 'Confirmed · in school order';
        }
      }

      /*
        2026-08-17 — the same correction as the badge, in the sentence under it.

        A student who owes postage is locked out of editing for the same reason
        as everyone else in a finalized cohort, but they are NOT part of the
        school order, and saying so told an admin the money was settled. Said
        once here because the row draws this line from two places.
      */
      /*
        2026-08-17 — three states, not one sentence.

        This line claimed "already confirmed and part of the school order" for
        every locked row. Wrong twice over on a finalized cohort: a student who
        owes postage was never billed, and a student in the Waiting group never
        submitted at all — that one was being told they were in an order while
        sitting under the heading "Invited, but no sizes submitted yet".
      */
      var lockedRowReason;

      if (!submitted) {
        lockedRowReason = 'This cohort is closed, so nothing here can be changed. They can still be given a new deadline by starting a late round.';
      } else if (awaitingPayment) {
        lockedRowReason = 'Already confirmed, but their delivery is not paid for, so they are not in the school order. This row can no longer be changed here.';
      } else {
        lockedRowReason = 'Already confirmed and part of the school order, so this student can no longer be changed here.';
      }

      var fullName = student
        ? [student.first_name || '', student.last_name || ''].join(' ').trim()
        : '';

      /*
        2026-08-07 (owner request) — both addresses on the row.

        A student who submitted with an address the admin never uploaded has
        two: the one their invitation and personal link were built on, and the
        one they typed into the form. The row is labelled with whichever the
        list it sits in walks by, so the other one was visible nowhere. The
        "outside list" badge said something had diverged without ever saying
        into what, which left the admin unable to judge whether it was a typo
        or a different person.

        Only for outside-list students: everyone else has one address, and a
        second line under every row would be noise.
      */
      var invitedEmail = String((student && student.roster_email) || '').trim().toLowerCase();
      var submittedEmail = String((student && (student.submitted_email || student.email)) || '').trim().toLowerCase();
      var rowDetails = [];

      /*
        2026-08-11, phase 6 — the campus this student chose, on their row.

        Derived from their items rather than stored: the cache already carries
        them, so nothing had to change in Mechanic and there is no second copy
        to fall out of step with the sizes. Blank until they submit, which is
        the truth — a student who has not answered has not chosen one.
      */
      /*
        2026-10-09 (owner, design 1a) - the campus is a chip in its own column.
        The Paid / Not paid yet chips that stood beside it are gone: the status
        pill at the end of the same row says the same thing.
      */
      var campusName = getStudentCampusName(student);
      var tagsHtml =
        '<span class="em-row-tags">' +
          (campusName
            ? '<span class="em-row-campus">' +
                '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 21s7-6.2 7-11.5A7 7 0 0 0 5 9.5C5 14.8 12 21 12 21z" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="9.5" r="2.5" stroke="currentColor" stroke-width="2"/></svg>' +
                esc(campusName) +
              '</span>'
            : '') +
        '</span>';

      /* Initials in a circle, as in 1a; "?" until the student gives a name. */
      var initials = String(fullName || '').trim().split(/\s+/).filter(Boolean).slice(0, 2)
        .map(function(word) { return word.charAt(0); }).join('').toUpperCase();
      /* 2026-10-09 (owner, version 3) - a drawn question mark, larger than the
         typed one, for a student who has not given a name. */
      var avatarHtml = '<span class="em-row-avatar" aria-hidden="true">' +
        (initials ? esc(initials) : '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 9.4a3 3 0 1 1 4.3 2.7c-.9.4-1.3 1-1.3 1.9" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/><circle cx="12" cy="17.7" r="1.5" fill="currentColor"/></svg>') + '</span>';

      if (student && isUnmatchedStudent(student)) {
        if (submittedEmail && submittedEmail !== email) {
          rowDetails.push('Submitted as <strong>' + esc(submittedEmail) + '</strong>');
        } else if (invitedEmail && invitedEmail !== email) {
          rowDetails.push('Invited as <strong>' + esc(invitedEmail) + '</strong>');
        }
      }

      var altEmailHtml = rowDetails.length
        ? '<p class="em-row-alt-email">' + rowDetails.join('<span class="em-row-detail-sep">·</span>') + '</p>'
        : '';

      /*
        Exactly one control per row, chosen by the active mode. Outside a mode
        the row is pure information — which is what makes the staged red and
        lavender marks readable instead of competing with live inputs.
      */
      /*
        2026-08-17 — the same correction as in getSelectableEmails, and the
        row's own half of it.

        Two places decide who may be ticked: that function builds the list for
        Select all, this line draws the individual box. Fixing one without the
        other gives a cohort where Select all reaches a student no box exists
        for. A student who owes for delivery is remindable — that is the whole
        point of the button next door.
      */
      var remindable = !markedForRemoval &&
        (!submitted || isAwaitingPaymentStudent(student));
      /*
        ── 2026-08-17 — a debtor has a button, not a tick (owner) ──────────

        Their letter carries a link built for that one student, so "select
        several and press once" was never really available: the automatic path
        can do it, the manual one cannot, and a screen that offers ticks has
        already promised both.

        A button on the row removes the promise instead of explaining it away.
        It also has somewhere to say when the last attempt was, which a tick
        does not — and that is the answer to the question an admin asks next.
      */
      var showCheckbox = rosterEditMode === 'remind' &&
        (reminderAudience === 'form' || reminderAudience === 'pay') && remindable;
      var showRemoveButton = rosterEditMode === 'remove' && removable;
      var showEmailInput = rosterEditMode === 'edit' && editable && !markedForRemoval;

      var leadHtml = '<span class="em-row-check-spacer" aria-hidden="true"></span>';

      if (showCheckbox) {
        leadHtml =
          '<label class="em-row-check"><input type="checkbox" class="em-row-select"' +
          (isSelected(email) ? ' checked' : '') +
          ' aria-label="Select ' + esc(email) + '"></label>';
      } else if (showRemoveButton) {
        /* SVG rather than × and ↺ glyphs: the arrow in particular is missing
           from the Windows font stack and rendered as a blank box. */
        leadHtml = markedForRemoval
          ? '<button type="button" class="em-row-remove is-undo" data-remove-email="' + esc(email) + '" aria-label="Keep ' + esc(email) + '">' +
              '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M4.4 9.2a5.8 5.8 0 1 1 1.5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path><path d="M3.1 5.1v4.3h4.3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
            '</button>'
          : '<button type="button" class="em-row-remove" data-remove-email="' + esc(email) + '" aria-label="Remove ' + esc(email) + '">' +
              '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M6.4 6.4l7.2 7.2M13.6 6.4l-7.2 7.2" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round"></path></svg>' +
            '</button>';
      }

      var toolsHtml =
        '<div class="em-row-tools">' +
          leadHtml +
          avatarHtml +
          '<span class="em-row-who">' +
          '<input type="text" class="em-row-name-input" value="' + esc(fullName) + '" placeholder="Name not submitted" readonly tabindex="-1" aria-label="Student name, read only">' +
          (showEmailInput
            ? '<span class="em-row-field">' +
                '<input type="email" class="em-row-input" value="' + esc(pendingEdit || editKey) + '" data-current-email="' + esc(editKey) + '" placeholder="student@school.edu" aria-label="Edit email for ' + esc(editKey) + '">' +
                '<svg class="em-row-field-icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
                  '<path d="M11.2 2.3a1.4 1.4 0 0 1 2 2l-7 7-2.7.7.7-2.7 7-7Z" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"></path>' +
                '</svg>' +
              '</span>'
            : '<span class="em-row-email-static">' + esc(pendingEdit || email) + '</span>') +
          '</span>' +
          tagsHtml +
          '<span class="em-row-badge ' + badgeClass + '">' + esc(badgeLabel) + '</span>' +
          /* Примечание отдельной таблеткой, а не припиской к состоянию. */
          (outsideNote ? '<span class="em-row-note">' + esc(outsideNote) + '</span>' : '') +
          /*
            2026-08-19 — the controls travel together (owner, screenshot 51).

            They were four separate children of the row, so when the row ran out
            of width the last two broke away on their own and landed hard against
            the left edge, under the student's name — reading as though the Note
            button belonged to nothing.

            As one group they wrap as one, and stay where actions belong.
          */
          '<span class="em-row-actions">' +
            rowNoteButtonHtml(student, email) +
            renderSizesTip(student) +
          '</span>' +
        '</div>' +
        (removable
          ? ''
          : '<p class="em-row-reason">' + lockedRowReason + '</p>');

      /*
        2026-08-13, owner — a row that can no longer be edited still has to say
        who it is.

        Once a cohort is finalized a confirmed student is neither editable nor
        removable, and this branch drew the email and nothing else: no name, no
        badge, no reason note. The admin's own words — the name is visible only
        while the student can still be edited, which is the moment it matters
        least.

        Two things computed above turned out to be drawn nowhere because of it.
        badgeLabel has a branch written for exactly this case
        ("Confirmed · in school order", and the outside-list variant that an
        admin has to act on), and the reason note explains why the row has no
        controls. Both live in toolsHtml, which this branch never used, so both
        were dead. They are drawn here now.

        The ID joins them, as asked. It is not added to the editable row: that
        row is a tight flex line whose layout took four attempts to settle (see
        the notes in cohort-admin-form.css), and one more item on it is how that
        gets reopened.
      */
      var studentIdText = String((student && student.student_id) || '').trim();
      var readOnlyMetaHtml = '';

      if (studentIdText || badgeLabel) {
        readOnlyMetaHtml =
          '<span class="em-row-static-meta">' +
            (studentIdText ? '<span class="em-row-id">ID ' + esc(studentIdText) + '</span>' : '') +
            (badgeLabel ? '<span class="em-row-badge ' + badgeClass + '">' + esc(badgeLabel) + '</span>' : '') +
            (outsideNote ? '<span class="em-row-note">' + esc(outsideNote) + '</span>' : '') +
            /* 2026-10-09 (owner) - why the row is locked, as a hint, so the
               row keeps the open cohort's layout. */
            adminInfoTipHtml(lockedRowReason) +
          '</span>';
      } else {
        readOnlyMetaHtml = '<span class="em-row-static-meta">' + adminInfoTipHtml(lockedRowReason) + '</span>';
      }

      var readOnlyMainHtml =
        '<div class="em-row-main">' +
          avatarHtml +
          '<span class="em-row-who">' +
            '<span class="em-row-name-static' + (fullName ? '' : ' is-missing') + '">' +
              esc(fullName || 'Name not submitted') +
            '</span>' +
            '<span class="em-row-email">' + esc(email) + '</span>' +
          '</span>' +
          tagsHtml +
          readOnlyMetaHtml +
        '</div>';

      var rowClassName = 'em-row ' + esc(options.stateClass || '');
      if (editable || removable) {
        rowClassName += ' is-editable';
      }
      if (markedForRemoval) rowClassName += ' is-marked-removed';
      if (pendingEdit) rowClassName += ' is-marked-edited';

      /*
        ── Блок «вне списка» ─────────────────────────────────────────────────

        Слева — сам факт, красным. Справа — единственное действие, которое из
        него следует.

        Кнопка добавляет адрес студента в список почт когорты, и это не
        косметика: страница считает студента «вне списка» по полю
        email_match_status, а его пересчитывает задача Cohort: Update Roster
        Emails по одному правилу — есть ли отправленный студентом адрес в
        списке почт. Поэтому поправить поле руками бесполезно, оно вернётся;
        добавить адрес в список — единственный способ, который держится.

        Адрес берётся тот же, что строка использует как ключ правки: у студента
        вне списка это адрес, который он сам вписал в форму, и именно его
        сверяет правило.

        Письма не будет. Задача умеет молчать (skip_notification), и здесь это
        обязательно: студент уже заполнил форму, звать его заполнить её ещё раз
        значит сказать ему, что его работа не дошла.
      */
      var outsideBlockHtml = '';

      if (outsideList) {
        var addToListEmail = getStudentIdentityEmail(student) || email;

        outsideBlockHtml =
          '<div class="em-row-outside">' +
            '<span class="em-row-outside-text">' +
              '<strong>Not on approved list</strong>' +
              '<span>This student is not on the list the school gave us.</span>' +
            '</span>' +
            '<button type="button" class="em-row-outside-btn"' +
              ' data-add-to-list="' + esc(addToListEmail) + '">' +
              'Add to cohort list' +
            '</button>' +
          '</div>';
      }

      var showResendNotice = !!pendingEmailFixNotices[email] && !(student && hasSubmittedSizes(student));
      /* 2026-10-09 (owner) - with Email students on, the form now goes to the
         new address by itself (Cohort: Fix Student Email); the reminder to
         resend is only for a cohort where letters are off. */
      var noticeCohort = findCohortByCode(editingCohortCode);
      var lettersOn = isSwitchOn(noticeCohort && noticeCohort.sendStudentEmails !== undefined ? noticeCohort.sendStudentEmails : 'true');
      var resendNoticeHtml = showResendNotice
        ? '<p class="em-row-resend-notice">' + (lettersOn
            ? 'Email updated — the form link is on its way to the new address.'
            : 'Email updated — Email students is off, so no email went out. Select the student and press Send reminders to send the form to the new address.') + '</p>'
        : '';

      return (
        '<article class="' + rowClassName + '" data-current-email="' + esc(email) + '">' +
          '<span class="em-row-num">' + (options.number < 10 ? '0' : '') + String(options.number) + '</span>' +
          (editable || removable
            ? toolsHtml
            : readOnlyMainHtml) +
          altEmailHtml +
          outsideBlockHtml +
          '<p class="em-row-status" aria-live="polite"></p>' +
          resendNoticeHtml +
          mailFailureNoticeHtml(student, email) +
        '</article>'
      );
    }

    /*
      Colour carries the meaning here: green confirmed, grey waiting, red for
      submissions from an address the admin never uploaded. Each group states its
      own count so the split is readable without counting rows.
    */
    /*
      Hover-only summary of what the student picked (2026-08-05). Checking sizes
      used to mean opening the status page in another tab; the roster already
      holds the data, so it may as well answer the question in place.
    */
    function buildSizesSummary(student) {
      if (!student) return '';

      /*
        2026-08-05 — read `items`, not `sizes`. The sizes object is keyed by
        product id / SKU, so summarising it printed raw identifiers where the
        admin expected product names. Each entry in `items` carries the title
        alongside the chosen option, which is what the status page renders too.
      */
      var items = student.items;

      try {
        if (typeof items === 'string') items = items ? JSON.parse(items) : [];
      } catch (error) {
        items = [];
      }

      if (!Array.isArray(items) || !items.length) return '';

      var lines = items.map(function(item) {
        if (!item || typeof item !== 'object') return '';

        var title = item.product_title || item.product || item.title || item.name || '';
        var selection = item.selection || item.size || item.variant_title || item.option || '';

        title = String(title || '').trim();
        selection = String(selection || '').trim();

        /*
          A product with no size options has nothing to report. Shopify labels
          such a variant "Default Title", and the form has been seen storing the
          SKU in its place — neither is a size, and printing them made it look
          like the student picked something they never chose.
        */
        var sku = String(item.sku || item.variant_sku || '').trim();
        if (selection.toLowerCase() === 'default title' || (sku && selection === sku)) {
          selection = '';
        }

        if (!title && !selection) return '';
        if (!selection) return title;
        if (!title) return selection;

        return title + ': ' + selection;
      }).filter(Boolean);

      return lines.join('\n');
    }

    function renderSizesTip(student) {
      var summary = buildSizesSummary(student);
      if (!summary) return '<span class="em-row-sizes-spacer" aria-hidden="true"></span>';

      return (
        '<span class="em-row-sizes" tabindex="0" aria-label="Sizes chosen by this student">' +
          '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
            '<path d="M2.5 5.5h11M2.5 8h11M2.5 10.5h7" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"></path>' +
          '</svg>' +
          '<span class="em-row-sizes-bubble" role="tooltip">' + esc(summary) + '</span>' +
        '</span>'
      );
    }

    function renderRosterGroup(options) {
      var rows = options.rows || [];

      return (
        '<section class="roster-group is-' + options.tone + '">' +
          '<header class="roster-group-head">' +
            '<span class="roster-group-dot" aria-hidden="true"></span>' +
            '<h4 class="roster-group-title">' + esc(options.title) + '</h4>' +
            '<span class="roster-group-count">' + rows.length + '</span>' +
          '</header>' +
          '<p class="roster-group-note">' + esc(options.note) + '</p>' +
          (rows.length
            ? '<div class="roster-group-rows">' + rows.join('') + '</div>'
            : '<p class="roster-group-empty">' + esc(options.emptyText) + '</p>') +
        '</section>'
      );
    }

    /*
      ── 2026-08-17 — the audience picker (owner) ─────────────────────────

      Two cards, each carrying its own count, shown the moment reminder mode
      opens and replaced by the list once one is chosen. Choosing again is one
      click on "Change" — no hidden state, nothing to remember.

      The counts come from the same roster the list will show, so a card
      reading zero is honest: there is nobody of that kind here, and the card
      says so rather than opening an empty list.
    */
    function reminderAudienceCounts(cohortCode) {
      var students = dedupeStudentsByEmail(getStudentsForCohort(cohortCode));
      var form = 0;
      var delivery = 0;

      getEditPanelRosterEmails(cohortCode).forEach(function(email) {
        var student = findStudentForRosterEmail(students, email);

        if (student && isAwaitingPaymentStudent(student)) delivery += 1;
        else if (!student || !hasSubmittedSizes(student)) form += 1;
      });

      return { form: form, delivery: delivery };
    }

    /*
      ── 2026-08-17 — the row's own remind button and its ten-minute state ──

      The window is enforced by the task, on the record, and always will be —
      this is only the row saying what the task would answer, so an admin can
      see it before pressing rather than reading about it in a log afterwards.

      Because it reads the cache, which lags, the button is never disabled on
      that basis alone: it says how long ago and lets the press happen. The
      task remains the authority and will decline if it must. Disabling on
      stale data would block a send that is genuinely due.
    */
    var REMIND_WINDOW_MS = 10 * 60 * 1000;

    function minutesSinceLastAttempt(student) {
      var stamp = String((student && student.last_reminded_at) || '').trim();
      if (!stamp) return null;

      var when = Date.parse(stamp);
      if (isNaN(when)) return null;

      return Math.floor((Date.now() - when) / 60000);
    }

    /*
      ── 2026-08-19 — заметка админа, кнопка в строке ─────────────────────

      У каждого студента и в любом состоянии — просьба владелицы. Админ и так
      пишет нам письмами «у этого перепутана когорта, у того отменён заказ»;
      место таким словам рядом со студентом, а не в переписке.

      Кнопка показывает начало заметки, когда та есть: иначе, чтобы узнать,
      написано ли что-то, пришлось бы открывать каждую по очереди.

      Без адреса вебхука кнопки нет вовсе. Кнопка, которой некуда писать, —
      это обещание, которое не выполнится.
    */
    /*
      ── 2026-08-19 — сохранённое не должно мигать старым ─────────────────

      Владелица стёрла заметку, нажала Save, дождалась спиннера — и на пару
      секунд снова увидела прежний текст, прежде чем он исчез окончательно.

      Это фоновое обновление. Оно приносит витрину с сервера, а витрина в тот
      момент ещё не пересобрана: в ней лежит прежняя заметка, и она затирает
      то, что админ только что сохранил. Ровно тот случай, о котором
      предупреждает CLAUDE.md — фоновое обновление не имеет права
      перерисовывать то, с чем человек сейчас работал.

      Поэтому сохранённое запоминается отдельно и показывается поверх витрины,
      пока витрина с ним не согласится. Согласилась — запись снимается сама:
      сравнение и есть условие снятия, отдельного сигнала не нужно.
    */
    var pendingNotes = {};

    function studentNoteText(student) {
      var stored = String((student && student.note) || '').trim();
      var email = student ? getStudentIdentityEmail(student) : '';

      if (!email || !Object.prototype.hasOwnProperty.call(pendingNotes, email)) {
        return stored;
      }

      var pending = pendingNotes[email];

      /* Витрина догнала — своя память больше не нужна и только мешала бы
         увидеть чужую правку. */
      if (stored === pending) {
        delete pendingNotes[email];
        return stored;
      }

      return pending;
    }

    /*
      The memory has to outlive a slow rebuild, which is the whole reason it
      exists — and two minutes did not.

      Reported by the owner: writing a note is reliable, deleting one is not.
      That asymmetry is this number. A written note survives the wait either
      way, because the stale cache and our memory both show text and the text
      that finally arrives is the same. A deleted one is held only by the
      memory: the cache still carries the old words, so the moment the memory
      expires they come back. On a large cohort the rebuild can take longer
      than two minutes, and the note reappeared.

      Ten minutes covers any rebuild this shop has produced. The cap stays
      because it is not really about the rebuild: if another admin edits the
      same note, the cache will never match ours, and without a cap we would
      hide their words for the rest of the session.
    */
    var PENDING_NOTE_MS = 600000;

    function rememberPendingNote(email, text) {
      var key = String(email || '').trim().toLowerCase();
      if (!key) return;

      pendingNotes[key] = text;

      window.setTimeout(function() {
        if (pendingNotes[key] === text) delete pendingNotes[key];
      }, PENDING_NOTE_MS);
    }

    /*
      2026-08-19 — пока заметка добирается до экранов, кнопка крутится.

      Владелица предлагала на выбор надпись «изменения вступят в силу в
      течение 30 секунд». Спиннер честнее: тридцати секунд никто не обещал и
      обещать не может — пересборка витрины идёт своим ходом, и на большой
      когорте она дольше.

      Спиннер не утверждает, что заметка ещё не сохранена. Она сохранена:
      вебхук принял, задача записала. Он говорит только «идёт», и гаснет сам
      через своё окно, оставляя текст заметки на месте.
    */
    var savingNoteEmails = {};

    function rowNoteButtonHtml(student, email) {
      if (!SAVE_STUDENT_NOTE_WEBHOOK_URL) return '';
      if (!student) return '';

      var saving = savingNoteEmails[String(email || '').toLowerCase()] === true;
      var note = studentNoteText(student);

      if (saving) {
        return '' +
          '<button type="button" class="em-row-note-btn is-saving" disabled' +
            ' title="Saving — it takes a moment to reach the status page">' +
            '<span class="em-row-note-spinner" aria-hidden="true"></span>' +
            '<span>Saving</span>' +
          '</button>';
      }

      var label = note
        ? (note.length > 28 ? note.slice(0, 28) + '…' : note)
        : 'Note';

      return '' +
        '<button type="button" class="em-row-note-btn' + (note ? ' has-note' : '') + '"' +
          ' data-note-email="' + esc(email) + '"' +
          ' title="' + esc(note || 'Leave a note about this student') + '">' +
          esc(label) +
        '</button>';
    }

    /*
      Окно намеренно скромное. Оно не измеряет пересборку — измерить её отсюда
      нечем, — а показывает, что нажатие принято и работа идёт. Дальше кнопка
      возвращается к тексту заметки, который на дашборде уже верен.
    */
    var NOTE_SAVING_MS = 12000;

    function markNoteSaving(email, on) {
      var key = String(email || '').toLowerCase();
      if (!key) return;

      if (on) savingNoteEmails[key] = true;
      else delete savingNoteEmails[key];

      renderEditStudentsList(editingCohortCode);
    }

    /*
      ── Reminders panel (2026-10-13, owner) ───────────────────────────────

      The flow of send-reminders-prototype-2026-10-13: the every-two-days
      switch always on top (a setting of the cohort, saved the moment it is
      pressed, so it does not belong to any step), then one question per
      screen, with Back on the second. The letters themselves are the same as
      before: sendSelectedReminders for the form, sendPaymentRemindersTo for
      the payment link, openSelfSendModal for a letter from the admin's own
      mailbox - drawn here in the panel instead of in a window.

      The switch keeps the ids the header tile had, so renderEmailSettings
      and saveEmailSettings drive it unchanged.
    */
    var REMIND_ICON_MAIL = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3.5" y="5.5" width="17" height="13" rx="3" stroke="currentColor" stroke-width="1.9"/><path d="m4.5 7.5 7.5 5.5 7.5-5.5" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"/></svg>';

    /* The students of one group, in roster order: 'form' has not filled in
       the form, 'pay' owes for delivery. Staged removals are left out. */
    function reminderGroupEmails(cohortCode, kind) {
      var students = dedupeStudentsByEmail(getStudentsForCohort(cohortCode));

      return getEditPanelRosterEmails(cohortCode).map(function(email) {
        return String(email || '').trim().toLowerCase();
      }).filter(function(email) {
        if (!email || isMarkedForRemoval(email)) return false;

        var student = findStudentForRosterEmail(students, email);
        var owing = student ? isAwaitingPaymentStudent(student) : false;

        if (kind === 'pay') return owing;
        return !owing && !(student && hasSubmittedSizes(student));
      });
    }

    /* 2026-10-13 (owner) - no step tabs: two pills side by side read as two
       buttons to press. Back alone says this is the second screen. */
    function remindHeadHtml(step, back, title, sub) {
      return (back !== null ? '<button type="button" class="cohort-remind-back" data-remind-go="' + esc(back) + '">&larr; Back</button>' : '') +
        '<h4 class="cohort-remind-title">' + esc(title) + '</h4>' +
        (sub ? '<p class="cohort-remind-sub">' + esc(sub) + '</p>' : '');
    }

    function remindOptionHtml(go, tone, mark, title, sub, disabled) {
      return '<button type="button" class="cohort-remind-option' + (tone ? ' is-' + tone : '') + '" data-remind-go="' + go + '"' + (disabled ? ' disabled' : '') + '>' +
        '<span class="cohort-remind-option-num">' + mark + '</span>' +
        '<span class="cohort-remind-option-text"><b>' + esc(title) + '</b><small>' + esc(sub) + '</small></span>' +
        '<span class="cohort-remind-option-go" aria-hidden="true">&rsaquo;</span>' +
      '</button>';
    }

    /* The letter window lives in the panel while an own-mailbox screen is
       open; every other moment it goes home, so redrawing the panel can never
       destroy it and the window keeps working wherever else it is opened. */
    function parkSelfSendDialog() {
      var overlay = document.getElementById('cohort-selfsend-modal');
      var dialog = document.querySelector('.cohort-selfsend-modal');
      if (!overlay || !dialog || dialog.parentNode === overlay) return;

      dialog.classList.remove('is-inline');
      overlay.appendChild(dialog);
    }

    function renderReminderAudiencePicker(cohortCode) {
      var node = document.getElementById('cohort-audience-pick');
      if (!node) return;

      parkSelfSendDialog();

      var show = rosterEditMode === 'remind' && !editingReadOnly;

      if (!show) {
        node.hidden = true;
        node.setAttribute('aria-hidden', 'true');
        node.innerHTML = '';
        return;
      }

      var counts = reminderAudienceCounts(cohortCode);
      var lateRound = getReusableLateBatchInfo(cohortCode);
      var paidForCodes = freeShipStudents(cohortCode);
      var freeShipLetter = null;

      var scheduleHtml =
        '<div class="cohort-remind-schedule" id="cohort-mail-reminders-row">' +
          '<span class="cohort-remind-schedule-ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></span>' +
          '<span class="cohort-remind-schedule-txt">' +
            '<span class="cohort-remind-schedule-name" id="cohort-mail-reminders-label">Automatic reminders to students</span>' +
            '<span class="cohort-mail-state" id="cohort-mail-reminders-state">Off</span>' +
          '</span>' +
          '<button type="button" class="cohort-mail-switch" id="cohort-mail-reminders" role="switch" aria-checked="false" aria-labelledby="cohort-mail-reminders-label"></button>' +
        '</div>';

      var screenHtml = '';
      var letterEmails = null;

      if (reminderAudience === 'form') {
        screenHtml = remindHeadHtml(2, '', 'Remind to fill in the form',
          lateRound
            ? 'They get a letter with the form link and join the open late round. Select the students to remind.'
            : 'They get a letter with the form link. Select the students to remind.');
      } else if (reminderAudience === 'pay') {
        screenHtml = remindHeadHtml(2, '', 'Remind to pay for delivery',
          'Each student gets a letter with their own payment link. Select the students to remind.');
      } else if (reminderAudience === 'own') {
        screenHtml = remindHeadHtml(2, '', 'Send it from your own mailbox',
          'A letter from the college address travels inside the college, and college mail systems do not block it. Who is it for?') +
          '<div class="cohort-remind-options">' +
            remindOptionHtml('own-form', '', String(counts.form), 'Students who have not filled in the form', 'One letter to all of them, in blind copy', !counts.form) +
            remindOptionHtml('own-pay', 'pay', String(counts.delivery), 'Students who have not paid for delivery', 'One letter each - every letter has that student\'s own payment link', !counts.delivery) +
            (FREE_SHIP_SCREEN
              ? remindOptionHtml('own-codes', 'paid', String(paidForCodes.length), 'Students who paid: free-shipping codes',
                  FREE_SHIPPING_CACHE_URL && EXTEND_FREE_SHIPPING_WEBHOOK_URL
                    ? 'Make their codes work longer, then one letter each with that student\'s own code'
                    : 'Not set up for this shop yet', !paidForCodes.length || !FREE_SHIPPING_CACHE_URL || !EXTEND_FREE_SHIPPING_WEBHOOK_URL)
              : '') +
          '</div>';
      } else if (reminderAudience === 'own-form') {
        var waiting = reminderGroupEmails(cohortCode, 'form');
        screenHtml = remindHeadHtml(2, 'own', waiting.length === 1 ? 'One letter to 1 student' : 'One letter to ' + waiting.length + ' students', '') +
          '<div class="cohort-remind-letter" id="cohort-remind-letter-host"></div>' +
          remindSentHtml('form');
        letterEmails = waiting;
      } else if (reminderAudience === 'own-codes') {
        if (freeShipEnds === null && !freeShipLoading) loadFreeShipEnds(cohortCode);
        if (paidForCodes.every(function(entry) { return entry.email !== remindLetterEmail; })) remindLetterEmail = '';

        var nowSeconds = Math.floor(Date.now() / 1000);
        var pickedEnd = remindLetterEmail && freeShipEnds ? Number(freeShipEnds[remindLetterEmail] || 0) : 0;

        screenHtml = remindHeadHtml(2, 'own', 'Free-shipping codes',
          'Each student who paid for delivery got a code for their next order - valid 3 days from the payment. First make the codes work longer, then copy each student\'s letter and send it from your own mailbox.') +
          '<div class="cohort-freeship-extend">' +
            '<span class="cohort-freeship-extend-txt"><b>1. Make the codes work longer</b>' +
              '<small>Every code of this cohort that is not used yet. Extend codes sends nothing; Email the codes also writes to each student with their code and its new date.</small></span>' +
            '<select class="cohort-freeship-days" id="cohort-freeship-days" aria-label="How long">' +
              ['2', '5', '7'].map(function(d) {
                return '<option value="' + d + '"' + (d === freeShipDays ? ' selected' : '') + '>' + d + ' days from today</option>';
              }).join('') +
            '</select>' +
            '<button type="button" class="cohort-freeship-btn" id="cohort-freeship-extend"' + (freeShipExtending ? ' disabled' : '') + '>' + (freeShipExtending ? 'Sending…' : 'Extend codes') + '</button>' +
            (freeShipEmailConfirm
              ? '<button type="button" class="cohort-freeship-btn is-email" id="cohort-freeship-email-yes"' + (freeShipExtending ? ' disabled' : '') + '>Yes, email ' + paidForCodes.length + (paidForCodes.length === 1 ? ' student' : ' students') + '</button>' +
                '<button type="button" class="cohort-freeship-btn is-light" id="cohort-freeship-email-no">Cancel</button>'
              : '<button type="button" class="cohort-freeship-btn is-email" id="cohort-freeship-email"' + (freeShipExtending ? ' disabled' : '') + '>Email the codes</button>') +
            '<button type="button" class="cohort-freeship-btn is-light" id="cohort-freeship-refresh"' + (freeShipLoading ? ' disabled' : '') + '>' + (freeShipLoading ? 'Checking…' : 'Refresh dates') + '</button>' +
            (freeShipMessage ? '<p class="cohort-freeship-msg">' + esc(freeShipMessage) + '</p>' : '') +
          '</div>' +
          '<p class="cohort-freeship-step"><b>2. Choose a student and copy their letter</b></p>' +
          '<div class="cohort-remind-people">' + paidForCodes.map(function(entry) {
            var end = freeShipEnds ? Number(freeShipEnds[entry.email] || 0) : null;
            var chip = end === null
              ? '<span class="cohort-freeship-chip">Checking…</span>'
              : end > nowSeconds
                ? '<span class="cohort-freeship-chip is-ok">Until ' + esc(formatFreeShipEnd(end)) + '</span>'
                : end === -1
                  ? '<span class="cohort-freeship-chip">Already used</span>'
                  : '<span class="cohort-freeship-chip is-off">No date yet</span>';
            return '<button type="button" class="cohort-remind-person' + (entry.email === remindLetterEmail ? ' is-active' : '') + '" data-remind-letter="' + esc(entry.email) + '">' +
              '<b>' + esc(entry.name || entry.email) + '</b>' + (entry.name ? '<small>' + esc(entry.email) + '</small>' : '') +
              chip +
              (remindOwnSent['code:' + entry.email] ? '<span class="cohort-remind-sent-chip">Sent</span>' : '') +
            '</button>';
          }).join('') + '</div>';

        if (remindLetterEmail && pickedEnd > nowSeconds) {
          screenHtml += '<div class="cohort-remind-letter" id="cohort-remind-letter-host"></div>' + remindSentHtml('code:' + remindLetterEmail);
          letterEmails = [remindLetterEmail];
          freeShipLetter = { code: freeShipCodeFor(cohortCode, remindLetterEmail), until: formatFreeShipEnd(pickedEnd) };
        } else if (remindLetterEmail && freeShipEnds) {
          screenHtml += '<p class="cohort-freeship-msg">' + esc(pickedEnd === -1
            ? 'This student has already used their code, so there is nothing to send.'
            : 'There is no date for this code yet. Press Extend codes, wait a minute, then Refresh dates. If it still says "No date yet", the code could not be found - their payment came before codes existed, or the order had no customer account. Write to us and we will look.') + '</p>';
        }
      } else if (reminderAudience === 'own-pay') {
        var debtors = reminderGroupEmails(cohortCode, 'pay');
        if (debtors.indexOf(remindLetterEmail) === -1) remindLetterEmail = debtors[0] || '';

        var studentsForNames = getStudentsForCohort(cohortCode);
        screenHtml = remindHeadHtml(2, 'own', 'A letter for each student',
          'Each letter carries that student\'s own payment link, so it goes to one person only. Choose a student, copy their letter, then the next.') +
          '<div class="cohort-remind-people">' + debtors.map(function(email) {
            var student = findStudentForRosterEmail(studentsForNames, email);
            var name = student ? [student.first_name || '', student.last_name || ''].join(' ').trim() : '';
            return '<button type="button" class="cohort-remind-person' + (email === remindLetterEmail ? ' is-active' : '') + '" data-remind-letter="' + esc(email) + '">' +
              '<b>' + esc(name || email) + '</b>' + (name ? '<small>' + esc(email) + '</small>' : '') +
              (remindOwnSent[email] ? '<span class="cohort-remind-sent-chip">Sent</span>' : '') +
            '</button>';
          }).join('') + '</div>' +
          (remindLetterEmail ? '<div class="cohort-remind-letter" id="cohort-remind-letter-host"></div>' + remindSentHtml(remindLetterEmail) : '');
        letterEmails = remindLetterEmail ? [remindLetterEmail] : null;
      } else {
        screenHtml = remindHeadHtml(1, null, 'What do you need?', 'Pick one. Each student gets the letter that is right for them.') +
          '<div class="cohort-remind-options">' +
            remindOptionHtml('form', '', String(counts.form), 'Remind students to fill in the form', 'Not submitted · they get the form link', !counts.form) +
            remindOptionHtml('pay', 'pay', String(counts.delivery), 'Remind students to pay for delivery',
              SEND_PAYMENT_REMINDER_WEBHOOK_URL ? 'Not paid · each gets their own payment link' : 'Not set up for this shop yet', !counts.delivery || !SEND_PAYMENT_REMINDER_WEBHOOK_URL) +
            remindOptionHtml('own', 'mail', REMIND_ICON_MAIL, 'Our letters do not arrive', 'Send it yourself, from your own mailbox', !counts.form && !counts.delivery) +
          '</div>';
      }

      node.innerHTML = scheduleHtml + screenHtml;
      node.hidden = false;
      node.setAttribute('aria-hidden', 'false');

      /* The switch shows the cohort's real state the moment it is drawn. */
      renderEmailSettings(findCohortByCode(cohortCode));

      Array.prototype.forEach.call(node.querySelectorAll('[data-remind-go]'), function(button) {
        button.addEventListener('click', function() {
          if (button.disabled) return;
          reminderAudience = button.getAttribute('data-remind-go') || '';
          remindLetterEmail = '';
          clearSelection();
          renderEditStudentsList(cohortCode);
          updateDraftBar();
        });
      });

      Array.prototype.forEach.call(node.querySelectorAll('[data-remind-letter]'), function(button) {
        button.addEventListener('click', function() {
          remindLetterEmail = button.getAttribute('data-remind-letter') || '';
          renderEditStudentsList(cohortCode);
        });
      });

      Array.prototype.forEach.call(node.querySelectorAll('[data-remind-sent]'), function(button) {
        button.addEventListener('click', function() {
          remindOwnSent[button.getAttribute('data-remind-sent')] = true;
          renderEditStudentsList(cohortCode);
        });
      });

      var daysSelect = document.getElementById('cohort-freeship-days');
      if (daysSelect) {
        daysSelect.addEventListener('change', function() { freeShipDays = daysSelect.value; });
      }

      var extendButton = document.getElementById('cohort-freeship-extend');
      if (extendButton) extendButton.addEventListener('click', function() { freeShipEmailConfirm = false; extendFreeShipCodes(cohortCode, false); });

      var emailButton = document.getElementById('cohort-freeship-email');
      if (emailButton) emailButton.addEventListener('click', function() {
        freeShipEmailConfirm = true;
        freeShipMessage = '';
        renderEditStudentsList(cohortCode);
      });

      var emailYes = document.getElementById('cohort-freeship-email-yes');
      if (emailYes) emailYes.addEventListener('click', function() { freeShipEmailConfirm = false; extendFreeShipCodes(cohortCode, true); });

      var emailNo = document.getElementById('cohort-freeship-email-no');
      if (emailNo) emailNo.addEventListener('click', function() {
        freeShipEmailConfirm = false;
        renderEditStudentsList(cohortCode);
      });

      var refreshButton = document.getElementById('cohort-freeship-refresh');
      if (refreshButton) refreshButton.addEventListener('click', function() { loadFreeShipEnds(cohortCode); });

      /* The same letter as the window writes, drawn in the panel. */
      var host = document.getElementById('cohort-remind-letter-host');
      if (host && letterEmails && letterEmails.length) openSelfSendModal(letterEmails, host, freeShipLetter);
    }

    /*
      ── 2026-10-14 (owner) - free-shipping codes, sent by hand ───────────

      A school's mail filter blocked the letters with the codes. The codes
      exist; the students never saw them. Here the admin extends them and
      copies each student's letter into her own mailbox.

      The code is built the way Cohort: Free Shipping After Payment builds it:
      FREESHIP-<COHORT>-<student token>, upper case (the student form builds
      it the same way - cohort-student-form.js, studentFreeShippingCode).
      Change one, change all three.
    */
    function freeShipStudents(cohortCode) {
      var students = dedupeStudentsByEmail(getStudentsForCohort(cohortCode));

      return getEditPanelRosterEmails(cohortCode).map(function(email) {
        return String(email || '').trim().toLowerCase();
      }).filter(function(email) {
        if (!email || isMarkedForRemoval(email)) return false;
        var student = findStudentForRosterEmail(students, email);
        return !!(student && !isRemovedStudent(student) && isPaidStudent(student) && String(student.unique_token || '').trim());
      }).map(function(email) {
        var student = findStudentForRosterEmail(students, email);
        return {
          email: email,
          token: String(student.unique_token || '').trim(),
          name: [student.first_name || '', student.last_name || ''].join(' ').trim()
        };
      });
    }

    function freeShipCodeFor(cohortCode, email) {
      var entry = freeShipStudents(cohortCode).filter(function(item) { return item.email === email; })[0];
      if (!entry) return '';
      return ('FREESHIP-' + String(cohortCode || '').trim().toUpperCase() + '-' + entry.token).toUpperCase();
    }

    function formatFreeShipEnd(epoch) {
      try {
        return new Date(epoch * 1000).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
      } catch (error) {
        return '';
      }
    }

    /* Twin of sha256Hex in cohort-student-form.js: the cache is keyed by the
       first 24 hex characters of the code's SHA-256, never by the code. */
    function freeShipSha256Hex(text) {
      if (!window.crypto || !window.crypto.subtle || typeof TextEncoder === 'undefined') {
        return Promise.resolve('');
      }

      return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(function(buffer) {
        return Array.prototype.map.call(new Uint8Array(buffer), function(byte) {
          return ('0' + byte.toString(16)).slice(-2);
        }).join('');
      }).catch(function() {
        return '';
      });
    }

    /*
      Reads each paid student's code end. An empty answer, a failed request
      and "no entry" are kept apart: only a real answer paints a student as
      having no working code; a failure says so and paints nobody.
    */
    function loadFreeShipEnds(cohortCode) {
      if (!FREE_SHIPPING_CACHE_URL || freeShipLoading) return;

      var people = freeShipStudents(cohortCode);
      freeShipLoading = true;
      renderEditStudentsList(cohortCode);

      Promise.all([
        fetch(FREE_SHIPPING_CACHE_URL, { method: 'GET', cache: 'no-store' }).then(function(response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        }),
        Promise.all(people.map(function(entry) {
          return freeShipSha256Hex(freeShipCodeFor(cohortCode, entry.email));
        }))
      ]).then(function(results) {
        var raw = results[0];
        if (raw && typeof raw.value !== 'undefined') raw = raw.value;
        if (typeof raw === 'string') raw = JSON.parse(raw);
        if (!raw || typeof raw !== 'object') raw = {};

        var ends = {};
        people.forEach(function(entry, index) {
          var hash = results[1][index];
          ends[entry.email] = hash ? Number(raw[hash.slice(0, 24)] || 0) : 0;
        });

        freeShipEnds = ends;
        if (freeShipMessage === 'Could not read the code dates. Check the connection and press Refresh dates.') freeShipMessage = '';
      }).catch(function() {
        freeShipMessage = 'Could not read the code dates. Check the connection and press Refresh dates.';
      }).then(function() {
        freeShipLoading = false;
        if (rosterEditMode === 'remind' && reminderAudience === 'own-codes') renderEditStudentsList(cohortCode);
      });
    }

    /*
      A 200 from the webhook only says the request arrived (CLAUDE.md, async
      webhook rules), so the message says to wait and refresh - the dates on
      screen change only when the cache shows the task's real result.
    */
    /*
      withLetters (2026-10-16, owner - "Email the codes"): the same request,
      plus each student's address beside their code. The task writes only to an
      address that builds that very code, after the new dates are saved, and at
      most once per code in 12 hours, so a second press does not write twice.
    */
    function extendFreeShipCodes(cohortCode, withLetters) {
      if (freeShipExtending || !EXTEND_FREE_SHIPPING_WEBHOOK_URL) return;

      var letters = [];
      var codes = freeShipStudents(cohortCode).map(function(entry) {
        var code = freeShipCodeFor(cohortCode, entry.email);
        if (code) letters.push({ code: code, email: entry.email });
        return code;
      }).filter(Boolean);

      if (!codes.length) return;

      freeShipExtending = true;
      freeShipMessage = '';
      renderEditStudentsList(cohortCode);

      var payload = {
        cohort_code: String(cohortCode || '').trim().toUpperCase(),
        days: Number(freeShipDays) || 7,
        codes: codes,
        admin_email: String(CUSTOMER.email || '').trim().toLowerCase()
      };
      if (withLetters) {
        payload.send_letters = true;
        payload.letters = letters;
      }

      postJson(EXTEND_FREE_SHIPPING_WEBHOOK_URL, payload).then(function() {
        freeShipMessage = withLetters
          ? 'Request sent. Within a minute the codes are extended and each student gets a letter with their code (a used code gets no letter). Press Refresh dates to see the new dates.'
          : 'Request sent. The codes are usually extended within a minute - press Refresh dates to see the new dates.';
      }).catch(function() {
        freeShipMessage = withLetters
          ? 'The request did not go through. Nothing was changed and no letters were sent. Check the connection and try again.'
          : 'The request did not go through. Nothing was changed. Check the connection and press Extend codes again.';
      }).then(function() {
        freeShipExtending = false;
        if (rosterEditMode === 'remind' && reminderAudience === 'own-codes') renderEditStudentsList(cohortCode);
      });
    }

    /* "I have sent it": only the admin's note; the page cannot see her mailbox. */
    function remindSentHtml(key) {
      if (remindOwnSent[key]) {
        return '<div class="cohort-remind-sent-note"><b>Marked as sent from your mailbox</b>' +
          '<span>This page cannot see your mailbox, so this is only a note for you. It goes when the page is reloaded.</span></div>';
      }

      return '<div class="cohort-remind-sent-row"><button type="button" class="cohort-remind-sent-btn" data-remind-sent="' + esc(key) + '">I have sent it</button></div>';
    }

    /*
      2026-10-13 (owner) - the students ticked on a form or payment screen,
      within that screen's group. The Send button lives on the black bar that
      sticks to the top of the screen (updateDraftBar), as it did before.
    */
    function remindPickedEmails() {
      if (rosterEditMode !== 'remind' || (reminderAudience !== 'form' && reminderAudience !== 'pay')) return [];

      var group = reminderGroupEmails(editingCohortCode, reminderAudience);
      return rosterSelection.filter(function(email) { return group.indexOf(email) !== -1; });
    }

    function sendPickedReminders() {
      if (remindSending) return;
      openReminderConfirm(collectReminderTargets(remindPickedEmails()), false);
    }

    /*
      2026-10-15 (owner) - Requests to join.

      A student whose email is not on the list can press "Ask to be added" on
      the form; Cohort: Student Join Request keeps the request on the cohort's
      cohort_join_requests record, printed into the page as joinRequestsRaw.

      Add goes through openAddEmailsModal - the very path Add students takes,
      with its own confirmation, late-round handling and invitation - so there
      is no second way of adding a student. Decline posts to the join request
      webhook, which drops the request from the record.

      A request leaves the group by itself once its email is on the list, so a
      student added by hand never lingers here. A 200 from Decline only says
      the request arrived (CLAUDE.md, async webhook rules): the row is hidden
      for this visit, and a reload shows the record's real state.
    */
    /*
      2026-10-16 (owner) - "Letter not delivered" on a student's row.

      Cohort: Sync Mail Failures keeps our Postmark's suppression list in the
      cache key mail_failures: SHA-256 of the lowercased address (first 24 hex)
      → { r: bounce | spam | manual | other, t: since }. The cache is public, so
      it holds no addresses; the page hashes each student's own and looks up.

      Read once per cohort each time Edit Cohort opens it. A failed read marks
      nobody - it says nothing about the students, so it must not say they are
      fine either: the row simply carries no mark (CLAUDE.md: an empty or failed
      answer is not an empty list).
    */
    var mailFailByEmail = {};
    var mailFailCohort = '';
    var mailFailLoading = false;
    var mailFailLoadedAt = 0;

    function mailFailureHash(text) {
      if (!window.crypto || !window.crypto.subtle || typeof TextEncoder === 'undefined') {
        return Promise.resolve('');
      }

      return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(function(buffer) {
        return Array.prototype.map.call(new Uint8Array(buffer), function(byte) {
          return ('0' + byte.toString(16)).slice(-2);
        }).join('').slice(0, 24);
      }).catch(function() {
        return '';
      });
    }

    /*
      2026-10-17 (owner) - the bell on the cohort cards needs every cohort's
      answer, not only the one open in Edit Cohort. So the map is one for the
      whole page, keyed by address, and each read changes only the addresses
      it asked about: found - set, not found - removed, hash unavailable -
      left as it was.
    */
    var mailFailAllLoading = false;
    var mailFailAllLoadedAt = 0;

    function mailFailureEmailsFor(cohortCode) {
      var cohort = findCohortByCode(cohortCode);
      var emails = getRosterEmailsOrdered(cohort).slice();
      getStudentsForCohort(cohortCode).forEach(function(student) {
        [student.email, student.roster_email, student.submitted_email, student.contact_email].forEach(function(value) {
          var email = String(value || '').trim().toLowerCase();
          if (email && emails.indexOf(email) === -1) emails.push(email);
        });
      });
      return emails;
    }

    function loadMailFailuresAll() {
      if (!MAIL_FAILURES_CACHE_URL || mailFailAllLoading || Date.now() - mailFailAllLoadedAt < 60000) return;

      var emails = [];
      dedupeCohortsByCode(MY_COHORTS.slice()).forEach(function(cohort) {
        mailFailureEmailsFor(cohort.cohortCode).forEach(function(email) {
          if (emails.indexOf(email) === -1) emails.push(email);
        });
      });
      if (!emails.length) return;

      mailFailAllLoading = true;
      fetchMailFailures(emails).catch(function() {
        /* unknown, not "all fine": keep whatever was shown */
      }).then(function() {
        mailFailAllLoading = false;
        mailFailAllLoadedAt = Date.now();
        refreshCohortAlertBadges();
      });
    }

    function fetchMailFailures(emails) {
      return Promise.all([
        fetch(MAIL_FAILURES_CACHE_URL, { method: 'GET', cache: 'no-store' }).then(function(response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        }),
        Promise.all(emails.map(function(email) {
          return mailFailureHash(email);
        }))
      ]).then(function(results) {
        var raw = results[0];
        if (raw && typeof raw.value !== 'undefined') raw = raw.value;
        if (typeof raw === 'string') raw = JSON.parse(raw);
        if (!raw || typeof raw !== 'object') return;

        emails.forEach(function(email, index) {
          var hash = results[1][index];
          if (!hash) return;
          var entry = raw[hash];
          if (entry && typeof entry === 'object') mailFailByEmail[email] = entry;
          else delete mailFailByEmail[email];
        });
      });
    }

    function loadMailFailures(cohortCode) {
      if (!MAIL_FAILURES_CACHE_URL || mailFailLoading) return;

      var emails = mailFailureEmailsFor(cohortCode);

      mailFailLoading = true;
      mailFailCohort = cohortCode;

      fetchMailFailures(emails).catch(function() {
        /* unknown, not "all fine": keep whatever was shown */
      }).then(function() {
        mailFailLoading = false;
        mailFailLoadedAt = Date.now();
        if (editingCohortCode === cohortCode) renderEditStudentsList(cohortCode);
        refreshCohortAlertBadges();
      });
    }

    /*
      2026-10-17 (owner) - the cross. An admin who has dealt with the address
      closes the notice; Cohort: Dismiss Mail Notice keeps that on the
      cohort's cohort_alerts record for every admin. What is kept is the
      address and the "since" of the failure that was seen, so a new failure
      of the same address shows again. Until the page is reloaded the cross
      is remembered here too (a 200 only says the request arrived - CLAUDE.md,
      async webhook rules; the record is the truth after a reload).
    */
    var mailDismissLocal = {};
    var mailDismissBusy = {};
    var mailDismissFailed = {};

    function mailFailureMatch(student, email) {
      var keys = [email];
      if (student) {
        [student.email, student.roster_email, student.submitted_email, student.contact_email].forEach(function(value) {
          keys.push(String(value || '').trim().toLowerCase());
        });
      }

      var match = null;
      keys.forEach(function(key) {
        if (!match && key && mailFailByEmail[key]) match = { key: key, entry: mailFailByEmail[key] };
      });
      return match;
    }

    function mailFailureSince(entry) {
      return entry && entry.t != null ? String(entry.t) : '';
    }

    function mailDismissedSince(cohort, email) {
      var code = String((cohort && cohort.cohortCode) || '').trim().toUpperCase();
      var localKey = code + '|' + email;
      if (Object.prototype.hasOwnProperty.call(mailDismissLocal, localKey)) return mailDismissLocal[localKey];

      var list = cohort ? cohort.mailDismissedRaw : '';
      if (typeof list === 'string') {
        try {
          list = list.trim() ? JSON.parse(list) : [];
        } catch (error) {
          list = [];
        }
      }
      if (!Array.isArray(list)) return null;

      var found = null;
      list.forEach(function(item) {
        if (item && String(item.e || '').trim().toLowerCase() === email) found = String(item.t == null ? '' : item.t);
      });
      return found;
    }

    function mailFailureIsOpen(cohort, match) {
      if (!match) return false;
      return mailDismissedSince(cohort, match.key) !== mailFailureSince(match.entry);
    }

    function dismissMailNotice(cohortCode, email, since) {
      if (showcaseRefuses(cohortCode)) return;
      var key = String(cohortCode || '').trim().toUpperCase() + '|' + email;
      if (!DISMISS_MAIL_NOTICE_WEBHOOK_URL || !email || mailDismissBusy[key]) return;

      mailDismissBusy[key] = true;
      delete mailDismissFailed[key];
      if (editingCohortCode === cohortCode) renderEditStudentsList(cohortCode);

      postJson(DISMISS_MAIL_NOTICE_WEBHOOK_URL, {
        action: 'dismiss_mail_notice',
        cohort_code: cohortCode,
        email: email,
        since: since,
        admin_email: String(CUSTOMER.email || '').trim().toLowerCase()
      }).then(function() {
        mailDismissLocal[key] = since;
      }).catch(function() {
        mailDismissFailed[key] = true;
      }).then(function() {
        delete mailDismissBusy[key];
        if (editingCohortCode === cohortCode) renderEditStudentsList(cohortCode);
        refreshCohortAlertBadges();
      });
    }

    function mailFailureNoticeHtml(student, email) {
      var match = mailFailureMatch(student, email);
      var cohort = findCohortByCode(editingCohortCode);
      if (!mailFailureIsOpen(cohort, match)) return '';
      var entry = match.entry;
      var dismissKey = String(editingCohortCode || '').trim().toUpperCase() + '|' + match.key;
      var busy = !!mailDismissBusy[dismissKey];
      var crossHtml = DISMISS_MAIL_NOTICE_WEBHOOK_URL && !editingReadOnly
        ? '<button type="button" class="em-row-mail-fail-x" data-mail-dismiss="' + escapeHtml(match.key) + '" data-mail-since="' + escapeHtml(mailFailureSince(entry)) + '" aria-label="Close this notice" title="Close this notice"' + (busy ? ' disabled' : '') + '>&times;</button>'
        : '';
      var failedHtml = mailDismissFailed[dismissKey]
        ? ' <span class="em-row-mail-fail-err">Could not close it. Check the connection and try again.</span>'
        : '';

      var why = entry.r === 'spam'
        ? 'The student marked one of our letters as spam, so our letters no longer reach this address.'
        : entry.r === 'manual'
          ? 'Letters to this address are switched off on our side.'
          : 'A letter to this address bounced - often a college mailbox that was not created yet - so our letters no longer reach it.';

      return '<p class="em-row-mail-fail' + (crossHtml ? ' has-cross' : '') + '">' + crossHtml + '<b>Letter not delivered.</b> ' + why +
        ' Send it from your own mailbox: <b>Send reminders</b> → <b>Our letters do not arrive</b>.' + failedHtml + '</p>';
    }

    var joinRequestsDeclined = {};
    var joinRequestBusyEmail = '';
    var joinRequestMessage = '';

    function joinRequestsFor(cohortCode) {
      var cohort = findCohortByCode(cohortCode);
      if (!cohort) return [];

      var list = cohort.joinRequestsRaw;
      if (typeof list === 'string') {
        try {
          list = list.trim() ? JSON.parse(list) : [];
        } catch (error) {
          list = [];
        }
      }
      if (!Array.isArray(list)) return [];

      var onList = getRosterEmailsOrdered(cohort).map(function(email) {
        return String(email || '').trim().toLowerCase();
      });
      var seen = {};

      return list.map(function(item) {
        item = item || {};
        return {
          email: String(item.email || '').trim().toLowerCase(),
          name: [item.first_name || '', item.last_name || ''].join(' ').trim(),
          studentId: String(item.student_id || '').trim(),
          t: Number(item.t) || 0
        };
      }).filter(function(item) {
        if (!item.email || seen[item.email]) return false;
        seen[item.email] = true;
        return onList.indexOf(item.email) === -1 && !joinRequestsDeclined[cohortCode + '|' + item.email];
      }).sort(function(a, b) {
        return b.t - a.t;
      });
    }

    function renderJoinRequests(cohortCode) {
      var host = document.getElementById('cohort-join-requests');
      if (!host) return;

      var show = !editingReadOnly && (rosterEditMode === '' || rosterEditMode === 'add');
      var requests = show ? joinRequestsFor(cohortCode) : [];

      if (!requests.length) {
        host.hidden = true;
        host.innerHTML = '';
        return;
      }

      host.hidden = false;
      host.innerHTML =
        '<div class="cohort-join-head">' +
          '<span class="cohort-join-title">Requests to join</span>' +
          '<span class="cohort-join-count">' + requests.length + '</span>' +
        '</div>' +
        '<p class="cohort-join-lead">These students opened the form, but their email is not on the list. Add the ones who are yours.</p>' +
        '<div class="cohort-join-list">' + requests.map(function(item) {
          var busy = joinRequestBusyEmail === item.email;
          var asked = item.t
            ? new Date(item.t * 1000).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
            : '';
          return '<div class="cohort-join-row">' +
            '<div class="cohort-join-who">' +
              '<b>' + escapeHtml(item.name || item.email) + '</b>' +
              (item.name ? '<small>' + escapeHtml(item.email) + '</small>' : '') +
              '<small>' + (asked ? 'Asked ' + escapeHtml(asked) : 'Asked to join') +
                (item.studentId ? ' · Student ID ' + escapeHtml(item.studentId) : '') + '</small>' +
            '</div>' +
            '<div class="cohort-join-actions">' +
              '<button type="button" class="cohort-join-add" data-join-add="' + escapeHtml(item.email) + '"' + (busy ? ' disabled' : '') + '>Add</button>' +
              (JOIN_REQUEST_WEBHOOK_URL
                ? '<button type="button" class="cohort-join-decline" data-join-decline="' + escapeHtml(item.email) + '"' + (busy ? ' disabled' : '') + '>' + (busy ? 'Declining…' : 'Decline') + '</button>'
                : '') +
            '</div>' +
          '</div>';
        }).join('') + '</div>' +
        (joinRequestMessage ? '<p class="cohort-join-msg">' + escapeHtml(joinRequestMessage) + '</p>' : '');

      host.onclick = function(event) {
        var addButton = event.target.closest('[data-join-add]');
        var declineButton = event.target.closest('[data-join-decline]');

        if (addButton && !addButton.disabled) {
          var email = addButton.getAttribute('data-join-add');
          if (getRosterEmailsOrdered(findCohortByCode(cohortCode)).indexOf(email) !== -1) {
            renderJoinRequests(cohortCode);
            return;
          }
          joinRequestMessage = '';
          openAddEmailsModal([email]);
        } else if (declineButton && !declineButton.disabled) {
          declineJoinRequest(cohortCode, declineButton.getAttribute('data-join-decline'));
        }
      };
    }

    function declineJoinRequest(cohortCode, email) {
      if (showcaseRefuses(cohortCode)) return;
      if (!JOIN_REQUEST_WEBHOOK_URL || !email || joinRequestBusyEmail) return;

      var cohort = findCohortByCode(cohortCode);
      joinRequestBusyEmail = email;
      joinRequestMessage = '';
      renderJoinRequests(cohortCode);

      postJson(JOIN_REQUEST_WEBHOOK_URL, {
        action: 'decline_join_request',
        cohort_code: cohortCode,
        email: email,
        admin_email: cohort && cohort.adminEmail ? cohort.adminEmail : String(CUSTOMER.email || '').trim().toLowerCase()
      }).then(function() {
        joinRequestsDeclined[cohortCode + '|' + email] = true;
        joinRequestMessage = 'Request declined. The student can ask again from the form.';
      }).catch(function() {
        joinRequestMessage = 'Could not decline this request. Check the connection and try again.';
      }).then(function() {
        joinRequestBusyEmail = '';
        if (editingCohortCode === cohortCode) renderJoinRequests(cohortCode);
      });
    }

    function renderEditStudentsList(cohortCode) {
      var approvedList = document.getElementById('cohort-edit-approved-students-list');
      var approvedCount = document.getElementById('cohort-edit-approved-count');
      if (!approvedList) return;

      /* Buttons, banner and Select all always describe the mode the rows are
         about to be drawn in — including after Discard, which clears it. */
      renderRosterModeChrome();
      renderJoinRequests(cohortCode);
      /* read again for another cohort, or after a minute (a reactivation in Postmark shows) */
      if (MAIL_FAILURES_CACHE_URL && !mailFailLoading && (mailFailCohort !== cohortCode || Date.now() - mailFailLoadedAt > 60000)) {
        loadMailFailures(cohortCode);
      }

      /*
        2026-08-17 — the picker is drawn before the list, and while reminder
        mode is waiting for an answer the list is not drawn at all.

        A list underneath an unanswered question invites the admin to act on it
        first, which is the mixing this whole change removes.
      */
      renderReminderAudiencePicker(cohortCode);

      if (rosterEditMode === 'remind' && reminderAudience !== 'form' && reminderAudience !== 'pay' && !editingReadOnly) {
        approvedList.innerHTML = '';
        if (approvedCount) approvedCount.textContent = '0';
        return;
      }

      var cohort = findCohortByCode(cohortCode);
      var rosterEmails = getEditPanelRosterEmails(cohortCode);
      var students = dedupeStudentsByEmail(getStudentsForCohort(cohortCode));

      /*
        2026-08-05 — split into labelled, colour-coded groups. One flat list with
        a pill on each row made "who still has to submit" something you had to
        read row by row; the counts now answer it at a glance.
      */
      /*
        2026-08-06 — numbered per group, not across the whole roster. A single
        running counter split into two lists produced "1, 4, 7" under Confirmed
        and "2, 3, 5" under Waiting: correct as positions in the roster, useless
        as a way to count the people in front of you.
      */
      var confirmedEntries = [];
      var pendingEntries = [];

      /*
        ── 2026-08-17 — one audience at a time (owner) ──────────────────────

        Reminder mode used to show the whole cohort with three buttons under
        it, each silently taking a different subset: the form letter went to
        those who had not submitted, the delivery letter to those who owed, and
        the manual panel to whoever was ticked. An admin had to hold all three
        rules in their head to know what a press would do. The owner said she
        could not, and she wrote them.

        So the audience is chosen first and the list shows only that audience.
        Nothing to hold in your head: whoever is on screen is who the buttons
        act on, and the two groups can no longer be mixed because they are
        never visible together.

        Only inside reminder mode. Every other mode shows the whole cohort, as
        it always has.
      */
      function entryPassesAudience(student, submitted) {
        if (rosterEditMode !== 'remind') return true;

        var owing = !!student && isAwaitingPaymentStudent(student);

        if (reminderAudience === 'pay') return owing;
        if (reminderAudience === 'form') return !submitted && !owing;
        return true;
      }
      /*
        2026-08-06 — students already drawn as a row of the approved list, so
        the "Outside list" below cannot show them a second time.

        How the duplicate happened: the two lists were built independently. The
        rows match a student on any of their addresses (email, roster_email,
        submitted_email, contact_email), while the Outside list selected purely
        on email_match_status. A student who submitted with one address but
        whose record still carries another that IS on the list therefore
        satisfied both, and appeared green above and outside below.

        Fixed by identity rather than by tightening either rule: whatever put a
        student in the list above, they are accounted for and belong in exactly
        one place.
      */
      var rosterMatchedIdentities = {};

      rosterEmails.forEach(function(email) {
        var student = findStudentForRosterEmail(students, email);
        var submitted = student ? hasSubmittedSizes(student) : false;

        if (student) {
          studentIdentityEmails(student).forEach(function(identity) {
            rosterMatchedIdentities[identity] = true;
          });
        }

        /*
          2026-08-11 — a student collecting answers in an open round is listed
          in that round, not here as well. Everyone else stays: confirmed
          students always, and those in the waiting room until a round of their
          own exists, because until then this is the only place they appear.
        */
        if (!isEditingLateStudentsTrack() && student && isOpenRoundStudent(cohort, student)) {
          return;
        }

        if (!entryPassesAudience(student, submitted)) return;

        (submitted ? confirmedEntries : pendingEntries).push({
          email: email,
          student: student,
          submitted: submitted
        });
      });

      /*
        2026-08-09 (owner decision) — one list, two groups. The separate
        "Outside list" block is gone: the red row and the "outside list" badge
        already say what it said, and a third block split the cohort into places
        the admin had to check one by one.

        These are the students the roster walk above could not reach — someone
        who submitted with an address that is on no invite line, and anyone
        whose entry lost its link to one. Merging the block away without them
        would have deleted them from the screen, which is the opposite of what
        removing a block is for: a student the admin cannot see is a student
        they cannot fix.

        Late-round members stay excluded — they are listed in their own round.

        2026-08-10 — and this whole pass is skipped while a late round is on
        screen. There the list above is the round's membership, not the cohort
        roster, so "everyone the walk did not reach" means the entire main
        cohort: reported as every confirmed main student appearing inside
        LATE-01. Nothing is hidden by skipping it — the round's own builder
        already appends members who are on no invite line, and main's confirmed
        students have their own read-only block below.
      */
      /*
        2026-08-17 — and skipped in read-only view as well (owner).

        A finalized main cohort was listing the late round's students as its
        own: the counter said 2 confirmed while four cards were drawn, because
        the counter reads the track-filtered roster and this pass did not.

        The rule below excludes a student only while their round is OPEN — the
        idea being that a closed round returns them to the waiting room, where
        the admin can see them. True while the main cohort is still open. Once
        it is finalized the list stops being a waiting room and becomes the
        record of who was billed, and a late student never was.

        Nothing is lost by skipping: in read-only view getReadOnlyTrackEmails
        already walks every student of the cohort and keeps the ones on this
        track, so the roster above is complete by construction. This pass has
        nothing left to add there — only off-track students to leak in.
      */
      if (!isEditingLateStudentsTrack() && !editingReadOnly) {
        students.forEach(function(student) {
          if (isRemovedStudent(student)) return;
          /* Only an OPEN round takes a student out of this list. Having once
             been in a round that has since closed does not: they are back in
             the waiting room and this is where they are seen. */
          if (isOpenRoundStudent(cohort, student)) return;

          var alreadyShown = studentIdentityEmails(student).some(function(identity) {
            return rosterMatchedIdentities[identity];
          });
          if (alreadyShown) return;

          var identity = getStudentIdentityEmail(student);
          if (!identity) return;

          var submitted = hasSubmittedSizes(student);
          if (!entryPassesAudience(student, submitted)) return;

        (submitted ? confirmedEntries : pendingEntries).push({
            email: identity,
            student: student,
            submitted: submitted
          });
        });
      }

      function renderGroupRows(entries) {
        return entries.map(function(entry, index) {
          return renderCompactEmailRow({
            cohortCode: cohortCode,
            number: index + 1,
            email: entry.email,
            student: entry.student,
            stateClass: getStudentRowStateClass(entry.student, entry.submitted),
            editable: !editingReadOnly,
            removable: !editingReadOnly
          });
        });
      }

      var confirmedRows = renderGroupRows(confirmedEntries);
      var pendingRows = renderGroupRows(pendingEntries);

      var shownCount = confirmedEntries.length + pendingEntries.length;

      /* 2026-10-13 (owner) - on a Send reminders screen only the group the
         screen is about is drawn; an empty "Confirmed 0" above the students
         being reminded is noise. */
      var remindScreen = rosterEditMode === 'remind' && (reminderAudience === 'form' || reminderAudience === 'pay');

      approvedList.innerHTML = shownCount
        ? (remindScreen && !confirmedEntries.length ? '' : renderRosterGroup({
            tone: remindScreen ? 'confirmed is-owing' : 'confirmed',
            title: remindScreen ? 'Not paid yet' : 'Confirmed',
            note: remindScreen ? 'Chose their sizes, delivery not paid yet.' : 'Submitted the form and chose their sizes.',
            rows: confirmedRows,
            emptyText: 'Nobody has submitted yet.'
          })) +
          (remindScreen && !pendingEntries.length ? '' : renderRosterGroup({
            tone: 'pending',
            title: 'Waiting',
            note: 'Invited, but no sizes submitted yet.',
            rows: pendingRows,
            emptyText: 'Everyone has submitted.'
          }))
        : '<p class="admin-edit-empty-note">' +
          (isEditingLateStudentsTrack() ? 'No late students.' : 'No students yet.') +
          '</p>';

      if (approvedCount) approvedCount.textContent = String(shownCount);

      if (isEditingLateStudentsTrack()) {
        bindEmailMgmtHandlers();
        return;
      }

      renderLockedStudentsBlock(cohortCode);
      bindEmailMgmtHandlers();
    }

    /*
      The main cohort's confirmed students, shown read-only underneath a late
      round (2026-08-06, owner's model).

      Only while a late batch is on screen: everywhere else the list above is
      already the whole cohort, and repeating it would be two lists of the same
      people. Read-only is not a restriction added here — these students are
      inside a school order that already exists, so there is nothing this panel
      could change about them.
    */
    function renderLockedStudentsBlock(cohortCode) {
      var block = document.getElementById('cohort-edit-locked-block');
      var list = document.getElementById('cohort-edit-locked-students-list');
      var count = document.getElementById('cohort-edit-locked-count');
      if (!block || !list) return;

      var cohort = findCohortByCode(cohortCode);
      var showBlock = isEditingLateStudentsTrack() && isCohortFinalized(cohort);

      if (!showBlock) {
        block.hidden = true;
        block.setAttribute('aria-hidden', 'true');
        list.innerHTML = '';
        if (count) count.textContent = '0';
        return;
      }

      /* Main track only — a student on a late batch is listed above, in their
         own round. Confirmed only: anyone who never submitted was not billed. */
      var mainConfirmed = dedupeStudentsByEmail(getStudentsForCohort(cohortCode)).filter(function(student) {
        if (isRemovedStudent(student)) return false;
        if (String(student.late_batch_code || '').trim()) return false;
        return hasSubmittedSizes(student);
      });

      if (!mainConfirmed.length) {
        block.hidden = true;
        block.setAttribute('aria-hidden', 'true');
        list.innerHTML = '';
        if (count) count.textContent = '0';
        return;
      }

      list.innerHTML = mainConfirmed.map(function(student, index) {
        return renderCompactEmailRow({
          cohortCode: cohortCode,
          number: index + 1,
          email: getStudentIdentityEmail(student),
          student: student,
          stateClass: getStudentRowStateClass(student, true),
          editable: false,
          removable: false
        });
      }).join('');

      if (count) count.textContent = String(mainConfirmed.length);

      block.hidden = false;
      block.setAttribute('aria-hidden', 'false');
    }

    /*
      2026-08-05 — these handlers now only write into rosterDraft. Nothing here
      contacts Mechanic; that happens once, from Apply. The old instant
      Save/Remove buttons are gone entirely.
    */
    function bindEmailMgmtHandlers() {
      document.querySelectorAll('.em-row-select').forEach(function(checkbox) {
        if (checkbox.dataset.bound === '1') return;
        checkbox.dataset.bound = '1';

        checkbox.addEventListener('change', function() {
          var row = checkbox.closest('.em-row');
          var email = row ? String(row.getAttribute('data-current-email') || '').trim().toLowerCase() : '';
          if (!email) return;

          /* Selection alone changes nothing — no re-render, no data touched. */
          toggleSelection(email, checkbox.checked);
          if (row) row.classList.toggle('is-selected', checkbox.checked);
          updateDraftBar();
        });
      });

      /*
        ── 2026-08-27 — «Add to cohort list» ─────────────────────────────────

        Одно нажатие, один адрес, без письма.

        Сообщение уходит той же задаче и тем же событием, что и обычное
        добавление студентов: add_emails_only говорит «только добавить, список
        не переписывать», skip_notification — «молча». Ничего нового на стороне
        Mechanic для этого не понадобилось: обе возможности у задачи уже были.

        Второй записи студента не появится. Задача считает запись существующей,
        если адрес совпал с любым из четырёх её адресов, и адрес отсюда — один
        из них. Размеры и адрес доставки остаются на месте.

        Кнопка блокируется на время запроса: успешный ответ означает только
        «просьба принята», а не «сделано», и второе нажатие послало бы вторую
        просьбу. Ответ придёт витриной, когда пересборка кэша закончится.
      */
      document.querySelectorAll('[data-add-to-list]').forEach(function(button) {
        if (button.dataset.bound === '1') return;
        button.dataset.bound = '1';

        button.addEventListener('click', function() {
          var addEmail = String(button.getAttribute('data-add-to-list') || '').trim().toLowerCase();
          if (!addEmail || !editingCohortCode) return;

          var row = button.closest('.em-row');
          var rowStatus = row ? row.querySelector('.em-row-status') : null;
          var cohort = findCohortByCode(editingCohortCode);

          button.disabled = true;
          if (rowStatus) {
            rowStatus.textContent = 'Adding to the list...';
            rowStatus.classList.remove('is-success');
          }

          postJson(UPDATE_ROSTER_WEBHOOK_URL, {
            action: 'update_roster_emails',
            source: 'cohort_admin_panel',
            cohort_code: editingCohortCode,
            admin_email: cohort && cohort.adminEmail ? cohort.adminEmail : (CUSTOMER.email || ''),
            add_emails_only: true,
            skip_notification: true,
            new_emails: [addEmail]
          }).then(function() {
            if (rowStatus) {
              rowStatus.textContent = 'Added to the list. The page will catch up in a moment.';
              rowStatus.classList.add('is-success');
            }
            beginEmailMutation(editingCohortCode, 'add', { emails: [addEmail] });
          }).catch(function(error) {
            button.disabled = false;
            if (rowStatus) {
              rowStatus.textContent = (error && error.message)
                ? error.message
                : 'Could not add this student to the list.';
              rowStatus.classList.remove('is-success');
            }
          });
        });
      });

      /*
        2026-08-17 — one debtor, one press, through the same dialog as
        everything else that writes to a student.
      */
      bindStudentNoteHandlers();


      /* The × stages a removal; pressing it again on a marked row takes it back. */
      document.querySelectorAll('.em-row-remove').forEach(function(button) {
        if (button.dataset.bound === '1') return;
        button.dataset.bound = '1';

        button.addEventListener('click', function() {
          var email = String(button.getAttribute('data-remove-email') || '').trim().toLowerCase();
          if (!email) return;

          toggleDraftRemoval(email, !isMarkedForRemoval(email));
          renderEditStudentsList(editingCohortCode);
          updateDraftBar();
        });
      });

      var selectAll = document.getElementById('cohort-select-all');
      if (selectAll && selectAll.dataset.bound !== '1') {
        selectAll.dataset.bound = '1';
        selectAll.addEventListener('change', function() {
          rosterSelection = selectAll.checked ? getSelectableEmails() : [];
          renderEditStudentsList(editingCohortCode);
          updateDraftBar();
        });
      }

      ROSTER_MODE_BUTTONS.forEach(function(entry) {
        var button = document.getElementById(entry.id);
        if (!button || button.dataset.bound === '1') return;
        button.dataset.bound = '1';

        button.addEventListener('click', function() {
          /*
            2026-10-16 (owner): every mode opens on a showcase cohort too,
            Send reminders included - the ticks are shown, and the Send that
            would follow gives way to Cancel (updateDraftBar).
          */
          setRosterEditMode(entry.mode);
        });
      });

      document.querySelectorAll('.em-row-input').forEach(function(input) {
        if (input.dataset.bound === '1') return;
        input.dataset.bound = '1';

        /*
          Staged on blur rather than on every keystroke: re-rendering mid-typing
          would steal focus, and a half-typed address is not a real change yet.
        */
        input.addEventListener('blur', function() {
          var currentEmail = String(input.getAttribute('data-current-email') || '').trim().toLowerCase();
          var nextEmail = String(input.value || '').trim().toLowerCase();
          var row = input.closest('.em-row');
          var statusEl = row ? row.querySelector('.em-row-status') : null;

          if (nextEmail && nextEmail !== currentEmail) {
            if (nextEmail.indexOf('@') === -1) {
              setEmailRowStatus(statusEl, 'Enter a valid email.');
              input.value = getDraftEdit(currentEmail) || currentEmail;
              return;
            }

            var studentForEdit = findStudentByEmail(getStudentsForCohort(editingCohortCode), currentEmail);
            if (isEmailTakenByAnotherStudent(editingCohortCode, nextEmail, studentForEdit)) {
              setEmailRowStatus(statusEl, 'This email is already used by another student in this cohort.');
              input.value = getDraftEdit(currentEmail) || currentEmail;
              return;
            }
          }

          setEmailRowStatus(statusEl, '');
          setDraftEdit(currentEmail, nextEmail);
          renderEditStudentsList(editingCohortCode);
          updateDraftBar();
        });
      });

      var addTextarea = document.getElementById('cohort-edit-add-textarea');
      if (addTextarea && addTextarea.dataset.draftBound !== '1') {
        addTextarea.dataset.draftBound = '1';
        addTextarea.addEventListener('input', updateDraftBar);
      }

      /*
        The add-emails field used to live in the left column, which is now gone.
        Rather than duplicate the markup (and its id) it is moved into the
        collapsible panel once, on first render.
      */
      var addPanel = document.getElementById('cohort-add-students-panel');
      var addSection = document.querySelector('.admin-edit-add-section');
      if (addPanel && addSection && addSection.parentNode !== addPanel) {
        addPanel.appendChild(addSection);
      }

      var addToggle = document.getElementById('cohort-add-students-toggle');
      if (addToggle && addToggle.dataset.bound !== '1') {
        addToggle.dataset.bound = '1';
        /*
          The visible entry point is now the "Add students" mode button; this
          one is hidden. Both go through setRosterEditMode so the discard
          confirmation and the one-action-at-a-time rule cannot be bypassed by
          whichever control happens to be on screen.
        */
        addToggle.addEventListener('click', function() {
          setRosterEditMode('add');
        });
      }

      updateDraftBar();
    }

    /*
      The action bar is the only place that reports pending changes, and it is
      hidden entirely while the draft is empty — nothing to act on, nothing on
      screen.
    */
    /*
      One bar, two modes. Selection wins while anything is ticked, because that
      is what the admin is looking at; otherwise it reports staged changes. Two
      separate bars competing for the same corner of the screen would be worse
      than either.
    */
    function updateDraftBar() {
      var bar = document.getElementById('cohort-draft-bar');
      if (!bar) return;

      if (!draftIsForCohort(editingCohortCode)) resetRosterDraft(editingCohortCode);

      var summary = getDraftSummary();
      var countEl = document.getElementById('cohort-draft-bar-count');
      /* 2026-10-13 (owner) - a reminder screen with students ticked turns the
         bar into the Send bar: how many, Clear, Send. */
      var picked = remindPickedEmails();
      var selectionMode = picked.length > 0 && !editingReadOnly;

      bar.classList.toggle('is-selection-mode', selectionMode);

      var sendButton = document.getElementById('cohort-remind-send');
      if (sendButton) {
        var chosen = collectReminderTargets(picked);
        var chosenTotal = chosen.form.length + chosen.delivery.length;

        sendButton.textContent = remindSending
          ? 'Sending…'
          : 'Send ' + chosenTotal + (chosenTotal === 1 ? ' reminder' : ' reminders');
        sendButton.disabled = remindSending || !chosenTotal;
      }

      if (countEl) {
        if (selectionMode) {
          countEl.textContent = picked.length === 1
            ? '1 student will be reminded'
            : picked.length + ' students will be reminded';
        } else {
          /*
            Spelled out rather than totalled (owner request, 2026-08-05): "3
            changes pending" made the admin re-read the list to find out what
            the three were, which is the moment a wrong removal slips through.
          */
          var parts = [];

          if (summary.removals.length) {
            parts.push(summary.removals.length === 1
              ? '1 student will be removed'
              : summary.removals.length + ' students will be removed');
          }

          if (summary.edits.length) {
            parts.push(summary.edits.length === 1
              ? '1 email will be corrected'
              : summary.edits.length + ' emails will be corrected');
          }

          if (summary.additions.length) {
            parts.push(summary.additions.length === 1
              ? '1 student will be added'
              : summary.additions.length + ' students will be added');
          }

          countEl.textContent = parts.join(' · ');
        }
      }

      var selectAll = document.getElementById('cohort-select-all');
      if (selectAll) {
        var selectable = getSelectableEmails();
        selectAll.checked = selectable.length > 0 && rosterSelection.length === selectable.length;
        selectAll.indeterminate = rosterSelection.length > 0 && rosterSelection.length < selectable.length;
      }

      /* Nothing can be staged on a read-only cohort, so the action bar has
         nothing to report and never appears. */
      var visible = !editingReadOnly && (selectionMode || summary.total > 0);
      bar.hidden = !visible;
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');

      /*
        2026-10-16 (owner, demo stage 5): on a showcase cohort the bar offers
        Cancel only. The first time a change is staged there, the showcase
        window says why - once per opening of the cohort.
      */
      var showcase = isShowcaseCohort(editingCohortCode);
      bar.classList.toggle('is-showcase', showcase);
      var applyButton = document.getElementById('cohort-draft-apply');
      var discardButton = document.getElementById('cohort-draft-discard');
      var clearButton = document.getElementById('cohort-selection-clear');
      if (applyButton) applyButton.hidden = showcase;
      if (sendButton) sendButton.hidden = showcase;
      if (discardButton) discardButton.textContent = showcase ? 'Cancel' : 'Discard';
      if (clearButton) clearButton.textContent = showcase ? 'Cancel' : 'Clear';

      if (showcase && visible && showcaseModalShownFor !== editingCohortCode) {
        showcaseModalShownFor = editingCohortCode;
        openShowcaseModal();
      }
    }

    /*
      removeSelectedStudents() lived here until 2026-08-05. Removal is no longer
      something you do to a selection: in Remove mode each row carries its own ×,
      so there is no "selected, now what" step to bulk-resolve. Selection means
      one thing again — who gets a reminder.
    */
    function clearSelectionAndRender() {
      clearSelection();
      renderEditStudentsList(editingCohortCode);
      updateDraftBar();
    }

    /*
      ── Late round (moved from the status page, 2026-08-05) ──────────────────

      Reuse vs. new batch is decided by the SERVER, not here: Cohort: Send
      Cohort Reminders creates a batch only when no open batch exists (see the
      note at STEP 5 of that task). What this reads from the cache is only used
      to TELL the admin which deadline they are about to reuse — a stale cache
      can make that sentence wrong, never the batch.

      2026-11-02 (owner): the "Use a different deadline instead" link and its
      new_late_batch request are gone. It could only show while a round was
      open, and this modal never opens then; a new date for an open round is
      Change date now (openLateDateModal).
    */

    function getOpenLateBatchInfo(cohortCode) {
      var batches = parseLateBatchesForCohort(cohortCode).slice().sort(function(a, b) {
        return Number(b.late_batch_index || 0) - Number(a.late_batch_index || 0);
      });

      var openBatch = batches.filter(function(batch) {
        return String(batch.status || '').toLowerCase() === 'open';
      })[0] || null;

      var deadline = openBatch ? String(openBatch.late_deadline || '').trim() : '';
      if (!openBatch || !deadline) return null;

      /*
        2026-08-07 — an open round whose date has passed is a different thing
        from an open round, and the difference matters.

        Reported after a round dated the 7th was still open on the 8th: the
        reminder reused that date, so students were emailed a deadline that had
        already gone, and their links opened on "Form closed" — correctly,
        because the date really had passed. The server refuses such a send too,
        and refuses it silently, so nothing looked wrong anywhere.

        Reusing a round's deadline is right only while the deadline is still
        ahead. Once it is behind, there is nothing to reuse: a new date means a
        new round, which means finalizing this one — the owner's rule, applied
        to the case the rule did not originally cover.
      */
      return {
        code: String(openBatch.late_batch_code || '').trim(),
        deadline: deadline,
        deadlineDisplay: String(openBatch.late_deadline_display || deadline).trim(),
        expired: isPastDate(deadline)
      };
    }

    /*
      Usable means: open. Nothing else.

      It used to mean "open and still ahead", and that was the rule that took
      Send reminders away from an overdue round - the admin could see students
      waiting and had no way to write to them, on a round the server was
      perfectly willing to send for (it stopped refusing on 2026-08-25).

      Changed by the owner 2026-09-14 to match the main deadline, which has
      never closed anything by itself: the round stays usable until it is
      finalized. The one thing a passed date still forbids is starting a NEW
      round on it, and that is enforced where new rounds are created - here and
      on the server, both of which ask for a future date.
    */
    function getReusableLateBatchInfo(cohortCode) {
      return getOpenLateBatchInfo(cohortCode);
    }

    /*
      The finalized cohort's half of the same story. The block that starts a
      round moved into the round on 2026-08-11; this is what stands in its
      place, so a closed cohort still says that latecomers have somewhere to go.
      Only a sentence: the round is where the doing happens.
    */
    function renderFinalizedRoundHint(cohortCode, cohort) {
      var hint = document.getElementById('cohort-finalized-round-hint');
      if (!hint) return;

      /*
        Drawn before the hint's own test and outside it: the hint is about the
        waiting room and hides itself inside a round, but a closed ROUND has
        debtors of its own and they are just as unreachable there.
      */

      var show = !!cohort && isCohortFinalized(cohort) && !isEditingLateStudentsTrack();

      if (!show) {
        hint.hidden = true;
        hint.setAttribute('aria-hidden', 'true');
        hint.textContent = '';
        return;
      }

      /* Same count as the late round block, from the same helper — the two
         said different numbers on one screen until 2026-08-17. */
      var waitingCounts = waitingRoomBreakdown(cohort, cohortCode);
      var waiting = waitingCounts.total;

      var openRound = getOpenLateBatchInfo(cohortCode);

      if (openRound) {
        hint.textContent = 'This cohort is finalized. A late round is open — open it below to see who is in it and to send reminders.';
      } else if (waiting > 0) {
        /*
          2026-08-17 — "has not submitted" no longer describes everyone counted
          here: a student who answered and owes postage is waiting too, and the
          button below will take them. A banner that names only one of the two
          would move somebody it never mentioned.
        */
        hint.textContent = 'This cohort is finalized. ' + waiting +
          (waiting === 1 ? ' student is still waiting — ' : ' students are still waiting — ') +
          waitingRoomBreakdownSentence(waitingCounts) +
          '. Press Start late round above to give them a new deadline.';
      } else {
        hint.textContent = 'This cohort is finalized. Everyone submitted before it closed.';
      }

      hint.hidden = false;
      hint.setAttribute('aria-hidden', 'false');
    }

    function renderLateRoundSection(cohortCode) {
      var section = document.getElementById('cohort-late-round-section');
      if (!section) return;

      var cohort = findCohortByCode(cohortCode);
      /*
        Only a finalized cohort can have a late round — before finalize the main
        deadline is the one that matters.

        2026-08-11 — and only inside the round itself. It used to appear in the
        finalized cohort too, where starting a round is not what the admin is
        looking at, and it arrived about five seconds late in both places:
        "finalized" comes from cohort data that the background refresh replaces,
        while which block you are in is known immediately. Reported both ways
        round — flashing on in the cohort, flashing in late in the round.
      */
      /*
        2026-08-17 — and the block has to be REACHABLE, which it had stopped
        being (owner: "кнопки Start Late round нет").

        The rule above was "only inside the round itself, and only when
        editable". Both halves are right while a round is open. Together they
        left no way in once it closed:

          main cohort finalized  → only "View students", read-only, main track
          late round finalized   → only "View students", read-only
          late round open        → editable, but a round is already open, so
                                   the button correctly refuses to offer a second

        Every door read-only, and the block hidden behind all of them. An admin
        who finalized their last round could not start the next one at all —
        while the banner three lines up told them to go and press exactly that
        button.

        So a second state is admitted, deliberately narrow: the finalized
        cohort's own view, and only when NO round is open. That is the moment
        the block has something to offer and the only screen the admin is on.

        This is not the 2026-08-11 problem coming back. Then it showed in both
        places at once, one of them with a round already running. Here it is one
        place, gated on there being no round. The late arrival that change also
        named is still handled where it was: the BUTTON waits for
        lateRoundDataConfirmed below, so nothing offers to start a round the
        page cannot yet see.
      */
      /*
        Corrected the same day: the first attempt admitted only the cohort's
        own view, and the owner had gone into the finalized ROUND — the more
        natural place to look, and still a closed door. Narrowing by screen was
        the wrong axis.

        What actually decides it is whether a round is running:

          a round is open  → the block explains that round, and belongs where
                             the round is worked on, which is editable
          no round is open → the block offers to start one, and belongs on
                             whatever screen of this finalized cohort the admin
                             happens to be standing on

        Still one offer at a time — the gate is the round, not the door — so
        the 2026-08-11 problem of two live blocks cannot return.
      */
      var openRoundForVisibility = getOpenLateBatchInfo(cohortCode);
      var insideOpenRound = isEditingLateStudentsTrack() && !editingReadOnly;

      var visible = !!cohort && isCohortFinalized(cohort) &&
        (insideOpenRound || !openRoundForVisibility);
      var wasHidden = section.hidden;

      renderFinalizedRoundHint(cohortCode, cohort);

      section.hidden = !visible;
      section.setAttribute('aria-hidden', visible ? 'false' : 'true');

      if (!visible) return;

      /*
        Bring it into view the first time it appears. A cohort becomes finalized
        while the admin is looking at the panel, and a block that quietly turns
        up above the fold is a block nobody notices.
      */
      if (wasHidden) {
        window.requestAnimationFrame(function() {
          section.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      /*
        2026-08-06 — the block says something different once a round is open.
        "Give latecomers another chance" is an invitation to start one; leaving
        it up after the invitations had gone out, next to the deadline they
        carry, read as if nothing had happened.

        2026-08-17 — reusing the lookup made for the visibility test above
        rather than asking again: two calls could disagree if the cache were
        replaced between them, and then the block would be drawn for one state
        while deciding by another.
      */
      var info = openRoundForVisibility;

      /*
        2026-08-07, owner's wording — an expired round gets its own look, not a
        longer sentence in the same one. This is the state an admin can do
        nothing useful in until they act, and the previous version said so in
        the same small grey text as everything else, which is how it went
        unnoticed until the cohort was stuck.
      */
      section.classList.toggle('is-expired', !!(info && info.expired));

      var titleEl = document.getElementById('cohort-late-round-title');
      var kickerEl = document.getElementById('cohort-late-round-kicker');
      var textEl = document.getElementById('cohort-late-round-text');
      var buttonEl = document.getElementById('cohort-late-round-button');

      /*
        2026-08-06 — count the students who still owe a form and say so here.
        They are no longer listed under the closed cohort, so this block is the
        only place that knows they exist — and it is the block that invites
        them. A number without a list is enough: the button reaches all of them
        whether or not they are on screen.
      */
      /*
        Corrected 2026-08-06 — counts EVERY student who has not submitted, in
        any batch or none.

        It used to skip anyone carrying a late_batch_code, on the theory that
        they belonged to a round rather than to the main cohort. But starting a
        round stamps that code onto everyone it invites, so the moment a round
        began this number fell to zero while five people could still be missing
        — it went blank exactly when it mattered.

        Counting all of them also matches what the button does: cohort-send-
        cohort-reminders skips only removed, archived and already-submitted
        students, and pulls everyone else into the one open round with that
        round's deadline. Number and action now describe the same people.
      */
      /*
        2026-08-17 — counted by the shared rule, and broken down.

        This used to count only students who had not submitted, which stopped
        matching what the button does the day unpaid students began moving with
        them: the block said one, the banner three lines down said three, on the
        same screen. Both now ask waitingRoomBreakdown.
      */
      var waitingCounts = waitingRoomBreakdown(cohort, cohortCode);

      var missingSentence = waitingCounts.total > 0
        ? ' ' + waitingCounts.total +
          (waitingCounts.total === 1 ? ' student will join it: ' : ' students will join it: ') +
          waitingRoomBreakdownSentence(waitingCounts) + '.'
        : '';
      /* 2026-10-09 (owner) - the card says it in one line; the rest is in the hint. */
      var shortJoinSentence = waitingCounts.total > 0
        ? ' ' + waitingCounts.total + (waitingCounts.total === 1 ? ' student will join.' : ' students will join.')
        : '';
      var roundShortText = '';

      if (kickerEl) kickerEl.textContent = info ? 'Late round open' : 'Late round';

      var roundTitleText = info
        ? 'Deadline ' + info.deadlineDisplay
        : 'Give latecomers another chance';

      if (textEl) {
        var roundText;

        if (info && info.expired) {
          /*
            2026-09-14, owner. This used to announce the round as overdue and
            push the admin towards finalizing it, on the belief that a passed
            date stopped everything. It does not: the students can still fill
            the form in and pay, and reminders still go out to them.

            So the date is reported as what it is - a date that has gone by -
            and the round is described as what it is, open. The urgency belongs
            on finalization, which is the moment that actually shuts the door.
          */
          roundText = 'This round’s date has passed, and the round is still open: students in it can fill the form in and pay. Change date gives the round a new date and, if you choose, emails it to everyone in the round who has not submitted or paid. Finalizing the round is what closes it — students who submitted are billed.';
          roundShortText = 'The date has passed, but the round is still open.';
        } else if (info) {
          roundText = 'To invite latecomers, select them in the list below and press Send reminders — they join this round and get this date. Change date gives the round a new date and, if you choose, emails it to everyone in the round who has not submitted or paid.';
          roundShortText = 'Select latecomers below and press Send reminders to add them.';
        } else {
          /*
            2026-08-17 — "emails every student who has not submitted" stopped
            being the whole truth when unpaid students started moving too, and
            they get a different letter: the form for one group, a payment link
            for the other.
          */
          roundText = 'Students who missed the deadline can be given a new one. Starting a round gives everyone still waiting a new deadline and writes to them — the form to those who have not submitted, a payment link to those who have and still owe for delivery.';
          roundShortText = 'Give everyone still waiting a new deadline.' + shortJoinSentence;
        }

        /*
          The demo says what would happen and why it will not happen here. The
          round itself is not the problem - the letter to every student who has
          not answered is, and those letters are switched off on this page.
        */
        if (isShowcaseCohort(editingCohortCode)) {
          roundText += ' This cohort is an example on display, so no round can be started in it. Create a cohort of your own and it works exactly as it does for a school.';
        }

        textEl.textContent = roundShortText;
        if (titleEl) titleEl.innerHTML = esc(roundTitleText) + adminInfoTipHtml(roundText + missingSentence);
      } else if (titleEl) {
        titleEl.textContent = roundTitleText;
      }

      /*
        The button exists only while there is no round to break. Once one is
        open it would be the second way to send — with a second deadline — and
        that is the thing being removed. Reminders then go through the roster's
        own "Send reminders", which reuses this round's date.
      */
      if (buttonEl) {
        /* Hidden until the server has confirmed the rounds — see
           lateRoundDataConfirmed. On the first paint the panel is drawn from
           the page's cache, and a round it cannot yet see is a round this
           button would offer to start a second time. */
        var mayOfferStart = !info && lateRoundDataConfirmed;

        /*
          ── 2026-08-17 — waiting, said out loud (owner) ──────────────────

          The owner asked why this button arrives late. It does, on purpose:
          the note above records what a stale answer cost once — the button
          reappeared before a refresh could see the open batch, and pressing it
          opened a SECOND round and moved every pending student into it.

          So the wait stays. What changes is that it stops looking like
          nothing: instead of empty space where a button should be, the button
          is there and says it is checking. An admin who can see the system
          working does not press elsewhere or reload.

          Only while a round could still be offered — when one is already open
          there is nothing to wait for and the button stays away entirely.
        */
        var stillChecking = !info && !lateRoundDataConfirmed;

        buttonEl.hidden = !mayOfferStart && !stillChecking;
        buttonEl.setAttribute('aria-hidden', buttonEl.hidden ? 'true' : 'false');
        buttonEl.disabled = stillChecking;
        buttonEl.textContent = stillChecking ? 'Checking rounds…' : 'Start late round';

        /* 2026-11-02 (owner): Change date stands where Start late round stood,
           once a round is open and the server has confirmed it. Not in the
           demo, which has no address to send it to. */
        var dateButtonEl = document.getElementById('cohort-late-date-button');
        if (dateButtonEl) {
          dateButtonEl.hidden = !(info && lateRoundDataConfirmed && SEND_REMINDERS_WEBHOOK_URL);
          dateButtonEl.setAttribute('aria-hidden', dateButtonEl.hidden ? 'true' : 'false');
        }

        /*
          ── 2026-09-14, owner: the demo's dead button ────────────────────

          Opening a round writes to every student who has not answered, and
          mass email is off in the demo - so the address this button posts to
          is not printed for a demo page at all. Pressing it did nothing
          visible: the refusal goes to the roster panel, which is not open when
          the button is pressed from the cohort card.

          A control that answers nothing is worse than one that is plainly
          unavailable, so it says so on itself and refuses to be pressed. The
          sentence beside it, set below, explains why.
        */
        /* 2026-10-16 (owner): on a showcase cohort the button stays
           pressable; openLateRoundModal answers with the showcase window. */
      }
    }

    function openLateRoundModal() {
      var overlay = document.getElementById('cohort-late-round-modal');
      if (!overlay) return;
      if (showcaseRefuses()) return;

      if (!SEND_REMINDERS_WEBHOOK_URL) {
        setRosterPanelMessage(
          CONFIG.demoMode
            ? 'Sign in to open a late round. The demo gives a signed-in visitor a cohort of their own, where rounds and reminders work exactly as they do for a school.'
            : 'Send reminders webhook URL is missing in section settings.',
          false
        );
        return;
      }

      if (readActionLock()) {
        setRosterPanelMessage(ACTION_LOCK_RESUMED_NOTE, false);
        return;
      }

      /*
        2026-08-06 — one open round at a time, enforced here and not only by
        hiding the button.

        A round owns its deadline: while it is open that date is what every
        student in it was told, and starting a second round — or switching this
        one to a new date — puts two dates in circulation at once. That is the
        bug this whole change exists to remove, so the rule lives in the
        function rather than in whichever control happens to call it.

        A different date is a different round, and reaching it means finalizing
        this one first.
      */
      var openRoundBlockingStart = getOpenLateBatchInfo(editingCohortCode);

      if (openRoundBlockingStart) {
        setRosterPanelMessage(
          openRoundBlockingStart.expired
            ? 'This cohort still has a late round open, and its deadline has passed. Press Change date to give it a new one.'
            : 'A late round is already open. Select the students below and press Send reminders to invite them with its deadline — to use a different date, press Change date.',
          false
        );
        return;
      }

      var info = getOpenLateBatchInfo(editingCohortCode);
      var lead = document.getElementById('cohort-late-round-modal-lead');
      var note = document.getElementById('cohort-late-round-note');
      var field = document.getElementById('cohort-late-round-field');
      var input = document.getElementById('cohort-late-round-deadline');

      setLateRoundError('');

      if (lead) {
        lead.textContent = info
          ? 'Everyone who has not submitted yet will be reminded, with the current late deadline: ' + info.deadlineDisplay + '.'
          : 'Choose a deadline for everyone who has not submitted yet.';
      }

      if (note) {
        note.textContent = 'Late submissions ship directly to the student\'s home address.';
      }

      if (field) {
        field.hidden = !!info;
        field.setAttribute('aria-hidden', info ? 'true' : 'false');
      }

      if (input) {
        input.value = '';
        setLateRoundDeadlineMin(input);
      }

      overlay.classList.add('is-open', 'show');
      overlay.setAttribute('aria-hidden', 'false');
    }

    function setLateRoundDeadlineMin(input) {
      var today = new Date();
      var month = String(today.getMonth() + 1);
      var day = String(today.getDate());

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      input.min = today.getFullYear() + '-' + month + '-' + day;
    }

    function closeLateRoundModal() {
      var overlay = document.getElementById('cohort-late-round-modal');
      if (!overlay) return;

      overlay.classList.remove('is-open', 'show');
      overlay.setAttribute('aria-hidden', 'true');
    }

    function setLateRoundError(message) {
      var el = document.getElementById('cohort-late-round-error');
      var text = String(message || '').trim();

      if (el) {
        el.textContent = text;
        el.hidden = !text;
        el.setAttribute('aria-hidden', text ? 'false' : 'true');
      }

      if (text && window.console && console.warn) {
        console.warn('[cohort] Late round refused: ' + text);
      }
    }

    function confirmLateRound() {
      var info = getOpenLateBatchInfo(editingCohortCode);
      var input = document.getElementById('cohort-late-round-deadline');
      var reuse = !!info;
      var deadline = reuse ? info.deadline : String((input && input.value) || '').trim();

      if (!deadline) {
        setLateRoundError('Choose a deadline first.');
        return;
      }

      if (!reuse && isPastDate(deadline)) {
        setLateRoundError('That deadline is in the past. Pick a later date.');
        return;
      }

      if (readActionLock()) {
        setLateRoundError(ACTION_LOCK_RESUMED_NOTE);
        return;
      }

      var cohort = findCohortByCode(editingCohortCode);
      var confirmButton = document.getElementById('cohort-late-round-confirm');

      var payload = {
        action: 'send_cohort_reminders',
        source: 'cohort_admin_panel',
        cohort_code: editingCohortCode,
        admin_email: cohort && cohort.adminEmail ? cohort.adminEmail : (CUSTOMER.email || ''),
        resend_mode: 'resend_form',
        manual_reminder: true,
        late_deadline: deadline,
        late_deadline_display: deadline
      };

      if (confirmButton) confirmButton.disabled = true;
      closeLateRoundModal();

      beginPanelBlockingLoad(PANEL_BLOCKING_APPLY_MS, 'Sending late reminder');
      setRosterPanelMessage(APPLY_PENDING_MESSAGE, true);

      postJson(SEND_REMINDERS_WEBHOOK_URL, payload).then(function() {
        if (confirmButton) confirmButton.disabled = false;
        /*
          No optimistic student changes here: the late batch is created by
          Mechanic and read back from the cache. The block is released by the
          normal sync ladder once the server shows it.
        */
        beginEmailMutation(editingCohortCode, 'late_round', {
          deadline: deadline,
          /* With no open round the server opens one - wait for it to appear. */
          expectNewBatch: !info
        });
        finishEmailPanelMutation(editingCohortCode, '');
      }).catch(function(error) {
        clearEmailInviteLoading(true);
        if (confirmButton) confirmButton.disabled = false;
        setRosterPanelMessage(
          (error && error.message)
            ? ('Could not send the late reminder: ' + error.message + ' Nothing was changed — please try again.')
            : 'Could not send the late reminder. Nothing was changed — please try again.',
          false
        );
      });
    }

    /*
      ── Change date of the open late round (owner, 2026-11-02) ────────────

      Any time the round is open, never to a past date. The round's record
      and every student in it still waiting get the new date; with the box
      ticked (the default) they are emailed it. Students who have paid keep
      their record as it is and get nothing.

      Sent to Cohort: Send Cohort Reminders with change_late_deadline and the
      round named in filter_late_batch_code, so only that round's students
      are touched. A 200 only means the request arrived: the panel waits, as
      for a new round, until the cache shows an open round with the new date.
    */
    function lateRoundWaitingStudents(code) {
      var students = dedupeStudentsByEmail(getStudentsForCohort(editingCohortCode));
      var out = { form: 0, delivery: 0 };
      var wanted = String(code || '').trim().toUpperCase();

      students.forEach(function(student) {
        if (isRemovedStudent(student)) return;
        if (String(student.late_batch_code || '').trim().toUpperCase() !== wanted) return;
        if (isAwaitingPaymentStudent(student)) out.delivery += 1;
        else if (!hasSubmittedSizes(student)) out.form += 1;
      });

      return out;
    }

    function setLateDateError(message) {
      var el = document.getElementById('cohort-late-date-error');
      var text = String(message || '').trim();
      if (!el) return;
      el.textContent = text;
      el.hidden = !text;
      el.setAttribute('aria-hidden', text ? 'false' : 'true');
    }

    function updateLateDateNote() {
      var note = document.getElementById('cohort-late-date-note');
      var emailBox = document.getElementById('cohort-late-date-email');
      var info = getOpenLateBatchInfo(editingCohortCode);
      if (!note || !info) return;

      var waiting = lateRoundWaitingStudents(info.code);
      var total = waiting.form + waiting.delivery;

      if (!total) {
        note.textContent = 'Nobody in this round is still waiting, so no email will go out. The round gets the new date.';
      } else if (emailBox && !emailBox.checked) {
        note.textContent = 'No email will go out. ' + total + (total === 1 ? ' student' : ' students') +
          ' still waiting will see the new date on their form.';
      } else {
        var parts = [];
        if (waiting.form) parts.push(waiting.form + (waiting.form === 1 ? ' student gets' : ' students get') + ' the form');
        if (waiting.delivery) parts.push(waiting.delivery + (waiting.delivery === 1 ? ' student gets' : ' students get') + ' their payment link');
        note.textContent = parts.join(', ') + ', with the new date.';
      }
    }

    function openLateDateModal() {
      var overlay = document.getElementById('cohort-late-date-modal');
      if (!overlay) return;
      if (showcaseRefuses()) return;

      var info = getOpenLateBatchInfo(editingCohortCode);
      if (!info) {
        setRosterPanelMessage('There is no open late round to change the date of.', false);
        return;
      }

      if (readActionLock()) {
        setRosterPanelMessage(ACTION_LOCK_RESUMED_NOTE, false);
        return;
      }

      var lead = document.getElementById('cohort-late-date-lead');
      var input = document.getElementById('cohort-late-date-input');
      var emailBox = document.getElementById('cohort-late-date-email');
      var confirmButton = document.getElementById('cohort-late-date-confirm');

      if (lead) lead.textContent = 'Now: ' + info.deadlineDisplay + (info.expired ? ' (passed)' : '') + '. Choose the new date for this round.';
      if (input) {
        input.value = '';
        setLateRoundDeadlineMin(input);
      }
      if (emailBox) emailBox.checked = true;
      if (confirmButton) confirmButton.disabled = false;

      setLateDateError('');
      updateLateDateNote();

      overlay.classList.add('is-open', 'show');
      overlay.setAttribute('aria-hidden', 'false');
      if (input) input.focus();
    }

    function closeLateDateModal() {
      var overlay = document.getElementById('cohort-late-date-modal');
      if (!overlay) return;
      overlay.classList.remove('is-open', 'show');
      overlay.setAttribute('aria-hidden', 'true');
    }

    function confirmLateDate() {
      var info = getOpenLateBatchInfo(editingCohortCode);
      var input = document.getElementById('cohort-late-date-input');
      var emailBox = document.getElementById('cohort-late-date-email');
      var confirmButton = document.getElementById('cohort-late-date-confirm');
      var deadline = String((input && input.value) || '').trim();

      if (!info) {
        setLateDateError('This round is no longer open. Refresh the page.');
        return;
      }

      /* The server refuses the same - but its refusal never reaches this page. */
      if (!/^\d{4}-\d{2}-\d{2}$/.test(deadline)) {
        setLateDateError('Choose the new date first.');
        return;
      }

      if (isPastDate(deadline)) {
        setLateDateError('That date is in the past. Pick today or a later date.');
        return;
      }

      if (deadline === String(info.deadline || '').slice(0, 10)) {
        setLateDateError('That is the date the round already has.');
        return;
      }

      if (readActionLock()) {
        setLateDateError(ACTION_LOCK_RESUMED_NOTE);
        return;
      }

      if (confirmButton && confirmButton.disabled) return;

      var cohort = findCohortByCode(editingCohortCode);
      var sendLetters = !emailBox || emailBox.checked;

      var payload = {
        action: 'send_cohort_reminders',
        source: 'cohort_admin_change_late_date',
        cohort_code: editingCohortCode,
        admin_email: cohort && cohort.adminEmail ? cohort.adminEmail : (CUSTOMER.email || ''),
        resend_mode: 'resend_form',
        manual_reminder: true,
        change_late_deadline: true,
        filter_late_batch_code: info.code,
        late_deadline: deadline,
        late_deadline_display: deadline,
        send_letters: sendLetters
      };

      if (confirmButton) confirmButton.disabled = true;
      closeLateDateModal();

      beginPanelBlockingLoad(PANEL_BLOCKING_APPLY_MS, 'Saving the new date');
      setRosterPanelMessage(APPLY_PENDING_MESSAGE, true);

      postJson(SEND_REMINDERS_WEBHOOK_URL, payload).then(function() {
        if (confirmButton) confirmButton.disabled = false;
        /* Wait for the cache to show the open round with the new date. */
        beginEmailMutation(editingCohortCode, 'late_round', {
          deadline: deadline,
          expectNewBatch: true
        });
        finishEmailPanelMutation(editingCohortCode, '');
      }).catch(function(error) {
        clearEmailInviteLoading(true);
        if (confirmButton) confirmButton.disabled = false;
        setRosterPanelMessage(
          (error && error.message)
            ? ('Could not change the date: ' + error.message + ' Nothing was changed — please try again.')
            : 'Could not change the date. Nothing was changed — please try again.',
          false
        );
      });
    }

    /*
      Reminders are not a roster change: they write nothing to the cohort, so
      they need neither the batch contract nor the page block. One request per
      student, because the task takes a single target_email. Students who have
      already submitted are skipped rather than refused — the admin selected a
      group, not a mistake.
    */
    /*
      Ask first (2026-08-06). Sending was immediate, which made "Send reminders"
      the only button on the panel that could not be reconsidered — and the only
      one whose effect leaves the building. The dialog names the deadline the
      students will be told, because that is the part the admin cannot check
      afterwards.
    */
    /*
      2026-10-09 (owner) - who gets which letter. Not filled in: the form.
      Filled in and owing: the payment link (needs their token). Anyone else
      gets nothing - a student who has paid is never asked again.
    */
    function collectReminderTargets(emails) {
      var students = dedupeStudentsByEmail(getStudentsForCohort(editingCohortCode));
      var out = { form: [], delivery: [] };

      (emails || []).forEach(function(raw) {
        var email = String(raw || '').trim().toLowerCase();
        if (!email) return;
        var student = findStudentForRosterEmail(students, email);

        if (student && isAwaitingPaymentStudent(student)) {
          var token = String(student.unique_token || '').trim();
          if (token && SEND_PAYMENT_REMINDER_WEBHOOK_URL) out.delivery.push({ email: email, token: token });
          return;
        }

        if (!student || !hasSubmittedSizes(student)) out.form.push(email);
      });

      return out;
    }

    function openReminderConfirm(targets, everyone) {
      if (!SEND_REMINDERS_WEBHOOK_URL) {
        setRosterPanelMessage(
          CONFIG.demoMode
            ? 'Sign in to send reminders. The demo gives a signed-in visitor a cohort of their own, and reminders from it reach the addresses they entered.'
            : 'Send reminders webhook URL is missing in section settings.',
          false
        );
        return;
      }

      var total = targets.form.length + targets.delivery.length;
      if (!total) {
        setRosterPanelMessage('Nobody selected still has a form to fill in or a delivery to pay for.', true);
        return;
      }

      var overlay = document.getElementById('cohort-remind-modal');
      var titleEl = document.getElementById('cohort-remind-modal-title');
      var textEl = document.getElementById('cohort-remind-modal-text');
      var confirmEl = document.getElementById('cohort-remind-modal-confirm');

      /* No dialog in the markup - send rather than strand the admin. */
      if (!overlay) {
        sendReminderBatch(targets);
        return;
      }

      pendingReminderTargets = targets;

      if (titleEl) titleEl.textContent = 'Send ' + total + (total === 1 ? ' reminder?' : ' reminders?');
      if (confirmEl) confirmEl.textContent = 'Send ' + total + (total === 1 ? ' reminder' : ' reminders');

      if (textEl) {
        /*
          2026-08-06 - inside an open late round the date that goes out is the
          ROUND's, not the cohort's; the dialog names the date the letter
          carries.
        */
        var lateRoundForText = getReusableLateBatchInfo(editingCohortCode);
        var cohortForText = findCohortByCode(editingCohortCode);
        var deadline = lateRoundForText
          ? String(lateRoundForText.deadlineDisplay || lateRoundForText.deadline || '').trim()
          : String((cohortForText && (cohortForText.deadlineDisplay || cohortForText.deadline)) || '').trim();

        var parts = [];
        if (targets.form.length) {
          parts.push((targets.form.length === 1 ? '1 student gets' : targets.form.length + ' students get') +
            ' the form' + (deadline ? ' with the deadline ' + deadline + (lateRoundForText ? ' (they join this late round)' : '') : ''));
        }
        if (targets.delivery.length) {
          parts.push((targets.delivery.length === 1 ? '1 student gets' : targets.delivery.length + ' students get') +
            ' their payment link');
        }

        /* 2026-10-13 (owner) - every student on a numbered line of their own,
           the address in bold, so the admin reads exactly who gets a letter. */
        var listed = targets.form.concat(targets.delivery.map(function(target) { return target.email; }));

        textEl.innerHTML =
          '<ol class="cohort-remind-modal-list">' + listed.map(function(email) {
            return '<li><b>' + esc(email) + '</b></li>';
          }).join('') + '</ol>' +
          '<p>' + esc((everyone ? 'Everyone who still owes something. ' : '') +
            parts.join('; ') + '. Letters cannot be called back.') + '</p>';
      }

      overlay.classList.add('is-open', 'show');
      overlay.setAttribute('aria-hidden', 'false');
    }

    var pendingReminderTargets = null;

    function closeRemindModal() {
      var overlay = document.getElementById('cohort-remind-modal');
      pendingReminderTargets = null;

      if (!overlay) return;

      overlay.classList.remove('is-open', 'show');
      overlay.setAttribute('aria-hidden', 'true');
    }

    function confirmSendReminders() {
      var targets = pendingReminderTargets;
      closeRemindModal();

      if (targets && (targets.form.length || targets.delivery.length)) sendReminderBatch(targets);
    }

    /* Both letters, then one sentence about what was asked for. */
    function sendReminderBatch(targets) {
      if (showcaseRefuses()) return;
      var jobs = [];
      remindSending = true;
      updateDraftBar();

      if (targets.form.length) jobs.push(sendSelectedReminders(targets.form));
      if (targets.delivery.length) jobs.push(sendPaymentRemindersTo(targets.delivery, document.getElementById('cohort-remind-send')));

      Promise.all(jobs).then(function(results) {
        remindSending = false;
        updateDraftBar();
        /* A failure has already said so; do not paint it over with success. */
        if (results.indexOf(false) !== -1) return;
        var total = targets.form.length + targets.delivery.length;
        setRosterPanelMessage(
          (total === 1 ? '1 reminder requested' : total + ' reminders requested') +
          ' (' + targets.form.length + ' form, ' + targets.delivery.length + ' payment). They go out in the background; ' +
          'a student who had a letter in the last 10 minutes is skipped.',
          true
        );
      });
    }

    /*
      ── Phase 8, edit C — who can be reminded about delivery ─────────────

      Only a student the RECORD shows as awaiting payment. Not the selection,
      not the admin's guess: a student who has already paid must never be
      asked again, and one who has not answered the form needs the other
      letter entirely.

      The task refuses the same three cases on the server for the same reason,
      and that refusal is the one that counts — this filter exists so the
      button does not offer an action that will be silently declined.
    */
    /* One sender for both entry points — the selection panel and the closed
       cohort's single button. Two copies would drift on the wording that
       carefully avoids promising a letter was sent. */
    function sendPaymentRemindersTo(targets, button) {
      if (!targets.length) return;

      if (button) button.disabled = true;
      setRosterPanelMessage('Sending delivery reminders...', true);

      return Promise.all(targets.map(function(target) {
        return postJson(SEND_PAYMENT_REMINDER_WEBHOOK_URL, {
          action: 'send_payment_reminder',
          source: 'cohort_admin_panel',
          cohort_code: editingCohortCode,
          token: target.token,
          student_email: target.email
        });
      })).then(function() {
        if (button) button.disabled = false;

        /*
          2026-08-17 — clear the ticks (owner).

          The form-reminder path has always done this; this one had not, so
          after sending, the same students stayed selected and the same buttons
          stayed offered. An admin coming back to the page a minute later
          cannot tell a selection they made from one left over from an action
          already taken — and the obvious next move is to press again.

          Re-rendered rather than reloaded: a reload would throw away the
          scroll position and any staged edit, to achieve the same thing.
        */
        clearSelectionAndRender();

        /*
          Asked for, not delivered, and not even certainly sent.

          The webhook answers before the task runs, so the browser cannot know
          the outcome of either question. Two things are therefore withheld
          rather than promised: that the letter arrived — this school has 130
          that were handed to the post and refused — and that it was sent at
          all, since the task declines a second letter inside ten minutes and
          says so only in its own log.

          The old wording claimed "requested" flatly, which reads as "done" to
          anyone who pressed twice. Naming the window here is the only place
          the admin can meet it after the fact.
        */
        setRosterPanelMessage(
          (targets.length === 1
            ? 'Delivery reminder requested for 1 student. It goes out in the background. '
            : 'Delivery reminders requested for ' + targets.length +
              ' students. They go out in the background. ') +
          (targets.length === 1
            ? 'If a letter already went to this student in the last 10 minutes, this one is skipped.'
            : 'Any student who already had a letter in the last 10 minutes is skipped.'),
          true
        );
        return true;
      }).catch(function() {
        if (button) button.disabled = false;
        setRosterPanelMessage('Could not send the delivery reminders. Please try again.', false);
        return false;
      });
    }

    function sendSelectedReminders(targets) {
      var button = document.getElementById('cohort-remind-send');
      var cohort = findCohortByCode(editingCohortCode);

      if (button) button.disabled = true;
      setRosterPanelMessage('Sending reminders...', true);

      var adminEmail = cohort && cohort.adminEmail ? cohort.adminEmail : (CUSTOMER.email || '');

      /*
        2026-08-06 — inside an open late round, a reminder is not a nudge about
        a date that has passed: it is the invitation into the round, and the
        student's form link does not work until they are in it.

        So the payload carries the round's OWN deadline, read from the round
        rather than asked for. cohort-send-cohort-reminders reuses the open
        batch when new_late_batch is not set, which is what puts the student in
        it. Never prompting is the point — a prompt is where the second,
        conflicting date came from.
      */
      var lateRound = getReusableLateBatchInfo(editingCohortCode);

      return Promise.all(targets.map(function(email) {
        var payload = {
          action: 'send_cohort_reminders',
          source: 'cohort_admin_panel',
          cohort_code: editingCohortCode,
          admin_email: adminEmail,
          target_email: email,
          student_email: email,
          manual_reminder: true
        };

        /*
          new_late_batch is deliberately absent: without it the task reuses the
          open batch, which is how the student ends up inside this round rather
          than a new one. filter_late_batch_code is absent too — it filters who
          is eligible to receive, and target_email above already narrows this
          to one person.
        */
        if (lateRound) {
          payload.resend_mode = 'resend_form';
          payload.late_deadline = lateRound.deadline;
          payload.late_deadline_display = lateRound.deadlineDisplay;
        }

        return postJson(SEND_REMINDERS_WEBHOOK_URL, payload);
      })).then(function() {
        if (button) button.disabled = false;
        clearSelectionAndRender();
        setRosterPanelMessage(
          targets.length === 1
            ? 'Reminder sent to 1 student.'
            : 'Reminders sent to ' + targets.length + ' students.',
          true
        );
        return true;
      }).catch(function(error) {
        if (button) button.disabled = false;
        setRosterPanelMessage(
          (error && error.message)
            ? ('Could not send reminders: ' + error.message)
            : 'Could not send reminders. Please try again.',
          false
        );
        return false;
      });
    }

    function draftSummaryLineHtml(text) {
      return '<p class="cohort-draft-modal-line">' + esc(text) + '</p>';
    }

    /* One @, something before it, a dot in the part after it, no spaces. */
    function looksLikeEmailAddress(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
    }

    /*
      2026-10-07 - two addresses that differ by a slip of the keyboard: the
      same name before the @ with another domain, or at most two letters
      changed. Used to catch "remove the old address, add the new one" when the
      admin meant to correct a typo.
    */
    function looksLikeSameAddress(a, b) {
      a = String(a || '').trim().toLowerCase();
      b = String(b || '').trim().toLowerCase();
      if (!a || !b || a === b) return false;
      if (a.split('@')[0] === b.split('@')[0]) return true;
      if (Math.abs(a.length - b.length) > 2) return false;

      var prev = [];
      for (var j = 0; j <= b.length; j += 1) prev.push(j);
      for (var i = 1; i <= a.length; i += 1) {
        var row = [i];
        for (var k = 1; k <= b.length; k += 1) {
          row.push(Math.min(prev[k] + 1, row[k - 1] + 1, prev[k - 1] + (a[i - 1] === b[k - 1] ? 0 : 1)));
        }
        prev = row;
      }
      return prev[b.length] <= 2;
    }

    /*
      Messages about the roster draft must land inside the edit panel.
      #cohort-message — what setMessage() writes to — sits inside the cohort
      CREATE form, which is hidden whenever the edit panel is open, so anything
      sent there while editing is invisible. That is what made Apply look like a
      dead button on 2026-08-05. setMessage is still called as well, for the
      case where the create panel is the one on screen.
    */
    function setRosterPanelMessage(message, isSuccess) {
      var statusEl = document.getElementById('cohort-edit-roster-status');

      if (statusEl) {
        statusEl.textContent = message || '';
        statusEl.classList.toggle('is-success', !!isSuccess);
      }

      setMessage(message, isSuccess ? 'success' : undefined);
    }

    function setDraftModalError(message) {
      var text = String(message || '').trim();
      var errorEl = document.getElementById('cohort-draft-modal-error');

      if (errorEl) {
        errorEl.textContent = text;
        errorEl.hidden = !text;
        errorEl.setAttribute('aria-hidden', text ? 'false' : 'true');
      }

      /*
        The section file is deployed by hand and separately from this one, so
        the error paragraph may simply not be there yet. Falling back to the
        panel message keeps the reason on screen instead of nowhere — silence
        is what cost two rounds of debugging on 2026-08-05.
      */
      if (!errorEl && text) {
        setRosterPanelMessage(text, false);
      }

      /* Also on the console: the fastest way for the owner to report back what
         stopped a batch, without having to describe the screen. */
      if (text && window.console && console.warn) {
        console.warn('[cohort] Apply refused: ' + text);
      }

      return !!text;
    }

    /* Plain-language review before anything is sent. Apply does the sending. */
    function openDraftReviewModal() {
      var overlay = document.getElementById('cohort-draft-modal');
      var listEl = document.getElementById('cohort-draft-modal-list');
      var warningEl = document.getElementById('cohort-draft-modal-warning');
      if (!overlay || !listEl) return;

      var summary = getDraftSummary();
      if (!summary.total) return;

      var lines = '';

      if (summary.removals.length) {
        lines += draftSummaryLineHtml(
          summary.removals.length === 1
            ? '1 student will be removed:'
            : summary.removals.length + ' students will be removed:'
        );
        /* 2026-10-23 (owner) - name each address, not only the count. */
        summary.removals.forEach(function(removed) {
          lines += draftSummaryLineHtml(removed);
        });
      }

      if (summary.edits.length) {
        summary.edits.forEach(function(entry) {
          lines += draftSummaryLineHtml(entry.from + '  →  ' + entry.to);
        });
        /*
          2026-10-07 (owner) - the corrected address is where the student's
          form and payment link go from now on.
        */
        lines += draftSummaryLineHtml('Please check the new address carefully — the student will use it to open their form and pay.');
      }

      /*
        2026-10-07 (owner) - removing one address and adding a near-identical
        one in the same Apply is usually a typo being fixed the long way. That
        way the student starts over as a new student; Edit emails keeps what
        they already did. A hint only - both ways stay allowed.
      */
      summary.removals.forEach(function(removed) {
        var twin = summary.additions.filter(function(added) {
          return looksLikeSameAddress(removed, added);
        })[0];
        if (twin) {
          lines += draftSummaryLineHtml(removed + ' and ' + twin + ' look like the same person. If this fixes a typo, use Edit emails instead — the student keeps their answers and payment.');
        }
      });

      if (summary.additions.length) {
        var cohortForInvite = findCohortByCode(editingCohortCode);

        lines += draftSummaryLineHtml(
          summary.additions.length === 1
            ? '1 student will be added'
            : summary.additions.length + ' students will be added'
        );

        /*
          Spell out what "added" costs them (owner, 2026-08-06): an email goes
          out immediately, and the deadline it names is the one they get.

          2026-08-11 — which deadline that is depends on where they are landing,
          and this sentence used to read it off the cohort every time. On a
          finalized cohort that is the date the main round closed on, so the
          admin was promised an invitation carrying a deadline in the past —
          reported both while a round was open and while none was.
        */
        var openRoundForInvite = getReusableLateBatchInfo(editingCohortCode);
        var inviteLine;

        /* 2026-10-08 - Email students off: added quietly (Update Roster Emails).
           2026-11-02 (owner) - said per case. The status page no longer sends
           forms (Send reminders is on this page), and since 2026-11-02 a
           student added while a late round is open joins that round even with
           letters off - only the letter waits. */
        var lettersOffForInvite = !isSwitchOn(cohortForInvite && cohortForInvite.sendStudentEmails !== undefined ? cohortForInvite.sendStudentEmails : 'true');

        if (lettersOffForInvite && openRoundForInvite) {
          inviteLine = 'They join the late round that is already open, with its deadline, ' + openRoundForInvite.deadlineDisplay +
            '. Email students is off, so no email goes out — when you are ready, select them in the list and press Send reminders.';
        } else if (lettersOffForInvite && isCohortFinalized(cohortForInvite)) {
          inviteLine = 'They are added to the students waiting for a late round. Email students is off, so no email goes out now — they get their form and a deadline when you press Start late round.';
        } else if (lettersOffForInvite) {
          inviteLine = 'Email students is off, so no email goes out. When you are ready, select them in the list and press Send reminders.';
        } else if (openRoundForInvite) {
          inviteLine = 'They join the late round that is already open and get its deadline, ' +
            openRoundForInvite.deadlineDisplay + '.';
        } else if (isCohortFinalized(cohortForInvite)) {
          inviteLine = 'They are added to the students waiting for a late round. No email goes out yet — they get their form and a deadline when you press Start late round.';
        } else if (isPastDate(getCohortDeadlineValue(cohortForInvite))) {
          /*
            An open cohort past its own deadline.

            2026-08-11 — this used to name the cohort's date, which promised an
            invitation carrying a deadline that had already gone.

            2026-08-25 — and then it promised a new one instead, because a date
            was being asked for below. Neither is true now: an open cohort no
            longer asks for a date and no longer starts a round, so the deadline
            does not change at all. What the admin needs to know is the part
            that is easy to doubt — that adding somebody still works — and what
            the letter will say when it arrives.
          */
          inviteLine = 'This cohort is past its deadline, but it is still open — you can keep adding students until you finalize it. Their email will say the date has passed and that they can still choose sizes.';
        } else {
          var inviteDeadline = String((cohortForInvite && (cohortForInvite.deadlineDisplay || cohortForInvite.deadline)) || '').trim();

          inviteLine = 'They will each get an email with their size form' +
            (inviteDeadline ? ', with the deadline ' + inviteDeadline + '.' : '.');
        }

        lines += draftSummaryLineHtml(inviteLine);
      }

      listEl.innerHTML = lines;

      if (warningEl) {
        warningEl.style.display = summary.removals.length ? '' : 'none';
      }

      /* Fresh look at the draft — clear whatever was refused last time. */
      setDraftModalError('');

      var deadlineWrap = document.getElementById('cohort-draft-modal-deadline-wrap');
      if (deadlineWrap) {
        /*
          Not asked for while a round is open — Apply reuses that round's date,
          so a field here would collect an answer nobody acts on. Worse than
          useless: it reads as an invitation to set a new date, which is the
          thing that split a round in two.
        */
        var needsDeadline = summary.additions.length > 0 &&
          needsLateDeadlineForNewEmails(findCohortByCode(editingCohortCode)) &&
          !getReusableLateBatchInfo(editingCohortCode);

        deadlineWrap.hidden = !needsDeadline;
        deadlineWrap.setAttribute('aria-hidden', needsDeadline ? 'false' : 'true');
      }

      /*
        is-open, not show. This overlay is a .cohort-email-modal-backdrop, and
        that class is displayed by .is-open only — .show belongs to the
        finalize/resend/danger overlays, which are a different component. The
        mismatch left the review modal at display:none, so Apply looked like a
        dead button from the day it was wired (found 2026-08-05). Both classes
        are set: the theme is deployed file by file, and a JS-ahead-of-CSS
        moment must not resurrect a dead button.
      */
      overlay.classList.add('is-open', 'show');
      overlay.setAttribute('aria-hidden', 'false');
    }

    function closeDraftReviewModal() {
      var overlay = document.getElementById('cohort-draft-modal');
      if (!overlay) return;

      overlay.classList.remove('is-open', 'show');
      overlay.setAttribute('aria-hidden', 'true');
    }

    /*
      ── Write it myself (2026-08-14) ──────────────────────────────────────

      Built after a school's mail system rejected 130 of 150 invitations: the
      addresses were suppressed by the sending service, and no letter of ours
      could reach those students again until the suppression was lifted.

      A letter from the college to its own students never leaves the college,
      so it meets none of that. This does not send it — it writes it out and
      lets the admin paste it into their own mailbox. Nothing here talks to a
      webhook or changes a record, which is what makes it safe to reach for on
      a bad day.
    */
    /*
      2026-08-19 — список адресов можно передать явно (владелица).

      Раньше панель ручной отправки читала только галочки. У должников галочек
      нет — там у каждой строки своя кнопка, потому что письмо об оплате несёт
      личную ссылку и одно письмо на всех отправить нельзя. Значит и адрес
      должен приходить из строки, а не из выделения.
    */
    function selfSendStudents(emails) {
      var students = getStudentsForCohort(editingCohortCode);
      var source = Array.isArray(emails) ? emails : rosterSelection;

      return source.map(function(email) {
        var student = findStudentForRosterEmail(students, email);
        return { email: email, student: student };
      });
    }

    /*
      The student's own link when the record carries one, otherwise the shared
      link with their token appended — the same address their invitation used.
      Blank only when neither exists, and such a line is left out rather than
      printed broken.
    */
    function selfSendPersonalLink(cohort, entry) {
      var stored = String((entry.student && entry.student.student_form_url) || '').trim();
      if (stored) return preferOwnPathInDemo(stored, STUDENT_FORM_PATH, '/pages/cohort-student');

      var base = preferOwnPathInDemo(
        String((cohort && cohort.studentFormUrl) || '').trim(),
        STUDENT_FORM_PATH,
        '/pages/cohort-student'
      );
      var token = String((entry.student && entry.student.unique_token) || '').trim();

      if (!base || !token) return '';

      return base + (base.indexOf('?') === -1 ? '?' : '&') + 'token=' + encodeURIComponent(token);
    }

    /* freeShipping (2026-10-14): { code, until } - the free-shipping letter
       for one paid student, drawn in the own-codes screen. */
    function openSelfSendModal(explicitEmails, inlineHost, freeShipping) {
      var overlay = document.getElementById('cohort-selfsend-modal');
      var dialogNode = document.querySelector('.cohort-selfsend-modal');

      /* 2026-10-13 (owner) - the own-mailbox screens draw this same letter in
         the panel: the dialog moves into the host and the window stays shut. */
      var inline = !!(inlineHost && inlineHost.nodeType === 1 && dialogNode);
      function showLetter() {
        if (inline) {
          dialogNode.classList.add('is-inline');
          inlineHost.appendChild(dialogNode);
          return;
        }
        overlay.classList.add('is-open', 'show');
        overlay.setAttribute('aria-hidden', 'false');
      }

      /* Осторожно: эта же функция висит обработчиком клика, и тогда первым
         аргументом приходит событие, а не список. Отсюда проверка на массив, а
         не на «что-нибудь передали». */
      var emails = Array.isArray(explicitEmails) ? explicitEmails : rosterSelection;

      if (!overlay || !emails.length) return;

      var cohort = findCohortByCode(editingCohortCode);
      var schoolName = String((cohort && cohort.schoolName) || 'your school').trim();
      var deadline = String((cohort && (cohort.deadlineDisplay || cohort.deadline)) || '').trim();

      /*
        ── 2026-09-01 — the date these letters name (owner) ────────────────

        This is the third place a deadline lives. The task writes one, the
        dashboard sends one, and these letters — the ones the admin copies and
        posts from her own mailbox — quoted the cohort's own date and nothing
        else. For a cohort with a late round open, that date is behind us by
        definition: a round opens only after finalization. So a student
        invited into a round running to 11 September was being asked, by hand,
        to submit by 24 August.

        The round's date wins wherever a round is open, and only while it is
        still ahead — the same rule the letters sent by Mechanic follow, and
        for the same reason: naming a date already gone says either that the
        door is shut or that the school cannot keep its own dates.
      */
      var openRoundForLetter = getReusableLateBatchInfo(editingCohortCode);

      if (openRoundForLetter) {
        deadline = String(openRoundForLetter.deadlineDisplay || openRoundForLetter.deadline || '').trim() || deadline;
      }

      var letterDeadline = deadline && !isPastDate(deadline) ? deadline : '';
      var sharedLink = preferOwnPathInDemo(
        String((cohort && cohort.studentFormUrl) || '').trim(),
        STUDENT_FORM_PATH,
        '/pages/cohort-student'
      );
      var entries = selfSendStudents(emails);

      /*
        ── Phase 8, edit C — two letters, not one ────────────────────────

        This panel used to offer one wording: open the link, enter your email,
        choose your sizes, submit. For a student who has already done all of
        that and owes only their postage, every line of it is wrong — the form
        cannot be filled in twice, and the shared link it offers does not put
        anything in their cart.

        That matters here more than anywhere, because this panel is the way
        out when our own post cannot reach them. A college mail policy refused
        130 of our letters; the school's own mailbox travels inside the school
        and meets none of that. Handing the admin the wrong words at that
        moment boards up the only exit.

        So: if every selected student owes for delivery, the panel writes the
        payment wording and gives each of them their OWN link. A mixed
        selection keeps the invitation, because the invitation is at least
        harmless to someone who has already answered, while the payment letter
        sent to someone who has not answered is simply confusing.
      */
      var payingEntries = entries.filter(function(entry) {
        return String((entry.student && entry.student.status) || '').toLowerCase() === 'awaiting_payment';
      });

      /*
        ── 2026-08-17 — one debtor at a time, and only one (owner) ────────

        The automatic button may take as many as it likes: the task writes a
        separate letter per student, each carrying that student's own link with
        that student's own items.

        A hand-sent letter cannot do that. It is one body sent to a blind-copy
        list, and one body cannot hold a different link for each reader —
        whoever is second gets somebody else's uniform in their cart, which is
        worse than sending nothing. So this panel refuses the plural: exactly
        one student who owes, selected alone, or it declines and says why.

        Not a preference. A shared letter with a personal link inside is not a
        thing that can be written correctly.
      */
      var deliveryMode = entries.length === 1 && payingEntries.length === 1;
      var refusedMixed = payingEntries.length > 0 && !deliveryMode;

      var codeMode = !!(freeShipping && freeShipping.code && entries.length === 1);
      if (codeMode) {
        deliveryMode = false;
        refusedMixed = false;
      }

      if (refusedMixed) {
        var refusalIntro = document.getElementById('cohort-selfsend-intro');

        if (refusalIntro) {
          refusalIntro.textContent = payingEntries.length === 1
            ? 'One of the students you selected owes for delivery. Their letter carries a link built for them alone, so it cannot go out with anybody else — select just that student to send it by hand, or use Send reminders to send to everyone at once.'
            : payingEntries.length + ' of the students you selected owe for delivery. Each of their letters carries a link built for that student alone, so they cannot share one message — select one of them at a time to send by hand, or use Send reminders to send to all of them at once.';
        }

        ['cohort-selfsend-addresses', 'cohort-selfsend-subject', 'cohort-selfsend-body'].forEach(function(id) {
          var field = document.getElementById(id);
          if (field) field.value = '';
        });



      setSelfSendStatus('');
        showLetter();
        return;
      }

      var intro = document.getElementById('cohort-selfsend-intro');
      if (intro) {
        var introTail = codeMode
          ? ' This letter carries this student\'s own free-shipping code, so it goes to them alone.'
          : deliveryMode
            ? ' They have all answered the form and owe only for delivery, so this message points each of them at their own link.'
            : '';

        /*
          2026-08-19 — the count is the fact, so it is set apart (owner).

          The sentence carries two things: how many people this letter is for,
          and what to do next. The first is the one an admin checks before
          copying anything — it is the difference between a letter to one
          person and a letter to thirty — and it was buried in the middle of a
          line of instructions.

          innerHTML rather than textContent because part of the line is marked
          up now. Everything variable in it is escaped; the only markup is ours.
        */
        var countPhrase = entries.length === 1
          ? 'One student selected'
          : entries.length + ' students selected';

        intro.innerHTML =
          '<span class="cohort-selfsend-intro-count">' + esc(countPhrase) + '</span>' +
          '<span class="cohort-selfsend-intro-text">' +
            esc('Copy each piece into a new message in your own email.' + introTail) +
          '</span>';
      }

      var addresses = document.getElementById('cohort-selfsend-addresses');
      if (addresses) {
        addresses.value = entries.map(function(entry) { return entry.email; }).join(', ');
      }

      var subject = document.getElementById('cohort-selfsend-subject');
      if (subject) {
        /*
          2026-08-25 — the school's name comes first in both subjects (owner).

          A student's inbox sorts on the first words. "Your uniform order form"
          is what every one of these letters is called; the school is the part
          that tells them which one this is, and it was last.
        */
        subject.value = codeMode
          ? schoolName + ' Uniform: Your Free-Shipping Code for Your Next Order'
          : deliveryMode
            ? schoolName + ' Uniform: Your Order Is Saved — Pay for Shipping'
            : schoolName + ' Uniform: Choose Your Sizes';
      }

      /*
        ── 2026-09-01 — the copied letter wears the same clothes (owner) ─────

        A student can receive two letters about one uniform: the one Mechanic
        sends and the one the admin pastes from her own mailbox. Until now they
        looked like letters from two different companies — the sent one a laid
        out card, the pasted one a stack of bare paragraphs.

        This is the sent one's shell, brought across from
        cohort-send-cohort-reminders.liquid: the lilac ground, the 600px card,
        the gradient hairline at its top, the uppercase kicker, the big title,
        the pill button and the school's name in the footer.

        Two deliberate differences, both because this HTML is PASTED rather
        than sent:

          - no doctype, html, head or body. A mail composer takes the fragment
            and wraps it in its own document; handing it a whole page produces
            either a stripped mess or a nested one.

          - the accented half of the title is drawn in solid violet, not in
            gradient-clipped text. The sent letter can afford
            -webkit-text-fill-color:transparent because it knows its own
            markup survives; a pasted letter is rewritten by whichever composer
            receives it, and a client that drops the gradient would leave that
            word invisible. Same colour family, no way to vanish.

        Everything a letter differs in — kicker, title, body, button, footer —
        is a slot. The letters themselves stay where they were.
      */
      function cohortLetterShell(parts) {
        var kicker = String(parts.kicker || '');
        var titleBefore = String(parts.titleBefore || '');
        var titleAccent = String(parts.titleAccent || '');
        var contentHtml = String(parts.contentHtml || '');
        var ctaText = String(parts.ctaText || '');
        var ctaHref = String(parts.ctaHref || '');
        var footerName = String(parts.schoolName || '');

        var titleHtml = escapeHtml(titleBefore);

        if (titleAccent) {
          titleHtml += ' <span style="color:#7c3aed;">' + escapeHtml(titleAccent) + '</span>';
        }

        var ctaHtml = ctaHref && ctaText
          ? '<table role="presentation" cellpadding="0" cellspacing="0" align="center" style="margin:32px auto 0;"><tr><td style="border-radius:999px;background:#17151f;">' +
              '<a href="' + escapeHtml(ctaHref) + '" style="display:inline-block;padding:18px 38px;color:#ffffff;text-decoration:none;font-size:18px;font-weight:800;letter-spacing:-0.01em;">' + escapeHtml(ctaText) + ' &rarr;</a>' +
            '</td></tr></table>'
          : '';

        return '' +
          '<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background:#f3effa;padding:40px 16px 44px;"><tr><td align="center">' +
          '<table role="presentation" width="600" cellpadding="0" cellspacing="0" style="max-width:600px;width:100%;"><tr><td style="padding:0 6px;">' +
          '<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="border-radius:28px;overflow:hidden;border:1px solid rgba(136,88,246,0.18);">' +
          '<tr><td style="height:5px;background:linear-gradient(90deg,#ff9ebd 0%,#f472b6 18%,#a875ff 52%,#6d8dff 100%);background-color:#a875ff;font-size:0;line-height:0;">&nbsp;</td></tr>' +
          '<tr><td style="background:#ffffff;padding:44px 40px 40px;">' +
            (kicker
              ? '<p style="margin:0 0 22px;text-align:center;"><span style="display:inline-block;padding:6px 12px;border-radius:999px;background:#f1f0f4;color:#9a94a3;font-size:11px;font-weight:400;letter-spacing:0.08em;text-transform:uppercase;">' + escapeHtml(kicker) + '</span></p>'
              : '') +
            (titleBefore || titleAccent
              ? '<h1 style="margin:0 0 24px;font-size:42px;font-weight:900;letter-spacing:-0.03em;line-height:1.06;color:#17151f;text-align:center;">' + titleHtml + '</h1>'
              : '') +
            '<div style="font-size:15px;line-height:1.7;color:#2a2733;">' + contentHtml + '</div>' +
            ctaHtml +
            (footerName
              ? '<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="margin-top:36px;"><tr><td style="height:1px;background:#ece7f7;font-size:0;line-height:0;">&nbsp;</td></tr>' +
                '<tr><td style="padding-top:20px;text-align:center;">' +
                  '<p style="margin:0;font-size:13px;font-weight:600;letter-spacing:0.14em;text-transform:uppercase;color:#b8b2c4;">' + escapeHtml(footerName) + '</p>' +
                  '<p style="margin:8px 0 0;font-size:14px;line-height:1.55;color:#9a94a3;">Uniform cohort order</p>' +
                '</td></tr></table>'
              : '') +
          '</td></tr>' +
          '</table>' +
          '</td></tr></table>' +
          '</td></tr></table>';
      }

      var body = document.getElementById('cohort-selfsend-body');

      /*
        2026-08-24 — the laid-out copy is cleared before either letter is
        built. One textarea serves both, and a stale copyHtml would let the
        Copy button hand over the previous letter while the box on screen shows
        the current one — the worst kind of wrong, because it looks right.
      */
      if (body && body.dataset) delete body.dataset.copyHtml;

      /*
        ── The payment letter (Send manually) ──────────────────────────────

        2026-10-08 (owner) - only ever the student's own payment page. The
        status cache carries the link (Cohort: Student Checkout Link stores
        it on the record). Same two steps, word for word, as the letter the
        task sends (cohort-send-payment-reminder.liquid, STEP 5): the same
        student can receive both. Change one, change the other.

        No link yet: no letter to copy. The automatic payment reminder asks the
        system for the link, and the letter that carries it goes out by itself.

        The cart-era letter (four steps, "Put my uniform in my cart", the
        $0.00 rescue box) was removed on 2026-10-08 with the owner's approval;
        git tag cohort-before-cart-letter-removal holds it.

        deliveryMode is on only when exactly one student is chosen, so
        entries[0] is always that student here.
      */
      var payLink = '';
      if (deliveryMode && entries.length === 1 && entries[0].student) {
        payLink = String(entries[0].student.draft_order_invoice_url || '').trim();
      }

      if (body && codeMode) {
        /* 2026-10-14 (owner) - the same words as the letter the task sends
           (cohort-free-shipping-after-payment.liquid), with the new date. */
        var freeCode = String(freeShipping.code);
        var freeUntil = String(freeShipping.until || '');

        body.value = [
          'Hello,',
          '',
          'Your uniform shipping is paid - thank you. Here is a free-shipping code for your next order from the shop:',
          '',
          freeCode,
          '',
          'If you would like anything else from the shop, enter this code at checkout. It is valid' + (freeUntil ? ' until ' + freeUntil : '') + ', for one order, and only with the email you used to pay for shipping.',
          '',
          'You can also see this code any time: open your cohort link and enter your email on step 1.',
          '',
          'Questions? Write to contact@apres-scrubs.com.'
        ].join('\n');

        body.dataset.copyHtml = cohortLetterShell({
          kicker: 'Thank you',
          titleBefore: 'Free shipping on your',
          titleAccent: 'next order',
          contentHtml:
            '<p style="margin:0 0 22px;font-size:18px;line-height:1.55;color:#7a7385;text-align:center;font-weight:500;">Your uniform shipping is paid.</p>' +
            '<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="margin:0 0 26px;"><tr><td style="border-radius:22px;background:#f6f1ff;padding:20px 22px;text-align:center;">' +
              '<p style="margin:0 0 6px;color:#6f6a78;font-size:14px;font-weight:500;">Your free-shipping code</p>' +
              '<p style="margin:0;color:#17151f;font-size:19px;font-weight:800;letter-spacing:0.03em;line-height:1.4;word-break:break-all;">' + escapeHtml(freeCode) + '</p>' +
            '</td></tr></table>' +
            '<p style="margin:0 0 18px;font-size:16px;line-height:1.7;color:#2a2733;text-align:center;">If you would like anything else from the shop, enter this code at checkout. It is valid' +
              (freeUntil ? ' until <strong>' + escapeHtml(freeUntil) + '</strong>' : '') + ', for one order, and only with the email you used to pay for shipping.</p>' +
            '<p style="margin:0;font-size:14px;line-height:1.6;color:#9a94a3;text-align:center;">You can also see this code any time: open your cohort link and enter your email on step 1. Questions? Write to <a href="mailto:contact@apres-scrubs.com" style="color:#7c3aed;">contact@apres-scrubs.com</a>.</p>',
          schoolName: schoolName
        });
      } else if (body && deliveryMode && !payLink) {
        body.value = 'This student does not have a payment link yet. Go back and choose "Remind students to pay for delivery" instead: the system creates the link and emails it to the student in a minute.';
      } else if (body && deliveryMode) {
        var payLines = [
          'Note: if you have already paid for shipping, or your school has already written to you about this, please ignore this email.',
          '',
          'Hello,',
          '',
          'Your uniform sizes are saved and your form is complete. Only the shipping is left to pay for.',
          '',
          'Your school pays for the uniform itself — you only pay for shipping, and your place in the school order is held once that payment goes through.',
          '',
          'Here is how to finish. It takes about a minute.',
          '',
          '1. Open your payment page',
          payLink,
          'Your uniform is already on it at $0.00, marked "Paid by school".',
          '',
          '2. Enter your address and phone number, then pay for shipping',
          'Please add your phone number so the delivery service can always reach you if there is a problem. There is no form to fill in again — your sizes are already saved.',
          '',
          'The link keeps working until you pay, so you can come back to this email later. If your uniform does not show $0.00, please do not pay — write to us at contact@apres-scrubs.com and we will sort it out.'
        ];

        /* 2026-09-01 — a letter asking for money should say by when. Pushed
           here rather than written into the array, so the closing lines keep
           their place: the date belongs after the instructions. */
        if (letterDeadline) {
          payLines.push('');
          payLines.push('Please pay by ' + letterDeadline + '.');
        }

        body.value = payLines.join('\n');

        /*
          The same letter laid out, for pasting into email: the Copy button
          puts both this HTML and the plain text on the clipboard, and the mail
          client takes whichever it understands (2026-08-24). Amber for the
          aside at the top, lilac for what is true, grey for the steps
          (2026-08-25, owner).
        */
        var payHtmlParts = [
          '<p style="margin:0 0 20px;padding:9px 14px;border-left:3px solid #f59e0b;background:#fffbf2;font-size:13px;line-height:1.55;color:#92400e;">' +
            '<strong style="font-weight:700;">Note:</strong> if you have already paid for shipping, or your school has already written to you about this, please ignore this email.' +
          '</p>',
          '<p>Hello,</p>',
          '<p style="margin:0 0 18px;padding:18px 20px;border-radius:16px;border:1px solid #e2d3ff;background:#faf8ff;">' +
            '<span style="display:block;margin:0 0 6px;font-size:15px;font-weight:700;line-height:1.5;color:#5b21b6;">Your uniform sizes are saved and your form is complete.</span>' +
            '<span style="display:block;font-size:14px;line-height:1.65;color:#6d5b9a;">Only the shipping is left to pay for. Your school pays for the uniform itself &mdash; and your place in the school order is held once that payment goes through.</span>' +
          '</p>',
          '<p style="margin:0 0 18px;padding:18px 20px;border-radius:16px;background:#f7f7f9;background:linear-gradient(180deg,#fcfcfd 0%,#f4f4f7 100%);">' +
            '<span style="display:block;margin:0 0 10px;font-size:15px;font-weight:700;line-height:1.5;color:#17151f;">Here is how to finish. It takes about a minute.</span>' +
            '<span style="display:block;font-size:14px;line-height:1.65;color:#4b4759;"><span style="display:inline-block;min-width:22px;font-weight:800;color:#7c3aed;">1.</span><strong style="font-size:16px;font-weight:800;color:#3a3745;">Open your payment page</strong><br>' +
              '<a href="' + escapeHtml(payLink) + '" style="color:#17151f;word-break:break-all;">' + escapeHtml(payLink) + '</a><br>' +
              'Your uniform is already on it at <strong style="color:#17151f;">$0.00</strong>, marked <strong>Paid by school</strong>.</span>' +
            '<span style="display:block;margin:14px 0 0;padding:12px 0 0;border-top:1px solid #e6e6ea;font-size:14px;line-height:1.65;color:#4b4759;"><span style="display:inline-block;min-width:22px;font-weight:800;color:#7c3aed;">2.</span><strong style="font-size:16px;font-weight:800;color:#3a3745;">Enter your address and phone number, then pay for shipping</strong><br>' +
              'Please add your phone number so the delivery service can always reach you if there is a problem. There is no form to fill in again &mdash; your sizes are already saved.</span>' +
          '</p>',
          '<p>The link keeps working until you pay, so you can come back to this email later. If your uniform does not show $0.00, <strong>please do not pay</strong> &mdash; write to us at <a href="mailto:contact@apres-scrubs.com">contact@apres-scrubs.com</a> and we will sort it out.</p>'
        ];

        if (letterDeadline) {
          /* Set exactly as the date on the invitation — one shape for one
             kind of fact, whichever of the two letters a student receives. */
          payHtmlParts.push(
            '<p style="margin:0 0 18px;padding:16px 16px;border-radius:12px;background:#fff7ed;border:1px solid #f59e0b;font-size:18px;line-height:1.45;color:#92400e;text-align:center;">' +
              'Please pay by<br><strong style="color:#78350f;">' + escapeHtml(letterDeadline) + '</strong>.' +
            '</p>'
          );
        }

        body.dataset.copyHtml = cohortLetterShell({
          kicker: 'Cohort Uniform Order',
          titleBefore: 'Pay for',
          titleAccent: 'shipping',
          contentHtml: payHtmlParts.join(''),
          ctaText: 'Pay for shipping',
          ctaHref: payLink,
          schoolName: schoolName
        });
      }

      /*
        2026-08-19 — one recipient gets their own link (owner).

        A shared link asks the student to type their address on the form so it
        can find them; a personal one already knows who they are. When the
        letter goes to exactly one person there is no reason to make them type
        anything, and no risk in it either — the risk of a personal link is
        that a second reader opens somebody else's form, and with one reader
        there is no second reader.

        Several recipients keep the shared link, for the same reason the
        payment letter refuses to go to several at once: one body cannot carry
        a different link for each reader.
      */
      var inviteLink = sharedLink;

      if (!deliveryMode && entries.length === 1) {
        var soloLink = selfSendPersonalLink(cohort, entries[0]);
        if (soloLink) inviteLink = soloLink;
      }

      if (body && !deliveryMode && !codeMode) {
        /*
          2026-08-25 — the letter stops naming a date already behind us (owner).

          On an open cohort whose date has passed, "Please submit by the 24th"
          reaches the student on the 25th and reads either as a closed door or
          as a school that cannot keep its own dates. It is neither — the form
          is open — so the letter says that instead, and puts the urgency on
          finalization, which is the thing that really does shut it.

          Computed here rather than after the letter, since 2026-09-01: the
          date is now written into the body rather than appended to it.
        */
        var invitePastDeadline = !isCohortFinalized(cohort) && isPastDate(getCohortDeadlineValue(cohort));

        /* Built once and placed into the letter below rather than appended to
           it — see the note beside lines.push for why the date moved up. Empty
           when there is no date to give, and an empty piece joins to nothing. */
        var inviteDeadlineHtml = '';

        if (invitePastDeadline) {
          inviteDeadlineHtml =
            '<p style="margin:0 0 14px;padding:16px 20px;border-radius:16px;border:1px solid #e2d3ff;background:#f6f1ff;">' +
              '<span style="display:block;margin:0 0 6px;font-size:15px;font-weight:700;line-height:1.5;color:#5b21b6;">The date your school set has passed &mdash; but your cohort is still open.</span>' +
              '<span style="display:block;font-size:14px;line-height:1.65;color:#6d5b9a;">You can still choose your sizes. Please do it soon: once your school closes the order, the only way in is a late round.</span>' +
            '</p>';
        } else if (letterDeadline) {
          /* 2026-09-01 — centred, on two lines, a fifth larger (owner). The
             date is the one thing in this letter a student has to remember, so
             it is set like a date and not like a sentence: the words on one
             line, the day beneath them, the whole thing in the middle of its
             own panel. <br> rather than two paragraphs, because mail clients
             collapse margins between paragraphs unpredictably. */
          inviteDeadlineHtml =
            '<p style="margin:0 0 14px;padding:16px 16px;border-radius:12px;background:#fff7ed;border:1px solid #f59e0b;font-size:18px;line-height:1.45;color:#92400e;text-align:center;">' +
              'Please submit by<br><strong style="color:#78350f;">' + escapeHtml(letterDeadline) + '</strong>.' +
            '</p>';
        }

        var lines = [
          /*
            The invitation's twin of the notice on the payment letter — same
            reason, and the school's own letter is even likelier here, since
            inviting is the thing a school does itself.

            2026-08-25 — turned down (owner). It was set in capitals at the top
            of a short letter, which made the first thing a student read a
            reason not to read the rest. It says the same words in ordinary
            case now, marked as an aside: still the first line, still read,
            no longer the loudest.
          */
          'Note: if you have already filled in the sizes form, or your school has already written to you about this, please ignore this email.',
          '',
          'Hello,',
          '',
          /*
            2026-09-01 — a sentence that survives being sent five times (owner).

            "Good news — your school has OPENED uniform ordering" announces an
            event, and this letter is sent again and again to the same students
            until they answer. By the third one the news is not news, and a
            student who has been putting it off is being congratulated for it.

            What is true every time is the standing fact: the school is
            collecting sizes, and this student has not sent theirs. The note at
            the top already covers anyone who has.
          */
          entries.length === 1
            ? 'Your school is collecting uniform sizes for your program. Everything happens on one page: open the link below, choose your sizes, and submit. It takes about two minutes.'
            : 'Your school is collecting uniform sizes for your program. Everything happens on one page: open the link below, enter your school email address, choose your sizes, and submit. It takes about two minutes.'
        ];

        /*
          2026-09-01 — the date moved up (owner).

          It was pushed on after the link, where it read as an afterthought to
          an address. A deadline is the reason to open the link at all, so it
          now stands between the invitation and the link — read before the
          student leaves the letter, not after.
        */
        if (invitePastDeadline) {
          lines.push('');
          lines.push('The date your school set has passed — but your cohort is still open. You can still choose your sizes. Please do it soon: once your school closes the order, the only way in is a late round.');
        } else if (letterDeadline) {
          lines.push('');
          lines.push('Please submit by ' + letterDeadline + '.');
        }

        lines.push('');
        lines.push(inviteLink);

        /*
          2026-08-25 — the letter stops naming a date already behind us (owner).

          Same correction as the emailed reminder: on an open cohort whose date
          has passed, "Please submit by the 24th" reaches the student on the
          25th and reads either as a closed door or as a school that cannot
          keep its own dates. It is neither — the form is open — so the letter
          says that, and puts the urgency on finalization, which is the thing
          that really does shut it.
        */
        lines.push('');
        lines.push('If you have any questions, just reply to this email.');

        /*
          2026-08-24 — for the student who has already answered (owner).

          The same reasoning as the closing line on the payment letter: this
          goes out to everyone who still looks unanswered, and that is a
          snapshot. Somebody who submitted an hour ago is on the list, reads a
          request to do a thing they have done, and writes back confused.
        */
        body.value = lines.join('\n');

        /*
          The laid-out version for the clipboard, as on the payment letter. The
          box is a textarea and copies plain text; the Copy button puts this
          beside it so a mail client that understands HTML takes this one.

          Short letter, so almost nothing is bold: the link, and the date the
          school is waiting on. Bolding more would make the emphasis mean less.
        */
        var inviteHtmlParts = [
          /*
            2026-08-25 — the notice takes less of the letter (owner).

            It was 16px, bold, inside a two-pixel amber box, and it opened a
            letter of four short paragraphs — the warning outweighed the
            invitation it was warning about. Amber is kept, because that is
            what an aside looks like in these letters, but as a rail down one
            side rather than a box around everything, at 13px and unbolded.
            Noticed, read, and over in one line.
          */
          '<p style="margin:0 0 20px;padding:9px 14px;border-left:3px solid #f59e0b;background:#fffbf2;font-size:13px;line-height:1.55;color:#92400e;">' +
            '<strong style="font-weight:700;">Note:</strong> if you have already filled in the sizes form, or your school has already written to you about this, please ignore this email.' +
          '</p>',
          '<p>Hello,</p>',
          /*
            ── 2026-08-25 — the same two panels as the payment letter (owner) ──

            The opening reads as a welcome rather than an instruction: the good
            news alone in the cohort's lilac, a size larger than the text under
            it, because it is the one sentence that has to land.

            What to do goes in grey underneath, with the link inside it in plain
            black — the same rhythm the payment letter uses, so an admin sending
            both is sending one voice. A solid grey is declared before the
            gradient: Outlook drops gradients and would leave it unpainted.

            Inline styles only, no shorthand a mail client can drop.
          */
          '<p style="margin:0 0 14px;padding:18px 20px;border-radius:16px;border:1px solid #e2d3ff;background:#faf8ff;">' +
            '<span style="display:block;font-size:18px;font-weight:800;line-height:1.4;color:#5b21b6;">Your school is collecting uniform sizes for your program.</span>' +
          '</p>',
          inviteDeadlineHtml,
          '<p style="margin:0 0 18px;padding:18px 20px;border-radius:16px;border:1px solid #ececef;background:#f7f7f9;background:linear-gradient(180deg,#fcfcfd 0%,#f4f4f7 100%);">' +
            '<span style="display:block;font-size:14px;line-height:1.65;color:#4b4759;">' + escapeHtml(entries.length === 1
              ? 'Everything happens on one page: open the link below, choose your sizes, and submit. It takes about two minutes.'
              : 'Everything happens on one page: open the link below, enter your school email address, choose your sizes, and submit. It takes about two minutes.') + '</span>' +
            (inviteLink
              ? '<span style="display:block;margin:14px 0 0;padding:12px 0 0;border-top:1px solid #e6e6ea;">' +
                  '<a href="' + escapeHtml(inviteLink) + '" style="font-size:14px;color:#17151f;word-break:break-all;">' + escapeHtml(inviteLink) + '</a>' +
                '</span>'
              : '') +
          '</p>'
        ];

        inviteHtmlParts.push('<p>If you have any questions, just reply to this email.</p>');

        body.dataset.copyHtml = cohortLetterShell({
          kicker: 'Cohort Uniform Order',
          titleBefore: 'Choose your',
          titleAccent: 'sizes',
          contentHtml: inviteHtmlParts.join(''),
          ctaText: 'Open size form',
          ctaHref: inviteLink,
          schoolName: schoolName
        });
      }

      /*
        2026-08-19 — the fourth box is gone (owner).

        It held one personal link per student, for mail merge. Both letters now
        carry the right link inside the message itself — the payment one always,
        the invitation whenever it goes to a single person — so the box was a
        second copy of something already in the text, and a second copy is a
        choice with no difference in it.
      */

      /*
        ── 2026-08-19 — у каждого поля сказано, куда его вставить ──────────

        Стоит ЗДЕСЬ, после заполнения полей, а не в ветке отказа выше — там
        этот блок и оказался при первой правке, и на обычном пути подписи не
        проставлялись вовсе. Ветка отказа очищает поля и выходит; всё, что
        должно случиться в нормальном случае, обязано быть после неё.

        Подписи объясняют не что это за поле, а в какое поле почтовой
        программы его вставить: первое админ видит сам, второго не знает.
        Тексты разные у приглашения и у письма об оплате — там рассылка на
        всех с общей ссылкой, здесь один человек и ссылка только его.
      */
      function setSelfSendCopy(id, text) {
        var node = document.getElementById(id);
        if (node) node.textContent = text;
      }

      var oneStudent = deliveryMode || codeMode;

      setSelfSendCopy('cohort-selfsend-label-addresses',
        oneStudent ? 'Student address' : 'Student addresses');

      setSelfSendCopy('cohort-selfsend-note-addresses', oneStudent
        ? 'Paste into the To field. This letter is for one student, so there is nobody to hide.'
        : 'Paste into the Bcc field, so students do not see each other.');

      setSelfSendCopy('cohort-selfsend-note-subject', 'Paste into the Subject line.');

      setSelfSendCopy('cohort-selfsend-note-body', codeMode
        ? 'Paste into the message. The code is this student\'s own and works only with their email - send it to them alone.'
        : deliveryMode
          ? 'Paste into the message. The personal link is already inside it — leave it there, it is what puts the uniform back in their cart.'
          : 'Paste into the message. One link for everyone: students enter their own school email on the form and it finds them.');

      setSelfSendStatus('');

      showLetter();
    }

    function closeSelfSendModal() {
      var overlay = document.getElementById('cohort-selfsend-modal');
      if (!overlay) return;

      overlay.classList.remove('is-open', 'show');
      overlay.setAttribute('aria-hidden', 'true');
    }

    function setSelfSendStatus(message) {
      var status = document.getElementById('cohort-selfsend-status');
      if (status) status.textContent = message || '';
    }

    /*
      Selecting the field and asking the browser to copy works everywhere,
      including the older browsers a college computer may be running, and it
      leaves the text visibly selected — so an admin whose browser refuses the
      copy can still press Ctrl+C themselves.
    */
    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    /*
      2026-08-24 — copy the laid-out letter where the browser allows it.

      A textarea can only hold plain text, so bold has to reach the clipboard
      another way: as a second flavour on the same copy. Where the browser
      supports it the mail client takes the HTML and the letter arrives with
      its headings and its numbers; where it does not, everything falls through
      to exactly the behaviour that was here before.

      Never an error the admin has to think about: every failure path ends at
      "the text is selected, press Ctrl+C", which always works.
    */
    function copySelfSendRich(field) {
      var html = field.dataset ? field.dataset.copyHtml : '';
      if (!html) return false;

      if (!navigator.clipboard || !navigator.clipboard.write || typeof ClipboardItem === 'undefined') return false;

      try {
        var item = new ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([field.value], { type: 'text/plain' })
        });

        navigator.clipboard.write([item]).then(function() {
          setSelfSendStatus('Copied with its layout. Paste it into your email.');
        }).catch(function() {
          setSelfSendStatus('The text is selected — press Ctrl+C to copy it.');
        });

        return true;
      } catch (error) {
        return false;
      }
    }

    function copySelfSendField(fieldId) {
      var field = document.getElementById(fieldId);
      if (!field) return;

      if (copySelfSendRich(field)) return;

      field.focus();
      field.select();
      field.setSelectionRange(0, field.value.length);

      var copied = false;

      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }

      if (copied) {
        setSelfSendStatus('Copied. Paste it into your email.');
        return;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(field.value).then(function() {
          setSelfSendStatus('Copied. Paste it into your email.');
        }).catch(function() {
          setSelfSendStatus('The text is selected — press Ctrl+C to copy it.');
        });
        return;
      }

      setSelfSendStatus('The text is selected — press Ctrl+C to copy it.');
    }

    /*
      ── 2026-08-19 — окно заметки: открыть, сохранить ────────────────────

      Сохранение по кнопке, а не по каждой букве. Вебхук отвечает раньше, чем
      задача выполняется, и посимвольная отправка завалила бы Mechanic
      очередью из полусотни запросов на одну фразу.

      «Сохранено» показывается по ответу вебхука, и это честно ровно
      настолько, насколько может быть: 200 значит «запрос принят», не
      «заметка записана». Поэтому текст говорит про появление на экране
      позже, а не обещает готовность.
    */
    var noteModalEmail = '';

    function openStudentNoteModal(email) {
      var overlay = document.getElementById('cohort-note-modal');
      var field = document.getElementById('cohort-note-text');
      var who = document.getElementById('cohort-note-student');
      if (!overlay || !field) return;

      var students = getStudentsForCohort(editingCohortCode);
      var student = findStudentForRosterEmail(students, email);

      noteModalEmail = email;
      field.value = studentNoteText(student);

      if (who) {
        var name = [
          String((student && student.first_name) || '').trim(),
          String((student && student.last_name) || '').trim()
        ].filter(Boolean).join(' ');

        who.textContent = name ? name + ' · ' + email : email;
      }

      /* Nothing written yet means nothing to delete, and a button that would
         do nothing is a question the admin has to answer for no reason. */
      var deleteButton = document.getElementById('cohort-note-delete');
      if (deleteButton) {
        var hasNote = field.value.trim() !== '';
        deleteButton.hidden = !hasNote;
        deleteButton.setAttribute('aria-hidden', hasNote ? 'false' : 'true');
      }

      setStudentNoteStatus('');
      overlay.classList.add('is-open', 'show');
      overlay.setAttribute('aria-hidden', 'false');
      field.focus();
    }

    function closeStudentNoteModal() {
      var overlay = document.getElementById('cohort-note-modal');
      if (!overlay) return;

      overlay.classList.remove('is-open', 'show');
      overlay.setAttribute('aria-hidden', 'true');
      noteModalEmail = '';
    }

    function setStudentNoteStatus(message) {
      var status = document.getElementById('cohort-note-status');
      if (status) status.textContent = message || '';
    }

    function saveStudentNote() {
      var field = document.getElementById('cohort-note-text');
      var saveButton = document.getElementById('cohort-note-save');
      if (!field || !noteModalEmail) return;
      if (isShowcaseCohort(editingCohortCode)) {
        closeStudentNoteModal();
        openShowcaseModal();
        return;
      }

      if (!SAVE_STUDENT_NOTE_WEBHOOK_URL) {
        setStudentNoteStatus('Save student note webhook URL is missing in section settings.');
        return;
      }

      var students = getStudentsForCohort(editingCohortCode);
      var student = findStudentForRosterEmail(students, noteModalEmail);
      var token = String((student && student.unique_token) || '').trim();

      if (!token) {
        setStudentNoteStatus('This student has no record yet, so there is nothing to attach a note to.');
        return;
      }

      var cohort = findCohortByCode(editingCohortCode);
      var text = String(field.value || '').trim();

      if (saveButton) saveButton.disabled = true;
      setStudentNoteStatus('Saving…');

      postJson(SAVE_STUDENT_NOTE_WEBHOOK_URL, {
        action: 'save_student_note',
        source: 'cohort_admin_panel',
        cohort_code: editingCohortCode,
        token: token,
        student_email: noteModalEmail,
        student_name: student ? [student.first_name || '', student.last_name || ''].join(' ').trim() : '',
        note: text,
        admin_email: cohort && cohort.adminEmail ? cohort.adminEmail : (CUSTOMER.email || '')
      }).then(function() {
        /* Показываем сразу, чтобы строка не выглядела неизменной, но это
           только экран: правду принесёт пересборка витрины. */
        if (student) student.note = text;

        /*
          И держим показанное поверх витрины, пока та не догонит: иначе
          фоновое обновление вернёт прежний текст на пару секунд.

          Два ключа, потому что у студента «не из списка» адрес приглашения и
          собственный адрес разные: строка подписана первым, а запись
          опознаётся вторым. Один ключ подошёл бы всем остальным и промахнулся
          бы именно у тех, кого чаще всего и комментируют.
        */
        rememberPendingNote(noteModalEmail, text);

        var identityEmail = student ? getStudentIdentityEmail(student) : '';
        if (identityEmail && identityEmail !== noteModalEmail) {
          rememberPendingNote(identityEmail, text);
        }

        setStudentNoteStatus(text ? 'Saved.' : 'Note cleared.');

        /* Окно закрывается сразу, а строка ещё крутится: смотреть на
           закрытое окно нечего, а строку админ видит и так. */
        var savedFor = noteModalEmail;
        closeStudentNoteModal();
        markNoteSaving(savedFor, true);

        window.setTimeout(function() {
          markNoteSaving(savedFor, false);
        }, NOTE_SAVING_MS);
      }).catch(function(error) {
        setStudentNoteStatus(error && error.message ? error.message : 'Could not save the note. Try again.');
      }).then(function() {
        if (saveButton) saveButton.disabled = false;
      });
    }

    function bindStudentNoteHandlers() {
      document.querySelectorAll('.em-row-note-btn').forEach(function(button) {
        if (button.dataset.bound === '1') return;
        button.dataset.bound = '1';

        button.addEventListener('click', function() {
          var email = String(button.getAttribute('data-note-email') || '').trim().toLowerCase();
          if (email) openStudentNoteModal(email);
        });
      });

      var saveButton = document.getElementById('cohort-note-save');
      if (saveButton && saveButton.dataset.bound !== '1') {
        saveButton.dataset.bound = '1';
        saveButton.addEventListener('click', saveStudentNote);
      }

      var cancelButton = document.getElementById('cohort-note-cancel');
      if (cancelButton && cancelButton.dataset.bound !== '1') {
        cancelButton.dataset.bound = '1';
        cancelButton.addEventListener('click', closeStudentNoteModal);
      }

      /* Delete empties the box and saves, which is the same path Save takes.
         One way in means one way to be wrong, and it is already tested. */
      var deleteNoteButton = document.getElementById('cohort-note-delete');
      if (deleteNoteButton && deleteNoteButton.dataset.bound !== '1') {
        deleteNoteButton.dataset.bound = '1';
        deleteNoteButton.addEventListener('click', function() {
          var field = document.getElementById('cohort-note-text');
          if (field) field.value = '';
          saveStudentNote();
        });
      }
    }

    function bindSelfSendHandlers() {
      var closeButton = document.getElementById('cohort-selfsend-close');
      var overlay = document.getElementById('cohort-selfsend-modal');

      if (closeButton && closeButton.dataset.bound !== '1') {
        closeButton.dataset.bound = '1';
        closeButton.addEventListener('click', closeSelfSendModal);
      }

      if (overlay && overlay.dataset.bound !== '1') {
        overlay.dataset.bound = '1';

        overlay.addEventListener('click', function(event) {
          if (event.target === overlay) closeSelfSendModal();
        });

        overlay.querySelectorAll('[data-copy-target]').forEach(function(button) {
          button.addEventListener('click', function() {
            copySelfSendField(button.getAttribute('data-copy-target'));
          });
        });
      }
    }

    function bindDraftBarHandlers() {
      var applyButton = document.getElementById('cohort-draft-apply');
      var discardButton = document.getElementById('cohort-draft-discard');
      var clearSelected = document.getElementById('cohort-selection-clear');
      var remindSend = document.getElementById('cohort-remind-send');

      if (clearSelected && clearSelected.dataset.bound !== '1') {
        clearSelected.dataset.bound = '1';
        clearSelected.addEventListener('click', clearSelectionAndRender);
      }

      if (remindSend && remindSend.dataset.bound !== '1') {
        remindSend.dataset.bound = '1';
        remindSend.addEventListener('click', sendPickedReminders);
      }

      bindSelfSendHandlers();
      var modalCancel = document.getElementById('cohort-draft-modal-cancel');
      var modalConfirm = document.getElementById('cohort-draft-modal-confirm');

      if (applyButton && applyButton.dataset.bound !== '1') {
        applyButton.dataset.bound = '1';
        applyButton.addEventListener('click', openDraftReviewModal);
      }

      if (discardButton && discardButton.dataset.bound !== '1') {
        discardButton.dataset.bound = '1';
        discardButton.addEventListener('click', discardRosterDraft);
      }

      if (modalCancel && modalCancel.dataset.bound !== '1') {
        modalCancel.dataset.bound = '1';
        modalCancel.addEventListener('click', closeDraftReviewModal);
      }

      if (modalConfirm && modalConfirm.dataset.bound !== '1') {
        modalConfirm.dataset.bound = '1';
        modalConfirm.addEventListener('click', applyRosterDraft);
      }

      [
        { id: 'cohort-remind-modal-cancel', fn: closeRemindModal },
        { id: 'cohort-remind-modal-confirm', fn: confirmSendReminders },
        { id: 'cohort-late-round-button', fn: openLateRoundModal },
        { id: 'cohort-late-round-cancel', fn: closeLateRoundModal },
        { id: 'cohort-late-round-confirm', fn: confirmLateRound },
        { id: 'cohort-late-date-button', fn: openLateDateModal },
        { id: 'cohort-late-date-cancel', fn: closeLateDateModal },
        { id: 'cohort-late-date-confirm', fn: confirmLateDate }
      ].forEach(function(entry) {
        var button = document.getElementById(entry.id);
        if (!button || button.dataset.bound === '1') return;
        button.dataset.bound = '1';
        button.addEventListener('click', entry.fn);
      });

      /* The sentence under the box says whether letters go out. */
      var lateDateEmailBox = document.getElementById('cohort-late-date-email');
      if (lateDateEmailBox && lateDateEmailBox.dataset.bound !== '1') {
        lateDateEmailBox.dataset.bound = '1';
        lateDateEmailBox.addEventListener('change', updateLateDateNote);
      }

      var switchCancel = document.getElementById('cohort-mode-switch-cancel');
      var switchConfirm = document.getElementById('cohort-mode-switch-confirm');

      if (switchCancel && switchCancel.dataset.bound !== '1') {
        switchCancel.dataset.bound = '1';
        switchCancel.addEventListener('click', closeModeSwitchModal);
      }

      if (switchConfirm && switchConfirm.dataset.bound !== '1') {
        switchConfirm.dataset.bound = '1';
        switchConfirm.addEventListener('click', confirmModeSwitch);
      }
    }

    /*
      One request for the whole draft (2026-08-05). Everything the admin staged
      leaves together, as the intended final roster plus the list of renames —
      never as a sequence of separate calls racing each other over the same
      cohort record, which is what produced every disagreement between the
      dashboard, the status page and the cache.
    */
    /*
      Nothing in this flow may fail silently. A refusal has a reason, and a
      thrown error has a message — both belong on screen, because a Mechanic
      webhook cannot report back and the admin has no other way to find out that
      their changes never left the browser.
    */
    function applyRosterDraft() {
      try {
        applyRosterDraftUnsafe();
      } catch (error) {
        setDraftModalError(
          'Something went wrong preparing your changes: ' +
          ((error && error.message) ? error.message : String(error)) +
          '. Nothing was sent.'
        );
        if (window.console && console.error) console.error('applyRosterDraft failed', error);
      }
    }

    function applyRosterDraftUnsafe() {
      if (showcaseRefuses()) return;
      var summary = getDraftSummary();
      if (!summary.total) {
        setDraftModalError('There are no changes to apply. Mark a student for removal, correct an email, or add new addresses first.');
        return;
      }

      /*
        Refusals keep the modal open and speak inside it. Closing it and writing
        the reason to the page message is what hid every refusal behind the
        create form on 2026-08-05.
      */
      if (!UPDATE_ROSTER_WEBHOOK_URL) {
        setDraftModalError('Update email list webhook URL is missing in section settings.');
        return;
      }

      var problem = validateRosterDraft(summary);
      if (problem) {
        setDraftModalError(problem);
        return;
      }

      /* Someone else's write is still in flight — do not start a second one. */
      if (readActionLock()) {
        setDraftModalError(ACTION_LOCK_RESUMED_NOTE);
        return;
      }

      var cohort = findCohortByCode(editingCohortCode);
      var finalEmails = buildFinalRosterEmails();
      var confirmButton = document.getElementById('cohort-draft-modal-confirm');

      /*
        Кого нет в списке школы, того нельзя из него вычесть — см.
        splitRemovalsByRoster. Такие уходят отдельной задачей, по записи.
      */
      var removalSplit = splitRemovalsByRoster(editingCohortCode, summary.removals);

      /*
        Отказ вслух. Раньше при пустом адресе вебхука такое удаление просто не
        происходило, и панель об этом молчала — а молчание здесь опаснее самой
        поломки: админ уходит уверенным, что студент убран.
      */
      if (removalSplit.offRoster.length && !REMOVE_STUDENT_WEBHOOK_URL) {
        setDraftModalError(
          (removalSplit.offRoster.length === 1 ? 'This student is' : 'These students are') +
          ' not on the school list, so removing them needs the "Remove student webhook URL"' +
          ' setting, which is empty. Ask your developer to fill it in.'
        );
        return;
      }

      var payload = {
        action: 'update_roster_emails',
        source: 'cohort_admin_panel',
        cohort_code: editingCohortCode,
        admin_email: cohort && cohort.adminEmail ? cohort.adminEmail : (CUSTOMER.email || ''),
        roster_mode: 'final',
        student_emails: finalEmails,
        email_edits: summary.edits.map(function(pair) {
          return { from: pair.from, to: pair.to };
        })
      };

      /*
        Students invited to a finalized or overdue cohort need a deadline of
        their own; the server refuses the invitation without one, and that
        refusal never reaches the browser.
      */
      if (summary.additions.length && needsLateDeadlineForNewEmails(cohort)) {
        /*
          2026-08-06 — the second door into two rounds at once, found the same
          way as the first: by an admin losing a student.

          Adding somebody to a finalized cohort asked for a deadline every
          time, even with a round already open. A fresh date makes a fresh
          batch, the new student lands in it, and everyone who was pending in
          the previous round is left behind there — invisible, because the
          panel shows the batch it is looking at. Nothing was deleted; the
          student had simply been sorted into a round nobody was looking at.

          A round owns its deadline. If one is open, the new student joins it,
          and the date is not asked for — same rule as the reminder buttons.
        */
        var openRoundForAdd = getReusableLateBatchInfo(editingCohortCode);

        if (openRoundForAdd) {
          payload.late_deadline = openRoundForAdd.deadline;
          payload.late_deadline_display = openRoundForAdd.deadlineDisplay;
          payload.resend_mode = 'resend_form';
        } else {
          var deadlineInput = document.getElementById('cohort-draft-modal-deadline');
          var lateDeadline = deadlineInput ? String(deadlineInput.value || '').trim() : '';

          if (!lateDeadline) {
            setDraftModalError('Set a deadline for the students you are adding.');
            return;
          }

          if (isPastDate(lateDeadline)) {
            setDraftModalError('That deadline is in the past. Pick a later date.');
            return;
          }

          payload.late_deadline = lateDeadline;
          payload.late_deadline_display = lateDeadline;
          payload.resend_mode = 'resend_form';
        }
      }

      setDraftModalError('');
      if (confirmButton) confirmButton.disabled = true;
      closeDraftReviewModal();

      beginPanelBlockingLoad(PANEL_BLOCKING_APPLY_MS, 'Applying changes');
      setRosterPanelMessage(APPLY_PENDING_MESSAGE, true);

      postJson(UPDATE_ROSTER_WEBHOOK_URL, payload).then(function() {
        /*
          Список записан. Теперь те, кого он выразить не может: студенты не из
          списка школы уходят своей задачей, по записи.

          Строго после, а не параллельно: обе задачи пишут в одни и те же
          записи студентов, и порядок между ними должен быть определённым.
        */
        return removalSplit.offRoster.length
          ? removeOffRosterStudents(editingCohortCode, removalSplit.offRoster)
          : null;
      }).then(function() {
        /*
          Local state is moved forward only so the page does not visibly snap
          back while the task runs. It is never treated as confirmation:
          beginEmailMutation records what to look for, and the sync ladder holds
          the block until the server actually shows it.
        */
        applyDraftToLocalState(summary, finalEmails);

        beginEmailMutation(editingCohortCode, 'apply', {
          removed: summary.removals.slice(),
          added: summary.additions.slice(),
          edits: summary.edits.map(function(pair) {
            return { from: pair.from, to: pair.to };
          })
        });

        resetRosterDraft(editingCohortCode);

        var addTextarea = document.getElementById('cohort-edit-add-textarea');
        if (addTextarea) addTextarea.value = '';

        if (confirmButton) confirmButton.disabled = false;

        renderEditStudentsList(editingCohortCode);
        updateDraftBar();
        finishEmailPanelMutation(editingCohortCode, '');
      }).catch(function(error) {
        /*
          The draft is deliberately left intact: the request never reached
          Mechanic, so nothing was applied and the admin can retry without
          re-entering everything.
        */
        clearEmailInviteLoading(true);
        if (confirmButton) confirmButton.disabled = false;
        setRosterPanelMessage(
          (error && error.message)
            ? ('Could not send your changes: ' + error.message + ' Nothing was changed — please try again.')
            : 'Could not send your changes. Nothing was changed — please try again.',
          false
        );
      });
    }

    /* Optimistic only. See the note at the call site. */
    function applyDraftToLocalState(summary, finalEmails) {
      var students = getStudentsForCohort(editingCohortCode).slice();

      var removed = {};
      summary.removals.forEach(function(email) {
        removed[email] = true;
      });

      var renamed = {};
      summary.edits.forEach(function(pair) {
        renamed[pair.from] = pair.to;
      });

      students = students.filter(function(student) {
        return !studentIdentityEmails(student).some(function(email) {
          return removed[email];
        });
      });

      students.forEach(function(student) {
        var next = '';

        studentIdentityEmails(student).forEach(function(email) {
          if (renamed[email]) next = renamed[email];
        });

        if (!next) return;

        var previousRoster = String(student.roster_email || '').trim().toLowerCase();

        student.email = next;
        student.submitted_email = next;
        student.contact_email = next;

        /* The invitation moves only when it was the address being renamed.
           Correcting an outside-list student's own address must leave the line
           they were invited on where it is — same rule the server follows. */
        if (!previousRoster || renamed[previousRoster]) {
          student.roster_email = next;
        }
      });

      summary.additions.forEach(function(email) {
        if (findStudentForRosterEmail(students, email)) return;

        students.push({
          email: email,
          status: 'pending',
          email_match_status: 'matched',
          roster_email: email,
          first_name: '',
          last_name: '',
          student_id: '',
          late_batch_code: ''
        });
      });

      persistStudentsToCache(editingCohortCode, students);
      persistRosterToCohort(editingCohortCode, finalEmails);
    }

    function discardRosterDraft() {
      resetRosterDraft(editingCohortCode);

      var addTextarea = document.getElementById('cohort-edit-add-textarea');
      if (addTextarea) addTextarea.value = '';

      renderEditStudentsList(editingCohortCode);
      updateDraftBar();
    }

    /*
      2026-08-18 — та же задача, что зовёт removeStudentFromCohort, но без
      окна подтверждения и без возни со строкой: здесь подтверждение уже
      получено на весь черновик, а строк может быть несколько.

      По одному запросу на студента, потому что задача принимает одного. Это
      не цикл ради цикла: адресов «не из списка» в когорте единицы.
    */
    function removeOffRosterStudents(cohortCode, emails) {
      var cohort = findCohortByCode(cohortCode);
      var adminEmail = cohort && cohort.adminEmail ? cohort.adminEmail : (CUSTOMER.email || '');

      return Promise.all((emails || []).map(function(email) {
        return postJson(REMOVE_STUDENT_WEBHOOK_URL, {
          action: 'remove_student',
          source: 'cohort_admin_panel',
          cohort_code: cohortCode,
          student_email: email,
          admin_email: adminEmail
        }).then(function() {
          applyOptimisticRemove(cohortCode, email);
        });
      }));
    }

    function removeStudentFromCohort(cohortCode, studentEmail, statusEl, button, row) {
      if (showcaseRefuses(cohortCode)) return;
      var cohort = findCohortByCode(cohortCode);

      if (!REMOVE_STUDENT_WEBHOOK_URL) {
        if (statusEl) statusEl.textContent = 'Remove student webhook URL is missing in section settings.';
        return;
      }

      if (!studentEmail) {
        if (statusEl) statusEl.textContent = 'No student email to remove.';
        return;
      }

      if (editingCohortFinalized && cohort) {
        var students = getStudentsForCohort(cohortCode);
        var target = students.find(function(student) {
          return String(student.email || '').trim().toLowerCase() === String(studentEmail || '').trim().toLowerCase();
        });

        if (target && !canEditStudentEmail(cohort, target)) {
          if (statusEl) statusEl.textContent = 'This student is confirmed and cannot be removed after finalize.';
          return;
        }
      }

      openAdminRemoveStudentModal({ studentEmail: studentEmail }).then(function(confirmed) {
        if (!confirmed) return;

        if (button) button.disabled = true;
        beginPanelBlockingLoad(PANEL_BLOCKING_REMOVE_MS, 'Removing student');
        setEmailRowLoading(row, true);
        if (statusEl) {
          statusEl.textContent = 'Removing...';
          statusEl.classList.remove('is-success');
        }

        postJson(REMOVE_STUDENT_WEBHOOK_URL, {
          action: 'remove_student',
          source: 'cohort_admin_panel',
          cohort_code: cohortCode,
          student_email: studentEmail,
          admin_email: cohort && cohort.adminEmail ? cohort.adminEmail : (CUSTOMER.email || '')
        }).then(function() {
          applyOptimisticRemove(cohortCode, studentEmail);
          beginEmailMutation(cohortCode, 'remove', { email: String(studentEmail || '').trim().toLowerCase() });
          if (statusEl) {
            statusEl.textContent = 'Removed';
            statusEl.classList.add('is-success');
          }
          finishEmailPanelMutation(cohortCode, '');
        }).catch(function(error) {
          finishPanelBlockingLoad(true);
          setEmailRowLoading(row, false);
          if (statusEl) {
            statusEl.textContent = error && error.message ? error.message : 'Unable to remove student.';
            statusEl.classList.remove('is-success');
          }
          if (button) button.disabled = false;
        });
      });
    }

    function mergeCohortLabelIntoSnapshot(snapshotRaw, label) {
      var snapshot = {};

      try {
        snapshot = snapshotRaw ? JSON.parse(snapshotRaw) : {};
      } catch (error) {
        snapshot = {};
      }

      if (!snapshot || typeof snapshot !== 'object' || Array.isArray(snapshot)) {
        snapshot = {};
      }

      snapshot.cohort_label = String(label || '').trim();
      return JSON.stringify(snapshot);
    }

    function applyOptimisticCohortLabel(cohortCode, label) {
      var normalized = normalizeKey(cohortCode);
      if (!normalized) return;

      var trimmedLabel = String(label || '').trim();
      var snapshotRaw = '';

      MY_COHORTS.forEach(function(cohort, index) {
        if (normalizeKey(cohort.cohortCode) !== normalized) return;

        snapshotRaw = mergeCohortLabelIntoSnapshot(
          cohort.campusAddressSnapshot || cohort.campus_address_snapshot || '',
          trimmedLabel
        );

        MY_COHORTS[index] = Object.assign({}, cohort, {
          cohortLabel: trimmedLabel,
          campusAddressSnapshot: snapshotRaw
        });
      });

      STATUS_CACHES.forEach(function(cache, index) {
        if (normalizeKey(cache.cohortCode) !== normalized || !cache.summaryJson) return;

        try {
          var summary = typeof cache.summaryJson === 'string'
            ? JSON.parse(cache.summaryJson)
            : Object.assign({}, cache.summaryJson);
          summary.cohort_label = trimmedLabel;
          STATUS_CACHES[index] = Object.assign({}, cache, {
            summaryJson: JSON.stringify(summary)
          });
        } catch (error) {
          /* ignore malformed summary cache */
        }
      });

      persistCohortMeta(cohortCode, { cohortLabel: trimmedLabel });
      markSessionCohort(cohortCode, { cohortLabel: trimmedLabel });
    }

    function saveCohortLabel(cohortCode, label, statusEl, button) {
      if (!UPDATE_COHORT_LABEL_WEBHOOK_URL) {
        if (statusEl) statusEl.textContent = 'Update cohort name webhook URL is missing.';
        return;
      }

      var cohort = findCohortByCode(cohortCode);
      var trimmedLabel = String(label || '').trim();

      if (!trimmedLabel) {
        if (statusEl) {
          statusEl.textContent = 'Enter a cohort name.';
          statusEl.classList.remove('is-success');
        }
        return;
      }

      if (button) button.disabled = true;
      setEmailPanelLoading(true);
      if (statusEl) {
        statusEl.textContent = 'Saving...';
        statusEl.classList.remove('is-success');
      }

      postJson(UPDATE_COHORT_LABEL_WEBHOOK_URL, {
        action: 'update_cohort_label',
        source: 'cohort_admin_panel',
        cohort_code: cohortCode,
        cohort_label: trimmedLabel,
        cohort_name: trimmedLabel,
        admin_email: cohort && cohort.adminEmail ? cohort.adminEmail : (CUSTOMER.email || '')
      }).then(function() {
        applyOptimisticCohortLabel(cohortCode, trimmedLabel);

        var titleWrapEl = document.getElementById('cohort-edit-title-wrap');
        if (titleWrapEl && !isEditingLateStudentsTrack()) titleWrapEl.innerHTML = cohortTitleHtml(trimmedLabel);

        if (statusEl) {
          statusEl.textContent = '';
          statusEl.classList.add('is-success');
        }
        endTitleEdit();

        renderManageCohorts();
      }).catch(function(error) {
        if (statusEl) {
          statusEl.textContent = error && error.message ? error.message : 'Unable to save cohort name.';
          statusEl.classList.remove('is-success');
        }
      }).finally(function() {
        setEmailPanelLoading(false);
        if (button) button.disabled = false;
      });
    }

    /*
      2026-10-09 (owner) - the name is edited in the title itself. The pencil
      turns the title into a field and becomes a tick; the tick (or Enter)
      saves, Escape gives up.
    */
    function isEditingTitle() {
      var row = document.querySelector('.cohort-edit-title-row');
      return !!(row && row.classList.contains('is-renaming'));
    }

    function startTitleEdit() {
      var row = document.querySelector('.cohort-edit-title-row');
      var title = document.getElementById('cohort-edit-title-wrap');
      var input = document.getElementById('cohort-edit-label-input');
      var button = document.getElementById('cohort-edit-rename-button');
      var status = document.getElementById('cohort-edit-label-status');
      var cohort = findCohortByCode(editingCohortCode);
      if (!row || !input || !cohort) return;

      /* 2026-10-09 (owner) - the field takes the title's own type, a touch
         smaller, read from the page rather than assumed, and is as tall as
         the title was: two lines of title, two lines of field. */
      if (title) {
        var look = window.getComputedStyle(title);
        var titleSize = parseFloat(look.fontSize) || 40;
        input.style.fontFamily = look.fontFamily;
        input.style.fontWeight = look.fontWeight;
        input.style.letterSpacing = look.letterSpacing;
        input.style.fontSize = Math.round(titleSize * 0.9) + 'px';
        input.style.lineHeight = look.lineHeight === 'normal' ? '1.1' : (parseFloat(look.lineHeight) / titleSize).toFixed(3);
      }

      row.classList.add('is-renaming');
      if (title) title.hidden = true;
      input.hidden = false;
      input.value = getCohortLabel(cohort);
      fitTitleField(input);
      if (status) { status.textContent = ''; status.classList.remove('is-success'); }
      if (button) { button.setAttribute('aria-label', 'Save name'); button.title = 'Save'; }
      input.focus();
      input.select();
    }

    /* The field grows and shrinks with its text, as the title would wrap. */
    function fitTitleField(input) {
      if (!input) return;
      input.style.height = 'auto';
      input.style.height = input.scrollHeight + 'px';
    }

    function endTitleEdit() {
      var row = document.querySelector('.cohort-edit-title-row');
      var title = document.getElementById('cohort-edit-title-wrap');
      var input = document.getElementById('cohort-edit-label-input');
      var button = document.getElementById('cohort-edit-rename-button');
      if (!row) return;
      row.classList.remove('is-renaming');
      if (title) title.hidden = false;
      if (input) input.hidden = true;
      if (button) { button.setAttribute('aria-label', 'Rename this cohort'); button.title = 'Rename'; }
    }

    function saveTitleEdit() {
      var input = document.getElementById('cohort-edit-label-input');
      if (!editingCohortCode || !input) return;
      if (isShowcaseCohort(editingCohortCode)) {
        endTitleEdit();
        openShowcaseModal();
        return;
      }
      saveCohortLabel(
        editingCohortCode,
        input.value,
        document.getElementById('cohort-edit-label-status'),
        document.getElementById('cohort-edit-rename-button')
      );
    }

    /*
      ── Emails to students: two switches (owner, 2026-10-08) ─────────────

      Email students is cohort.send_student_emails; Automatic reminders is a
      cohort_settings record (Cohort: Update Email Settings writes both).
      The two are independent (owner, 2026-10-08).

      A click is not a save. The webhook answers before the task runs (trap
      3), so the switch shows "Saving..." until this page, fetched again,
      carries the new value - the same re-fetch the roster editor uses. An
      empty or failed fetch is "not known yet", never "not saved".
    */
    /* 2026-10-09 (owner: saving felt slow) - the first look comes sooner and
       the checks are closer together; the wait itself is Mechanic running. */
    var EMAIL_SETTINGS_FIRST_CHECK_MS = 1200;
    var EMAIL_SETTINGS_POLL_MS = 1500;
    var EMAIL_SETTINGS_WAIT_MS = 60000;
    var emailSettingsPending = false;

    function isSwitchOn(value) {
      return String(value || '').trim().toLowerCase() === 'true';
    }

    function setMailSwitch(button, on, disabled) {
      if (!button) return;
      button.setAttribute('aria-checked', on ? 'true' : 'false');
      button.classList.toggle('is-on', !!on);
      button.disabled = !!disabled;
    }

    function renderEmailSettings(cohort) {
      var card = document.getElementById('cohort-mail-card');
      if (!card || !cohort) return;

      var emailsOn = isSwitchOn(cohort.sendStudentEmails);
      var remindersOn = isSwitchOn(cohort.autoReminders);
      var finalized = isCohortFinalized(cohort);
      var locked = editingReadOnly || emailSettingsPending;

      /* 2026-11-02 (owner) - one switch for the cohort and its late rounds:
         after finalization it keeps working while a round is open (Cohort:
         Send Reminders writes to that round's students, with its date). It
         stops only when nothing is left open. The finalized cohort's own view
         is read-only for the roster, not for this switch. */
      var openRoundForReminders = finalized ? getOpenLateBatchInfo(cohort.cohortCode || editingCohortCode) : null;
      var remindersStopped = finalized && !openRoundForReminders;
      var remindersLocked = emailSettingsPending || remindersStopped || (editingReadOnly && !openRoundForReminders);

      setMailSwitch(document.getElementById('cohort-mail-emails'), emailsOn, locked);
      setMailSwitch(document.getElementById('cohort-mail-reminders'), remindersOn, remindersLocked);

      var emailsTile = document.getElementById('cohort-mail-emails-tile');
      var remindersTile = document.getElementById('cohort-mail-reminders-row');
      if (emailsTile) emailsTile.classList.toggle('is-on', emailsOn);
      if (remindersTile) remindersTile.classList.toggle('is-on', remindersOn && !remindersStopped);

      var emailsState = document.getElementById('cohort-mail-emails-state');
      var remindersState = document.getElementById('cohort-mail-reminders-state');
      if (emailsState) emailsState.textContent = emailsOn ? 'On' : 'Off';
      if (remindersState) {
        remindersState.textContent = remindersStopped
          ? 'Stopped · cohort finalized'
          : (remindersOn ? (openRoundForReminders ? 'On · every 2 days · late round' : 'On · every 2 days') : 'Off');
      }

      /* 2026-10-09 (owner) - while a tile saves, its own line says so and
         blinks; no separate note. Redrawn here so a background redraw keeps it. */
      [[emailsTile, emailsState], [remindersTile, remindersState]].forEach(function(pair) {
        if (pair[0] && pair[1] && pair[0].classList.contains('is-saving')) pair[1].textContent = 'Saving...';
      });

      /* The demo is never sent the scheduled letters (cohort-send-reminders). */
      var remindersRow = document.getElementById('cohort-mail-reminders-row');
      if (remindersRow) remindersRow.hidden = !!CONFIG.demoMode;

      var help = document.getElementById('cohort-mail-reminders-help');
      if (help) {
        help.textContent = remindersStopped
          ? 'This cohort is finalized, so reminders have stopped. With the switch on, they start again for a late round while it is open.'
          : (openRoundForReminders
            ? 'Every two days while the late round is open, with its date. Students who have not filled in the form are reminded to do it; students who filled it in but have not paid are reminded to pay for delivery.'
            : 'Every two days until the cohort is finalized. Students who have not filled in the form are reminded to do it; students who filled it in but have not paid are reminded to pay for delivery.');
      }
    }

    function fetchServerCohort(cohortCode) {
      var syncUrl = window.location.pathname + window.location.search;
      syncUrl += (syncUrl.indexOf('?') >= 0 ? '&' : '?') + '_sync=' + Date.now();

      return fetch(syncUrl, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Accept': 'text/html' }
      })
        .then(function(response) { return response.ok ? response.text() : ''; })
        .then(function(html) {
          var fresh = html ? extractWindowArrayFromHtml(html, 'COHORT_ADMIN_MY_COHORTS') : null;
          if (!fresh || !fresh.length) return null;
          return fresh.find(function(entry) {
            return normalizeKey(entry.cohortCode) === normalizeKey(cohortCode);
          }) || null;
        })
        .catch(function() { return null; });
    }

    function storeServerEmailSettings(cohortCode, serverCohort) {
      MY_COHORTS.forEach(function(cohort, index) {
        if (normalizeKey(cohort.cohortCode) !== normalizeKey(cohortCode)) return;
        MY_COHORTS[index] = Object.assign({}, cohort, {
          sendStudentEmails: serverCohort.sendStudentEmails,
          autoReminders: serverCohort.autoReminders
        });
      });
    }

    /*
      2026-10-09 (owner) - while a switch saves, the same loading window as a
      roster change covers the page, so nothing else can be pressed. Unlike a
      roster change it has no minimum time: it goes the moment the save is
      confirmed (or given up on), and it speaks of seconds, not minutes.
    */
    var EMAIL_SETTINGS_RING_ESTIMATE_MS = 15000;

    function setEmailSettingsBlocking(active) {
      var panel = document.getElementById('cohort-email-edit-panel');

      if (active) {
        panelRingLabelText = 'Saving email settings';
        setEmailPanelLoading(true);
        if (panel) panel.classList.add('is-blocking');
        setAdminPageBlocked(true);
        startPanelLoadingProgress(EMAIL_SETTINGS_RING_ESTIMATE_MS);

        /* Its own words: the roster captions talk about one to two minutes. */
        if (panelCaptionTimer) {
          window.clearInterval(panelCaptionTimer);
          panelCaptionTimer = null;
        }
        var ringNote = document.getElementById('cohort-email-edit-ring-note');
        if (ringNote) ringNote.textContent = 'Saving your email settings. This usually takes a few seconds — please wait.';
        return;
      }

      stopPanelLoadingProgress();
      setEmailPanelLoading(false);
      if (panel) panel.classList.remove('is-blocking');
      setAdminPageBlocked(false);
    }

    function saveEmailSettings(cohortCode, wantEmails, wantReminders) {
      if (showcaseRefuses(cohortCode)) return;
      var statusEl = document.getElementById('cohort-mail-status');
      var cohort = findCohortByCode(cohortCode);
      if (!cohort || emailSettingsPending) return;

      function say(text, success) {
        if (!statusEl) return;
        statusEl.textContent = text;
        statusEl.classList.toggle('is-success', !!success);
      }

      if (!UPDATE_EMAIL_SETTINGS_WEBHOOK_URL) {
        say('Email settings webhook URL is missing.');
        return;
      }

      var wantEmailsText = wantEmails ? 'true' : 'false';
      var wantRemindersText = wantReminders ? 'true' : 'false';

      emailSettingsPending = true;
      /* 2026-10-09 (owner) - the tile whose switch was pressed shimmers and its
         own line reads "Saving..." (renderEmailSettings). Only an error is
         written below the tiles. */
      var savingTile = document.getElementById(
        wantEmails !== isSwitchOn(cohort.sendStudentEmails) ? 'cohort-mail-emails-tile' : 'cohort-mail-reminders-row'
      );
      if (savingTile) savingTile.classList.add('is-saving');
      say('');
      setEmailSettingsBlocking(true);
      /* Show the choice while it is on its way, locked. */
      renderEmailSettings(Object.assign({}, cohort, {
        sendStudentEmails: wantEmailsText,
        autoReminders: wantRemindersText
      }));

      function finish(serverCohort, text, success) {
        emailSettingsPending = false;
        if (savingTile) savingTile.classList.remove('is-saving');
        setEmailSettingsBlocking(false);
        if (serverCohort) storeServerEmailSettings(cohortCode, serverCohort);
        /* The admin may have moved on to another cohort meanwhile. */
        if (normalizeKey(editingCohortCode) !== normalizeKey(cohortCode)) return;
        renderEmailSettings(findCohortByCode(cohortCode));
        say(text, success);
      }

      var started = Date.now();
      var lastSeen = null;

      function checkSaved() {
        fetchServerCohort(cohortCode).then(function(serverCohort) {
          if (serverCohort) {
            lastSeen = serverCohort;
            if (isSwitchOn(serverCohort.sendStudentEmails) === wantEmails &&
                isSwitchOn(serverCohort.autoReminders) === wantReminders) {
              /* The switch itself shows the result; no "Saved" (owner). */
              finish(serverCohort, '', true);
              return;
            }
          }

          if (Date.now() - started >= EMAIL_SETTINGS_WAIT_MS) {
            finish(lastSeen, 'Not confirmed yet. Refresh the page in a minute to see whether it was saved.');
            return;
          }

          setTimeout(checkSaved, EMAIL_SETTINGS_POLL_MS);
        });
      }

      postJson(UPDATE_EMAIL_SETTINGS_WEBHOOK_URL, {
        action: 'update_email_settings',
        source: 'cohort_admin_panel',
        cohort_code: cohortCode,
        send_student_emails: wantEmailsText,
        auto_reminders: wantRemindersText,
        admin_email: cohort.adminEmail ? cohort.adminEmail : (CUSTOMER.email || '')
      }).then(function() {
        setTimeout(checkSaved, EMAIL_SETTINGS_FIRST_CHECK_MS);
      }).catch(function(error) {
        finish(null, error && error.message ? error.message : 'Unable to save. Check your connection and try again.');
      });
    }

    function openCohortEmailEditor(cohortCode, options) {
      options = options || {};
      var cohort = findCohortByCode(cohortCode);
      if (!cohort) return;

      editingCohortCode = cohort.cohortCode;
      /* A draft belongs to one cohort — never carry staged changes across. */
      resetRosterDraft(cohort.cohortCode);
      editingLateStudentsTrack = !!options.lateTrack && isCohortFinalized(cohort);
      editingLateBatchCode = editingLateStudentsTrack ? String(options.lateBatchCode || '').trim().toUpperCase() : '';
      /*
        2026-10-16 (owner, demo stage 5): a showcase cohort is no longer
        opened read-only. A visitor presses every mode and sees what it does;
        nothing is sent - see showcaseRefuses. Read-only stays for the
        "View students" button it was made for.
      */
      editingReadOnly = !!options.readOnly;
      showcaseModalShownFor = '';
      /* A different cohort's rounds have not been confirmed by anything yet. */
      lateRoundDataConfirmed = false;
      persistEmailEditState(cohort.cohortCode);
      setManagePanelsVisible('edit');

      var editPanel = document.getElementById('cohort-email-edit-panel');
      if (editPanel) editPanel.classList.toggle('is-read-only', editingReadOnly);

      /* Why this one cannot be changed, said inside the cohort it is about. */
      var showcaseNote = document.getElementById('cohort-showcase-note');
      if (showcaseNote) showcaseNote.hidden = !isShowcaseCohort(cohort.cohortCode);

      var statusLink = document.getElementById('cohort-edit-status-link');
      var addTextarea = document.getElementById('cohort-edit-add-textarea');
      var rosterStatus = document.getElementById('cohort-edit-roster-status');
      var labelInput = document.getElementById('cohort-edit-label-input');
      var labelStatus = document.getElementById('cohort-edit-label-status');

      endTitleEdit();
      applyLateTrackEditPanelChrome(cohort);
      renderEditCohortMeta(cohort);
      rosterFilterState = { kind: 'all', query: '' };
      var rosterSearchBox = document.getElementById('cohort-roster-search');
      if (rosterSearchBox) rosterSearchBox.value = '';
      bindRosterFilter();
      syncRosterFilter();
      if (statusLink) statusLink.href = buildStatusPageUrl(cohort);
      if (addTextarea) addTextarea.value = '';
      if (rosterStatus) rosterStatus.textContent = '';
      if (labelInput) labelInput.value = getCohortLabel(cohort);
      if (labelStatus) labelStatus.textContent = '';
      var mailStatus = document.getElementById('cohort-mail-status');
      if (mailStatus && !emailSettingsPending) mailStatus.textContent = '';
      renderEmailSettings(cohort);

      setCohortEmailEditorLockState(cohort);
      /*
        2026-08-11 — the whole panel, not two of its five parts.

        Opening a view used to redraw the lists and leave the late-round block,
        the finalized-cohort sentence and the stat tiles to the background sync,
        which arrives seconds later. Switching between the cohort and its round
        therefore showed the previous view's block until then — reported in both
        directions, and read as the blocks "loading slowly".

        Going through the one function that redraws everything also means the
        next part added here cannot be forgotten the same way.
      */
      refreshEmailManagementUI(cohort.cohortCode);

      /*
        Nothing is chosen for the admin any more. Owner, 2026-09-15.

        Opening a finalized cohort with a round open used to arrive in Send
        reminders already: with a round open, the argument went, writing to the
        people still missing is the only thing left to do, so the admin should
        meet ticks and a button rather than a row of verbs.

        Two things had changed since that was written. A round no longer closes
        on its deadline, so this fired on every finalized cohort that had ever
        opened one, not only on the handful still waiting for an answer. And on
        the demo the chosen button is the one that is switched off - a screen
        that opens with a disabled control already pressed.

        Underneath both is the thing to remember: a mode carries a verb, and
        every tick on the list means whatever the verb says. Arriving in a mode
        nobody chose means the first tick does something nobody decided.
      */

      startEmailPanelIdleSync(cohort.cohortCode);

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    var pendingAddEmails = [];
    var pendingAddEmailsReuseDeadline = '';

    function openAddEmailsModal(emails) {
      pendingAddEmails = emails.slice();
      pendingAddEmailsReuseDeadline = '';
      setAddEmailsModalLoading(false);

      var cohort = findCohortByCode(editingCohortCode);
      var finalized = isCohortFinalized(cohort);
      var lateTrackAdd = isEditingLateStudentsTrack();
      var lateDecision = lateTrackAdd ? getLateBatchAddEmailsDecision(editingCohortCode) : null;
      var reuseDeadline = lateDecision && !lateDecision.next_batch_required ? lateDecision.open_batch_deadline : '';
      var reuseDeadlineDisplay = lateDecision && !lateDecision.next_batch_required
        ? (lateDecision.open_batch_deadline_display || lateDecision.open_batch_deadline)
        : '';

      /*
        2026-08-06 — the fourth way to mint a second deadline, found by auditing
        the other three rather than by losing another student.

        lateDecision is only consulted on the Late students track, so adding
        from the Main track of a finalized cohort still asked for a fresh date —
        and a fresh date makes a fresh round, stranding everyone pending in the
        previous one. Same fault as the reminder buttons and as Apply, through a
        door nobody had walked yet.

        Safe to override: next_batch_required means precisely "there is no open
        batch", so reusing when one IS open cannot add students to a round that
        is being billed.
      */
      if (!reuseDeadline) {
        var openRoundForModal = getReusableLateBatchInfo(editingCohortCode);

        if (openRoundForModal) {
          reuseDeadline = openRoundForModal.deadline;
          reuseDeadlineDisplay = openRoundForModal.deadlineDisplay || openRoundForModal.deadline;
        }
      }

      var needsLateDeadline = reuseDeadline
        ? false
        : (lateTrackAdd ? true : needsLateDeadlineForNewEmails(cohort));
      pendingAddEmailsReuseDeadline = reuseDeadline || '';
      var confirmButton = document.getElementById('cohort-add-emails-modal-confirm');
      var cancelButton = document.getElementById('cohort-add-emails-modal-cancel');
      var title = document.getElementById('cohort-add-emails-modal-title');
      var lead = document.getElementById('cohort-add-emails-modal-lead');
      var note = document.getElementById('cohort-add-emails-modal-note');
      var lateWrap = document.getElementById('cohort-add-emails-late-deadline-wrap');
      var lateInput = document.getElementById('cohort-add-emails-late-deadline');
      var lateError = document.getElementById('cohort-add-emails-late-deadline-error');
      var emailLead = pendingAddEmails.length === 1
        ? pendingAddEmails[0]
        : 'these students';

      if (confirmButton) {
        confirmButton.disabled = false;
        confirmButton.textContent = reuseDeadline
          ? 'Add & notify'
          : getAddEmailsModalConfirmLabel(needsLateDeadline, false);
      }
      if (cancelButton) {
        cancelButton.disabled = false;
      }
      if (title) {
        title.textContent = reuseDeadline
          ? 'Add student to this Late Cohort?'
          : (needsLateDeadline ? 'Add late students' : 'Send form invitations?');
      }
      if (lead) {
        lead.textContent = reuseDeadline
          ? emailLead + ' will receive a reminder email with the current deadline: ' + reuseDeadlineDisplay + '.'
          : (needsLateDeadline
            ? 'Choose a new deadline for ' + emailLead + '.'
            : 'These students will receive an email with a link to choose their scrub sizes for this cohort.');
      }
      if (note) {
        var noteText = reuseDeadline
          ? ''
          /*
            2026-08-25 — the second half of this went with the rule above it.

            "The original deadline has passed. Choose a new deadline" was what
            an open cohort said; an open cohort no longer asks for a date, so
            needsLateDeadline can only be true on a finalized one and that
            branch could never be reached again. Removed rather than left
            looking alive.
          */
          : (needsLateDeadline
            ? 'Late submissions ship directly to the student\'s home address.'
            : 'They will appear in your pending list until they submit the form.');

        if (!reuseDeadline && finalized && needsLateDeadline) {
          noteText = 'This creates a new Late Cohort block in addition to your main cohort — visible on both the dashboard and the student status page. ' + noteText;
        }

        if (!reuseDeadline && finalized && lateDecision) {
          if (lateDecision.next_batch_required && lateDecision.previous_batch_code) {
            noteText = lateBatchFinalizedWarningText(lateDecision.previous_batch_code) + ' ' + noteText;
          }
        }

        note.textContent = noteText;
      }
      if (lateWrap) {
        lateWrap.hidden = !needsLateDeadline;
      }
      if (lateInput) {
        lateInput.value = '';
      }
      if (lateError) {
        lateError.style.display = 'none';
        lateError.textContent = '';
      }
      if (needsLateDeadline) {
        setAddEmailsDeadlineMin();
      }

      var modal = document.getElementById('cohort-add-emails-modal');
      var list = document.getElementById('cohort-add-emails-modal-list');
      if (list) {
        if (needsLateDeadline && pendingAddEmails.length === 1) {
          list.hidden = true;
          list.textContent = '';
        } else {
          list.hidden = false;
          list.textContent = pendingAddEmails.join('\n');
        }
      }
      if (modal) {
        modal.classList.add('show');
        modal.setAttribute('aria-hidden', 'false');
      }
      if (needsLateDeadline && lateInput) {
        lateInput.focus();
      }
    }

    function closeAddEmailsModal() {
      pendingAddEmails = [];
      pendingAddEmailsReuseDeadline = '';
      setAddEmailsModalLoading(false);
      var modal = document.getElementById('cohort-add-emails-modal');
      if (modal) {
        modal.classList.remove('show');
        modal.setAttribute('aria-hidden', 'true');
      }
    }

    function addOrReplaceRosterEmails(emails, statusEl, button, addOnly, options) {
      options = options || {};
      var cohort = findCohortByCode(editingCohortCode);
      var finalized = isCohortFinalized(cohort);

      if (finalized && !addOnly) {
        if (statusEl) statusEl.textContent = 'This cohort is finalized. The approved email list cannot be changed.';
        statusEl.classList.remove('is-success');
        return;
      }

      var isLateTrackAdd = addOnly && isEditingLateStudentsTrack();
      var needsLateDeadline = !isLateTrackAdd && needsLateDeadlineForNewEmails(cohort);

      if (needsLateDeadline && addOnly) {
        var lateDeadline = String(options.late_deadline || '').trim();
        if (!lateDeadline) {
          if (statusEl) {
            statusEl.textContent = 'Choose a late submission deadline before adding students.';
            statusEl.classList.remove('is-success');
          }
          return;
        }

        if (isPastDate(lateDeadline)) {
          if (statusEl) {
            statusEl.textContent = 'The late submission deadline cannot be in the past.';
            statusEl.classList.remove('is-success');
          }
          return;
        }
      }

      if (!emails.length) {
        if (statusEl) {
          statusEl.textContent = 'Add at least one valid email.';
          statusEl.classList.remove('is-success');
        }
        return;
      }

      if (!UPDATE_ROSTER_WEBHOOK_URL) {
        if (statusEl) {
          statusEl.textContent = 'Update email list webhook URL is missing in section settings.';
          statusEl.classList.remove('is-success');
        }
        return;
      }

      if (button) button.disabled = true;
      if (addOnly) {
        beginPanelBlockingLoad(PANEL_BLOCKING_ADD_MS, 'Adding students');
        setAddEmailsModalLoading(true);
      } else {
        setEmailPanelLoading(true);
      }
      if (statusEl) {
        if (addOnly) {
          var lateDeadlineForStatus = String(options.late_deadline || '').trim();
          statusEl.textContent = (isLateTrackAdd && !lateDeadlineForStatus) ? 'Adding students...' : 'Sending invitations...';
        } else {
          statusEl.textContent = 'Saving email list...';
        }
        statusEl.classList.remove('is-success');
      }

      var payload = {
        action: 'update_roster_emails',
        source: 'cohort_admin_panel',
        cohort_code: editingCohortCode,
        admin_email: cohort && cohort.adminEmail ? cohort.adminEmail : (CUSTOMER.email || '')
      };

      if (addOnly) {
        payload.add_emails_only = true;
        payload.new_emails = emails;
        if (isLateTrackAdd) {
          var lateTrackDeadline = String(options.late_deadline || '').trim();
          if (lateTrackDeadline) {
            payload.late_deadline = lateTrackDeadline;
            payload.late_deadline_display = lateTrackDeadline;
            payload.resend_mode = 'resend_form';
          } else {
            payload.skip_notification = true;
          }
        } else if (needsLateDeadlineForNewEmails(cohort)) {
          payload.late_deadline = String(options.late_deadline || '').trim();
          payload.late_deadline_display = payload.late_deadline;
          payload.resend_mode = 'resend_form';
        } else {
          payload.resend_mode = 'invite';
        }
      } else {
        payload.student_emails = emails;
      }

      postJson(UPDATE_ROSTER_WEBHOOK_URL, payload).then(function() {
        if (addOnly) {
          applyOptimisticAddEmails(editingCohortCode, emails);
          beginEmailMutation(editingCohortCode, 'add', { emails: emails.slice() });
        } else {
          persistRosterToCohort(editingCohortCode, emails);
          beginEmailMutation(editingCohortCode, 'add', { emails: emails.slice() });
        }
        if (statusEl) {
          if (addOnly) {
            var invitesOff = cohort && cohort.sendStudentEmails !== undefined && !isSwitchOn(cohort.sendStudentEmails);
            statusEl.textContent = (payload.skip_notification || invitesOff) ? 'Students added. Updating list...' : 'Invitations sent. Updating list...';
          } else {
            statusEl.textContent = 'Email list saved.';
          }
          statusEl.classList.add('is-success');
        }
        if (button) button.disabled = false;
        closeAddEmailsModal();
        var addTextarea = document.getElementById('cohort-edit-add-textarea');
        if (addTextarea) addTextarea.value = '';
        finishEmailPanelMutation(editingCohortCode, emails[0] || '');
      }).catch(function(error) {
        clearEmailInviteLoading(true);
        if (statusEl) {
          statusEl.textContent = error && error.message ? error.message : 'Unable to save email list.';
          statusEl.classList.remove('is-success');
        }
        if (button) button.disabled = false;
      });
    }

    function promptAddNewRosterEmails() {
      var cohort = findCohortByCode(editingCohortCode);

      var textarea = document.getElementById('cohort-edit-add-textarea');
      var emails = extractEmails(textarea ? textarea.value : '');
      var statusEl = document.getElementById('cohort-edit-roster-status');

      if (!emails.length) {
        if (statusEl) {
          statusEl.textContent = 'Enter at least one valid email to add.';
          statusEl.classList.remove('is-success');
        }
        return;
      }

      var existing = getRosterEmailsOrdered(cohort);
      var duplicates = emails.filter(function(email) {
        return existing.indexOf(email) !== -1;
      });

      if (duplicates.length) {
        if (statusEl) {
          statusEl.textContent = 'These emails are already on the approved list: ' + duplicates.join(', ');
          statusEl.classList.remove('is-success');
        }
        return;
      }

      openAddEmailsModal(emails);
    }

    function confirmAddNewRosterEmails() {
      if (isShowcaseCohort(editingCohortCode)) {
        closeAddEmailsModal();
        openShowcaseModal();
        return;
      }
      var button = document.getElementById('cohort-add-emails-modal-confirm');
      var statusEl = document.getElementById('cohort-edit-roster-status');
      var cohort = findCohortByCode(editingCohortCode);
      var lateError = document.getElementById('cohort-add-emails-late-deadline-error');
      var lateInput = document.getElementById('cohort-add-emails-late-deadline');

      if (pendingAddEmailsReuseDeadline) {
        addOrReplaceRosterEmails(pendingAddEmails.slice(), statusEl, button, true, {
          late_deadline: pendingAddEmailsReuseDeadline
        });
        return;
      }

      var needsLateDeadline = isEditingLateStudentsTrack() || needsLateDeadlineForNewEmails(cohort);
      var lateDeadline = '';

      if (needsLateDeadline) {
        lateDeadline = String(lateInput && lateInput.value ? lateInput.value : '').trim();
        if (!lateDeadline) {
          if (lateError) {
            lateError.style.display = '';
            lateError.textContent = 'Please choose a deadline.';
          }
          return;
        }

        if (isPastDate(lateDeadline)) {
          if (lateError) {
            lateError.style.display = '';
            lateError.textContent = 'The deadline cannot be in the past.';
          }
          return;
        }

        if (lateError) {
          lateError.style.display = 'none';
          lateError.textContent = '';
        }
      }

      addOrReplaceRosterEmails(pendingAddEmails.slice(), statusEl, button, true, {
        late_deadline: lateDeadline
      });
    }

    function getCacheSummaryForCohort(code) {
      var normalized = normalizeKey(code);
      var match = STATUS_CACHES.find(function(cache) {
        return normalizeKey(cache.cohortCode) === normalized;
      });

      if (!match || !match.summaryJson) {
        return null;
      }

      try {
        return typeof match.summaryJson === 'string' ? JSON.parse(match.summaryJson) : match.summaryJson;
      } catch (error) {
        return null;
      }
    }

    function getSessionCohortEntries() {
      try {
        var raw = sessionStorage.getItem(SESSION_COHORT_KEY);
        var parsed = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(parsed)) return [];

        return parsed.map(function(entry) {
          if (typeof entry === 'string') {
            return {
              code: normalizeKey(entry),
              createdAt: '',
              cohortLabel: ''
            };
          }

          return {
            code: normalizeKey(entry.code || entry.cohortCode || ''),
            createdAt: String(entry.createdAt || entry.openedAt || '').trim(),
            cohortLabel: String(entry.cohortLabel || entry.cohort_label || '').trim()
          };
        }).filter(function(entry) {
          return entry.code;
        });
      } catch (error) {
        return [];
      }
    }

    function getSessionCohortCodes() {
      return getSessionCohortEntries().map(function(entry) {
        return entry.code;
      });
    }

    function getCohortMetaMap() {
      try {
        var raw = localStorage.getItem(COHORT_META_STORAGE_KEY);
        var parsed = raw ? JSON.parse(raw) : {};
        return parsed && typeof parsed === 'object' ? parsed : {};
      } catch (error) {
        return {};
      }
    }

    function persistCohortMeta(cohortCode, meta) {
      var normalized = normalizeKey(cohortCode);
      if (!normalized || !meta) return;

      var map = getCohortMetaMap();
      map[normalized] = Object.assign({}, map[normalized] || {}, meta);
      localStorage.setItem(COHORT_META_STORAGE_KEY, JSON.stringify(map));
    }

    function getCohortMetaForCode(cohortCode) {
      var normalized = normalizeKey(cohortCode);
      if (!normalized) return null;

      var fromStorage = getCohortMetaMap()[normalized];
      if (fromStorage) return fromStorage;

      return getSessionCohortEntries().find(function(entry) {
        return entry.code === normalized;
      }) || null;
    }

    function markSessionCohort(cohortCode, meta) {
      var normalized = normalizeKey(cohortCode);
      if (!normalized) return;

      var metaObj = meta || {};
      var createdAt = String(metaObj.createdAt || metaObj.openedAt || new Date().toISOString()).trim();
      var cohortLabel = String(metaObj.cohortLabel || metaObj.cohort_label || '').trim();
      var entries = getSessionCohortEntries().filter(function(entry) {
        return entry.code !== normalized;
      });

      entries.unshift({
        code: normalized,
        createdAt: createdAt,
        cohortLabel: cohortLabel
      });

      sessionStorage.setItem(SESSION_COHORT_KEY, JSON.stringify(entries));
      persistCohortMeta(normalized, {
        createdAt: createdAt,
        cohortLabel: cohortLabel
      });
    }

    function enrichCohortRecord(cohort) {
      if (!cohort) return cohort;

      var meta = getCohortMetaForCode(cohort.cohortCode) || {};
      var enriched = Object.assign({}, cohort);

      if (!String(enriched.cohortLabel || '').trim() && meta.cohortLabel) {
        enriched.cohortLabel = meta.cohortLabel;
      }

      if (!String(enriched.cohortLabel || '').trim()) {
        enriched.cohortLabel = parseCohortLabelFromSnapshot(
          enriched.campusAddressSnapshot || enriched.campus_address_snapshot || ''
        );
      }

      if (!getCohortCreatedAt(enriched)) {
        enriched.createdAt = meta.createdAt || enriched.openedAt || '';
      }

      if (!enriched.openedAt) {
        enriched.openedAt = enriched.createdAt || meta.createdAt || '';
      }

      return enriched;
    }

    function getCohortCreatedAt(cohort) {
      return String(
        cohort.createdAt ||
        cohort.openedAt ||
        cohort.created_at ||
        cohort.opened_at ||
        ''
      ).trim();
    }

    function formatCohortAddedDate(isoValue) {
      var iso = String(isoValue || '').trim();
      if (!iso) return '';

      var parsed = new Date(iso);
      if (isNaN(parsed.getTime())) return '';

      try {
        return parsed.toLocaleDateString(undefined, {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        });
      } catch (error) {
        return '';
      }
    }

    function dedupeEmailList(emails) {
      var seen = {};
      var unique = [];

      (emails || []).forEach(function(email) {
        var value = String(email || '').trim().toLowerCase();
        if (!value || seen[value]) return;
        seen[value] = true;
        unique.push(value);
      });

      return unique;
    }

    function normalizeStudentEmailsRaw(raw) {
      if (!raw) return [];

      if (Array.isArray(raw)) {
        return dedupeEmailList(raw);
      }

      try {
        var parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;

        if (Array.isArray(parsed)) {
          return dedupeEmailList(parsed);
        }

        if (typeof parsed === 'string') {
          try {
            var nested = JSON.parse(parsed);
            if (Array.isArray(nested)) {
              return dedupeEmailList(nested);
            }
          } catch (nestedError) {
            return dedupeEmailList(extractEmails(parsed));
          }
        }
      } catch (error) {
        return dedupeEmailList(extractEmails(String(raw || '')));
      }

      return dedupeEmailList(extractEmails(String(raw || '')));
    }

    function getRosterEmailCount(raw) {
      return normalizeStudentEmailsRaw(raw).length;
    }

    /*
      Does this cohort have students paying for their own delivery?

      true or false when the row says so, null when it carries nothing to say
      it with - the caller then falls back to reading the students. Three
      fields are consulted because three have held this answer across the
      system's life, and old cohorts were written by older code.
    */
    function cohortPaysForDelivery(cohort) {
      if (!cohort) return null;

      var mode = String(cohort.deliveryMode || '').trim().toLowerCase();
      if (mode === 'home_delivery') return true;
      if (mode === 'school_delivery') return false;

      var orderType = String(cohort.orderType || '').trim().toLowerCase();
      if (orderType === 'individual_student_orders') return true;
      if (orderType === 'school_order') return false;

      var shipToStudents = String(cohort.shipToStudents || '').trim().toLowerCase();
      if (shipToStudents === 'true') return true;
      if (shipToStudents === 'false') return false;

      return null;
    }

    function getCohortStudentStats(cohort) {
      var summary = getCacheSummaryForCohort(cohort.cohortCode) || {};
      var rosterFallback = getRosterEmailCount(cohort.studentEmailsRaw);
      var students = dedupeStudentsByEmail(getStudentsForCohort(cohort.cohortCode));
      var mainStudents = students.filter(function(student) {
        return !String(student.late_batch_code || '').trim();
      });
      var submitted = mainStudents.length ? mainStudents.filter(hasSubmittedSizes).length : (summary.submitted || summary.confirmed || 0);

      /*
        ── 2026-08-25 — how many of them have paid (owner: D9) ──────────────

        The row said "27 / 28 chose sizes" and stopped, so the question an
        admin actually has to answer next — who still owes for delivery — was
        only findable by opening the cohort.

        "Paid" is a form that is in with no delivery payment outstanding. It is
        counted from the students, not from the cache summary, for the same
        reason the two numbers above it are.

        And it is only worth saying where students pay at all: on a
        school-delivery cohort nobody owes anything, and "27 paid" beside "27
        chose sizes" would be two numbers for one fact. Rather than trust a
        delivery_mode field this row does not carry, the evidence is asked for
        directly — somebody here is either waiting to pay or has an order of
        their own.
      */
      var paid = mainStudents.filter(function(student) {
        return hasSubmittedSizes(student) && !isAwaitingPaymentStudent(student);
      }).length;

      var awaiting = mainStudents.filter(isAwaitingPaymentStudent).length;

      /*
        2026-09-14, owner: ask the cohort, not the students.

        The evidence test below is right eventually and wrong at the start. On
        the first morning of a home-delivery cohort nobody is awaiting payment
        and nobody has an order, so the card counted forms - and then changed
        its mind days later when the first student submitted. For a cohort
        where students pay their own delivery, paid is the number the admin
        actually chases, and it should be the number from the first day.

        The delivery mode is now printed on the row. It is asked first, and the
        old evidence test stays as the fallback for a row that predates it -
        a cached page, or a cohort written before the field existed.
      */
      var paysDelivery = cohortPaysForDelivery(cohort);

      if (paysDelivery === null) {
        paysDelivery = mainStudents.some(function(student) {
          return isAwaitingPaymentStudent(student) || String(student.paid_order_id || '').trim() !== '';
        });
      }
      var total = mainStudents.length
        ? mainStudents.length
        : Math.max(summary.total_students || summary.totalStudents || 0, rosterFallback);

      if (!total && rosterFallback) {
        total = rosterFallback;
      }

      return {
        submitted: submitted,
        paid: paid,
        awaiting: awaiting,
        paysDelivery: paysDelivery,
        total: total,
        rosterFallback: rosterFallback,
        cacheReady: !!(summary.total_students || summary.totalStudents)
      };
    }

    function getAccountEmailSync() {
      var fromContext = String(CUSTOMER.email || '').trim();
      if (fromContext) return fromContext;

      if (resolvedAccountEmail) {
        return String(resolvedAccountEmail).trim();
      }

      var metaTag = document.querySelector('meta[name="shopify-customer-email"]');
      if (metaTag && metaTag.content) {
        return String(metaTag.content).trim();
      }

      if (window.Shopify && window.Shopify.customer && window.Shopify.customer.email) {
        return String(window.Shopify.customer.email).trim();
      }

      return '';
    }

    function getAccountEmail() {
      return getAccountEmailSync();
    }

    function resolveAccountEmail() {
      if (accountEmailResolvePromise) {
        return accountEmailResolvePromise;
      }

      var existing = getAccountEmailSync();
      if (existing) {
        resolvedAccountEmail = existing;
        return Promise.resolve(existing);
      }

      if (!CUSTOMER.loggedIn) {
        return Promise.resolve('');
      }

      accountEmailResolvePromise = fetch('/account', { credentials: 'same-origin' })
        .then(function(response) {
          if (!response.ok) return '';
          return response.text();
        })
        .then(function(html) {
          if (!html) return '';

          var patterns = [
            /name="customer\[email\]"[^>]*value="([^"]+)"/i,
            /value="([^"]+)"[^>]*name="customer\[email\]"/i,
            /"email"\s*:\s*"([^"]+)"/i,
            /customerEmail['"]\s*:\s*['"]([^'"]+)['"]/i
          ];

          for (var i = 0; i < patterns.length; i++) {
            var match = html.match(patterns[i]);
            if (match && match[1]) {
              return String(match[1]).trim();
            }
          }

          return '';
        })
        .catch(function() {
          return '';
        })
        .then(function(email) {
          if (email) {
            resolvedAccountEmail = email;
            if (!CUSTOMER.email) {
              CUSTOMER.email = email;
            }
          }
          return email || '';
        })
        .finally(function() {
          accountEmailResolvePromise = null;
        });

      return accountEmailResolvePromise;
    }

    function syncAdminEmailAccountNotice() {
      var field = document.getElementById('admin_email');
      var notice = document.getElementById('admin-email-account-notice');
      if (!field || !notice) return;

      var accountEmail = getAccountEmailSync();
      var accountEmailNormalized = accountEmail.toLowerCase();
      var enteredEmail = String(field.value || '').trim().toLowerCase();
      var referenceEmail = accountEmailNormalized || String(initialAccountEmail || '').trim().toLowerCase();

      if (!enteredEmail) {
        notice.classList.remove('is-visible');
        notice.textContent = '';
        return;
      }

      if (referenceEmail && enteredEmail !== referenceEmail) {
        notice.classList.add('is-visible');
        notice.textContent = accountEmail
          ? 'This admin email is different from your Shopify account (' + accountEmail + '). The cohort will still be created, but it will only appear in Your cohorts when you are signed in with the same admin email.'
          : 'This admin email is different from your Shopify account. The cohort will still be created, but it will only appear in Your cohorts when you are signed in with the same admin email.';
        return;
      }

      if (CUSTOMER.loggedIn && !referenceEmail && enteredEmail) {
        notice.classList.remove('is-visible');
        notice.textContent = '';
        resolveAccountEmail().then(function() {
          syncAdminEmailAccountNotice();
        });
        return;
      }

      notice.classList.remove('is-visible');
      notice.textContent = '';
    }

    function getCohortDisplayStatus(cohort) {
      var status = String(cohort.status || 'open').toLowerCase();
      var finalizeLock = String(cohort.finalizeLock || '').toLowerCase();

      if (status === 'archived') {
        return { label: 'Archived', className: 'is-closed' };
      }

      if (status === 'completed' || status === 'delivered') {
        return { label: 'Completed', className: 'is-completed' };
      }

      /*
        ── 2026-08-17 — "Closed" was never a state, it was a miss (owner) ──

        The owner asked why a finalized main cohort says "Closed" while a
        finalized round says "Finalized", when they plainly mean the same
        thing. They do mean the same thing. The difference was an accident.

        This function tested finalizeLock === 'true'. Finalize writes "locked"
        — isCohortFinalized above accepts locked, complete AND true precisely
        because the value has changed over the years. So a modern finalized
        cohort never matched the branch meant for it and fell through to the
        catch-all below, which called it Closed and painted it red: the colour
        of a problem, on the one outcome the whole system is built to reach.

        Asking isCohortFinalized instead means this pill and every other rule
        on the page now agree about the same cohort, and the word is the same
        word the rounds use.
      */
      if (isCohortFinalized(cohort)) {
        return { label: 'Finalized', className: 'is-finalized' };
      }

      return { label: 'Open', className: 'is-open' };
    }

    /*
      ── Demo links stay on the demo pages (owner, 2026-09-14) ─────────────

      A cohort stores the address of its own status page and student form,
      written when it was created. Those stored addresses win everywhere,
      which is right: a cohort made months ago keeps working after the pages
      have been renamed.

      On the demo it threw the visitor out. The showcase cohorts were created
      while the settings still named the live pages, so every "View status"
      carried the word demo out of the address bar and landed on the real
      cohort pages - which then, quite correctly, refused a stranger.

      So in demo mode the page's own paths win instead. Only the path: the
      query keeps the cohort code and the token, which are what the link is
      for. Nothing changes outside demo mode.
    */
    function preferOwnPathInDemo(storedUrl, ownPath, fallbackPath) {
      var stored = String(storedUrl || '').trim();
      if (!stored || !CONFIG.demoMode) return stored;

      try {
        var parsed = new URL(stored, window.location.origin);
        return sanitizePagePath(ownPath, fallbackPath) + parsed.search + parsed.hash;
      } catch (error) {
        return stored;
      }
    }

    function buildStatusPageUrl(cohort) {
      if (cohort.statusPageUrl) {
        return preferOwnPathInDemo(cohort.statusPageUrl, STATUS_PAGE_PATH, '/pages/cohort-status');
      }

      var path = sanitizePagePath(STATUS_PAGE_PATH, '/pages/cohort-status');
      return toAbsoluteUrl(path + '?cohort=' + encodeURIComponent(cohort.cohortCode || ''));
    }

    /* The status page in its Unpaid invoices mode (cohort-status.js,
       isUnpaidInvoicesMode), narrowed to this page's school when there is one. */
    function buildUnpaidInvoicesUrl() {
      var path = sanitizePagePath(STATUS_PAGE_PATH, '/pages/cohort-status');
      var school = findSchoolByUrl();
      var schoolCode = school && school.schoolCode ? String(school.schoolCode) : '';
      return toAbsoluteUrl(path + '?invoices=unpaid' + (schoolCode ? '&school=' + encodeURIComponent(schoolCode) : ''));
    }

    function formatLateDeadlineLabel(value) {
      var raw = String(value || '').trim();
      if (!raw) return '—';

      var parts = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!parts) return raw;

      var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var monthIndex = parseInt(parts[2], 10) - 1;
      return monthNames[monthIndex] + ' ' + parseInt(parts[3], 10) + ', ' + parts[1];
    }

    function isLateResubmitStudent(student) {
      if (!student || isRemovedStudent(student) || isUnmatchedStudent(student)) return false;
      if (hasSubmittedSizes(student)) return false;
      return String(student.late_resubmit_deadline || '').trim() !== '';
    }

    function isLateRosterStudent(student) {
      if (!student || isRemovedStudent(student) || isUnmatchedStudent(student)) return false;
      return !hasSubmittedSizes(student);
    }

    function findLateBatchByCode(cohortCode, batchCode) {
      var code = String(batchCode || '').trim().toUpperCase();
      if (!code) return null;

      return parseLateBatchesForCohort(cohortCode).filter(function(batch) {
        return String(batch.late_batch_code || '').trim().toUpperCase() === code;
      })[0] || null;
    }

    /*
      ── The waiting room (2026-08-11, owner's model) ──────────────────────────

      Students whose track has closed without them and who are not in an open
      round yet. It is the same rule at every level, which is what lets the
      chain continue past the first round:

        · Main finalized      → everyone still pending, with no round
        · a round finalized   → that round's students who never submitted

      The waiting room is a STATE, not a record. No cohort_late_batch exists for
      it and none is created: the round becomes real when a deadline is set, and
      until then these students simply have nowhere else to be. That is why they
      are also still listed under the finalized cohort — hiding them before they
      have a round of their own would put them nowhere at all.
    */
    /*
      2026-08-17 — a student who owes postage is still waiting (owner).

      Answering the form used to be the whole test. That is right for someone
      whose uniform is on its way and wrong for someone whose parcel cannot
      leave: awaiting_payment appears in none of the billable status lists at
      finalization, so the school never paid for them and this cohort still
      owes them a round.

      Hence the two names read differently from here on. "Submitted" answers
      whether the form is in; "waiting" answers whether the cohort still owes
      this student something. For everyone else the two agree.

      Kept in step with cohort-status.js.
    */
    function isWaitingRoomStudent(cohort, student) {
      if (!student || isRemovedStudent(student)) return false;
      if (hasSubmittedSizes(student) && !isAwaitingPaymentStudent(student)) return false;

      var batchCode = String(student.late_batch_code || '').trim().toUpperCase();

      if (!batchCode) return isCohortFinalized(cohort);

      var batch = findLateBatchByCode(cohort && cohort.cohortCode, batchCode);

      /*
        2026-08-11 — no record of their round means they stay IN it, not out.

        This read the other way round, and it cost a student their place: they
        submitted in LATE-01, the round's record could not be matched, so they
        counted as waiting — which their submission disqualified them from — and
        they appeared in the finalized main cohort instead while the round
        showed nobody and could not be finalized. Their entry was correct
        throughout; only our reading of it was not.

        A student carries the code of the round they were put in. That is the
        fact. What we can learn about the round record decides whether the round
        is still collecting, and when we cannot learn it, the answer that keeps
        them where they were put is the safe one.
      */
      if (!batch) return false;

      return String(batch.status || '').toLowerCase() === 'finalized';
    }

    /*
      ── 2026-08-17 — one count, said the same way everywhere ─────────────

      The owner found the same screen giving two answers: the late round block
      said "1 student still has not submitted" while the banner under it said
      "3 students are still waiting". Both were honest about their own rule and
      the rules had drifted — the banner learned about unpaid students, the
      block did not.

      So the two questions are counted once, here, and split into the two
      groups that will be treated differently when the round starts: one gets
      the form to fill in, the other gets a payment link. An admin about to
      press a button that moves people deserves to know which people.
    */
    function waitingRoomBreakdown(cohort, cohortCode) {
      var notSubmitted = 0;
      var unpaid = 0;

      dedupeStudentsByEmail(getStudentsForCohort(cohortCode)).forEach(function(student) {
        if (!isWaitingRoomStudent(cohort, student)) return;
        if (isAwaitingPaymentStudent(student)) unpaid += 1;
        else notSubmitted += 1;
      });

      return { notSubmitted: notSubmitted, unpaid: unpaid, total: notSubmitted + unpaid };
    }

    function waitingRoomBreakdownSentence(counts) {
      var parts = [];

      if (counts.notSubmitted) {
        parts.push(counts.notSubmitted +
          (counts.notSubmitted === 1 ? ' has not submitted' : ' have not submitted'));
      }

      if (counts.unpaid) {
        parts.push(counts.unpaid +
          (counts.unpaid === 1
            ? ' has submitted but not paid for delivery'
            : ' have submitted but not paid for delivery'));
      }

      return parts.join(', and ');
    }

    /* In a round that is still collecting answers — the one place they must not
       be listed under the finalized cohort as well. */
    function isOpenRoundStudent(cohort, student) {
      var batchCode = String(student && student.late_batch_code || '').trim().toUpperCase();
      if (!batchCode) return false;

      var batch = findLateBatchByCode(cohort && cohort.cohortCode, batchCode);

      /* Same reading as isWaitingRoomStudent: with no record of the round, the
         student stays in the round whose code they carry. Anything else lists
         them under the finalized cohort, where nothing can be done with them. */
      if (!batch) return true;

      var status = String(batch.status || '').toLowerCase();
      return status !== 'finalized';
    }

    function isEditingLateStudentsTrack() {
      return !!editingLateStudentsTrack;
    }

    /*
      ── Who is in this late round (2026-08-07) ────────────────────────────────

      Membership is decided by late_batch_code on the student record, never by
      whether their current address still matches a roster line.

      Two faults are fixed here, both reported as "the student who changed their
      email vanished from the late round":

      1. unmatched students were excluded outright. That contradicts the rule
         that the outside-list fact belongs to the student and is shown ON their
         row (business rule 4.4) — hiding the row is not marking it.

      2. a student who was never on the roster at all had no way into this list,
         because it is built by walking roster addresses. They are appended
         below by identity, so the round shows everyone it actually contains.

      Deduplication is by student identity, not by address: one student appears
      once even when their submitted address differs from their roster line.
    */
    function getLateRosterEmailsForCohort(cohortCode, lateBatchCode) {
      var cohort = findCohortByCode(cohortCode);
      var rosterEmails = getRosterEmailsOrdered(cohort);
      var students = dedupeStudentsByEmail(getStudentsForCohort(cohortCode));
      var code = String(lateBatchCode || '').trim().toUpperCase();
      var seenIdentities = {};
      var list = [];

      /*
        2026-08-10 — without a batch code this falls back to "everyone who has
        not submitted", which is the legacy track: cohorts from before named
        rounds existed, where there is no batch to belong to.

        Reported as a pending Main student appearing inside LATE-01. Their
        record carries no late_batch_code at all — they were never invited to
        the round — but the panel had been opened without a code, so the
        fallback listed them anyway. The status page, which always filters by
        late_batch_code, correctly did not show them: the two disagreed about
        who is in the round.

        Once a cohort has named rounds, the fallback is never right — a student
        belongs to exactly one track, and membership is what late_batch_code
        says. Pick the newest round rather than show the wrong list. Cohorts
        with no rounds at all keep the legacy behaviour untouched.
      */
      /*
        2026-08-11 — without a code, this is the waiting room, not "everyone who
        has not submitted".

        An OPEN round is the exception: opened without naming it, the panel
        means that one. A finalized round is never the answer — its students
        have moved on to the next waiting room, which is exactly how the chain
        continues after a round closes.
      */
      if (!code) {
        var openBatch = getOpenLateBatchInfo(cohortCode);

        /*
          2026-08-11 — if no round reports itself open, fall back to the newest
          one that exists before falling back to the waiting room.

          getOpenLateBatchInfo answers only for a round whose status is "open"
          AND which still has a deadline. A round can fail both and still be the
          round everyone is in — that is exactly what happened when a student
          submitted into LATE-01 and the panel showed an empty waiting room,
          with Finalize unavailable because it counted nobody. A round with
          members is never empty; showing it empty is always our mistake.
        */
        if (!openBatch || !openBatch.code) {
          var known = parseLateBatchesForCohort(cohortCode).slice().sort(function(a, b) {
            return Number(b.late_batch_index || 0) - Number(a.late_batch_index || 0);
          });

          var newest = known.filter(function(batch) {
            return String(batch.status || '').toLowerCase() !== 'finalized';
          })[0];

          if (newest && newest.late_batch_code) {
            openBatch = { code: String(newest.late_batch_code).trim().toUpperCase() };
          }
        }

        /*
          2026-08-11 — last resort: ask the STUDENTS which round they are in.

          Everything above reads the round's own cache record, and the cache is
          rebuilt after the round is created, not with it. In the window between
          — or any time a rebuild is late — a round exists, students carry its
          code, and none of the lookups above can see it. The panel then fell
          through to the waiting room, which excludes anyone who has submitted,
          so a round with a confirmed student in it showed nobody and could not
          be finalized.

          A student's own late_batch_code needs no cache to be true.
        */
        if (!openBatch || !openBatch.code) {
          var codesFromStudents = [];

          students.forEach(function(student) {
            if (isRemovedStudent(student)) return;

            var studentCode = String(student.late_batch_code || '').trim().toUpperCase();
            if (!studentCode) return;

            var batchRecord = findLateBatchByCode(cohortCode, studentCode);
            if (batchRecord && String(batchRecord.status || '').toLowerCase() === 'finalized') return;

            if (codesFromStudents.indexOf(studentCode) === -1) {
              codesFromStudents.push(studentCode);
            }
          });

          /* Alphabetical on LATE-01, LATE-02 … is newest last, which is the one
             still collecting. */
          codesFromStudents.sort();

          if (codesFromStudents.length) {
            openBatch = { code: codesFromStudents[codesFromStudents.length - 1] };
          }
        }

        if (openBatch && openBatch.code) {
          code = String(openBatch.code).trim().toUpperCase();
        } else {
          var waiting = [];

          students.forEach(function(student) {
            if (!isWaitingRoomStudent(cohort, student)) return;

            var identity = getStudentIdentityEmail(student);
            if (!identity) return;
            if (seenIdentities[identity]) return;

            markSeen(student);
            waiting.push(identity);
          });

          return waiting;
        }
      }

      function markSeen(student) {
        studentIdentityEmails(student).forEach(function(identity) {
          seenIdentities[identity] = true;
        });
      }

      rosterEmails.forEach(function(email) {
        var student = findStudentForRosterEmail(students, email);

        if (!student) {
          /* An address nobody has claimed yet: only meaningful on the legacy
             track, where there is no batch to belong to. */
          if (!code) list.push(email);
          return;
        }

        if (isRemovedStudent(student)) return;

        var belongs = code
          ? String(student.late_batch_code || '').trim().toUpperCase() === code
          : isLateRosterStudent(student);

        if (!belongs) return;

        markSeen(student);
        list.push(email);
      });

      if (!code) return list;

      students.forEach(function(student) {
        if (isRemovedStudent(student)) return;
        if (String(student.late_batch_code || '').trim().toUpperCase() !== code) return;

        var alreadyShown = studentIdentityEmails(student).some(function(identity) {
          return seenIdentities[identity];
        });
        if (alreadyShown) return;

        var identity = getStudentIdentityEmail(student);
        if (!identity) return;

        markSeen(student);
        list.push(identity);
      });

      return list;
    }

    /*
      Read-only student list for a finalized cohort or late batch. Includes both
      confirmed and still-waiting students: a pending Main student who has not
      been invited to any late batch yet used to be filtered out here, which made
      them invisible on the dashboard even though the status page still showed
      them. Removed/archived entries stay excluded. renderCompactEmailRow marks
      each row is-confirmed or is-pending, so the two are still told apart.
    */
    function getReadOnlyTrackEmails(cohortCode, lateBatchCode) {
      var code = String(lateBatchCode || '').trim().toUpperCase();
      var students = dedupeStudentsByEmail(getStudentsForCohort(cohortCode));
      /*
        2026-08-06 — a finalized main cohort lists only the students who are in
        its order. Anyone who never submitted was not billed, and leaving them
        under a closed cohort made it look as though they were still expected
        there; they are not, and nothing on that screen could move them.

        Only the main track is filtered. Inside a late batch the people who have
        not submitted yet are exactly the ones the round is waiting for, so they
        stay.
      */
      var hideNotSubmitted = !code && isCohortFinalized(findCohortByCode(cohortCode));

      return students.filter(function(student) {
        if (isRemovedStudent(student)) return false;

        var studentBatchCode = String(student.late_batch_code || '').trim().toUpperCase();
        var onThisTrack = code ? studentBatchCode === code : !studentBatchCode;
        if (!onThisTrack) return false;

        return hideNotSubmitted ? hasSubmittedSizes(student) : true;
      }).map(function(student) {
        return getStudentIdentityEmail(student);
      }).filter(Boolean);
    }

    function getEditPanelRosterEmails(cohortCode) {
      if (editingReadOnly) {
        return getReadOnlyTrackEmails(cohortCode, editingLateBatchCode);
      }
      if (isEditingLateStudentsTrack()) {
        return getLateRosterEmailsForCohort(cohortCode, editingLateBatchCode);
      }

      return getRosterEmailsOrdered(findCohortByCode(cohortCode));
    }

    /*
      2026-10-09 (owner, design 1a header) - the pills under the cohort
      title: the school, the deadline and how it is delivered, each with its
      icon, then the state. Read from the cohort row the page already holds.
    */
    function cohortTitleHtml(label) {
      var words = String(label || '').trim().split(/\s+/).filter(Boolean);
      var lead = words.length >= 3 ? words.slice(0, -2).join(' ') : '';
      var accent = words.length >= 3 ? words.slice(-2).join(' ') : words.join(' ');
      return (lead ? esc(lead) + ' ' : '') +
        '<span class="tb-gradient-text" id="cohort-edit-title">' + esc(accent) + '</span>';
    }

    var EDIT_META_ICONS = {
      school: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="9" cy="8" r="3.5" stroke="currentColor" stroke-width="2"/><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M16 4.5a3.5 3.5 0 0 1 0 7M18 14c2 .6 3.5 2.8 3.5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
      deadline: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3.5" y="5" width="17" height="15" rx="3" stroke="currentColor" stroke-width="2"/><path d="M3.5 10h17M8 3v4M16 3v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
      delivery: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M2 7h11v9H2zM13 10h4l3 3v3h-7z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="6.5" cy="18" r="1.8" stroke="currentColor" stroke-width="2"/><circle cx="16.5" cy="18" r="1.8" stroke="currentColor" stroke-width="2"/></svg>'
    };

    function renderEditCohortMeta(cohort) {
      var host = document.getElementById('cohort-edit-meta');
      if (!host) return;
      if (!cohort) { host.innerHTML = ''; return; }

      var finalized = isCohortFinalized(cohort);
      var school = String(cohort.schoolName || '').trim();
      var deadline = String(cohort.deadlineDisplay || cohort.deadline || '').trim();
      var pays = cohortPaysForDelivery(cohort);
      var pills = [];

      if (school) pills.push('<span class="cohort-edit-pill">' + EDIT_META_ICONS.school + esc(school) + '</span>');
      if (deadline) pills.push('<span class="cohort-edit-pill">' + EDIT_META_ICONS.deadline + 'Deadline ' + esc(deadline) + '</span>');
      if (pays !== null) pills.push('<span class="cohort-edit-pill">' + EDIT_META_ICONS.delivery + (pays ? 'Home delivery' : 'School delivery') + '</span>');
      pills.push('<span class="cohort-edit-pill is-state ' + (finalized ? 'is-finalized' : 'is-open') + '">' + (finalized ? 'Finalized' : 'Open') + '</span>');

      host.innerHTML = pills.join('');
    }

    /*
      ── Filter and search over the student list (2026-10-09, design 9B) ──

      On screen only: a row is hidden with a class, nothing is changed. Active
      while viewing and adding. Remove, Edit emails and Send reminders clear it
      and hide the bar, because Select all ticks every row in the list and
      must never reach a row the admin cannot see. Recounted whenever the list
      is drawn again (the observer below), so a background sync cannot leave
      the counts or the hidden rows stale.
    */
    var rosterFilterState = { kind: 'all', query: '' };

    function rosterRowKind(row) {
      if (row.classList.contains('is-paid')) return 'paid';
      if (row.classList.contains('is-unpaid')) return 'unpaid';
      if (row.classList.contains('is-pending')) return 'pending';
      return 'other';
    }

    function syncRosterFilter() {
      var bar = document.getElementById('cohort-roster-filter');
      var list = document.getElementById('cohort-edit-approved-students-list');
      if (!bar || !list) return;

      var allowed = rosterEditMode === '' || rosterEditMode === 'add';
      if (!allowed) {
        rosterFilterState = { kind: 'all', query: '' };
        var searchBox = document.getElementById('cohort-roster-search');
        if (searchBox) searchBox.value = '';
      }

      var rows = list.querySelectorAll('.em-row');
      var counts = { all: 0, paid: 0, unpaid: 0, pending: 0 };
      var query = rosterFilterState.query;

      Array.prototype.forEach.call(rows, function(row) {
        var kind = rosterRowKind(row);
        counts.all += 1;
        if (counts[kind] !== undefined) counts[kind] += 1;

        var text = (row.getAttribute('data-current-email') || '') + ' ' + (row.textContent || '');
        var nameInput = row.querySelector('.em-row-name-input');
        if (nameInput) text += ' ' + nameInput.value;

        var hide = allowed && (
          (rosterFilterState.kind !== 'all' && kind !== rosterFilterState.kind) ||
          (query && text.toLowerCase().indexOf(query) === -1)
        );
        row.classList.toggle('is-filtered-out', !!hide);
      });

      list.querySelectorAll('.roster-group').forEach(function(group) {
        var anyVisible = group.querySelector('.em-row:not(.is-filtered-out)');
        group.classList.toggle('is-filtered-out', !anyVisible && group.querySelector('.em-row') !== null);
      });

      bar.querySelectorAll('[data-roster-filter]').forEach(function(chip) {
        var on = chip.getAttribute('data-roster-filter') === rosterFilterState.kind;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        /* A chip for a kind nobody is in says nothing. */
        var kind = chip.getAttribute('data-roster-filter');
        chip.hidden = kind !== 'all' && !counts[kind];
      });

      bar.hidden = !allowed || counts.all === 0;
    }

    function bindRosterFilter() {
      var bar = document.getElementById('cohort-roster-filter');
      var list = document.getElementById('cohort-edit-approved-students-list');
      if (!bar || !list || bar.dataset.bound) return;
      bar.dataset.bound = '1';

      bar.addEventListener('click', function(event) {
        var chip = event.target.closest ? event.target.closest('[data-roster-filter]') : null;
        if (!chip) return;
        rosterFilterState.kind = chip.getAttribute('data-roster-filter');
        syncRosterFilter();
      });

      var search = document.getElementById('cohort-roster-search');
      if (search) {
        search.addEventListener('input', function() {
          rosterFilterState.query = String(search.value || '').trim().toLowerCase();
          syncRosterFilter();
        });
      }

      if (window.MutationObserver) {
        var scheduled = false;
        new MutationObserver(function() {
          if (scheduled) return;
          scheduled = true;
          window.requestAnimationFrame(function() { scheduled = false; syncRosterFilter(); });
        }).observe(list, { childList: true, subtree: true });
      }
    }

    function applyLateTrackEditPanelChrome(cohort) {
      var panel = document.getElementById('cohort-email-edit-panel');
      var kicker = document.getElementById('cohort-edit-kicker');
      var titleWrap = document.getElementById('cohort-edit-title-wrap');
      var listLabel = document.getElementById('cohort-edit-list-section-label');
      var manageLabel = document.getElementById('cohort-edit-manage-section-label');
      var renameButton = document.getElementById('cohort-edit-rename-button');
      var stats = document.querySelector('.admin-edit-stats');

      if (panel) {
        panel.classList.toggle('is-late-track-edit', isEditingLateStudentsTrack());
      }

      if (kicker) {
        kicker.textContent = isEditingLateStudentsTrack() ? 'Late students' : 'Cohort management';
      }

      if (titleWrap) {
        if (isEditingLateStudentsTrack()) {
          titleWrap.innerHTML =
            '<span class="tb-gradient-text" id="cohort-edit-title">' +
            esc(getLateStudentsTrackTitle(cohort)) +
            '</span>';
        } else {
          /* 2026-10-09 (design 1a) - two-tone, without the word "Cohort". */
          titleWrap.innerHTML = cohortTitleHtml(getCohortDisplayTitle(cohort));
        }
      }

      if (listLabel) {
        listLabel.textContent = isEditingLateStudentsTrack() ? 'Late students' : 'Uploaded list';
      }

      if (manageLabel) {
        manageLabel.textContent = editingReadOnly
          ? 'Students'
          : (isEditingLateStudentsTrack() ? 'Late students' : 'Students in this cohort');
      }

      if (renameButton) {
        renameButton.hidden = isEditingLateStudentsTrack() || editingReadOnly;
      }

      if (stats) {
        stats.hidden = isEditingLateStudentsTrack();
      }
    }

    function getLateStudentsTrackMeta(cohort, students) {
      if (!isCohortFinalized(cohort)) return null;

      var lateStudents = (students || []).filter(isLateRosterStudent);
      if (!lateStudents.length) return null;

      var deadlineKeys = [];
      var deadlineSeen = {};

      lateStudents.filter(isLateResubmitStudent).forEach(function(student) {
        var key = String(student.late_resubmit_deadline || '').trim().slice(0, 10);
        if (!key || deadlineSeen[key]) return;
        deadlineSeen[key] = true;
        deadlineKeys.push(key);
      });

      deadlineKeys.sort();

      var deadlineKey = deadlineKeys.length === 1 ? deadlineKeys[0] : '';
      var deadlineLabel = deadlineKeys.length === 1
        ? formatLateDeadlineLabel(deadlineKeys[0])
        : (deadlineKeys.length > 1 ? 'Multiple deadlines' : '—');

      return {
        total: lateStudents.length,
        waiting: lateStudents.length,
        deadlineKey: deadlineKey,
        deadlineLabel: deadlineLabel,
        deadlineOverdue: deadlineKeys.some(function(key) {
          return isPastDate(key);
        }),
        homeDelivery: lateStudents.some(function(student) {
          return String(student.late_delivery_mode || 'home_delivery').toLowerCase() === 'home_delivery';
        })
      };
    }

    function getLateStudentsTrackTitle(cohort) {
      var cohortLabel = getCohortLabel(cohort);
      var baseTitle = cohortLabel || 'Untitled cohort';
      return baseTitle + ' · Late Students';
    }

    function renderAdminCohortMainRow(cohort, students, context) {
      context = context || {};
      var status = getCohortDisplayStatus(cohort);
      var stats = getCohortStudentStats(cohort);
      var submitted = stats.submitted;
      var paidCount = stats.paid;
      var owedCount = stats.awaiting;
      var showPaid = stats.paysDelivery;
      var total = stats.total;
      /* Everyone the cohort has not heard from at all. Clamped at zero because
         total falls back to the roster count, which can briefly run behind the
         students actually on file. */
      var silentCount = Math.max(0, (Number(total) || 0) - (Number(submitted) || 0));
      var totalLabel = total || (stats.rosterFallback ? String(stats.rosterFallback) : '');
      var statusUrl = buildStatusPageUrl(cohort);
      var deadlineLabel = cohort.deadlineDisplay || cohort.deadline || '';
      var deadlineOverdue = isPastDate(cohort.deadline);

      /*
        2026-08-05 — em-dash placeholders removed. Program is no longer chosen on
        Step 1 (it moved onto each product copy), so cohort.programName is empty
        for every new cohort and the meta line rendered as "Campus · —". Missing
        pieces are now simply left out, and the separator only appears when there
        is something on both sides of it.
      */
      var metaParts = [];
      /*
        2026-08-11 — every campus this cohort covers, not just the one the
        cohort's single campus reference points at. Since campuses moved to
        Step 3 a cohort routinely has several, and naming one of them read as
        if the others were not there.
      */
      var campusLabel = getCohortCampusLabel(cohort);
      var programLabel = cohort.programName || '';
      if (campusLabel) metaParts.push(esc(campusLabel));
      if (programLabel) metaParts.push(esc(programLabel));

      var cohortLabel = getCohortLabel(cohort);
      var displayTitle = cohortLabel || 'Untitled cohort';
      var metaLine = metaParts.join(' · ');
      var addedDate = formatCohortAddedDate(getCohortCreatedAt(cohort));
      var emailMismatch = context.emailMismatch;
      /*
        2026-08-06 — "Different admin email" used to sit under the status pill
        as loose amber text: it broke the pill's centring and read as a warning,
        which it is not. Now that the access list scopes the dashboard to one
        school, seeing a colleague's cohort is ordinary, so it folds into the
        "Added ..." line, where the rest of the provenance already lives.
      */
      var provenanceParts = [];
      if (addedDate) provenanceParts.push('Added ' + esc(addedDate));
      if (emailMismatch) provenanceParts.push(addedDate ? 'created by another admin' : 'Created by another admin');
      var provenanceLine = provenanceParts.join(' · ');
      var finalized = isCohortFinalized(cohort);
      /* lateDecisionForMain / canAddLateStudents went with the "Add students"
         button they gated — see the note further down this function. */
      var archiveButtonHtml = '';
      if (SHOW_ARCHIVE_TEST_BUTTON && finalized && !isCohortArchived(cohort)) {
        archiveButtonHtml =
          '<button type="button" class="export-button admin-btn-archive-test" data-archive-cohort="' +
          esc(cohort.cohortCode || '') +
          '">Archive (test)</button>';
      }

      return (
        /* is-finalized on the row too (2026-08-17): the card carries a soft
           green so a closed cohort reads as done at a glance, without having
           to find the pill. */
        '<article class="admin-cohort-row' + (finalized ? ' is-finalized' : '') + (deadlineOverdue ? ' is-overdue' : '') + (emailMismatch ? ' is-email-mismatch' : '') + '">' +
          '<div class="admin-cohort-status-col">' +
            '<span class="cohort-manage-status ' + status.className + '">' + esc(status.label) + '</span>' +
          '</div>' +
          '<div class="admin-cohort-card">' +
            '<span class="admin-cohort-alerts" data-alerts-for="' + esc(cohort.cohortCode || '') + '">' + cohortAlertsHtml(cohort) + '</span>' +
            '<div class="admin-cohort-identity">' +
              '<p class="admin-cohort-title">' + esc(displayTitle) + '</p>' +
              '<p class="admin-cohort-meta">' + metaLine + '</p>' +
              (provenanceLine ? '<p class="admin-cohort-added">' + provenanceLine + '</p>' : '') +
              '<div class="admin-cohort-deadline' + (deadlineOverdue ? ' is-overdue' : '') + '">' +
                '<span class="admin-cohort-deadline-label">Deadline</span>' +
                '<span class="admin-cohort-deadline-value">' + esc(deadlineLabel) + '</span>' +
              '</div>' +
            '</div>' +
            /*
              2026-08-24 — the label says what the number counts (owner).

              It read "Submitted" while open and "Confirmed" once finalized,
              but both counted the same people: those who have chosen their
              sizes. On the status page "Confirmed" means something narrower —
              chosen and paid — so the same word answered two questions and
              an admin comparing the pages could not tell which. The count is
              unchanged; only the word is, and it matches the status page now.
            */
            '<div class="admin-cohort-side-panel">' +
              /*
                ── 2026-08-25 — the fraction is about the money now (owner: F3d)

                It counted forms: how many had chosen sizes, out of everyone.
                But a cohort is finished when it is paid for, not when it is
                filled in, so the big number is the paid one and the whole
                cohort stands beside it a step smaller. What is left over —
                who owes, who has not answered — is said underneath in words,
                where it can be read without being counted.

                Where students do not pay for delivery the old fraction stays:
                there is no payment to lead with, and "24 paid" would be a
                number for something nobody did.
              */
              (showPaid
                ? '<div class="admin-cohort-stat-value">' +
                    '<span class="admin-cohort-stat-primary">' + esc(String(paidCount)) + '</span>' +
                    '<span class="admin-cohort-stat-sep">/</span>' +
                    '<span class="admin-cohort-stat-secondary">' + esc(String(totalLabel)) + '</span>' +
                  '</div>' +
                  '<div class="admin-cohort-stat-label">Paid</div>' +
                  '<div class="admin-cohort-stat-rest">' +
                    (owedCount > 0 ? '<span class="is-owed">' + esc(String(owedCount)) + ' owe</span>' : '') +
                    (owedCount > 0 && silentCount > 0 ? ' · ' : '') +
                    (silentCount > 0 ? '<span>' + esc(String(silentCount)) + ' no form</span>' : '') +
                  '</div>'
                : (finalized
                  ? '<div class="admin-cohort-stat-value">' +
                      '<span class="admin-cohort-stat-primary">' + esc(String(submitted)) + '</span>' +
                    '</div>' +
                    '<div class="admin-cohort-stat-label">Chose sizes</div>'
                  : '<div class="admin-cohort-stat-value">' +
                      '<span class="admin-cohort-stat-primary">' + esc(String(submitted)) + '</span>' +
                      '<span class="admin-cohort-stat-sep">/</span>' +
                      '<span class="admin-cohort-stat-secondary">' + esc(String(totalLabel)) + '</span>' +
                    '</div>' +
                    '<div class="admin-cohort-stat-label">Chose sizes</div>')) +
              '<span class="admin-cohort-code">' + esc(cohort.cohortCode || '—') + '</span>' +
            '</div>' +
            '<div class="admin-cohort-actions">' +
              '<a class="export-button admin-btn-black" href="' + esc(statusUrl) + '">View status</a>' +
              (finalized
                ? '<button type="button" class="export-button admin-btn-outline" data-view-late-students="1" data-cohort-code="' + esc(cohort.cohortCode || '') + '" data-late-batch-code="">View students</button>'
                : '<button type="button" class="export-button admin-btn-add-students" data-edit-cohort="' + esc(cohort.cohortCode || '') + '">Edit Cohort</button>') +
              /*
                2026-08-06 — "Add students" removed from the cohort card. On a
                finalized cohort it opened the late track, which meant a student
                could be added before any late round existed: they landed in a
                round of one, while everybody else who had not submitted stayed
                behind in the closed cohort with no way in.

                Adding after finalization now happens in one place — the Late
                round block inside the cohort — where starting the round and
                inviting everyone who is still missing are the same action.
              */
              archiveButtonHtml +
            '</div>' +
          '</div>' +
        '</article>'
      );
    }

    // Wave 2 / Phase 3 — one row per real cohort_late_batch record (LATE-01,
    // LATE-02, ...), never one merged pool. Falls back to the legacy
    // undifferentiated heuristic (getLateStudentsTrackMeta) only for cohorts
    // that predate the batch model (no cohort_late_batch records at all) —
    // see docs/late-cohort-implementation-plan.md.
    function getLateBatchDashboardRows(cohort, students) {
      var batches = parseLateBatchesForCohort(cohort.cohortCode).slice().sort(function(a, b) {
        return Number(a.late_batch_index || 0) - Number(b.late_batch_index || 0);
      });

      if (batches.length) {
        return batches.map(function(batch, index) {
          var code = String(batch.late_batch_code || '').trim().toUpperCase();
          var batchStudents = (students || []).filter(function(student) {
            return String(student.late_batch_code || '').trim().toUpperCase() === code;
          });
          var confirmed = batchStudents.filter(hasSubmittedSizes);
          var confirmedCount = confirmed.length;
          var pendingCount = batchStudents.length - confirmed.length;
          var ordersCreated = confirmed.filter(function(student) { return !!student.draft_order_id; }).length;

          var schoolInvoiceStatus = 'Not created';
          if (batch.status === 'finalized' && batch.school_draft_order_id) schoolInvoiceStatus = 'Created';
          else if (batch.status === 'finalizing') schoolInvoiceStatus = 'Creating';

          return {
            isLegacy: false,
            isFinalized: batch.status === 'finalized',
            isFinalizing: batch.status === 'finalizing',
            isLatestBatch: index === batches.length - 1,
            lateBatchCode: batch.late_batch_code || '',
            statusLabel: batch.status === 'finalized' ? 'Finalized' : (batch.status === 'finalizing' ? 'Finalizing' : (confirmedCount > 0 ? 'Ready to finalize' : 'Awaiting responses')),
            deadlineLabel: batch.late_deadline_display || batch.late_deadline || '—',
            deadlineOverdue: batch.status !== 'finalized' && isPastDate(batch.late_deadline),
            confirmedCount: confirmedCount,
            pendingCount: pendingCount,
            totalCount: batchStudents.length,
            schoolInvoiceStatus: schoolInvoiceStatus,
            studentOrdersLabel: ordersCreated + ' of ' + confirmedCount
          };
        });
      }

      var legacyMeta = getLateStudentsTrackMeta(cohort, students);
      if (!legacyMeta) return [];

      return [{
        isLegacy: true,
        isFinalized: false,
        isFinalizing: false,
        isLatestBatch: true,
        lateBatchCode: '',
        statusLabel: 'Awaiting responses',
        deadlineLabel: legacyMeta.deadlineLabel,
        deadlineOverdue: legacyMeta.deadlineOverdue,
        confirmedCount: 0,
        pendingCount: legacyMeta.waiting,
        totalCount: legacyMeta.waiting,
        schoolInvoiceStatus: 'Not created',
        studentOrdersLabel: '0 of 0'
      }];
    }

    function renderAdminCohortLateRow(cohort, row) {
      var titleText = row.isLegacy ? 'Late Students' : ('Late Cohort ' + (row.lateBatchCode || '').replace(/^LATE-/i, ''));
      var metaBits = [row.confirmedCount + ' chose sizes', row.pendingCount + ' still to choose'];

      var statusPillClass = 'cohort-manage-status is-late';
      if (row.isFinalized) statusPillClass += ' admin-late-status-finalized';
      else if (row.isFinalizing) statusPillClass += ' admin-late-status-finalizing';
      else statusPillClass += ' admin-late-status-open';

      var actionsHtml;
      if (row.isFinalized) {
        actionsHtml =
          '<span class="admin-late-finalized-badge">Finalized</span>' +
          '<button type="button" class="export-button admin-btn-outline" data-view-late-students="1" data-cohort-code="' + esc(cohort.cohortCode || '') +
          '" data-late-batch-code="' + esc(row.lateBatchCode) + '">View students</button>';
          /* "Add students" removed here too (2026-08-06): it opened a blank
             late track and started the next round with whoever was typed in,
             leaving everyone else still missing behind. The next round starts
             from the Late round block inside the cohort, which invites all of
             them at once. */
      } else if (row.isFinalizing) {
        actionsHtml = '<span class="admin-late-finalizing-badge">Finalizing…</span>';
      } else {
        actionsHtml =
          '<button type="button" class="export-button admin-btn-add-students" data-edit-cohort="' + esc(cohort.cohortCode || '') +
          '" data-edit-late-track="1" data-late-batch-code="' + esc(row.lateBatchCode) + '">Edit Cohort</button>';
      }

      return (
        '<article class="admin-cohort-row admin-cohort-row--late-child' + (row.isFinalized ? ' is-finalized' : '') + (row.deadlineOverdue ? ' is-overdue' : '') + '">' +
          '<div class="admin-cohort-status-col admin-cohort-status-col--connector" aria-hidden="true">' +
            '<span class="' + statusPillClass + '">' + esc(row.statusLabel) + '</span>' +
          '</div>' +
          '<div class="admin-cohort-card admin-cohort-card--late">' +
            '<div class="admin-cohort-identity">' +
              '<p class="admin-cohort-title admin-cohort-title--late">' + esc(titleText) + '</p>' +
              '<p class="admin-cohort-meta admin-cohort-meta--late">' + esc(metaBits.join(' · ')) + '</p>' +
              '<p class="admin-cohort-meta admin-cohort-meta--late">School invoice: ' + esc(row.schoolInvoiceStatus) + ' · Student orders: ' + esc(row.studentOrdersLabel) + '</p>' +
              (row.isFinalized && row.pendingCount > 0
                ? '<p class="admin-late-carryover-prompt">' + row.pendingCount +
                  (row.pendingCount === 1 ? ' student hasn\'t' : ' students haven\'t') +
                  /* Corrected 2026-08-06: this used to send the admin to the
                     status page, which stopped sending reminders in step 3 of
                     the rework. The next late round starts from this cohort's
                     own Late round block on this page. */
                  ' chosen sizes yet. Open this cohort and use the Late round block to start the next one.</p>'
                : '') +
              '<div class="admin-cohort-deadline admin-cohort-deadline--late' + (row.deadlineOverdue ? ' is-overdue' : '') + '">' +
                '<span class="admin-cohort-deadline-label">Late deadline</span>' +
                '<span class="admin-cohort-deadline-value">' + esc(row.deadlineLabel) + '</span>' +
              '</div>' +
            '</div>' +
            '<div class="admin-cohort-side-panel admin-cohort-side-panel--late">' +
              (row.isFinalized
                ? '<div class="admin-cohort-stat-value">' +
                    '<span class="admin-cohort-stat-primary">' + row.confirmedCount + '</span>' +
                  '</div>' +
                  '<div class="admin-cohort-stat-label">Chose sizes</div>'
                : '<div class="admin-cohort-stat-value">' +
                    '<span class="admin-cohort-stat-primary">' + row.confirmedCount + '</span>' +
                    '<span class="admin-cohort-stat-sep">/</span>' +
                    '<span class="admin-cohort-stat-secondary">' + row.totalCount + '</span>' +
                  '</div>' +
                  '<div class="admin-cohort-stat-label">Chose sizes</div>') +
              '<span class="admin-cohort-code">' + esc(row.lateBatchCode || 'LATE') + '</span>' +
            '</div>' +
            '<div class="admin-cohort-actions admin-cohort-actions--late">' +
              actionsHtml +
            '</div>' +
          '</div>' +
        '</article>'
      );
    }

    function openAdminRemoveStudentModal(options) {
      options = options || {};

      return new Promise(function(resolve) {
        var modal = document.getElementById('cohort-remove-student-modal');
        var confirmButton = document.getElementById('cohort-remove-student-modal-confirm');
        var cancelButton = document.getElementById('cohort-remove-student-modal-cancel');
        var emailEl = document.getElementById('cohort-remove-student-modal-email');
        var studentEmail = String(options.studentEmail || '').trim();

        if (!modal || !confirmButton || !cancelButton) {
          resolve(false);
          return;
        }

        if (emailEl) {
          emailEl.textContent = studentEmail || '';
          emailEl.style.display = studentEmail ? '' : 'none';
        }

        function closeModal(result) {
          modal.classList.remove('is-open');
          modal.setAttribute('aria-hidden', 'true');
          confirmButton.removeEventListener('click', onConfirm);
          cancelButton.removeEventListener('click', onCancel);
          modal.removeEventListener('click', onOverlayClick);
          document.removeEventListener('keydown', onKeyDown);
          resolve(result);
        }

        function onConfirm() {
          closeModal(true);
        }

        function onCancel() {
          closeModal(false);
        }

        function onOverlayClick(event) {
          if (event.target === modal) closeModal(false);
        }

        function onKeyDown(event) {
          if (event.key === 'Escape') closeModal(false);
        }

        confirmButton.addEventListener('click', onConfirm);
        cancelButton.addEventListener('click', onCancel);
        modal.addEventListener('click', onOverlayClick);
        document.addEventListener('keydown', onKeyDown);
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        cancelButton.focus();
      });
    }

    function markLocalCohortArchived(cohortCode) {
      var normalized = normalizeKey(cohortCode);
      MY_COHORTS = MY_COHORTS.map(function(entry) {
        if (normalizeKey(entry.cohortCode) !== normalized) return entry;
        var next = Object.assign({}, entry);
        next.status = 'archived';
        return next;
      });
    }

    function removeLocalCohort(cohortCode) {
      var normalized = normalizeKey(cohortCode);
      MY_COHORTS = MY_COHORTS.filter(function(entry) {
        return normalizeKey(entry.cohortCode) !== normalized;
      });
      STATUS_CACHES = STATUS_CACHES.filter(function(cache) {
        var cacheCode = cache.cohortCode || cache.uniqueCode || cache.cohortId || '';
        return normalizeKey(cacheCode) !== normalized;
      });
    }

    function openAdminDeleteCohortModal(cohort) {
      return new Promise(function(resolve) {
        var modal = document.getElementById('cohort-delete-modal');
        var confirmButton = document.getElementById('cohort-delete-modal-confirm');
        var cancelButton = document.getElementById('cohort-delete-modal-cancel');
        var nameEl = document.getElementById('cohort-delete-modal-cohort-name');
        var finalizedNote = document.getElementById('cohort-delete-modal-finalized-note');

        if (!modal || !confirmButton || !cancelButton) {
          resolve(false);
          return;
        }

        if (nameEl) {
          nameEl.textContent = getCohortDisplayTitle(cohort) + ' (' + (cohort.cohortCode || '') + ')';
        }
        if (finalizedNote) {
          finalizedNote.style.display = isCohortFinalized(cohort) ? '' : 'none';
        }

        /* 2026-11-03 (owner) - warn, not block: an unpaid invoice's payment
           link keeps working after the cohort is deleted. The count comes
           from the cache (unpaidInvoices, cohort-admin-form.liquid), so it
           can lag a payment by a rebuild - it only asks the admin to look. */
        var unpaidNote = document.getElementById('cohort-delete-modal-unpaid-note');
        if (unpaidNote) {
          var unpaidCache = STATUS_CACHES.find(function(cache) {
            return normalizeKey(cache.cohortCode) === normalizeKey(cohort.cohortCode);
          });
          var unpaidCount = unpaidCache ? Number(unpaidCache.unpaidInvoices) || 0 : 0;
          var unpaidTitle = document.getElementById('cohort-delete-modal-unpaid-title');
          if (unpaidTitle) {
            unpaidTitle.textContent = unpaidCount
              ? unpaidCount + ' school invoice' + (unpaidCount === 1 ? ' is' : 's are') + ' not paid'
              : '';
          }
          unpaidNote.hidden = !unpaidCount;
        }

        function closeModal(result) {
          modal.classList.remove('show');
          modal.setAttribute('aria-hidden', 'true');
          confirmButton.removeEventListener('click', onConfirm);
          cancelButton.removeEventListener('click', onCancel);
          modal.removeEventListener('click', onOverlayClick);
          document.removeEventListener('keydown', onKeyDown);
          resolve(result);
        }

        function onConfirm() {
          closeModal(true);
        }

        function onCancel() {
          closeModal(false);
        }

        function onOverlayClick(event) {
          if (event.target === modal) closeModal(false);
        }

        function onKeyDown(event) {
          if (event.key === 'Escape') closeModal(false);
        }

        confirmButton.addEventListener('click', onConfirm);
        cancelButton.addEventListener('click', onCancel);
        modal.addEventListener('click', onOverlayClick);
        document.addEventListener('keydown', onKeyDown);
        modal.classList.add('show');
        modal.setAttribute('aria-hidden', 'false');
        cancelButton.focus();
      });
    }

    function deleteCohortFromManageList(cohortCode, button) {
      if (showcaseRefuses(cohortCode)) return;
      var cohort = findCohortByCode(cohortCode);
      var statusEl = button ? button.parentElement.querySelector('.admin-cohort-delete-link-status') : null;

      if (!cohort) {
        if (statusEl) statusEl.textContent = 'Cohort not found.';
        return;
      }

      if (!DELETE_COHORT_WEBHOOK_URL) {
        if (statusEl) statusEl.textContent = 'Delete cohort webhook URL is missing in section settings.';
        return;
      }

      openAdminDeleteCohortModal(cohort).then(function(confirmed) {
        if (!confirmed) return;

        if (button) {
          button.disabled = true;
          button.textContent = 'Deleting…';
        }
        if (statusEl) statusEl.textContent = '';

        /* Destructive and irreversible — same lock and unload guard as create. */
        setAdminPageBlocked(true);
        panelRingLabelText = 'Deleting cohort';
        writeActionLock('Deleting cohort', PANEL_BLOCKING_DELETE_MS, {
          action: 'delete',
          cohortCode: cohort.cohortCode
        });
        startPanelLoadingProgress(PANEL_BLOCKING_DELETE_MS);

        return fetch(DELETE_COHORT_WEBHOOK_URL, webhookInit({
          cohort_code: cohort.cohortCode,
          cohort_id: cohort.cohortId || cohort.cohortCode,
          admin_email: cohort.adminEmail || CUSTOMER.email || '',
          source: 'cohort_admin_manage_list'
        })).then(function(response) {
          if (!response.ok) {
            return response.text().then(function(text) {
              throw new Error(text || 'Delete request failed.');
            });
          }

          removeLocalCohort(cohort.cohortCode);
          if (editingCohortCode === cohort.cohortCode) {
            editingCohortCode = '';
            editingLateStudentsTrack = false;
            editingReadOnly = false;
            persistEmailEditState('');
            stopEmailPanelIdleSync();
            setManagePanelsVisible('manage');
          }
          renderManageCohorts();

          /*
            Returned, so .finally() — which drops the block — waits for it. The
            local list already hides the cohort; this is about not telling the
            admin it is deleted until the server agrees.
          */
          return waitForCohortGone(cohort.cohortCode).then(function(confirmed) {
            if (confirmed) return;

            if (statusEl) {
              statusEl.textContent = 'Still deleting. This is taking longer than usual — reload the page in a minute to see the result.';
            }
          });
        }).catch(function(error) {
          if (button) {
            button.disabled = false;
            button.textContent = 'Delete this cohort';
          }
          if (statusEl) {
            statusEl.textContent = error && error.message ? error.message : 'Unable to delete cohort.';
          }
        }).finally(function() {
          releaseRestoredActionLock();
        });
      });
    }

    function archiveCohortFromDashboard(cohortCode, button) {
      var cohort = findCohortByCode(cohortCode);
      if (!cohort) {
        setMessage('Cohort not found.', 'error');
        return;
      }

      if (!ARCHIVE_WEBHOOK_URL) {
        setMessage('Missing archive webhook URL in section settings.', 'error');
        return;
      }

      if (!isCohortFinalized(cohort)) {
        setMessage('Archive is only available after the cohort is finalized.', 'error');
        return;
      }

      if (isCohortArchived(cohort)) {
        setMessage('This cohort is already archived.', 'error');
        return;
      }

      var confirmText =
        'Archive cohort ' +
        (cohort.cohortCode || '') +
        '?\n\nThis saves a snapshot, marks the cohort archived, and removes individual student entries from Shopify. ' +
        'Use a test cohort first. Continue?';

      if (!window.confirm(confirmText)) {
        return;
      }

      if (button) {
        button.disabled = true;
        button.textContent = 'Archiving...';
      }

      fetch(ARCHIVE_WEBHOOK_URL, webhookInit({
        cohort_code: cohort.cohortCode,
        cohort_id: cohort.cohortId || cohort.cohortCode,
        source: 'admin_dashboard_test',
        dry_run: false,
        delete_student_entries: true
      }))
        .then(function(response) {
          if (!response.ok) {
            return response.text().then(function(text) {
              throw new Error(text || 'Archive request failed.');
            });
          }

          markLocalCohortArchived(cohort.cohortCode);
          renderManageCohorts();
          setMessage(
            'Archive request sent. Check Mechanic in 1–2 minutes. Status page should still show frozen roster from cache.',
            'success'
          );
        })
        .catch(function(error) {
          setMessage(error && error.message ? error.message : 'Unable to archive cohort.', 'error');
        })
        .finally(function() {
          if (button) {
            button.disabled = false;
            button.textContent = 'Archive (test)';
          }
        });
    }

    function setManageActionBannerLoading(active) {
      var banner = document.getElementById('cohort-manage-action-banner');
      var progress = banner ? banner.querySelector('.cohort-manage-action-banner-progress') : null;
      var wait = banner ? banner.querySelector('.cohort-manage-action-banner-wait') : null;
      var copy = banner ? banner.querySelector('.cohort-manage-action-banner-copy') : null;
      var title = banner ? banner.querySelector('.cohort-manage-action-banner-title') : null;
      var text = banner ? banner.querySelector('.cohort-manage-action-banner-text') : null;

      if (!banner) return;

      if (active) {
        banner.classList.add('show', 'is-loading');
        banner.classList.remove('is-sent');
        if (title) title.textContent = '';
        if (text) text.textContent = '';
        if (progress) progress.hidden = false;
        if (wait) wait.hidden = false;
        if (copy) copy.style.display = 'none';
        return;
      }

      banner.classList.remove('is-loading');
      if (progress) progress.hidden = true;
      if (wait) wait.hidden = true;
      if (copy) copy.style.display = '';
    }

    function showManageActionBanner(title, text) {
      var banner = document.getElementById('cohort-manage-action-banner');
      var titleEl = banner ? banner.querySelector('.cohort-manage-action-banner-title') : null;
      var textEl = banner ? banner.querySelector('.cohort-manage-action-banner-text') : null;

      if (!banner) return;

      setManageActionBannerLoading(false);
      banner.classList.add('show', 'is-sent');
      if (titleEl) titleEl.textContent = title || '';
      if (textEl) textEl.textContent = text || '';
    }

    function hideManageActionBanner() {
      var banner = document.getElementById('cohort-manage-action-banner');
      if (!banner) return;

      banner.classList.remove('show', 'is-loading', 'is-sent');
      setManageActionBannerLoading(false);
    }

    function upsertLocalCohortFromPayload(payload) {
      if (!payload) return;

      var cohortCode = String(payload.cohort_code || payload.code || '').trim();
      if (!cohortCode) return;

      var createdAt = String(payload.created_at || payload.opened_at || new Date().toISOString()).trim();
      var cohortLabel = String(payload.cohort_label || payload.cohort_name || '').trim();
      if (!cohortLabel) {
        cohortLabel = parseCohortLabelFromSnapshot(payload.campus_address_snapshot || '');
      }
      var entry = {
        cohortCode: cohortCode,
        cohortLabel: cohortLabel,
        schoolName: payload.school_name || '',
        campusName: payload.campus_name || '',
        programName: payload.program_name || '',
        campusAddressSnapshot: payload.campus_address_snapshot || '',
        createdAt: createdAt,
        openedAt: String(payload.opened_at || payload.created_at || createdAt).trim(),
        deadline: payload.deadline || '',
        deadlineDisplay: payload.deadline_display || payload.deadline || '',
        status: payload.status || 'open',
        /* Carried here too, so a cohort just created leads with the right
           number before the page has been back to the server for it. */
        deliveryMode: payload.delivery_mode || '',
        orderType: payload.order_type || '',
        shipToStudents: payload.ship_to_students || '',
        finalizeLock: '',
        adminEmail: String(payload.admin_email || '').trim().toLowerCase(),
        statusPageUrl: payload.status_page_url || '',
        studentFormUrl: payload.student_form_url || '',
        schoolDraftOrderId: '',
        studentEmailsRaw: JSON.stringify(payload.student_emails || [])
      };

      var normalized = normalizeKey(cohortCode);
      var existingIndex = -1;

      MY_COHORTS.forEach(function(cohort, index) {
        if (normalizeKey(cohort.cohortCode) === normalized) {
          existingIndex = index;
        }
      });

      if (existingIndex >= 0) {
        var existing = MY_COHORTS[existingIndex];
        MY_COHORTS[existingIndex] = Object.assign({}, existing, entry, {
          createdAt: entry.createdAt || existing.createdAt || existing.openedAt || '',
          openedAt: entry.openedAt || existing.openedAt || existing.createdAt || '',
          cohortLabel: entry.cohortLabel || existing.cohortLabel || ''
        });
      } else {
        MY_COHORTS.unshift(entry);
      }

      markSessionCohort(cohortCode, {
        createdAt: entry.createdAt,
        cohortLabel: entry.cohortLabel
      });
    }

    /*
      2026-08-06 — cohortMatchesDashboardFilter removed.

      It kept a cohort only when its admin_email matched the signed-in account
      or the cohort had been created in this very browser session. Written long
      before the access list, it now contradicted it: the section grants every
      address in a School's admin_emails the whole school, and this then hid a
      colleague's cohorts again. Two admins at one school would each have seen
      half the picture — and, not seeing the other's cohort, made a second one
      for the same class.

      It was never a privacy boundary and must not be mistaken for one: it only
      hid rows already delivered to the browser, and its first line returned
      true for everything whenever the account email could not be read. The
      boundary is the Liquid filter in cohort-admin-form.liquid, which decides
      what is printed at all.
    */

    function isFinalScreenActive() {
      var finalPanel = document.getElementById('cohort-final-state');
      return !!(finalPanel && finalPanel.classList.contains('is-visible'));
    }

    function isCreateFlowLoading() {
      var finalPanel = document.getElementById('cohort-final-state');
      return !!(finalPanel && finalPanel.classList.contains('is-visible') && finalPanel.classList.contains('is-pending'));
    }

    /*
      ── 2026-10-17 (owner) - the bell and the purple Note icon ───────────

      Top right of a cohort card. The bell shows when the cohort has
      something an admin should act on: a student asking to join (open
      cohorts only, as Requests to join), or a student whose letters do not
      arrive and whose notice nobody has closed. Hover or focus shows the
      list; Open the cohort goes to Edit Cohort.

      The purple Note icon is for our own team only (IS_TEAM, decided in
      Liquid, and the notes are printed for the team only): notes admins
      wrote since this browser last pressed "Mark as seen". The seen mark is
      kept in this browser - a convenience, not a record.

      Both are drawn into their own span, so a later answer (the undelivered
      list arrives after the cards) changes the icons and nothing else on
      the page.
    */
    var TEAM_NOTES_SEEN_KEY = 'cohortTeamNotesSeen';
    var BELL_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22Zm7-6V11a7 7 0 0 0-5.5-6.84V3.5a1.5 1.5 0 0 0-3 0v.66A7 7 0 0 0 5 11v5l-1.7 1.7A1 1 0 0 0 4 19.4h16a1 1 0 0 0 .7-1.7Z"/></svg>';
    var NOTE_ICON = '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true" focusable="false"><path fill="currentColor" d="M6 2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm8 1.5V8h4.5ZM8 12h8v1.6H8Zm0 4h8v1.6H8Z"/></svg>';

    function readTeamNotesSeen() {
      try {
        var parsed = JSON.parse(window.localStorage.getItem(TEAM_NOTES_SEEN_KEY) || '{}');
        return parsed && typeof parsed === 'object' ? parsed : {};
      } catch (error) {
        return {};
      }
    }

    function markTeamNotesSeen(cohortCode, at) {
      var seen = readTeamNotesSeen();
      seen[cohortCode] = Math.max(Number(seen[cohortCode]) || 0, Number(at) || 0);
      try {
        window.localStorage.setItem(TEAM_NOTES_SEEN_KEY, JSON.stringify(seen));
      } catch (error) {
        /* private window: the icon simply stays */
      }
    }

    function unseenTeamNotes(cohort) {
      if (!IS_TEAM || !cohort) return [];
      var list = cohort.teamNotesRaw;
      if (typeof list === 'string') {
        try {
          list = list.trim() ? JSON.parse(list) : [];
        } catch (error) {
          list = [];
        }
      }
      if (!Array.isArray(list)) return [];

      var code = String(cohort.cohortCode || '').trim().toUpperCase();
      var seenAt = Number(readTeamNotesSeen()[code]) || 0;
      return list.filter(function(item) {
        return item && Number(item.at) > seenAt;
      }).sort(function(a, b) {
        return Number(b.at) - Number(a.at);
      });
    }

    function cohortAlertItems(cohort) {
      var code = String(cohort.cohortCode || '').trim().toUpperCase();
      var items = [];

      if (!isCohortFinalized(cohort)) {
        joinRequestsFor(code).forEach(function(request) {
          items.push({
            title: (request.name || request.email) + ' asks to join',
            sub: request.name ? request.email : ''
          });
        });
      }

      var students = getStudentsForCohort(code);
      getRosterEmailsOrdered(cohort).forEach(function(rosterEmail) {
        var email = String(rosterEmail || '').trim().toLowerCase();
        if (!email) return;
        var match = mailFailureMatch(findStudentForRosterEmail(students, email), email);
        if (mailFailureIsOpen(cohort, match)) {
          items.push({ title: 'Letter not delivered', sub: email });
        }
      });

      return items;
    }

    function shortDate(epochSeconds) {
      var value = Number(epochSeconds) || 0;
      return value ? new Date(value * 1000).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '';
    }

    function cohortAlertsHtml(cohort) {
      if (!cohort) return '';
      var code = String(cohort.cohortCode || '').trim().toUpperCase();
      var items = cohortAlertItems(cohort);
      var notes = unseenTeamNotes(cohort);
      var html = '';

      if (items.length) {
        var shown = items.slice(0, 8);
        html +=
          '<span class="cohort-alert is-bell">' +
            '<button type="button" class="cohort-alert-btn" aria-label="' + items.length + (items.length === 1 ? ' notification' : ' notifications') + '">' +
              BELL_ICON + '<span class="cohort-alert-count">' + items.length + '</span>' +
            '</button>' +
            '<span class="cohort-alert-pop" role="tooltip">' +
              '<span class="cohort-alert-pop-title">Notifications</span>' +
              shown.map(function(item) {
                return '<span class="cohort-alert-item"><b>' + esc(item.title) + '</b>' + (item.sub ? '<small>' + esc(item.sub) + '</small>' : '') + '</span>';
              }).join('') +
              (items.length > shown.length ? '<span class="cohort-alert-more">and ' + (items.length - shown.length) + ' more</span>' : '') +
              (!isCohortFinalized(cohort) ? '<button type="button" class="cohort-alert-open" data-edit-cohort="' + esc(code) + '">Open the cohort</button>' : '') +
            '</span>' +
          '</span>';
      }

      if (notes.length) {
        var shownNotes = notes.slice(0, 5);
        html +=
          '<span class="cohort-alert is-note">' +
            '<button type="button" class="cohort-alert-btn" aria-label="' + notes.length + (notes.length === 1 ? ' new note' : ' new notes') + ' for our team">' +
              NOTE_ICON + '<span class="cohort-alert-count">' + notes.length + '</span>' +
            '</button>' +
            '<span class="cohort-alert-pop" role="tooltip">' +
              '<span class="cohort-alert-pop-title">New notes · our team only</span>' +
              shownNotes.map(function(note) {
                var who = note.name || note.email || '';
                var meta = [shortDate(note.at), note.by ? 'by ' + note.by : ''].filter(Boolean).join(' · ');
                return '<span class="cohort-alert-item"><b>' + esc(who) + '</b>' +
                  '<span class="cohort-alert-note">' + esc(note.note || '') + '</span>' +
                  (meta ? '<small>' + esc(meta) + '</small>' : '') + '</span>';
              }).join('') +
              (notes.length > shownNotes.length ? '<span class="cohort-alert-more">and ' + (notes.length - shownNotes.length) + ' more</span>' : '') +
              '<button type="button" class="cohort-alert-open" data-team-notes-seen="' + esc(code) + '" data-team-notes-at="' + esc(String(notes[0].at || 0)) + '">Mark as seen</button>' +
            '</span>' +
          '</span>';
      }

      return html;
    }

    function refreshCohortAlertBadges() {
      document.querySelectorAll('[data-alerts-for]').forEach(function(host) {
        var cohort = findCohortByCode(host.getAttribute('data-alerts-for') || '');
        var html = cohort ? cohortAlertsHtml(cohort) : '';
        /* do not redraw an open list for nothing: the pointer would lose it */
        if (host.innerHTML !== html) host.innerHTML = html;
      });
    }

    function renderManageCohorts() {
      var panel = document.getElementById('cohort-manage-panel');
      var list = document.getElementById('cohort-manage-list');

      if (!panel || !list) {
        return;
      }

      loadMailFailuresAll();

      var adminEmail = String(getAccountEmailSync() || '').trim().toLowerCase();
      var sessionCodes = getSessionCohortCodes();
      var allCohorts = dedupeCohortsByCode(MY_COHORTS.slice());
      var cohorts = allCohorts.slice();

      cohorts = cohorts.map(enrichCohortRecord);

      cohorts.sort(function(a, b) {
        var aCreated = getCohortCreatedAt(a);
        var bCreated = getCohortCreatedAt(b);

        if (aCreated && bCreated) {
          var createdCompare = bCreated.localeCompare(aCreated);
          if (createdCompare) return createdCompare;
        } else if (aCreated) {
          return -1;
        } else if (bCreated) {
          return 1;
        }

        var aSessionIndex = sessionCodes.indexOf(normalizeKey(a.cohortCode));
        var bSessionIndex = sessionCodes.indexOf(normalizeKey(b.cohortCode));

        if (aSessionIndex !== -1 && bSessionIndex !== -1 && aSessionIndex !== bSessionIndex) {
          return aSessionIndex - bSessionIndex;
        }

        if (aSessionIndex !== -1) return -1;
        if (bSessionIndex !== -1) return 1;

        return String(b.deadline || '').localeCompare(String(a.deadline || ''));
      });

      var listSearch = document.getElementById('cohort-list-search');
      if (listSearch) listSearch.hidden = cohorts.length < 2;

      /* 2026-11-02 (owner) - every unpaid school invoice, on the status page.
         Not in the demo: its invoices carry no payment link. */
      var invoicesLink = document.getElementById('cohort-list-invoices');
      if (invoicesLink) {
        invoicesLink.hidden = !cohorts.length || !!CONFIG.demoMode;
        invoicesLink.href = buildUnpaidInvoicesUrl();
      }

      var listTools = document.getElementById('cohort-list-tools');
      if (listTools) {
        listTools.hidden = (!listSearch || listSearch.hidden) && (!invoicesLink || invoicesLink.hidden);
      }

      if (!cohorts.length) {
        /*
          Nothing is filtered out here any more, so an empty list means the
          school genuinely has no cohorts yet — not that some are hidden from
          this account. The old "No cohorts match your account" panel went with
          the filter: it explained a rule that no longer exists and sent people
          to the status page, which is read-only and behind the same list.
        */
        panel.style.display = isCreateFlowLoading() ? 'none' : ((allCohorts.length || mustSignInToCreate()) ? '' : 'none');
        if (!isCreateFlowLoading() && !editingCohortCode) {
          /* Signed out: stay on the list, where the button offers sign-in. */
          setCreatePanelVisible(!mustSignInToCreate());
        } else {
          syncManagePanelVisibility();
        }

        list.innerHTML = '';

        return;
      }

      panel.style.display = isCreateFlowLoading() ? 'none' : '';
      syncManagePanelVisibility();

      document.querySelectorAll('.cf-info-tip.is-open').forEach(function(tip) {
        closeInfoTip(tip);
      });

      list.innerHTML = cohorts.map(function(cohort) {
        /*
          The session-code condition went with the filter: it only ever existed
          because a colleague's cohort could otherwise not appear at all. Now
          any cohort of the school can, so the note marks every one whose admin
          differs from the viewer — which is the whole point of showing it.
        */
        var cohortAdminEmail = String(cohort.adminEmail || '').trim().toLowerCase();
        var emailMismatch = !!adminEmail && !!cohortAdminEmail && cohortAdminEmail !== adminEmail;
        var students = dedupeStudentsByEmail(getStudentsForCohort(cohort.cohortCode));
        var lateRows = getLateBatchDashboardRows(cohort, students);
        var mainRow = renderAdminCohortMainRow(cohort, students, { emailMismatch: emailMismatch });

        /*
          Reverted 2026-08-06 to the original text link. The square tile and the
          small right-aligned pill were both tried and both rejected — the plain
          link reads as what it is without competing with the cohort card above
          it, which is the right weight for something guarded by a confirmation
          dialog anyway.
        */
        var deleteLinkHtml =
          '<div class="admin-cohort-delete-link-row">' +
            '<button type="button" class="admin-cohort-delete-link" data-delete-cohort="' + esc(cohort.cohortCode || '') + '">Delete Cohort</button>' +
            '<span class="admin-cohort-delete-link-status" aria-live="polite"></span>' +
          '</div>';

        var searchText = [
          cohort.cohortCode, cohort.cohortLabel, cohort.schoolName, cohort.campusName, cohort.programName
        ].join(' ');

        return (
          '<div class="admin-cohort-stack" data-cohort-search="' + esc(cohortSearchKey(searchText)) + '">' +
            mainRow +
            lateRows.map(function(row) { return renderAdminCohortLateRow(cohort, row); }).join('') +
            deleteLinkHtml +
          '</div>'
        );
      }).join('');

      bindCohortListSearch();
      applyCohortListSearch();
    }

    /*
      2026-10-16 (owner) - the search above the cohort list. The words are kept
      across redraws (the list is redrawn by the background sync), so a search
      in progress is not undone under the admin's fingers. A code is matched
      with or without its dash: "mccmpyqbc" finds MCC-MPYQBC.
    */
    var cohortListQuery = '';

    function cohortSearchKey(text) {
      var lower = String(text || '').toLowerCase().replace(/\s+/g, ' ').trim();
      return lower + ' | ' + lower.replace(/[^a-z0-9]/g, '');
    }

    function bindCohortListSearch() {
      var input = document.getElementById('cohort-list-search-input');
      if (!input || input.dataset.bound) return;
      input.dataset.bound = '1';
      input.value = cohortListQuery;
      input.addEventListener('input', function() {
        cohortListQuery = input.value;
        applyCohortListSearch();
      });
    }

    function applyCohortListSearch() {
      var list = document.getElementById('cohort-manage-list');
      var empty = document.getElementById('cohort-list-search-empty');
      if (!list) return;

      var query = String(cohortListQuery || '').toLowerCase().trim();
      var compact = query.replace(/[^a-z0-9]/g, '');
      var shown = 0;
      var stacks = list.querySelectorAll('.admin-cohort-stack');

      Array.prototype.forEach.call(stacks, function(stack) {
        var key = stack.getAttribute('data-cohort-search') || '';
        var match = !query || key.indexOf(query) !== -1 || (compact && key.indexOf(compact) !== -1);
        stack.hidden = !match;
        if (match) shown += 1;
      });

      if (empty) {
        empty.hidden = !query || shown > 0;
        empty.textContent = query && !shown ? 'No cohort matches "' + cohortListQuery.trim() + '".' : '';
      }
    }

    function setFinalScreenVisible(visible) {
      var createHero = document.getElementById('cohort-create-hero');
      var successHero = document.getElementById('cohort-success-hero');
      var wizard = document.getElementById('cohort-wizard');
      var finalPanel = document.getElementById('cohort-final-state');

      if (createHero) createHero.style.display = visible ? 'none' : '';
      if (successHero) successHero.classList.toggle('is-visible', visible);
      if (wizard) wizard.style.display = visible ? 'none' : 'block';
      if (finalPanel) finalPanel.classList.toggle('is-visible', visible);
    }

    function updateSuccessHero(kicker, titleHtml, text) {
      var titleEl = document.getElementById('cohort-success-title');
      var textEl = document.getElementById('cohort-success-text');
      var successHero = document.getElementById('cohort-success-hero');

      if (titleEl) titleEl.innerHTML = titleHtml || 'Cohort <span class="cohort-gradient-text-internal">Created!</span>';
      if (textEl) textEl.textContent = text || '';
      if (successHero) successHero.classList.toggle('is-pending', kicker === 'Please wait');
    }

    function updateFinalPanelCopy(kicker, title, text) {
      var kickerEl = document.getElementById('final-panel-kicker');
      var titleEl = document.getElementById('final-panel-title');
      var textEl = document.getElementById('final-panel-text');

      if (kickerEl) kickerEl.textContent = kicker || '';
      if (titleEl) titleEl.textContent = title || '';
      if (textEl) textEl.textContent = text || '';
    }

    var setupProgressTimer = null;
    var setupProgressStartedAt = 0;
    var setupProgressCompleteTimer = null;
    var setupProgressFinishTimer = null;
    var setupProgressOnComplete = null;
    var activeCreationFlow = null;
    var SETUP_PROGRESS_DURATION_MS = 30000;
    var SETUP_STATUS_MESSAGES = [
      { until: 0.18, text: 'Creating your cohort…' },
      { until: 0.42, text: 'Adding student emails…' },
      { until: 0.64, text: 'Building student links…' },
      { until: 0.84, text: 'Preparing your dashboard…' },
      { until: 1, text: 'Almost ready…' }
    ];

    function getSetupStatusMessage(ratio) {
      for (var i = 0; i < SETUP_STATUS_MESSAGES.length; i += 1) {
        if (ratio <= SETUP_STATUS_MESSAGES[i].until) {
          return SETUP_STATUS_MESSAGES[i].text;
        }
      }

      return SETUP_STATUS_MESSAGES[SETUP_STATUS_MESSAGES.length - 1].text;
    }

    function toggleSetupScreenMode(pending) {
      var setupScreen = document.getElementById('cohort-setup-screen');
      var successStage = document.getElementById('cohort-success-stage');
      var successHero = document.getElementById('cohort-success-hero');
      var footer = document.querySelector('#cohort-final-state .final-code-footer');

      if (setupScreen) {
        setupScreen.hidden = !pending;
        setupScreen.setAttribute('aria-busy', pending ? 'true' : 'false');
      }

      if (successStage) successStage.hidden = pending;
      if (footer) footer.hidden = pending;

      if (successHero && pending) {
        successHero.classList.remove('is-visible');
        successHero.classList.remove('is-pending');
      }
    }

    function updateSetupProgressVisual(percent, statusText) {
      var bar = document.getElementById('cohort-setup-progress-bar');
      var statusEl = document.getElementById('cohort-setup-status');
      var clamped = Math.max(0, Math.min(100, percent));

      if (bar) {
        bar.classList.remove('is-indeterminate');
        bar.classList.toggle('is-complete', clamped >= 100);
        bar.style.width = clamped + '%';
      }

      if (statusEl && statusText && statusEl.textContent !== statusText) {
        statusEl.classList.add('is-changing');
        window.setTimeout(function() {
          statusEl.textContent = statusText;
          statusEl.classList.remove('is-changing');
        }, 60);
      }
    }

    function tickSetupProgress() {
      var elapsed = Date.now() - setupProgressStartedAt;
      var ratio = Math.min(1, elapsed / SETUP_PROGRESS_DURATION_MS);
      var eased = 1 - Math.pow(1 - ratio, 1.85);
      var percent = Math.round(eased * 100);

      updateSetupProgressVisual(percent, getSetupStatusMessage(ratio));
    }

    function startSetupProgress(onComplete) {
      stopSetupProgress(false);
      setupProgressStartedAt = Date.now();
      setupProgressOnComplete = typeof onComplete === 'function' ? onComplete : null;

      var titleEl = document.getElementById('final-panel-title');
      var bar = document.getElementById('cohort-setup-progress-bar');

      toggleSetupScreenMode(true);
      if (titleEl) titleEl.classList.remove('is-setup-loading');

      if (bar) {
        bar.classList.add('is-active');
        bar.classList.remove('is-complete');
        bar.style.width = '0%';
      }

      updateSetupProgressVisual(0, SETUP_STATUS_MESSAGES[0].text);
      setupProgressTimer = window.setInterval(tickSetupProgress, 90);
      window.requestAnimationFrame(function() {
        tickSetupProgress();
      });

      if (setupProgressFinishTimer) {
        window.clearTimeout(setupProgressFinishTimer);
      }

      setupProgressFinishTimer = window.setTimeout(function() {
        setupProgressFinishTimer = null;
        finishSetupProgress(function() {
          if (typeof setupProgressOnComplete === 'function') {
            var done = setupProgressOnComplete;
            setupProgressOnComplete = null;
            done();
          }
        });
      }, SETUP_PROGRESS_DURATION_MS);
    }

    function finishSetupProgress(onDone) {
      if (setupProgressTimer) {
        window.clearInterval(setupProgressTimer);
        setupProgressTimer = null;
      }

      var bar = document.getElementById('cohort-setup-progress-bar');
      if (bar) {
        bar.classList.remove('is-active');
        bar.classList.add('is-complete');
      }

      updateSetupProgressVisual(100, 'Your cohort is almost ready…');

      if (setupProgressCompleteTimer) {
        window.clearTimeout(setupProgressCompleteTimer);
      }

      setupProgressCompleteTimer = window.setTimeout(function() {
        setupProgressCompleteTimer = null;
        if (typeof onDone === 'function') onDone();
      }, 200);
    }

    function stopSetupProgress(resetVisual) {
      if (setupProgressTimer) {
        window.clearInterval(setupProgressTimer);
        setupProgressTimer = null;
      }

      if (setupProgressCompleteTimer) {
        window.clearTimeout(setupProgressCompleteTimer);
        setupProgressCompleteTimer = null;
      }

      if (setupProgressFinishTimer) {
        window.clearTimeout(setupProgressFinishTimer);
        setupProgressFinishTimer = null;
      }

      setupProgressOnComplete = null;

      var bar = document.getElementById('cohort-setup-progress-bar');
      var titleEl = document.getElementById('final-panel-title');

      if (titleEl) titleEl.classList.remove('is-setup-loading');

      if (resetVisual !== false) {
        if (bar) {
          bar.style.width = '0%';
          bar.classList.remove('is-indeterminate', 'is-active', 'is-complete');
        }
        updateSetupProgressVisual(0, SETUP_STATUS_MESSAGES[0].text);
      }
    }

    function collectPageStyles() {
      var css = '';

      document.querySelectorAll('style').forEach(function(node) {
        css += node.textContent + '\n';
      });

      return css;
    }

    function printHtmlInIframe(options) {
      options = options || {};

      var iframe = document.createElement('iframe');
      iframe.setAttribute('aria-hidden', 'true');
      iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;opacity:0;pointer-events:none';
      document.body.appendChild(iframe);

      var win = iframe.contentWindow;
      var doc = win.document;
      var css = collectPageStyles() +
        'body{margin:0;padding:0;background:#ffffff;}' +
        '#cohort-print-layout,.print-only-qr,.print-report{display:block!important;visibility:visible!important;}';

      doc.open();
      doc.close();

      doc.title = options.title || 'Cohort QR';

      var styleNode = doc.createElement('style');
      styleNode.textContent = css;
      doc.head.appendChild(styleNode);

      if (options.qrOnly) {
        doc.body.className = 'print-qr-mode';
      }

      var mount = doc.createElement('div');
      mount.innerHTML = options.bodyHtml || '';
      while (mount.firstChild) {
        doc.body.appendChild(mount.firstChild);
      }

      function cleanup() {
        if (iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
      }

      function runPrint() {
        if (!win) {
          cleanup();
          return;
        }

        win.focus();
        win.print();
        setTimeout(cleanup, 1200);
      }

      setTimeout(runPrint, options.qrOnly ? 700 : 450);
    }

    function positionInfoTipBubble(tip) {
      var trigger = tip.querySelector('.cf-info-tip-trigger');
      var bubble = tip._floatedBubble || tip.querySelector('.cf-info-tip-bubble');

      if (!trigger || !bubble) {
        return;
      }

      if (!tip._floatedBubble) {
        tip._floatedBubble = bubble;
        tip._bubblePlaceholder = document.createComment('cf-info-tip-bubble');
        bubble.parentNode.insertBefore(tip._bubblePlaceholder, bubble);
        bubble._ownerTip = tip;
        document.body.appendChild(bubble);
        bubble.classList.add('cf-info-tip-bubble--portaled');
      }

      tip.classList.add('cf-info-tip--floating');
      bubble.classList.remove('cf-info-tip-bubble--below');
      bubble.style.visibility = 'hidden';
      bubble.style.display = 'block';
      bubble.style.position = 'fixed';
      bubble.style.left = '-9999px';
      bubble.style.top = '0';
      bubble.style.transform = 'none';

      var bubbleWidth = bubble.offsetWidth;
      var bubbleHeight = bubble.offsetHeight;
      var triggerRect = trigger.getBoundingClientRect();
      var gap = 10;
      var viewportPadding = 12;
      var placeBelow = triggerRect.top - bubbleHeight - gap < viewportPadding;
      var centerX = triggerRect.left + triggerRect.width / 2;
      var minLeft = viewportPadding + bubbleWidth / 2;
      var maxLeft = window.innerWidth - viewportPadding - bubbleWidth / 2;

      centerX = Math.max(minLeft, Math.min(maxLeft, centerX));

      if (placeBelow) {
        bubble.classList.add('cf-info-tip-bubble--below');
        bubble.style.left = centerX + 'px';
        bubble.style.top = (triggerRect.bottom + gap) + 'px';
        bubble.style.transform = 'translate(-50%, 0)';
      } else {
        bubble.style.left = centerX + 'px';
        bubble.style.top = (triggerRect.top - gap) + 'px';
        bubble.style.transform = 'translate(-50%, -100%)';
      }

      bubble.style.visibility = '';
      bubble.style.display = '';
    }

    function resetInfoTipBubble(tip) {
      var bubble = tip._floatedBubble || tip.querySelector('.cf-info-tip-bubble');

      if (!bubble) {
        return;
      }

      bubble.classList.remove('cf-info-tip-bubble--portaled');
      bubble.classList.remove('is-visible');
      bubble._ownerTip = null;

      if (tip._bubblePlaceholder && tip._bubblePlaceholder.parentNode) {
        tip._bubblePlaceholder.parentNode.insertBefore(bubble, tip._bubblePlaceholder);
        tip._bubblePlaceholder.remove();
      }

      tip._floatedBubble = null;
      tip._bubblePlaceholder = null;

      tip.classList.remove('cf-info-tip--floating');
      bubble.classList.remove('cf-info-tip-bubble--below');
      bubble.style.left = '';
      bubble.style.top = '';
      bubble.style.transform = '';
      bubble.style.position = '';
      bubble.style.visibility = '';
      bubble.style.display = '';
    }

    function openInfoTip(tip) {
      if (!tip) {
        return;
      }

      positionInfoTipBubble(tip);

      var bubble = tip._floatedBubble || tip.querySelector('.cf-info-tip-bubble');
      if (bubble) {
        bubble.classList.add('is-visible');
      }

      tip.classList.add('is-open');
    }

    function closeInfoTip(tip) {
      if (!tip) {
        return;
      }

      var bubble = tip._floatedBubble || tip.querySelector('.cf-info-tip-bubble');
      if (bubble) {
        bubble.classList.remove('is-visible');
      }

      tip.classList.remove('is-open');
      resetInfoTipBubble(tip);
    }

    function bindInfoTips(root) {
      if (!root || root.dataset.tipsBound === '1') {
        return;
      }

      root.dataset.tipsBound = '1';

      var openTip = null;
      var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      function closeAll() {
        if (!openTip) {
          return;
        }

        closeInfoTip(openTip);
        openTip = null;
      }

      root.addEventListener('click', function(event) {
        var trigger = event.target.closest('.cf-info-tip-trigger');

        if (trigger) {
          event.preventDefault();
          event.stopPropagation();

          if (supportsHover) {
            return;
          }

          var tip = trigger.closest('.cf-info-tip');
          var isOpen = tip && tip.classList.contains('is-open');
          closeAll();

          if (tip && !isOpen) {
            openInfoTip(tip);
            openTip = tip;
          }

          return;
        }

        if (!event.target.closest('.cf-info-tip')) {
          closeAll();
        }
      });

      if (supportsHover) {
        root.addEventListener('mouseover', function(event) {
          var trigger = event.target.closest('.cf-info-tip-trigger');

          if (!trigger || !root.contains(trigger)) {
            return;
          }

          var tip = trigger.closest('.cf-info-tip');

          if (!tip) {
            return;
          }

          closeAll();
          openInfoTip(tip);
          openTip = tip;
        });

        root.addEventListener('mouseout', function(event) {
          var tip = event.target.closest('.cf-info-tip');
          var bubble = event.target.closest('.cf-info-tip-bubble--portaled');
          var related = event.relatedTarget;

          if (tip) {
            var floatedBubble = tip._floatedBubble;

            if (floatedBubble && (floatedBubble === related || (related && floatedBubble.contains(related)))) {
              return;
            }

            if (related && tip.contains(related)) {
              return;
            }
          }

          if (bubble && bubble._ownerTip) {
            var ownerTip = bubble._ownerTip;
            var ownerTrigger = ownerTip.querySelector('.cf-info-tip-trigger');

            if (bubble === related || (related && bubble.contains(related))) {
              return;
            }

            if (ownerTrigger === related || (related && ownerTip.contains(related))) {
              return;
            }
          }

          if (!tip && !bubble) {
            return;
          }

          closeAll();
        });
      }
    }

    function esc(value) {
      return String(value || '').replace(/[&<>"']/g, function(match) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;'
        }[match];
      });
    }

    function adminInfoTipHtml(text) {
      return (
        '<span class="cf-info-tip">' +
          '<button type="button" class="cf-info-tip-trigger" aria-label="More information">' +
            '<svg class="cf-info-tip-icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
              '<circle cx="8" cy="4.7" r="1.15" fill="currentColor"></circle>' +
              '<path d="M8 7.2v4.2" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"></path>' +
            '</svg>' +
          '</button>' +
          '<span class="cf-info-tip-bubble" role="tooltip">' + esc(text) + '</span>' +
        '</span>'
      );
    }

    function getParam(name) {
      return new URLSearchParams(window.location.search).get(name);
    }

    function normalizeKey(value) {
      return String(value || '')
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9-]/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
    }

    function normalizeCompare(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '');
    }

    function toNumber(value) {
      var number = parseFloat(value);
      return isNaN(number) ? 0 : number;
    }

    function formatMoney(amount, currencyCode) {
      var numericAmount = Number(amount) || 0;
      var currency = currencyCode || 'USD';

      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(numericAmount);
      } catch (error) {
        return '$' + numericAmount.toFixed(2);
      }
    }

    function randomCode(length) {
      var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
      var result = '';

      for (var i = 0; i < length; i += 1) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      return result;
    }

    function sanitizePagePath(path, fallbackPath) {
      var value = String(path || fallbackPath || '').trim();

      if (!value) {
        value = fallbackPath || '';
      }

      value = value.replace(/^https?:\/\/[^/]+/i, '');
      value = value.replace(/\s+/g, '');

      if (!/^[\x00-\x7F]*$/.test(value)) {
        value = fallbackPath || '';
      }

      if (value.charAt(0) !== '/') {
        value = '/' + value;
      }

      value = value.replace(/\/+/g, '/');

      return value || fallbackPath || '';
    }

    function toAbsoluteUrl(path) {
      try {
        return new URL(path, SHOP_ORIGIN).toString();
      } catch (error) {
        return '';
      }
    }

    function buildUrls(code) {
      var studentFormPath = sanitizePagePath(STUDENT_FORM_PATH, '/pages/cohort-student');
      var statusPagePath = sanitizePagePath(STATUS_PAGE_PATH, '/pages/cohort-status');

      return {
        studentFormPath: studentFormPath,
        statusPagePath: statusPagePath,
        studentFormUrl: toAbsoluteUrl(studentFormPath + '?cohort=' + encodeURIComponent(code)),
        statusPageUrl: toAbsoluteUrl(statusPagePath + '?cohort=' + encodeURIComponent(code))
      };
    }

    function buildQrUrl(url) {
      return url ? 'https://quickchart.io/qr?size=880&text=' + encodeURIComponent(url) : '';
    }

    function setMessage(message, type) {
      var el = document.getElementById('cohort-message');
      el.textContent = message || '';
      el.classList.remove('success');

      if (type === 'success') {
        el.classList.add('success');
      }
    }

    function getSelectedSchool() {
      return SCHOOLS.find(function(school) {
        return normalizeKey(school.schoolCode) === normalizeKey(selectedSchoolCode);
      }) || null;
    }

    function getSelectedSchoolProducts() {
      var school = getSelectedSchool();
      var products = school && Array.isArray(school.products) ? school.products : [];
      return products.filter(function(product) {
        return productMatchesCampus(product);
      });
    }

    function getCampusesForSchool(school) {
      if (!school) return [];
      var schoolHandle = normalizeCompare(school.schoolHandle || school.schoolCode || '');

      return CAMPUSES.filter(function(campus) {
        if (campus.active === false) return false;
        return normalizeCompare(campus.schoolHandle || '') === schoolHandle;
      });
    }

    /*
      Multi campus (2026-07-31). A cohort can cover several campuses at once.
      The selection lives in selectedCampusHandles; the single-value helper
      below still exists and returns the FIRST selected entry, because the
      cohort metaobject stores one campus reference today and every downstream
      consumer (create-cohort task, dashboard cards, finalize tags) still reads
      that single field. campuses_snapshot carries the full list separately.

      No program selection on Step 1 (2026-08-02, see
      docs/multi-campus-program-phase-1.md §6c): program is assigned per item
      on Step 3 instead — getProgramsForProduct below returns every program a
      product is tied to, not a Step-1-selected subset.
    */
    function getSelectedCampusHandles() {
      return selectedCampusHandles.slice();
    }

    function findCampusByHandle(handle) {
      if (!handle) return null;
      return CAMPUSES.find(function(campus) {
        return normalizeCompare(campus.handle) === normalizeCompare(handle);
      }) || null;
    }

    function findProgramByHandle(handle) {
      if (!handle) return null;
      return PROGRAMS.find(function(program) {
        return normalizeCompare(program.handle) === normalizeCompare(handle);
      }) || null;
    }

    function getSelectedCampuses() {
      return selectedCampusHandles.map(findCampusByHandle).filter(Boolean);
    }

    function getSelectedCampus() {
      return getSelectedCampuses()[0] || null;
    }

    function getCampusLabel(campus) {
      if (!campus) return '';
      return campus.campusName || campus.campusCode || campus.handle || '';
    }

    function getProgramLabel(program) {
      if (!program) return '';
      return program.programName || program.programCode || program.handle || '';
    }

    /*
      2026-08-11 — read the control, not the variable behind it.

      This has now been reported three times as "Submit does nothing, and I have
      to go back and fill in an address I was told I did not need". Twice the
      cause was the state and the dropdown disagreeing — the value was applied
      to one and not the other — and each fix closed only the path that had
      desynced them that time.

      The dropdown is what the admin is looking at and what they answered. If it
      says the orders go to the campuses chosen with the clothing, that is the
      answer, whatever a variable elsewhere believes. The variable stays as the
      fallback for the moment before the control exists.
    */
    /*
      2026-08-11 — one place holds the answer: the hidden input the buttons
      write to.

      Submit refusing over an address the admin had been told was not needed
      was reported three times. Each time the cause was the same shape — the
      chosen value lived both in a control and in a script variable, and some
      path updated one and not the other — and each fix closed only the path
      that had failed that time. There is nothing left to disagree.
    */
    function getShipToValue() {
      var input = document.getElementById('ship-to-campus-value');
      var value = input ? String(input.value || '').trim() : '';
      return value || CAMPUS_FROM_ITEMS_VALUE;
    }

    function setShipToValue(value) {
      var input = document.getElementById('ship-to-campus-value');
      var next = String(value || '').trim() || CAMPUS_FROM_ITEMS_VALUE;

      if (input) input.value = next;
      selectedShipToCampusHandle = next;
    }

    function shipsToCampusesFromItems() {
      return getShipToValue() === CAMPUS_FROM_ITEMS_VALUE;
    }

    function getShipToCampus() {
      if (!selectedShipToCampusHandle) return null;
      if (selectedShipToCampusHandle === CUSTOM_SHIP_TO_VALUE) return null;
      if (selectedShipToCampusHandle === CAMPUS_FROM_ITEMS_VALUE) return null;
      return findCampusByHandle(selectedShipToCampusHandle);
    }

    function renderShipToCampusOptions() {
      var container = document.getElementById('ship-to-campus-options');
      if (!container) return;

      var campuses = getSelectedCampuses();
      var current = getShipToValue();

      /*
        ── One choice, explained where it is made (owner, 2026-09-17) ───────

        The hint used to sit inside each button, which meant the page carried
        three or four explanations of choices nobody had made. The sentence now
        belongs to the chosen one and is printed under the row, where there is
        room to say something worth reading.
      */
      /*
        Short on the button, long underneath (owner, 2026-09-18). A button says
        which one it is; the sentence below says what it does. Four long labels
        made a row of paragraphs pretending to be controls.
      */
      var choices = [{
        value: CAMPUS_FROM_ITEMS_VALUE,
        label: 'Each campus',
        detail: 'Every order is delivered to the campus its clothing was chosen under on the next step. A cohort covering two campuses ships to both, and when you finalize it each campus is invoiced for its own students.'
      }];

      campuses.forEach(function(campus) {
        choices.push({
          value: campus.handle,
          label: 'All to ' + getCampusLabel(campus),
          detail: 'The whole cohort is delivered to ' + getCampusLabel(campus) + ', whichever campus each student belongs to. The invoices still follow the campuses.'
        });
      });

      choices.push({
        value: CUSTOM_SHIP_TO_VALUE,
        label: 'Another address',
        detail: 'Everything is delivered to one address you type in below. Use this when the boxes go somewhere that is not a campus at all — a warehouse, an office, a person.'
      });

      /* The chosen campus may have been removed on Step 3 since. Fall back to
         the default rather than leaving a choice pointing at nothing. */
      var stillOffered = choices.some(function(choice) {
        return normalizeCompare(choice.value) === normalizeCompare(current);
      });

      if (!stillOffered) {
        setShipToValue(CAMPUS_FROM_ITEMS_VALUE);
        prefillSchoolDeliveryAddress(null);
        current = CAMPUS_FROM_ITEMS_VALUE;
      }

      var activeDetail = '';

      container.innerHTML = choices.map(function(choice) {
        var active = normalizeCompare(choice.value) === normalizeCompare(current);
        if (active) activeDetail = choice.detail;

        return '<button type="button" class="cohort-ship-to-option' + (active ? ' is-active' : '') + '" ' +
          'data-ship-to="' + esc(choice.value) + '" aria-pressed="' + (active ? 'true' : 'false') + '">' +
          '<span class="cohort-ship-to-option-label">' + esc(choice.label) + '</span>' +
          '</button>';
      }).join('');

      /* The explanation of what was chosen, under the row that chose it. */
      var detailEl = document.getElementById('ship-to-campus-detail');
      if (detailEl) detailEl.textContent = activeDetail;

      container.querySelectorAll('[data-ship-to]').forEach(function(button) {
        button.addEventListener('click', function() {
          onShipToCampusChange(String(button.getAttribute('data-ship-to') || ''));
        });
      });

      syncSchoolDeliveryAddressFields();
    }

    /*
      2026-08-11 — the address fields only appear when one address is being
      named for everything. Under the default each order goes to its campus and
      the address comes from the campus record, so there is nothing to type;
      leaving the fields on screen made them look required, and Review then
      refused to submit until they were filled.
    */
    function syncSchoolDeliveryAddressFields() {
      var wrap = document.getElementById('school-delivery-address-fields');
      if (!wrap) return;

      var hide = shipsToCampusesFromItems();
      wrap.hidden = hide;
      wrap.setAttribute('aria-hidden', hide ? 'true' : 'false');

      /* Hiding and un-requiring have to happen together — apart, they produced
         a form the browser would not submit and would not explain. */
      toggleSchoolDeliveryAddressBox();
    }

    function onShipToCampusChange(value) {
      setShipToValue(value);
      shipToChosenByAdmin = true;
      renderShipToCampusOptions();
      syncSchoolDeliveryAddressFields();

      /*
        "Different address" clears the fields on purpose: leaving a campus
        address behind would make it far too easy to submit the campus address
        while believing a custom one was entered.
      */
      prefillSchoolDeliveryAddress(getShipToCampus());
      updateSummary();
    }

    function prefillSchoolDeliveryAddress(campus) {
      var fields = {
        school_delivery_name: campus ? campus.deliveryName : '',
        school_delivery_address1: campus ? campus.address1 : '',
        school_delivery_address2: campus ? campus.address2 : '',
        school_delivery_city: campus ? campus.city : '',
        school_delivery_province: campus ? campus.province : '',
        school_delivery_postal_code: campus ? campus.postalCode : '',
        school_delivery_country_code: campus ? campus.countryCode : ''
      };

      Object.keys(fields).forEach(function(id) {
        var input = document.getElementById(id);
        if (input) input.value = fields[id] || '';
      });
    }

    function toggleSchoolDeliveryAddressBox() {
      var box = document.getElementById('school-delivery-address-box');
      if (!box) return;

      var isSchoolDelivery = getSelectedDeliveryMode() === 'school_delivery';
      box.style.display = isSchoolDelivery ? '' : 'none';

      /*
        Owner decision, 2026-08-02: postal_code, province and delivery_name
        (attention line) joined address1/city/country_code as required — all
        her schools are US-based, so no per-country conditional logic is
        needed here. postal_code/province matter for accurate shipping and
        tax; delivery_name matters because several cohorts can ship to the
        SAME campus address at once, and an unnamed box is easy to misdeliver
        at a school reception desk.
      */
      /*
        2026-08-11 — the address fields stop being required when they are not
        being asked for.

        This is what made Create Cohort a dead button, four reports over: the
        script marked them required, phase 2 hid them under the campuses-from-
        items default, and the browser then refused to submit a form whose
        invalid field it could not focus. It says so only as a console warning,
        so from the screen it looked like nothing happened at all.

        Delivery name is not in the list: it is asked for on every school
        delivery, campus or not, and stays visible.
      */
      var addressWrap = document.getElementById('school-delivery-address-fields');
      var addressAsked = isSchoolDelivery && !(addressWrap && addressWrap.hidden);

      var nameInput = document.getElementById('school_delivery_name');
      if (nameInput) nameInput.required = isSchoolDelivery;

      [
        'school_delivery_address1',
        'school_delivery_city',
        'school_delivery_province',
        'school_delivery_postal_code',
        'school_delivery_country_code'
      ].forEach(function(id) {
        var input = document.getElementById(id);
        if (input) input.required = addressAsked;
      });
    }

    function buildSchoolDeliveryAddressSnapshot() {
      if (getSelectedDeliveryMode() !== 'school_delivery') return '';

      var snapshot = {
        delivery_name: (document.getElementById('school_delivery_name') || {}).value || '',
        address1: (document.getElementById('school_delivery_address1') || {}).value || '',
        address2: (document.getElementById('school_delivery_address2') || {}).value || '',
        city: (document.getElementById('school_delivery_city') || {}).value || '',
        province: (document.getElementById('school_delivery_province') || {}).value || '',
        postal_code: (document.getElementById('school_delivery_postal_code') || {}).value || '',
        country_code: (document.getElementById('school_delivery_country_code') || {}).value || '',
        delivery_instructions: (document.getElementById('school_delivery_instructions') || {}).value || ''
      };

      if (!snapshot.address1.trim() && !snapshot.city.trim()) return '';

      return JSON.stringify(snapshot);
    }

    function buildCampusAddressSnapshot(campus, cohortLabel) {
      var label = String(cohortLabel || '').trim();
      var snapshot = {
        cohort_label: label
      };

      if (!campus) {
        return label ? JSON.stringify(snapshot) : '';
      }

      snapshot.campus_gid = campus.gid || '';
      snapshot.campus_handle = campus.handle || '';
      snapshot.campus_code = campus.campusCode || '';
      snapshot.campus_name = campus.campusName || '';
      snapshot.delivery_name = campus.deliveryName || '';
      snapshot.address1 = campus.address1 || '';
      snapshot.address2 = campus.address2 || '';
      snapshot.city = campus.city || '';
      snapshot.province = campus.province || '';
      snapshot.postal_code = campus.postalCode || '';
      snapshot.country_code = campus.countryCode || '';

      return JSON.stringify(snapshot);
    }

    function handleListMatchesAny(productHandles, selectedHandles) {
      return productHandles.some(function(handle) {
        var productKey = normalizeCompare(handle);
        return selectedHandles.some(function(selectedHandle) {
          return normalizeCompare(selectedHandle) === productKey;
        });
      });
    }

    /*
      A product is shown when it matches AT LEAST ONE selected campus (union,
      not exact match). Products with no campus metafield at all stay visible
      regardless of campus selection. Program no longer filters visibility
      (2026-08-02) — every campus-matching product shows, and its program is
      decided per copy on the card instead (see getProgramsForProduct below).
    */
    function productMatchesCampus(product) {
      var selectedCampuses = getSelectedCampusHandles();
      var campusHandles = Array.isArray(product.campusHandles) ? product.campusHandles : [];
      var hasCampusMeta = campusHandles.length > 0;

      if (!hasCampusMeta) return true;

      return !selectedCampuses.length || handleListMatchesAny(campusHandles, selectedCampuses);
    }

    /*
      Every program this product is tied to (via its own custom.programs
      metafield), regardless of anything selected on Step 1 — there is no
      Step-1 program selection anymore (2026-08-02). Used to populate the
      per-copy program picker and to default a new copy's program.
    */
    function getProgramsForProduct(product) {
      var programHandles = Array.isArray(product.programHandles) ? product.programHandles : [];
      if (!programHandles.length) return [];

      return PROGRAMS.filter(function(program) {
        if (program.active === false) return false;
        return handleListMatchesAny(programHandles, [program.handle]);
      });
    }

    /*
      Copies model (2026-08-02, replaces the qty +/- pill). Each unit of a
      product is its own "copy" — {copyId, programHandle} — so the SAME product
      can be duplicated once per program it belongs to (e.g. one copy tagged
      Nursing, another tagged Medical Assistant), each becoming its own line
      item downstream. 1 copy = 1 unit; there is no per-copy quantity control
      (owner decision, 2026-08-02). Students still see every item regardless of
      program (owner decision, 2026-07-31) — this assignment only decides which
      Step 3 group a copy renders in and what label its line item carries.
    */
    function getProductCopies(productId) {
      return productCopies[String(productId)] || [];
    }

    /*
      Default program for a product with no copies yet (the template card) and
      for a brand-new first copy: first program it matches among the ones
      currently selected in Step 1. Returns null for products with no program
      metafield at all ("Other items").
    */
    function getDefaultProgramForProduct(product, campusHandle) {
      var matches = getProgramsForProductAtCampus(product, campusHandle);
      return matches.length ? matches[0] : null;
    }

    /*
      2026-10-05 - a product marked program_exclusive is the only uniform for
      its programs on its campuses (see the export in cohort-admin-form.liquid).

      The case it was made for: the school wears white for MRI and RADA at
      Columbus and Cleveland, and blue for the same programs everywhere else,
      while the blue set also serves STP at Cleveland. Product fields are two
      independent lists, so the blue product could not say "MRI, but not at
      Cleveland". Here the white one says it instead: at Cleveland, MRI and
      RADA are taken, and the blue product's picker offers only what is left.

      The catalog applies the same rule (filter-collection.liquid). The student
      form needs none: it shows what the cohort was built with.
    */
    function isProgramTakenByExclusive(product, campusHandle, programHandle) {
      if (!campusHandle || !programHandle) return false;
      if (product && product.programExclusive) return false;

      var school = getSelectedSchool();
      var products = school && Array.isArray(school.products) ? school.products : [];

      return products.some(function(other) {
        if (!other || !other.programExclusive) return false;
        if (String(other.product_id) === String(product && product.product_id)) return false;
        if (!productBelongsToCampus(other, campusHandle)) return false;
        var handles = Array.isArray(other.programHandles) ? other.programHandles : [];
        return handleListMatchesAny(handles, [programHandle]);
      });
    }

    /*
      Two limits on what a product may be assigned under a campus:
      - the campus's own programs (Campus record, field "programs") - the
        blue scrubs list ten programs, Cleveland teaches three of them. An
        empty field restricts nothing, as in the catalog;
      - programs taken there by an exclusive product (above).
    */
    function campusTeachesProgram(campusHandle, programHandle) {
      var campus = findCampusByHandle(campusHandle);
      var taught = campus && Array.isArray(campus.programHandles) ? campus.programHandles : [];
      if (!taught.length) return true;
      return handleListMatchesAny(taught, [programHandle]);
    }

    function getProgramsForProductAtCampus(product, campusHandle) {
      return getProgramsForProduct(product).filter(function(program) {
        if (campusHandle && !campusTeachesProgram(campusHandle, program.handle)) return false;
        return !isProgramTakenByExclusive(product, campusHandle, program.handle);
      });
    }

    function totalProductCopiesCount() {
      return Object.keys(productCopies).reduce(function(sum, key) {
        return sum + productCopies[key].length;
      }, 0);
    }

    /*
      One-time hint (owner decision, 2026-08-02): shown the moment the admin
      selects their very first item in this cohort, explaining the + button
      before they'd otherwise need to discover duplication/program assignment
      on their own. Stays visible afterward as a standing reminder — not
      auto-dismissed, since losing it after a single glance would defeat the
      point for an admin who skimmed past it the first time.
    */
    function maybeShowCopyHint() {
      var notice = document.getElementById('copy-hint-notice');
      if (notice) notice.style.display = 'flex';
    }

    /*
      ── Campuses on Step 3 (2026-08-11, phase 3) ──────────────────────────────

      Which campuses this cohort is being built for. Chosen here, beside the
      clothing, because each campus brings its own items — the reason Step 1
      stopped asking.

      Deliberately NOT a second place where campuses live: the cohort's campus
      list is derived from the items, and this array only drives the screen and
      the order of its sections. An admin cannot keep a campus with no items
      (their own rule), so the two can never disagree.
    */
    var step3CampusHandles = [];

    /*
      True once a background sync has handed us the server's own view of this
      cohort's rounds. Until then "Start late round" stays hidden — see the note
      where this is set. Reset whenever a different cohort is opened.
    */
    var lateRoundDataConfirmed = false;

    function getStep3Campuses() {
      return step3CampusHandles
        .map(findCampusByHandle)
        .filter(function(campus) { return !!campus; });
    }

    /*
      Items belonging to a campus: its own, plus the school-wide ones — a
      product with no campus metafield belongs to every campus of its school.
      Owner's decision 2026-08-11: they appear in every section, and ticking one
      under two campuses is two positions, exactly as it is for two campuses'
      own items.
    */
    function productBelongsToCampus(product, campusHandle) {
      var handles = Array.isArray(product.campusHandles) ? product.campusHandles : [];
      if (!handles.length) return true;
      return handles.some(function(handle) {
        return normalizeCompare(handle) === normalizeCompare(campusHandle);
      });
    }

    function getProductCopiesForCampus(productId, campusHandle) {
      return getProductCopies(productId).filter(function(copy) {
        return normalizeCompare(copy.campusHandle || '') === normalizeCompare(campusHandle || '');
      });
    }

    function addProductCopy(product, campusHandle) {
      /*
        Guard here rather than at each click handler: there are two ways to add
        a copy today (the whole template card, and the "+" on an existing one)
        and the rule has to hold for any third. A cohort must never be built
        around an item the student form will then refuse to offer.
      */
      if (isProductOutOfStock(product)) return;

      var key = String(product.product_id);
      var copies = productCopies[key] || (productCopies[key] = []);
      var campus = String(campusHandle || '').trim();
      var defaultHandle = null;
      var isFirstCopyOverall = totalProductCopiesCount() === 0;

      /* Copy the program from the last copy IN THE SAME CAMPUS: the same item
         under two campuses is two independent lines, and inheriting across them
         would quietly assign a program the admin never chose there. */
      var siblings = campus ? getProductCopiesForCampus(key, campus) : copies;

      if (siblings.length) {
        defaultHandle = siblings[siblings.length - 1].programHandle;
      } else {
        var defaultProgram = getDefaultProgramForProduct(product, campus);
        defaultHandle = defaultProgram ? defaultProgram.handle : null;
      }

      copies.push({ copyId: nextCopyId++, programHandle: defaultHandle, campusHandle: campus });

      if (isFirstCopyOverall) maybeShowCopyHint();

      renderProducts();
      updateSummary();
    }

    function removeProductCopy(productId, copyId) {
      var key = String(productId);
      var copies = productCopies[key];
      if (!copies) return;

      productCopies[key] = copies.filter(function(copy) {
        return copy.copyId !== copyId;
      });

      if (!productCopies[key].length) delete productCopies[key];

      renderProducts();
      updateSummary();
    }

    function setCopyProgram(productId, copyId, programHandle) {
      var copies = getProductCopies(productId);
      var copy = copies.find(function(item) {
        return item.copyId === copyId;
      });
      if (copy) copy.programHandle = programHandle;
      renderProducts();
      updateSummary();
    }

    /*
      Reuses the existing rule-card markup and styling (delivery mode, optional
      services) so campus/program checkboxes look native; "is-compact" only
      shrinks the card, since a school can have many campuses and programs.
    */
    function buildChoiceCard(kind, handle, label, note, checked) {
      return (
        '<label class="cohort-rule-card is-compact" data-kind="checkbox">' +
          '<input class="cohort-rule-input" type="checkbox" data-choice="' + kind + '" value="' + esc(handle) + '"' + (checked ? ' checked' : '') + '>' +
          '<span class="cohort-rule-content">' +
            '<span class="cohort-rule-marker" aria-hidden="true"></span>' +
            '<span class="cohort-rule-copy">' +
              '<strong>' + esc(label) + '</strong>' +
              (note ? '<span>' + esc(note) + '</span>' : '') +
            '</span>' +
          '</span>' +
        '</label>'
      );
    }

    function renderCampusChoices(school) {
      var list = document.getElementById('campus-choice-list');
      var help = document.getElementById('campus-help');
      if (!list) return;

      var options = getCampusesForSchool(school);

      if (!options.length) {
        list.innerHTML = '<div class="empty-state">No campuses are set up for this school. You can continue without choosing one — every item from this school will be available.</div>';
        selectedCampusHandles = [];
        if (help) help.textContent = 'No campuses found for this school.';
        return;
      }

      list.innerHTML = options.map(function(campus) {
        var checked = selectedCampusHandles.some(function(handle) {
          return normalizeCompare(handle) === normalizeCompare(campus.handle);
        });
        return buildChoiceCard('campus', campus.handle, getCampusLabel(campus), campus.city || '', checked);
      }).join('');

      if (help) {
        help.textContent = 'Select one or more campuses. Items update automatically.';
      }
    }

    function onCampusSelectionChange(handle, checked) {
      if (checked) {
        var alreadySelected = selectedCampusHandles.some(function(existing) {
          return normalizeCompare(existing) === normalizeCompare(handle);
        });
        if (!alreadySelected) selectedCampusHandles.push(handle);
      } else {
        selectedCampusHandles = selectedCampusHandles.filter(function(existing) {
          return normalizeCompare(existing) !== normalizeCompare(handle);
        });
      }

      renderShipToCampusOptions();
      productCopies = {};
      renderProducts();
      updateSummary();
    }

    function getProductCurrency(products) {
      var list = products || [];
      for (var i = 0; i < list.length; i += 1) {
        if (list[i] && list[i].currency_code) {
          return list[i].currency_code;
        }
      }
      return 'USD';
    }

    /*
      2026-10-16 (owner) - "Edit this cohort" on the status page links here
      with ?edit=CODE. Only cohorts this viewer may see are on the page at all,
      so a code that is not theirs finds nothing and the dashboard opens as
      usual. The parameter is taken off the address afterwards, so Back and a
      reload do not keep reopening the editor.
    */
    function openEditorFromUrl() {
      var code = String(getParam('edit') || '').trim().toUpperCase();
      if (!code) return;

      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('edit');
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      } catch (error) {
        /* an old browser keeps the parameter; harmless */
      }

      var cohort = findCohortByCode(code);
      if (!cohort) return;

      /*
        2026-10-17 (owner) - a finalized cohort with a late round still open
        opens on that round, as its own Edit Cohort button on the list does:
        the closed main list has nothing left to change. The newest round that
        is not finalized wins; with none, the main list opens as before.
      */
      if (isCohortFinalized(cohort)) {
        var openRound = parseLateBatchesForCohort(code).filter(function(batch) {
          return batch && batch.late_batch_code && batch.status !== 'finalized' && batch.status !== 'finalizing';
        }).sort(function(a, b) {
          return Number(b.late_batch_index || 0) - Number(a.late_batch_index || 0);
        })[0];

        if (openRound) {
          openCohortEmailEditor(code, {
            lateTrack: true,
            lateBatchCode: String(openRound.late_batch_code)
          });
          return;
        }
      }

      openCohortEmailEditor(code, {});
    }

    function findSchoolByUrl() {
      var raw = getParam('school');
      if (!raw) return null;

      var normalized = normalizeKey(raw);
      var compare = normalizeCompare(raw);

      return SCHOOLS.find(function(school) {
        return (
          normalizeKey(school.schoolCode) === normalized ||
          normalizeCompare(school.schoolName) === compare ||
          normalizeCompare(school.schoolHandle) === compare ||
          normalizeCompare(school.schoolCode) === compare
        );
      }) || null;
    }

    function detectSchoolFromCustomer() {
      if (!SCHOOLS.length) return null;

      var companyKey = normalizeCompare(CUSTOMER.companyName || '');
      var emailDomain = String(CUSTOMER.email || '').split('@')[1] || '';
      var emailDomainKey = normalizeCompare(emailDomain);

      var matches = SCHOOLS.filter(function(school) {
        var schoolNameKey = normalizeCompare(school.schoolName);
        var schoolCodeKey = normalizeCompare(school.schoolCode);
        var schoolHandleKey = normalizeCompare(school.schoolHandle);

        return (
          (companyKey && (schoolNameKey === companyKey || schoolCodeKey === companyKey || schoolHandleKey === companyKey || schoolNameKey.indexOf(companyKey) !== -1)) ||
          (emailDomainKey && schoolNameKey.indexOf(emailDomainKey) !== -1)
        );
      });

      if (matches.length === 1) return matches[0];
      if (SCHOOLS.length === 1) return SCHOOLS[0];

      return null;
    }

    function hydrateSchoolFromContext() {
      var school = findSchoolByUrl() || detectSchoolFromCustomer() || null;

      selectedSchoolCode = school ? normalizeKey(school.schoolCode) : '';

      document.getElementById('school_code_hidden').value = school ? school.schoolCode : '';
      document.getElementById('school_name_hidden').value = school ? school.schoolName : '';
      document.getElementById('personalization_fee_hidden').value = school ? String(toNumber(school.personalizationFeePerStudent).toFixed(2)) : '0.00';

      renderSchoolContextCard(school);
      renderPersonalizationNote(school);
      renderCampusChoices(school);
      renderShipToCampusOptions();
      refreshCohortCode(false);
      renderProducts();
      updateSummary();
    }

    function renderSchoolContextCard(school) {
      var nameEl = document.getElementById('school-context-name');
      if (!nameEl) return;

      nameEl.textContent = school ? (school.schoolName || 'School') : 'School not found';
    }

    function renderPersonalizationNote(school) {
      var note = document.getElementById('personalization-note');
      if (!note) return;

      if (!school) {
        note.textContent = 'School not found. Personalization fee cannot be loaded.';
        return;
      }

      var fee = toNumber(school.personalizationFeePerStudent);
      note.textContent = 'Default personalization fee for this school: ' + formatMoney(fee, getProductCurrency(school.products || []));
    }

    function refreshCohortCode(force) {
      var school = getSelectedSchool();
      var prefix = school ? normalizeKey(school.schoolCode) : 'SCH';

      if (!currentCohortCode || force) {
        currentCohortCode = prefix + '-' + randomCode(6);
      } else {
        var currentPrefix = String(currentCohortCode).split('-')[0] || '';
        if (currentPrefix !== prefix) {
          currentCohortCode = prefix + '-' + randomCode(6);
        }
      }

      currentCohortCode = normalizeKey(currentCohortCode);
      document.getElementById('cohort_code').value = currentCohortCode;
      document.getElementById('final-cohort-code-display').textContent = currentCohortCode;
    }

    function filterProducts(products) {
      var searchInput = document.getElementById('product-search-input');
      var query = String(searchInput ? searchInput.value : '').trim().toLowerCase();

      return (products || []).filter(function(product) {
        return String(product.title || '').toLowerCase().indexOf(query) !== -1;
      });
    }

    /*
      Stock, 2026-08-06.

      Deliberately the same test the student form uses to decide which sizes to
      offer (cohort-student-form.liquid, "availableVariants"): available and
      availableForSale, never inventory_quantity. Shopify sets those two false
      only when an item genuinely cannot be bought — an item set to keep selling
      past zero stays purchasable, and second-guessing that with a raw count
      would hide items the shop means to sell.

      The rule has to match on both sides or the pages disagree about the same
      product: the admin adds it, the student is told there is nothing to pick.
      That is exactly what was happening.
    */
    function countAvailableVariants(product) {
      var variants = Array.isArray(product && product.variants) ? product.variants : [];

      return variants.filter(function(variant) {
        return variant.available !== false && variant.availableForSale !== false;
      }).length;
    }

    function isProductOutOfStock(product) {
      var variants = Array.isArray(product && product.variants) ? product.variants : [];

      /* No variant list at all is not evidence of anything — do not block. */
      if (!variants.length) return false;

      return countAvailableVariants(product) === 0;
    }

    function getProductMinPrice(product) {
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var prices = variants.map(function(variant) {
        return toNumber(variant.price_amount);
      }).filter(function(price) {
        return price > 0;
      });

      if (prices.length) {
        return Math.min.apply(Math, prices);
      }

      return toNumber(product.price_amount);
    }

    /*
      Copies model (2026-08-02): one entry per COPY, not per product — a
      product duplicated into two copies (e.g. one Nursing, one Medical
      Assistant) produces two separate entries here, each quantity 1. This is
      what the review screen, products_json, pricing_json and ultimately the
      order line items are built from downstream; none of them assume one
      entry per product_id, so this is a safe shape (already the case before
      this change too, just with larger quantity numbers instead of more rows).
    */
    function getSelectedProducts() {
      var results = [];

      getSelectedSchoolProducts().forEach(function(product) {
        getProductCopies(product.product_id).forEach(function(copy) {
          var cloned = JSON.parse(JSON.stringify(product));
          cloned.quantity = 1;
          cloned.quantity_per_student = 1;
          cloned.line_total_per_student = getProductMinPrice(cloned);

          var assignedProgram = copy.programHandle ? findProgramByHandle(copy.programHandle) : null;
          cloned.program_handles = assignedProgram ? [assignedProgram.handle] : [];
          cloned.program_names = assignedProgram ? getProgramLabel(assignedProgram) : '';

          /*
            2026-08-11, phase 3 — the campus rides on the item, the way the
            program already does.

            No new field on the cohort: the metaobject has been at 40 of 40
            since 2026-08-02, when programs hit the same wall and were solved
            the same way. Everything downstream reads it from here — the tag on
            the student's order, and the split of the school invoice — just as
            finalize already derives the program list from these items.
          */
          var assignedCampus = copy.campusHandle ? findCampusByHandle(copy.campusHandle) : null;
          cloned.campus_handle = assignedCampus ? assignedCampus.handle : '';
          cloned.campus_name = assignedCampus ? getCampusLabel(assignedCampus) : '';

          results.push(cloned);
        });
      });

      return results;
    }

    /*
      The estimate above is built from list prices and deliberately excludes the
      per-item surcharge (2026-08-06): folding it in would create a second
      number to keep in step with the invoice forever. Saying plainly that the
      invoice will be higher cannot drift out of date.

      One rate across the cohort — the normal case — is named outright. Two
      different rates would make a single figure a lie, so that wording drops
      the number instead.
    */
    function renderSurchargeNotice(elementId, products, currencyCode) {
      var el = document.getElementById(elementId);
      if (!el) return;

      /*
        Owner decision, 2026-08-06 — the surcharge is not announced anywhere on
        screen any more. It still reaches the invoice exactly as before: the
        amount is snapshotted onto the item when the student submits and
        finalize bills it as a Processing Fee line. Only the sentence explaining it
        is gone, here and in surchargeNoticeHtml() on the status page.

        Left wired rather than deleted: the wording took several rounds to get
        right, and this is one line to undo if the notice is ever wanted back.

        2026-08-11 — wanted back, here and on the status page. Undone exactly
        as the note above anticipated: the three lines that blanked the
        element are gone and the wording below is untouched.
      */

      /*
        Named, not counted (owner, 2026-08-06). "Each of these items" left the
        admin looking at a list of several products with no way to tell which
        one the surcharge was about. Grouped by amount, because two products can
        carry different ones.
      */
      var byRate = {};
      (products || []).forEach(function(product) {
        var rate = toNumber(product && product.surcharge);
        if (rate <= 0) return;

        var key = String(rate);
        if (!byRate[key]) byRate[key] = [];

        var title = String((product && product.title) || '').trim();
        if (title && byRate[key].indexOf(title) === -1) byRate[key].push(title);
      });

      var rates = Object.keys(byRate);

      if (!rates.length) {
        el.hidden = true;
        el.setAttribute('aria-hidden', 'true');
        el.textContent = '';
        return;
      }

      var parts = rates.map(function(rate) {
        return 'A ' + formatMoney(Number(rate), currencyCode) + ' processing fee applies to: ' + byRate[rate].join(', ') + '.';
      });

      el.textContent = parts.join(' ') +
        ' It is not included in the estimate above and will be added to the school invoice.';

      el.hidden = false;
      el.setAttribute('aria-hidden', 'false');
    }

    /*
      2026-08-13 — one entry per PRODUCT, not per copy.

      getSelectedProducts returns the cohort's item copies, and a garment added
      twice — two campuses, or two of the same shirt — is two copies of one
      product. That is right for the invoice, where each copy is its own line,
      and wrong for these two lists: they answer "which products is this cohort
      about", a question with no repeats in it.

      Sent with repeats, Shopify refused the student discount outright with
      "Product with id: … is already entitled" and created no code at all — so
      the students' uniforms would not have been free at checkout. The two
      Mechanic tasks deduplicate as well, for the cohorts already carrying
      duplicates in their record; this stops new ones being written.
    */
    function dedupeStrings(values) {
      var seen = {};
      var unique = [];

      (values || []).forEach(function(value) {
        if (!value || seen[value]) return;
        seen[value] = true;
        unique.push(value);
      });

      return unique;
    }

    function getSelectedProductIds(products) {
      return dedupeStrings((products || []).map(function(product) {
        return String(product.product_id || product.id || '');
      }));
    }

    function getSelectedProductGids(products) {
      return dedupeStrings((products || []).map(function(product) {
        return String(product.product_gid || product.gid || ('gid://shopify/Product/' + (product.product_id || product.id || '')));
      }));
    }

    /*
      Step 3 shows all items together, no grouping by program (owner decision,
      2026-08-02 — reverses the 2026-07-31 grouped layout). Cards are still
      built per COPY, not per product: a product duplicated into several copies
      still renders one card per copy (each with its own badge/remove/program
      picker), they just sit next to each other in the same flat grid instead
      of under separate program headings. A product with zero copies still
      needs an entry point to add the first one — it renders as a single dim
      template card.
    */
    /*
      2026-08-11, phase 3 — cards are built for ONE campus section at a time, so
      a copy ticked under another campus must not appear here. Without the
      filter the same line would be drawn in every section and removing it from
      one would remove it from all.
    */
    function buildProductCards(products, campusHandle) {
      var cards = [];

      products.forEach(function(product) {
        var copies = campusHandle
          ? getProductCopiesForCampus(product.product_id, campusHandle)
          : getProductCopies(product.product_id);

        if (!copies.length) {
          cards.push({ product: product, copy: null, position: 0, total: 0, campusHandle: campusHandle || '' });
          return;
        }

        copies.forEach(function(copy, index) {
          cards.push({ product: product, copy: copy, position: index + 1, total: copies.length, campusHandle: campusHandle || '' });
        });
      });

      return cards;
    }

    function buildProductCardHtml(cardSpec) {
      var product = cardSpec.product;
      var copy = cardSpec.copy;
      var isTemplate = !copy;

      var imageHtml = product.image
        ? '<img src="' + esc(product.image) + '" alt="' + esc(product.title) + '" loading="lazy">'
        : '<span style="color:#111;font-weight:900;font-size:42px;">' + esc(String(product.title || '?').charAt(0)) + '</span>';

      /*
        Owner decision, 2026-08-02 (round 2): the template card (no copies yet)
        has NO "+" at all — the whole card is the click target that adds the
        first copy, same as the original click-to-select behaviour before the
        copies model existed. The "+" only shows up once a copy already exists,
        because that's the moment duplicating (a second program, a second
        unit) becomes a meaningful choice — and it now sits centered over the
        photo rather than in a corner. Badge and remove (×) both moved onto the
        image itself so all three overlays share one visual frame instead of
        two (card corners vs. image).
      */
      var badgeHtml = '';
      if (!isTemplate && cardSpec.total >= 2) {
        badgeHtml = '<div class="cohort-copy-badge">' + cardSpec.position + ' of ' + cardSpec.total + '</div>';
      }

      var removeHtml = '';
      if (!isTemplate) {
        removeHtml =
          '<button type="button" class="cohort-copy-remove" data-remove-copy="' + esc(product.product_id) + '" ' +
            'data-copy-id="' + copy.copyId + '" aria-label="Remove this copy" title="Remove this copy">' +
            '&times;' +
          '</button>';
      }

      var addHtml = '';
      if (!isTemplate) {
        addHtml =
          '<button type="button" class="cohort-copy-add" data-add-copy="' + esc(product.product_id) + '" ' +
            'data-campus="' + esc(cardSpec.campusHandle || '') + '" ' +
            'aria-label="Add another copy" title="Add another copy">' +
            '<span aria-hidden="true">+</span>' +
          '</button>';
      }

      /*
        Out of stock shows, but cannot be picked. Hiding it would leave the
        admin hunting for an item they can see in Shopify Admin; letting them
        pick it produced a cohort whose student form offered nothing to choose.
      */
      var outOfStock = isProductOutOfStock(product);
      if (outOfStock) {
        addHtml = '';
        badgeHtml = badgeHtml + '<div class="cohort-product-stock-badge">Out of stock</div>';
      }

      var availableCount = countAvailableVariants(product);
      var totalCount = (product.variants || []).length;
      var stockNote = '';
      if (!outOfStock && totalCount > 1 && availableCount < totalCount) {
        stockNote = ' · <span class="cohort-product-stock-note">' + (totalCount - availableCount) + ' of ' + totalCount + ' sizes out of stock</span>';
      }

      var matches = getProgramsForProductAtCampus(product, cardSpec.campusHandle || (copy && copy.campusHandle) || '');
      var programPickerHtml = '';

      /*
        2026-10-06 - one program is shown too, fixed (owner). With nothing on
        the card the admin could not tell which program a copy carried - the
        blue scrubs under Cleveland, left with STP alone. The only choice is
        also written onto the copy, so what the card says is what the cohort
        stores.
      */
      if (!isTemplate && matches.length === 1 &&
          normalizeCompare(copy.programHandle || '') !== normalizeCompare(matches[0].handle)) {
        copy.programHandle = matches[0].handle;
      }

      if (!isTemplate && matches.length >= 1) {
        var singleProgram = matches.length === 1;
        var optionsHtml = matches.map(function(program) {
          var isSelected = normalizeCompare(program.handle) === normalizeCompare(copy.programHandle);
          return '<option value="' + esc(program.handle) + '"' + (isSelected ? ' selected' : '') + '>' + esc(getProgramLabel(program)) + '</option>';
        }).join('');

        programPickerHtml =
          '<label class="cohort-product-program-picker" data-product-program-picker>' +
            '<span>Program</span>' +
            '<select data-copy-program-assign="' + esc(product.product_id) + '" data-copy-id="' + copy.copyId + '"' +
              (singleProgram ? ' disabled title="The only program this item has at this campus"' : '') + '>' + optionsHtml + '</select>' +
          '</label>';
      }

      return (
        '<div class="cohort-product-card ' + (isTemplate ? 'is-template' : 'is-selected') + (outOfStock ? ' is-out-of-stock' : '') + '" data-product-id="' + esc(product.product_id) + '"' + (outOfStock ? ' aria-disabled="true"' : '') + (copy ? ' data-copy-id="' + copy.copyId + '"' : '') + '>' +
          '<div class="cohort-product-image">' + imageHtml + badgeHtml + removeHtml + addHtml + '</div>' +
          '<p class="cohort-product-title">' + esc(product.title) + '</p>' +
          '<p class="cohort-product-meta">Variants: ' + esc((product.variants || []).length) + ' · From ' + esc(formatMoney(getProductMinPrice(product), product.currency_code || 'USD')) + stockNote + '</p>' +
          programPickerHtml +
        '</div>'
      );
    }

    /*
      Surfaces a rule that is otherwise invisible: productMatchesCampus() treats
      a product with no campuses metafield as school-wide, so it shows up in
      every cohort no matter which campus is picked. That is deliberate for
      shared items, but it looks exactly like forgetting to fill the field in —
      and nothing on screen distinguished the two. Counted against the school's
      whole catalogue, not the filtered view, so the number does not change as
      the admin types in the search box.
    */
    /*
      Builds the notice if the section markup has not been deployed yet. This
      theme is updated by copying files one at a time, and JS has already gone
      out ahead of the section once before (see the comment in renderProducts) —
      when that happens the notice must still work rather than silently do
      nothing, which is exactly how it went unnoticed on 2026-08-04.
    */
    function ensureNoCampusNotice() {
      var notice = document.getElementById('no-campus-notice');
      if (notice) return notice;

      var anchor = document.getElementById('products-list');
      if (!anchor || !anchor.parentNode) return null;

      notice = document.createElement('div');
      notice.className = 'notice-box';
      notice.id = 'no-campus-notice';
      notice.style.display = 'none';
      notice.innerHTML =
        '<div class="notice-icon">!</div>' +
        '<div class="notice-content">' +
          '<span class="notice-highlight" id="no-campus-notice-title"></span>' +
          '<span class="notice-text">These items count as school-wide, so they show up in every cohort for this school. ' +
          'If that is not what you want, assign a campus to them.</span>' +
        '</div>';

      anchor.parentNode.insertBefore(notice, anchor);
      return notice;
    }

    function updateNoCampusNotice() {
      var notice = ensureNoCampusNotice();
      if (!notice) return;

      /*
        Only worth saying once a campus is picked (owner decision, 2026-08-05).
        With no campus selected productMatchesCampus() shows every item anyway,
        so "these show up in every cohort" describes the whole list rather than
        singling anything out — it reads as a warning about a problem that does
        not exist yet.
      */
      if (!getSelectedCampusHandles().length) {
        notice.style.display = 'none';
        return;
      }

      var school = getSelectedSchool();
      var allProducts = (school && Array.isArray(school.products)) ? school.products : [];

      var missing = allProducts.filter(function(product) {
        var handles = Array.isArray(product.campusHandles) ? product.campusHandles : [];
        return handles.length === 0;
      }).length;

      if (!missing) {
        notice.style.display = 'none';
        return;
      }

      var title = document.getElementById('no-campus-notice-title');
      if (title) {
        title.textContent = missing === 1
          ? '1 item has no campus set'
          : missing + ' items have no campus set';
      }

      notice.style.display = '';
    }

    function renderCampusSectionsHtml(products) {
      var campuses = getStep3Campuses();

      if (!campuses.length) {
        return '<div class="empty-state cohort-campus-empty">No campus added yet. Add the first one below — its items appear here, and you can add another campus after that.</div>';
      }

      return campuses.map(function(campus) {
        var forCampus = products.filter(function(product) {
          if (!productBelongsToCampus(product, campus.handle)) return false;
          /* A product whose every program is taken here by an exclusive one
             has nothing left to offer this campus. */
          var ownPrograms = getProgramsForProduct(product);
          if (ownPrograms.length && !getProgramsForProductAtCampus(product, campus.handle).length) return false;
          return true;
        });

        var body = forCampus.length
          ? '<div class="cohort-product-grid">' +
              buildProductCards(forCampus, campus.handle).map(buildProductCardHtml).join('') +
            '</div>'
          : '<div class="empty-state" style="grid-column:1/-1;">No items are assigned to this campus, and this school has no shared items either.</div>';

        return '' +
          '<section class="cohort-campus-section" data-campus-section="' + esc(campus.handle) + '">' +
            '<header class="cohort-campus-section-head">' +
              '<h4 class="cohort-campus-section-title">' + esc(getCampusLabel(campus)) + '</h4>' +
              '<button type="button" class="cohort-campus-remove" data-remove-campus="' + esc(campus.handle) + '">Remove campus</button>' +
            '</header>' +
            body +
          '</section>';
      }).join('');
    }

    function renderAddCampusHtml() {
      var school = getSelectedSchool();
      var remaining = getCampusesForSchool(school).filter(function(campus) {
        return !step3CampusHandles.some(function(handle) {
          return normalizeCompare(handle) === normalizeCompare(campus.handle);
        });
      });

      if (!remaining.length) {
        return getStep3Campuses().length
          ? '<p class="cohort-help cohort-add-campus-done">Every campus of this school has been added.</p>'
          : '<p class="cohort-help cohort-add-campus-done">No campuses are set up for this school.</p>';
      }

      /*
        ── What a second campus means, said before the second campus ────────

        2026-09-17, owner. The first campus needs no explanation: it is the one
        the cohort is for. The second changes what the students see - they are
        asked which campus they belong to before they are asked their sizes -
        and it changes what the school receives at the end, which is one
        invoice per campus rather than one invoice.

        So the sentence appears once there is something to explain, and the
        whole of it lives in the tip beside the heading for anyone who wants
        the rest.
      */
      var hasCampusAlready = getStep3Campuses().length > 0;

      var campusTip =
        '<span class="cf-info-tip">' +
          '<button type="button" class="cf-info-tip-trigger" aria-label="More information about campuses in a cohort">' +
            '<svg class="cf-info-tip-icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
              '<circle cx="8" cy="4.7" r="1.15" fill="currentColor"></circle>' +
              '<path d="M8 7.2v4.2" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"></path>' +
            '</svg>' +
          '</button>' +
          '<span class="cf-info-tip-bubble" role="tooltip">' +
            'One cohort can cover several campuses. A student opening the size form is asked which campus they belong to first, and only then for their sizes, so the cohort stays a single list while the orders inside it stay separated by campus. ' +
            'When you finalize, each campus is invoiced on its own: a campus pays for its own students and for nobody else’s. ' +
            'And if Step 2 ships to the campuses, every order is delivered to the campus its student chose.' +
          '</span>' +
        '</span>';

      return '' +
        '<div class="cohort-add-campus">' +
          '<span class="cohort-add-campus-label">' +
            (hasCampusAlready ? 'Add another campus' : 'Add a campus') + campusTip +
          '</span>' +
          (hasCampusAlready
            ? '<p class="cohort-add-campus-lead">Add the next campus this cohort covers. Students choose their campus on the size form before they choose sizes, and each campus is invoiced separately when you finalize.</p>'
            : '') +
          '<div class="select-wrapper">' +
            '<select class="cohort-input cohort-select" id="add-campus-select" aria-label="Campus to add">' +
              remaining.map(function(campus) {
                return '<option value="' + esc(campus.handle) + '">' + esc(getCampusLabel(campus)) + '</option>';
              }).join('') +
            '</select>' +
          '</div>' +
          /*
            The word "this" is doing work here. "Add campus" read as a way to
            create one, and sitting beside the dropdown it looked like a second
            control rather than the end of the one above it. Under the list,
            naming what it adds, it reads as the step it is.
          */
          '<button type="button" class="export-button admin-btn-black" id="add-campus-button">Add this campus</button>' +
        '</div>';
    }

    function bindAddCampusHandlers(container) {
      var addButton = container.querySelector('#add-campus-button');

      if (addButton) {
        addButton.addEventListener('click', function() {
          var select = container.querySelector('#add-campus-select');
          var handle = select ? String(select.value || '').trim() : '';
          if (!handle) return;

          step3CampusHandles.push(handle);
          syncStep1CampusSelection();
          renderProducts();
          updateSummary();
        });
      }

      container.querySelectorAll('[data-remove-campus]').forEach(function(button) {
        button.addEventListener('click', function() {
          var handle = String(button.getAttribute('data-remove-campus') || '').trim();
          if (!handle) return;

          var campus = findCampusByHandle(handle);
          var label = campus ? getCampusLabel(campus) : handle;

          /* Confirmed because it throws away work: every item ticked under this
             campus goes with it (owner's rule, 2026-08-10). */
          if (!window.confirm('Remove ' + label + '? The items you chose for this campus will be removed too.')) return;

          step3CampusHandles = step3CampusHandles.filter(function(item) {
            return normalizeCompare(item) !== normalizeCompare(handle);
          });

          Object.keys(productCopies).forEach(function(productId) {
            productCopies[productId] = productCopies[productId].filter(function(copy) {
              return normalizeCompare(copy.campusHandle || '') !== normalizeCompare(handle);
            });
            if (!productCopies[productId].length) delete productCopies[productId];
          });

          syncStep1CampusSelection();
          renderProducts();
          updateSummary();
        });
      });
    }

    /*
      The Step 1 chooser is hidden but still the place the payload builder and
      the Ship-to list read campuses from. Writing Step 3's choice back into it
      keeps cohort.campus and cohort.campuses_snapshot filled exactly as before,
      so nothing downstream has to learn about this change.
    */
    function syncStep1CampusSelection() {
      selectedCampusHandles = step3CampusHandles.slice();
      renderShipToCampusOptions();
    }

    function renderProducts() {
      var container = document.getElementById('products-list');
      var school = getSelectedSchool();

      updateNoCampusNotice();

      /*
        Always render our own ".cohort-product-grid" wrapper instead of relying
        on #products-list already carrying that class (2026-08-02). This theme
        is deployed by copying files manually, one at a time — if the section
        markup and this script ever get deployed a step apart (exactly what
        happened here: JS/CSS went out before the section update), cards must
        still lay out correctly rather than collapsing into stacked full-width
        blocks with no grid at all.
      */
      if (!school) {
        container.innerHTML = '<div class="cohort-product-grid"><div class="empty-state" style="grid-column:1/-1;">School was not found from the page link.</div></div>';
        return;
      }

      var products = filterProducts(getSelectedSchoolProducts());

      if (!products.length) {
        container.innerHTML = '<div class="cohort-product-grid"><div class="empty-state" style="grid-column:1/-1;">No items found for this school.</div></div>';
        return;
      }

      /*
        2026-08-11, phase 3 — one section per campus, added one at a time.

        The admin picks a campus, sees its items, ticks what that campus needs,
        then adds the next. A campus already added is gone from the picker, so
        the same one cannot be opened twice.

        School-wide items — those with no campus metafield — appear in every
        section (owner, 2026-08-11). Ticking one under two campuses makes two
        positions, the same as any item chosen twice, because the two will end
        up on two different invoices.
      */
      container.innerHTML = renderCampusSectionsHtml(products) + renderAddCampusHtml();
      bindAddCampusHandlers(container);

      /*
        ── "Click an item to select it" waits for something to click ────────

        2026-09-18, owner. Until a campus is added this step has no items on
        it, so the instruction stood over an empty page telling the admin to do
        something they could not yet do - and the thing they could do, add a
        campus, was further down with nothing pointing at it.

        A school with no campuses at all never adds one, and its items are
        there from the start, so for them the line appears immediately. The
        test is the school's campuses, not this cohort's.
      */
      var chooseNotice = document.getElementById('choose-items-notice');

      if (chooseNotice) {
        var schoolHasCampuses = getCampusesForSchool(getSelectedSchool()).length > 0;
        var cohortHasCampus = getStep3Campuses().length > 0;

        chooseNotice.style.display = (!schoolHasCampuses || cohortHasCampus) ? '' : 'none';
      }

      container.querySelectorAll('[data-add-copy]').forEach(function(button) {
        button.addEventListener('click', function(event) {
          event.stopPropagation();
          var productId = button.getAttribute('data-add-copy');
          /* The copy belongs to the section it was added from — that is what
             makes the same item under two campuses two separate lines. */
          var campusHandle = button.getAttribute('data-campus') || '';
          var product = getSelectedSchoolProducts().find(function(item) {
            return String(item.product_id) === productId;
          });
          if (product) addProductCopy(product, campusHandle);
        });
      });

      container.querySelectorAll('[data-remove-copy]').forEach(function(button) {
        button.addEventListener('click', function(event) {
          event.stopPropagation();
          var productId = button.getAttribute('data-remove-copy');
          var copyId = parseInt(button.getAttribute('data-copy-id'), 10);
          removeProductCopy(productId, copyId);
        });
      });

      /*
        The picker sits inside the card, so its own click (opening the native
        <select>) must not also trigger anything on the card — matters again
        now that copy cards with a picker could in theory sit next to a
        template card's whole-card click handler below.
      */
      container.querySelectorAll('[data-copy-program-assign]').forEach(function(select) {
        select.addEventListener('click', function(event) {
          event.stopPropagation();
        });
        select.addEventListener('change', function(event) {
          event.stopPropagation();
          var productId = select.getAttribute('data-copy-program-assign');
          var copyId = parseInt(select.getAttribute('data-copy-id'), 10);
          setCopyProgram(productId, copyId, select.value);
        });
      });

      /*
        Template card (no copies yet, owner decision 2026-08-02) has no "+" —
        the whole card is the click target for adding the first copy, same as
        the original pre-copies click-to-select. It has no nested interactive
        elements (no ×, no +, no picker — those only exist once a copy
        exists), so a plain click handler needs no closest()/target guard.
      */
      container.querySelectorAll('.cohort-product-card.is-template').forEach(function(card) {
        card.addEventListener('click', function() {
          var productId = card.getAttribute('data-product-id');
          /* Same rule as the "+" — the first copy belongs to the campus section
             the card was clicked in. Read from the section rather than the card
             so a template card needs no attribute of its own. */
          var section = card.closest('[data-campus-section]');
          var campusHandle = section ? String(section.getAttribute('data-campus-section') || '') : '';
          var product = getSelectedSchoolProducts().find(function(item) {
            return String(item.product_id) === productId;
          });
          if (product) addProductCopy(product, campusHandle);
        });
      });
    }

    function extractEmails(text) {
      var matches = String(text || '').match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/ig) || [];
      var unique = [];
      var seen = {};

      matches.forEach(function(email) {
        var value = String(email || '').trim().toLowerCase();
        if (!value || seen[value]) return;
        seen[value] = true;
        unique.push(value);
      });

      return unique;
    }

    function updateEmailPreview() {
      parsedEmails = extractEmails(document.getElementById('student-email-textarea').value || '');
      document.getElementById('unique-emails-count').textContent = String(parsedEmails.length);
      enforceDemoRosterCap(parsedEmails.length);
      updateSummary();
    }

    /*
      ── The demo's ceiling, said while the list is being typed ─────────────

      Owner, 2026-09-15. The cap was enforced when the form was submitted,
      which is the wrong moment: by then a person has pasted a class of thirty
      and has to work out which ten to keep, with the paste already gone from
      the clipboard.

      So the plaque under the box changes the moment the list goes over, and
      the counter beside it turns red. No popup: a dialog is dismissed and then
      the screen looks exactly as it did before, while this stays visible for
      as long as the problem does.

      The submit-time check stays where it is. This is the kinder half of the
      same rule, not a replacement - and the one in the task behind it is the
      half that actually holds.
    */
    /*
      Five demo cohorts per address, counted from the cohorts on the page.

      Counting rather than keeping a tally: the cleanup deletes demo cohorts
      after a week, so a tally would drift, and counting means an old demo
      frees its slot by itself.

      Returns the sentence to show, or an empty string when there is room.
    */
    /*
      ── The showcase cohorts ───────────────────────────────────────────────

      2026-09-15, owner. The demo now has two kinds of cohort in it. The four
      showcase ones are the exhibit - built by hand, seeded, finalized, meant
      to look like a school mid-order and to stay that way. Everything else is
      somebody trying the system, and they may do as they like with their own.

      So the rule is about the cohort, not about the page: a showcase cohort
      opens read-only for everyone, including the account that made it.

      This is the polite half. The firm half is in the Mechanic tasks, which
      carry the same four codes and refuse outright - a webhook address is
      printed in this page and carries no signature, so a button that merely
      declines to fire protects nothing from anyone who reads the source.
    */
    function showcaseCohortCodes() {
      return String(CONFIG.showcaseCohortCodes || '')
        .split(',')
        .map(function(code) { return normalizeKey(code); })
        .filter(function(code) { return !!code; });
    }

    /*
      ── 2026-10-16 (owner, demo stage 5): the showcase window ─────────────

      One window for every limit of a showcase cohort, in the owner's words.
      The menu works there; what would write is answered here instead. The
      tasks refuse showcase codes on their own as well - this is what the
      visitor sees, not the protection.
    */
    var showcaseModalShownFor = '';

    function showcaseRefuses(cohortCode) {
      if (!isShowcaseCohort(cohortCode || editingCohortCode)) return false;
      openShowcaseModal();
      return true;
    }

    function openShowcaseModal() {
      var overlay = document.getElementById('cohort-showcase-modal');
      if (!overlay) return;

      var create = document.getElementById('cohort-showcase-modal-create');
      if (create) create.textContent = CUSTOMER.email ? 'Create my cohort' : 'Sign in and create my cohort';

      if (!overlay.dataset.bound) {
        overlay.dataset.bound = '1';
        overlay.addEventListener('click', function(event) {
          if (event.target === overlay || event.target.id === 'cohort-showcase-modal-close') closeShowcaseModal();
          if (event.target.id === 'cohort-showcase-modal-create') {
            closeShowcaseModal();
            if (!CUSTOMER.email) {
              goToSignInToCreate();
              return;
            }
            discardRosterDraft();
            setManagePanelsVisible('create');
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        });
        onDocumentOnce('showcase-escape', 'keydown', function(event) {
          if (event.key === 'Escape') closeShowcaseModal();
        });
      }

      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      var close = document.getElementById('cohort-showcase-modal-close');
      if (close) close.focus();
    }

    function closeShowcaseModal() {
      var overlay = document.getElementById('cohort-showcase-modal');
      if (!overlay) return;
      overlay.classList.remove('is-open', 'show');
      overlay.setAttribute('aria-hidden', 'true');
    }

    function isShowcaseCohort(cohortCode) {
      var code = normalizeKey(cohortCode);
      if (!code) return false;

      return showcaseCohortCodes().indexOf(code) !== -1;
    }

    function demoCohortLimitMessage() {
      if (!CONFIG.demoMode) return '';

      var limit = Number(CONFIG.demoMaxCohortsPerAdmin) || 5;
      var mine = String((CUSTOMER && CUSTOMER.email) || '').trim().toLowerCase();
      if (!mine) return '';

      var owned = MY_COHORTS.filter(function(cohort) {
        return String(cohort.adminEmail || '').trim().toLowerCase() === mine;
      }).length;

      if (owned < limit) return '';

      return 'You already have ' + owned + ' demo cohorts, which is the most one address can try at once. ' +
        'Delete one, or wait - demo cohorts are removed a week after they are made.';
    }

    function enforceDemoRosterCap(count) {
      if (!CONFIG.demoMode) return;

      var cap = Number(CONFIG.demoMaxStudents) || 5;
      var note = document.getElementById('cohort-demo-create-cap');
      var counter = document.getElementById('unique-emails-count');
      var over = count > cap;

      if (note) {
        note.textContent = over
          ? 'That is ' + count + ' addresses, and a demo cohort holds ' + cap + '. Remove ' + (count - cap) +
            ' and the cohort can be created. The live system has no limit.'
          : 'A demo cohort holds up to ' + cap + ' students. Put your own address in and you will get the invitation exactly as a student would. The live system has no limit.';
        note.classList.toggle('is-over', over);
      }

      if (counter && counter.parentNode) {
        counter.parentNode.classList.toggle('is-over-demo-cap', over);
      }
    }

    function buildPricingPreview() {
      var selectedProducts = getSelectedProducts();
      var uniqueEmailsCount = parsedEmails.length;
      var personalized = document.getElementById('personalize-order-checkbox').checked;
      var school = getSelectedSchool();
      var personalizationFee = school ? toNumber(school.personalizationFeePerStudent) : 0;
      var currencyCode = getProductCurrency(selectedProducts.length ? selectedProducts : getSelectedSchoolProducts());
      var perStudentProductsTotal = 0;

      var lineItems = selectedProducts.map(function(product, index) {
        var unitPrice = getProductMinPrice(product);
        var qty = parseInt(product.quantity_per_student, 10) || 0;
        var lineTotalPerStudent = unitPrice * qty;

        perStudentProductsTotal += lineTotalPerStudent;

        return {
          title: product.title || ('Item ' + (index + 1)),
          program_names: product.program_names || '',
          /* 2026-08-11 — the same item can appear under two campuses, so the
             review has to say which line is which; without it two identical
             rows look like a mistake. */
          campus_name: product.campus_name || '',
          quantity_per_student: qty,
          unit_price: unitPrice,
          line_total_per_student: lineTotalPerStudent,
          all_students_total: lineTotalPerStudent * uniqueEmailsCount,
          submitted_students_total: 0
        };
      });

      var productsTotal = perStudentProductsTotal * uniqueEmailsCount;
      var personalizationTotal = personalized ? personalizationFee * uniqueEmailsCount : 0;

      /*
        2026-08-16 — what a student actually costs, per campus.

        perStudentProductsTotal above adds up every item in the cohort. With
        one campus that is the answer; with two it is the price of a student
        who somehow attends both. A cohort of navy scrubs at one campus and
        white at another announced the price of all four garments.

        No single number can be right here: a student picks their campus when
        they fill the form, so how many go where is unknown while this screen
        is open. What IS known is the cheapest and the dearest campus, and the
        truth lies between them — so that is what gets shown.

        The old totals are left exactly as they were. They still go into the
        cohort record, and changing what is stored is a different decision
        from changing what is displayed.
      */
      var byCampus = {};
      var campusOrder = [];

      lineItems.forEach(function(item) {
        var campus = String(item.campus_name || '').trim();

        if (!Object.prototype.hasOwnProperty.call(byCampus, campus)) {
          byCampus[campus] = 0;
          campusOrder.push(campus);
        }

        byCampus[campus] += item.line_total_per_student;
      });

      var perStudentByCampus = campusOrder.map(function(campus) {
        return { campus: campus, perStudent: byCampus[campus] };
      });

      var perStudentLow = null;
      var perStudentHigh = null;

      perStudentByCampus.forEach(function(entry) {
        if (perStudentLow === null || entry.perStudent < perStudentLow) perStudentLow = entry.perStudent;
        if (perStudentHigh === null || entry.perStudent > perStudentHigh) perStudentHigh = entry.perStudent;
      });

      if (perStudentLow === null) perStudentLow = 0;
      if (perStudentHigh === null) perStudentHigh = 0;

      /*
        One campus, or several that happen to cost the same, is not a range —
        it is a number, and it should read like one.
      */
      var perStudentIsRange = perStudentHigh > perStudentLow;

      return {
        currencyCode: currencyCode || 'USD',
        perStudentProductsTotal: perStudentProductsTotal,
        productsTotal: productsTotal,
        personalizationFee: personalizationFee,
        personalizationTotal: personalizationTotal,
        grandTotal: productsTotal + personalizationTotal,
        lineItems: lineItems,
        perStudentByCampus: perStudentByCampus,
        perStudentLow: perStudentLow,
        perStudentHigh: perStudentHigh,
        perStudentIsRange: perStudentIsRange,
        studentsCount: uniqueEmailsCount
      };
    }

    function buildPricingJson(preview) {
      return {
        pricing_source: 'Admin form preview',
        currency_code: preview.currencyCode || 'USD',
        line_items: preview.lineItems || [],
        all_students: {
          products_total: preview.productsTotal || 0,
          personalization_total: preview.personalizationTotal || 0,
          grand_total: preview.grandTotal || 0
        },
        submitted_students: {
          products_total: 0,
          personalization_total: 0,
          grand_total: 0
        },
        note: 'Estimated preview based on the selected school items and unique email list.'
      };
    }

    function createSummaryItem(label, value, options) {
      if (typeof options === 'boolean') {
        options = { compact: options };
      }

      options = options || {};

      var valueStr = value == null ? '' : String(value);
      var type = options.type;

      if (!type) {
        if (options.compact) {
          type = 'text-compact';
        } else if (valueStr === 'Yes' || valueStr === 'No') {
          type = 'bool';
        } else if (/^\d+$/.test(valueStr)) {
          type = 'metric';
        } else if (/^\$/.test(valueStr)) {
          type = 'money';
        } else {
          type = 'text';
        }
      }

      var chipClass = 'cohort-summary-chip' + (type === 'text-compact' ? ' is-compact' : '');
      var html = '<div class="' + chipClass + '"><span class="label">' + esc(label) + '</span>';

      if (type === 'bool') {
        html += '<span class="chip-value ' + (valueStr === 'Yes' ? 'is-yes' : 'is-no') + '">' + esc(valueStr) + '</span>';
      } else if (type === 'metric') {
        html += '<span class="chip-value is-metric">' + esc(valueStr) + '</span>';
      } else if (type === 'money') {
        html += '<span class="chip-value is-money' + (options.highlight ? ' is-total' : '') + '">' + esc(valueStr) + '</span>';
      } else if (type === 'text-compact') {
        html += '<span class="chip-value is-compact">' + esc(valueStr) + '</span>';
      } else {
        html += '<span class="chip-value">' + esc(valueStr) + '</span>';
      }

      /*
        2026-08-16 — a line of small print under the value, for a number that
        needs a word of explanation ("depending on campus"). Passed as an
        option rather than baked into the value, because every branch above
        escapes what it is given — markup handed in as a value would be
        printed rather than rendered.
      */
      if (options.hint) {
        html += '<span class="cohort-summary-hint">' + esc(options.hint) + '</span>';
      }

      html += '</div>';
      return html;
    }

    function updateSummary() {
      if (currentStep !== 5) return;

      refreshCohortCode(false);

      var school = getSelectedSchool();
      var form = document.getElementById('cohort-form');
      var selectedProducts = getSelectedProducts();
      var pricing = buildPricingPreview();
      var campusesLabel = getSelectedCampuses().map(getCampusLabel).join(', ');
      var shipToCampus = getShipToCampus();

      document.getElementById('final-summary-admin').innerHTML =
        createSummaryItem('Cohort Name', String(form.cohort_label.value || '').trim() || '—', true) +
        createSummaryItem('School', school ? school.schoolName : '-', true) +
        createSummaryItem(getSelectedCampuses().length > 1 ? 'Campuses' : 'Campus', campusesLabel || '-', true) +
        (getSelectedDeliveryMode() === 'school_delivery'
          ? createSummaryItem('Ships to', shipToCampus ? getCampusLabel(shipToCampus) : 'Different address', true)
          : '') +
        createSummaryItem('Admin Name', form.admin_name.value || '-', true) +
        createSummaryItem('Admin Email', form.admin_email.value || '-', true) +
        createSummaryItem('School Invoice Email', school && school.invoiceEmail ? school.invoiceEmail : '-', true);

      document.getElementById('final-summary-rules').innerHTML =
        createSummaryItem('Cohort Code', currentCohortCode || '-', true) +
        createSummaryItem('Deadline', form.deadline.value || '-', true) +
        createSummaryItem('Delivery Mode', getDeliveryModeSummaryLabel(getSelectedDeliveryMode()), true) +
        createSummaryItem('Email Students', form.send_student_emails.checked ? 'Yes' : 'No') +
        createSummaryItem('Personalized Packing', form.personalize_order.checked ? 'Yes' : 'No');

      /*
        "Units per Student" was removed 2026-08-16 (owner). It added up the
        quantity of every item in the cohort, across all campuses — so a cohort
        with two garments at one campus and two at another announced four units
        per student, when no student receives more than two.

        There is no honest number to put here while a cohort spans campuses: a
        student's items are decided when they pick their campus on the form,
        which has not happened yet. The full list of what was chosen is at the
        bottom of this same screen, grouped by campus, and that is the answer
        the question actually has.
      */
      document.getElementById('final-summary-students-items').innerHTML =
        createSummaryItem('Students', parsedEmails.length);

      /*
        2026-08-16 — the four money lines, told honestly for a cohort that
        spans campuses. See buildPricingPreview for why a single number cannot
        be right: the split of students between campuses is decided later, on
        the student's own form.

        A one-campus cohort — which is most of them — reads exactly as before.
      */
      var moneyRange = function(low, high) {
        if (!pricing.perStudentIsRange) return formatMoney(low, pricing.currencyCode);
        return formatMoney(low, pricing.currencyCode) + ' – ' + formatMoney(high, pricing.currencyCode);
      };

      var studentsCount = pricing.studentsCount || 0;
      var productsLow = pricing.perStudentLow * studentsCount;
      var productsHigh = pricing.perStudentHigh * studentsCount;

      document.getElementById('final-summary-pricing').innerHTML =
        createSummaryItem(
          'Products per Student',
          moneyRange(pricing.perStudentLow, pricing.perStudentHigh),
          { type: 'money', hint: pricing.perStudentIsRange ? 'depending on campus' : '' }
        ) +
        createSummaryItem('Products Total', moneyRange(productsLow, productsHigh), { type: 'money' }) +
        createSummaryItem('Personalization Total', formatMoney(pricing.personalizationTotal, pricing.currencyCode), { type: 'money' }) +
        createSummaryItem(
          'Estimated Total',
          moneyRange(productsLow + pricing.personalizationTotal, productsHigh + pricing.personalizationTotal),
          { type: 'money', highlight: true }
        );

      renderSurchargeNotice('cohort-create-surcharge-note', getSelectedProducts(), pricing.currencyCode);

      var pricingLines = document.getElementById('final-pricing-lines');

      if (!pricing.lineItems.length) {
        pricingLines.innerHTML = '<div class="empty-state">No items selected.</div>';
        return;
      }

      /*
        2026-08-11 — grouped under a campus heading rather than repeating the
        campus on every line. Flat, the list read as the same garment over and
        over with a word changing in the middle; grouped, it reads as what it is
        — what each campus is ordering, which is also how the invoices will
        come out.
      */
      pricingLines.innerHTML = groupLineItemsByCampus(pricing.lineItems).map(function(group) {
        var rows = group.items.map(function(item) {
          return (
            '<div class="cohort-pricing-line">' +
              '<strong>' + esc(item.title) + '</strong>' +
              (item.program_names ? '<span class="cohort-pricing-line-program">' + esc(item.program_names) + '</span>' : '') +
              '<span>Qty/student: ' + esc(item.quantity_per_student) + ' · Unit: ' + esc(formatMoney(item.unit_price, pricing.currencyCode)) + '</span>' +
              '<span>All students: ' + esc(formatMoney(item.all_students_total, pricing.currencyCode)) + '</span>' +
            '</div>'
          );
        }).join('');

        /*
          2026-08-16 — the campus heading carries what a student there costs.

          The block above can only give a range, because nobody knows yet how
          the students will divide between campuses. Down here the question has
          an exact answer for each campus, and this is where an admin looks for
          it — so it is answered where it is asked, with no new block and no
          layout to rebuild.
        */
        var campusPerStudent = null;

        (pricing.perStudentByCampus || []).forEach(function(entry) {
          if (entry.campus === group.campus) campusPerStudent = entry.perStudent;
        });

        var campusPriceHtml = campusPerStudent === null
          ? ''
          : '<span class="cohort-pricing-campus-per-student">' +
              esc(formatMoney(campusPerStudent, pricing.currencyCode)) + ' per student</span>';

        return group.campus
          ? '<div class="cohort-pricing-campus-group">' +
              '<p class="cohort-pricing-campus-title">' + esc(group.campus) + campusPriceHtml + '</p>' +
              rows +
            '</div>'
          : rows;
      }).join('');
    }

    /*
      Line items in the order they were chosen, gathered under their campus.
      Insertion order is kept rather than sorted: it is the order the admin
      built the cohort in, and reordering it here would make the review look
      unlike the screen it is reviewing.

      Items with no campus — every cohort created before campuses moved to Step
      3 — come back as one unnamed group, which renders exactly as the flat list
      always did.
    */
    function groupLineItemsByCampus(lineItems) {
      var order = [];
      var byCampus = {};

      (lineItems || []).forEach(function(item) {
        var campus = String(item.campus_name || '').trim();

        if (!byCampus[campus]) {
          byCampus[campus] = { campus: campus, items: [] };
          order.push(campus);
        }

        byCampus[campus].items.push(item);
      });

      return order.map(function(campus) {
        return byCampus[campus];
      });
    }

    function isPastDate(value) {
      if (!value) return false;

      var now = new Date();
      var todayLocal = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var parts = String(value).split('-');

      if (parts.length !== 3) return false;

      var selected = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
      return selected.getTime() < todayLocal.getTime();
    }

    function validateStep(step) {
      var form = document.getElementById('cohort-form');
      var school = getSelectedSchool();

      setMessage('');

      if (step === 1) {
        if (!school) {
          setMessage('School was not found. Open this page with a school code in the URL, for example ?school=mcc');
          return false;
        }

        if (!form.admin_name.value.trim() || !form.admin_email.value.trim()) {
          setMessage('Please enter admin name and admin email.');
          return false;
        }

        if (!form.admin_email.checkValidity()) {
          setMessage('Please enter a valid admin email.');
          return false;
        }

        syncAdminEmailAccountNotice();

        /*
          Campus is optional (owner decision, 2026-08-03). Leaving it empty is a
          supported setup, not a mistake: Step 3 then offers every product the
          school has (productMatchesCampus returns true for all when nothing is
          selected), and Step 2's Ship-to list falls back to "Different address"
          so the delivery address is typed by hand — still with the same required
          fields. Nothing downstream needs a campus either: cohort-create-cohort
          .liquid only requires school_name/admin_email/cohort_code, writes the
          campus field solely when a valid GID arrives, and skips
          campuses_snapshot entirely for an empty list.
        */
      }

      if (step === 2) {
        if (!form.deadline.value) {
          setMessage('Please choose a deadline.');
          return false;
        }

        if (isPastDate(form.deadline.value)) {
          setMessage('The deadline cannot be in the past.');
          return false;
        }

        /*
          2026-08-11 — Delivery name is asked for whenever the order ships to a
          school, campus or not: it names the person the box is handed to, and
          skipping it was reported as a field marked required that nothing
          enforced.
        */
        if (getSelectedDeliveryMode() === 'school_delivery') {
          var deliveryName = document.getElementById('school_delivery_name');

          if (!deliveryName || !deliveryName.value.trim()) {
            setMessage('Please enter the delivery name / attention for this order.');
            return false;
          }
        }

        /*
          2026-08-11, phase 2 — no single address to demand when each order goes
          to the campus it was chosen under. Those addresses come from the
          campus records, and there may be several.

          Keyed on whether the fields are actually on screen rather than on the
          choice behind them: never demand what is not being shown. That rule
          cannot come apart from the interface the way the previous three
          attempts did.
        */
        var addressWrap = document.getElementById('school-delivery-address-fields');
        var addressAsked = !!addressWrap && !addressWrap.hidden;

        if (getSelectedDeliveryMode() === 'school_delivery' && addressAsked) {
          var addrName = document.getElementById('school_delivery_name');
          var addr1 = document.getElementById('school_delivery_address1');
          var addrCity = document.getElementById('school_delivery_city');
          var addrProvince = document.getElementById('school_delivery_province');
          var addrPostal = document.getElementById('school_delivery_postal_code');
          var addrCountry = document.getElementById('school_delivery_country_code');

          if (
            !addrName || !addrName.value.trim() ||
            !addr1 || !addr1.value.trim() ||
            !addrCity || !addrCity.value.trim() ||
            !addrProvince || !addrProvince.value.trim() ||
            !addrPostal || !addrPostal.value.trim() ||
            !addrCountry || !addrCountry.value.trim()
          ) {
            setMessage('Please enter a complete school delivery address (delivery name, address line 1, city, province/state, postal code, country code).');
            return false;
          }
        }
      }

      if (step === 3) {
        /*
          2026-08-11, phase 3 — the owner's two rules, checked in the order the
          admin meets them: a cohort needs a campus, and a campus that is on
          screen with nothing ticked under it is unfinished work rather than a
          deliberate empty section.
        */
        var step3Campuses = getStep3Campuses();

        if (!step3Campuses.length) {
          setMessage('Add at least one campus and choose the items for it.');
          return false;
        }

        var emptyCampus = step3Campuses.filter(function(campus) {
          return !Object.keys(productCopies).some(function(productId) {
            return getProductCopiesForCampus(productId, campus.handle).length > 0;
          });
        })[0];

        if (emptyCampus) {
          setMessage('Choose at least one item for ' + getCampusLabel(emptyCampus) + ', or remove that campus.');
          return false;
        }

        if (!getSelectedProducts().length) {
          setMessage('Please select at least one item.');
          return false;
        }
      }

      if (step === 4) {
        if (!parsedEmails.length) {
          setMessage('Please add at least one valid student email.');
          return false;
        }

        /*
          2026-09-15, owner: over the demo's ceiling, this step does not pass.

          The plaque under the box said so already and the step let the person
          through anyway - so the refusal arrived at the end, on Create, after
          two more screens of work. A warning that does not stop anything
          teaches people to walk past warnings.

          The same number is checked again on Create and once more in the task
          behind it. This is the earliest of the three, which is the one worth
          having.
        */
        if (CONFIG.demoMode) {
          var stepCap = Number(CONFIG.demoMaxStudents) || 5;

          if (parsedEmails.length > stepCap) {
            setMessage(
              'A demo cohort holds up to ' + stepCap + ' students, and this list has ' + parsedEmails.length +
              '. Remove ' + (parsedEmails.length - stepCap) + ' to continue. The live system has no limit.'
            );
            return false;
          }
        }
      }

      return true;
    }

    function goToStep(step) {
      if (step < 1) step = 1;
      if (step > 5) step = 5;

      setMessage('');
      currentStep = step;

      document.querySelectorAll('[data-step-panel]').forEach(function(panel) {
        panel.classList.toggle('is-active', Number(panel.dataset.stepPanel) === currentStep);
      });

      document.querySelectorAll('[data-step-tab]').forEach(function(tab) {
        var tabStep = Number(tab.dataset.stepTab);
        tab.classList.toggle('is-active', tabStep === currentStep);
        tab.classList.toggle('is-complete', tabStep < currentStep);
      });

      var navRight = document.getElementById('nav-right-container');
      var nav = document.getElementById('cohort-nav');
      var form = document.getElementById('cohort-form');

      if (nav) nav.classList.toggle('is-review', currentStep === 5);
      if (form) form.classList.toggle('is-step-review', currentStep === 5);

      if (currentStep === 5) {
        updateSummary();
        navRight.innerHTML = '<button type="submit" class="cohort-nav-button confirm" id="confirm-button">Create Cohort</button>';
      } else {
        navRight.innerHTML = '<button type="button" class="cohort-nav-button primary" id="next-button">Continue</button>';
        document.getElementById('next-button').addEventListener('click', onNextClick);
      }

      document.getElementById('back-button').style.visibility = currentStep === 1 ? 'hidden' : 'visible';
      syncAdminEmailAccountNotice();
      window.scrollTo({ top: document.getElementById('cohort-wizard').offsetTop - 20, behavior: 'smooth' });
    }

    function onNextClick() {
      if (!validateStep(currentStep)) return;
      goToStep(currentStep + 1);
    }

    function getSelectedDeliveryMode() {
      var selected = document.querySelector('input[name="delivery_mode_display"]:checked');
      return selected && selected.value === 'home_delivery' ? 'home_delivery' : 'school_delivery';
    }

    function getDeliveryModeSummaryLabel(mode) {
      return mode === 'home_delivery'
        ? 'Home delivery (ship to student)'
        : 'School delivery (ship to campus)';
    }

    function syncDeliveryModeFields() {
      var mode = getSelectedDeliveryMode();
      var orderTypeHidden = document.getElementById('order_type_hidden');

      if (orderTypeHidden) {
        orderTypeHidden.value = mode === 'home_delivery' ? 'individual_student_orders' : 'school_order';
      }
    }

    function collectPayload() {
      var form = document.getElementById('cohort-form');
      var school = getSelectedSchool();
      var campus = getSelectedCampus();
      var selectedProducts = getSelectedProducts();
      var urls = buildUrls(currentCohortCode);
      var pricingPreview = buildPricingPreview();
      var pricingJson = buildPricingJson(pricingPreview);
      var productIds = getSelectedProductIds(selectedProducts);
      var productGids = getSelectedProductGids(selectedProducts);
      var openedAt = new Date().toISOString();
      var cohortLabelInput = document.getElementById('cohort_label');
      var cohortLabelValue = cohortLabelInput ? String(cohortLabelInput.value || '').trim() : '';
      /*
        Multi-campus (2026-07-31): the cohort metaobject still stores ONE campus
        reference, so we store the campus the order actually ships to. When the
        admin picked "Different address" there is no ship-to campus, and we fall
        back to the first selected one — same value the form sent before this
        change. The full lists travel as campus_handles / program_handles; the
        create-cohort task ignores unknown keys today and will read them once the
        list fields exist on the cohort metaobject.
      */
      var shipToCampus = getShipToCampus() || campus;
      var campusAddressSnapshot = buildCampusAddressSnapshot(shipToCampus, cohortLabelValue);
      var schoolDeliveryAddressSnapshot = buildSchoolDeliveryAddressSnapshot();
      var deliveryMode = getSelectedDeliveryMode();
      var selectedCampuses = getSelectedCampuses();

      var students = parsedEmails.map(function(email) {
        return {
          first_name: '',
          last_name: '',
          email: email,
          student_id: '',
          status: 'pending',
          email_match_status: 'matched'
        };
      });

      return {
        action: 'create_cohort',
        source: 'cohort_admin_form',
        cohort_code: currentCohortCode,
        cohort_id: currentCohortCode,
        unique_code: currentCohortCode,
        code: currentCohortCode,
        school_code: school ? school.schoolCode : '',
        school_name: school ? school.schoolName : '',
        school_gid: school ? school.schoolGid : '',
        admin_name: String(form.admin_name.value || '').trim(),
        admin_email: String(form.admin_email.value || '').trim().toLowerCase(),
        cohort_label: cohortLabelValue,
        cohort_name: cohortLabelValue,
        deadline: String(form.deadline.value || '').trim(),
        deadline_display: String(form.deadline.value || '').trim(),
        status: 'open',
        order_type: deliveryMode === 'home_delivery' ? 'individual_student_orders' : 'school_order',
        delivery_mode: deliveryMode,
        ship_to_students: deliveryMode === 'home_delivery' ? 'true' : 'false',
        campus_gid: shipToCampus ? shipToCampus.gid : '',
        campus_handle: shipToCampus ? shipToCampus.handle : '',
        campus_code: shipToCampus ? shipToCampus.campusCode : '',
        campus_name: shipToCampus ? shipToCampus.campusName : '',
        campus_address_snapshot: campusAddressSnapshot,
        school_delivery_address_snapshot: schoolDeliveryAddressSnapshot,
        ship_to_campus_handle: shipToCampus ? shipToCampus.handle : '',
        campus_handles: selectedCampuses.map(function(item) { return item.handle; }),
        campus_names: selectedCampuses.map(getCampusLabel),
        /*
          No Step-1 program selection (2026-08-02) — program is assigned per
          item on Step 3 instead (see products_json below, each entry already
          carries its own program_names). These legacy single-program keys
          stay in the payload as blanks so cohort-create-cohort.liquid's
          existing blank-check conditionals keep working unchanged.
        */
        program_gid: '',
        program_handle: '',
        program_code: '',
        program_name: '',
        school_invoice_email_snapshot: school ? String(school.invoiceEmail || '').trim().toLowerCase() : '',
        team_notification_email: String(TEAM_NOTIFICATION_EMAIL || '').trim().toLowerCase(),
        opened_at: openedAt,
        personalize_order: form.personalize_order.checked ? 'true' : 'false',
        personalization_fee_per_student: school ? String(toNumber(school.personalizationFeePerStudent).toFixed(2)) : '0.00',
        send_student_emails: form.send_student_emails.checked ? 'true' : 'false',
        student_form_page_path: urls.studentFormPath,
        status_page_path: urls.statusPagePath,
        student_form_url: urls.studentFormUrl,
        status_page_url: urls.statusPageUrl,
        cohort_status_url: urls.statusPageUrl,
        students_count: students.length,
        student_emails: parsedEmails.slice(),
        students: students,
        students_json: JSON.stringify(students),
        products: selectedProducts,
        products_json: JSON.stringify(selectedProducts),
        product_ids: productIds,
        product_gids: productGids,
        selected_styles_count: selectedProducts.length,
        selected_units_per_student: selectedProducts.reduce(function(acc, product) {
          return acc + (parseInt(product.quantity_per_student, 10) || 0);
        }, 0),
        per_student_product_total: pricingPreview.perStudentProductsTotal,
        estimated_products_total: pricingPreview.productsTotal,
        estimated_personalization_total: pricingPreview.personalizationTotal,
        estimated_cohort_total: pricingPreview.grandTotal,
        currency_code: pricingPreview.currencyCode || 'USD',
        pricing_json: JSON.stringify(pricingJson),
        pricing_preview: pricingJson,
        created_at: openedAt
      };
    }

    function bodyFitsKeepalive(body) {
      try {
        return new Blob([body]).size <= KEEPALIVE_MAX_BYTES;
      } catch (error) {
        return false;
      }
    }

    /*
      Shared fetch options for every webhook POST. keepalive is set only when the
      body is small enough for the browser to accept it, so a large payload (a
      big cohort create) degrades to a normal request instead of failing
      outright. Keep in step with webhookInit in cohort-status.js.
    */
    function webhookInit(payload) {
      var body = JSON.stringify(payload);
      var init = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
      };

      if (bodyFitsKeepalive(body)) init.keepalive = true;

      return init;
    }

    function postJson(url, payload) {
      return fetch(url, webhookInit(payload)).then(function(response) {
        return response.text().then(function(text) {
          var data = {};

          try {
            data = text ? JSON.parse(text) : {};
          } catch (error) {
            data = { raw: text || '' };
          }

          if (!response.ok) {
            throw new Error((data && (data.error || data.message)) || text || ('HTTP ' + response.status));
          }

          if (data && data.ok === false) {
            throw new Error(data.error || data.message || 'Request failed');
          }

          return data;
        });
      });
    }

    function isNetworkFetchError(error) {
      var message = error && error.message ? String(error.message) : '';
      return /failed to fetch|networkerror|network error|load failed|network request failed/i.test(message);
    }

    function recoverCohortCreation(payload, result, onComplete) {
      pollUntilCohortReady(payload.cohort_code, {
        studentFormUrl: (result && (result.student_form_url || result.studentFormUrl)) || payload.student_form_url,
        statusPageUrl: (result && (result.status_page_url || result.statusPageUrl)) || payload.status_page_url,
        expectedStudentCount: payload.students_count || parsedEmails.length
      }, function(timedOut) {
        if (activeCreationFlow) {
          activeCreationFlow.result = result || activeCreationFlow.result || {};
          activeCreationFlow.timedOut = timedOut;
        } else {
          completeSetupAndShowDashboard(result || {}, payload, timedOut);
        }

        if (timedOut) {
          setMessage('Connection was interrupted while creating your cohort. If the cohort does not appear yet, refresh in a moment.');
        }

        onComplete();
      });
    }

    function renderFinalQr(studentFormUrl, schoolName, cohortCode) {
      var qrImage = document.getElementById('final-qr-image');
      var qrPlaceholder = document.getElementById('final-qr-placeholder');
      var qrUrl = buildQrUrl(studentFormUrl);
      var displaySchoolName = schoolName || 'Cohort';
      var displayCode = cohortCode || currentFinalCohortCode || '—';

      if (!studentFormUrl || !qrUrl) {
        if (qrImage) {
          qrImage.style.display = 'none';
          qrImage.removeAttribute('src');
        }
        if (qrPlaceholder) qrPlaceholder.style.display = '';
        return;
      }

      qrImage.src = qrUrl;
      qrImage.style.display = 'block';
      if (qrPlaceholder) qrPlaceholder.style.display = 'none';

      document.getElementById('final-print-qr-button').onclick = function() {
        var qrHtml =
          '<div class="print-only-qr">' +
            '<div class="print-only-qr-sheet">' +
              '<img class="print-only-qr-image" src="' + esc(qrUrl) + '" alt="Student form QR code">' +
              '<h2 class="print-only-qr-title">Scan to open Student Form</h2>' +
              '<p class="print-only-qr-meta">' + esc(displaySchoolName) + ' · ' + esc(displayCode) + '</p>' +
            '</div>' +
          '</div>';

        printHtmlInIframe({
          qrOnly: true,
          title: 'Cohort ' + displayCode + ' QR',
          bodyHtml: qrHtml
        });
      };
    }

    function mergeEmailsIntoTextarea(newEmails) {
      var textarea = document.getElementById('student-email-textarea');
      if (!textarea) return;

      var merged = extractEmails((textarea.value || '') + '\n' + (newEmails || []).join('\n'));
      textarea.value = merged.join('\n');
      updateEmailPreview();
    }

    function setEmailUploadStatus(message) {
      var status = document.getElementById('student-email-upload-status');
      if (!status) return;

      if (!message) {
        status.hidden = true;
        status.textContent = '';
        return;
      }

      status.hidden = false;
      status.textContent = message;
    }

    function loadXlsxLibrary(callback) {
      if (window.XLSX) {
        callback();
        return;
      }

      var existing = document.getElementById('cohort-xlsx-lib');
      if (existing) {
        existing.addEventListener('load', callback, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.id = 'cohort-xlsx-lib';
      script.src = 'https://cdn.sheetjs.com/xlsx-0.20.3/package/dist/xlsx.full.min.js';
      script.onload = callback;
      script.onerror = function() {
        setEmailUploadStatus('Could not load Excel support. Save the file as CSV and try again.');
      };
      document.head.appendChild(script);
    }

    function parseSpreadsheetFile(file) {
      loadXlsxLibrary(function() {
        var reader = new FileReader();

        reader.onload = function(event) {
          try {
            var workbook = window.XLSX.read(new Uint8Array(event.target.result), { type: 'array' });
            var rows = [];

            workbook.SheetNames.forEach(function(sheetName) {
              var sheet = workbook.Sheets[sheetName];
              var sheetRows = window.XLSX.utils.sheet_to_json(sheet, { header: 1, raw: false });
              rows = rows.concat(sheetRows);
            });

            var text = rows.map(function(row) {
              return Array.isArray(row) ? row.join('\n') : String(row || '');
            }).join('\n');

            mergeEmailsIntoTextarea(extractEmails(text));
            setEmailUploadStatus('Imported ' + parsedEmails.length + ' unique email' + (parsedEmails.length === 1 ? '' : 's') + ' from ' + file.name + '.');
          } catch (error) {
            setEmailUploadStatus('Could not read that Excel file. Try CSV or TXT instead.');
          }
        };

        reader.readAsArrayBuffer(file);
      });
    }

    function handleEmailFileUpload(file) {
      if (!file) return;

      var name = String(file.name || '').toLowerCase();

      if (/\.(xlsx|xls)$/.test(name)) {
        parseSpreadsheetFile(file);
        return;
      }

      var reader = new FileReader();

      reader.onload = function(event) {
        mergeEmailsIntoTextarea(extractEmails(event.target.result));
        setEmailUploadStatus('Imported ' + parsedEmails.length + ' unique email' + (parsedEmails.length === 1 ? '' : 's') + ' from ' + file.name + '.');
      };

      reader.onerror = function() {
        setEmailUploadStatus('Could not read that file. Try CSV or TXT instead.');
      };

      reader.readAsText(file);
    }

    function setFinalLinksEnabled(enabled) {
      var studentButton = document.getElementById('final-student-form-button');
      var statusButton = document.getElementById('final-status-page-button');
      var printButton = document.getElementById('final-print-qr-button');
      var finalCard = document.getElementById('cohort-final-state');

      [studentButton, statusButton, printButton].forEach(function(button) {
        if (!button) return;
        button.disabled = !enabled;
        button.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      });

      if (finalCard) {
        finalCard.classList.toggle('is-pending', !enabled);
      }
    }

    function parseStatusPageStudentCount(html, code) {
      var normalized = normalizeKey(code);
      if (!normalized || !html) return 0;

      var escaped = normalized.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var blockRe = new RegExp('cohortCode:\\s*"' + escaped + '"[\\s\\S]*?studentsJson:\\s*(\\[[\\s\\S]*?\\])\\s*,', 'i');
      var match = html.match(blockRe);

      if (!match) return 0;

      try {
        var students = JSON.parse(match[1]);
        if (!Array.isArray(students)) return 0;

        return students.filter(function(student) {
          var status = String(student && student.status ? student.status : '').toLowerCase();
          return status !== 'removed' && status !== 'archived';
        }).length;
      } catch (error) {
        return 0;
      }
    }

    function statusHtmlHasCohortCode(html, code) {
      var normalized = normalizeKey(code);
      var codePattern = new RegExp('"' + normalized.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '"', 'i');
      return codePattern.test(html) || html.indexOf(normalized) !== -1;
    }

    function statusHtmlCohortReady(html, code, expectedStudentCount) {
      if (!statusHtmlHasCohortCode(html, code)) return false;

      var studentCount = parseStatusPageStudentCount(html, code);
      var minExpected = Math.max(1, parseInt(expectedStudentCount, 10) || 1);
      return studentCount >= minExpected;
    }

    function pollUntilCohortReady(code, urls, onReady) {
      var attempts = 0;
      var maxAttempts = 30;
      var statusUrl = urls && urls.statusPageUrl ? urls.statusPageUrl : '';
      var expectedStudentCount = urls && urls.expectedStudentCount ? urls.expectedStudentCount : 1;

      if (!statusUrl || !code) {
        onReady();
        return;
      }

      function checkAgain() {
        attempts += 1;

        fetch(statusUrl + (statusUrl.indexOf('?') === -1 ? '?' : '&') + 'cohort=' + encodeURIComponent(code) + '&_poll=' + Date.now(), {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store'
        }).then(function(response) {
          if (!response.ok) throw new Error('Status page not ready');
          return response.text();
        }).then(function(html) {
          if (statusHtmlCohortReady(html, code, expectedStudentCount)) {
            onReady(false);
            return;
          }

          if (attempts >= maxAttempts) {
            onReady(true);
            return;
          }

          window.setTimeout(checkAgain, 3000);
        }).catch(function() {
          if (attempts >= maxAttempts) {
            onReady(true);
            return;
          }

          window.setTimeout(checkAgain, 3000);
        });
      }

      window.setTimeout(checkAgain, 2000);
    }

    function showCreatingState(payload) {
      var finalPanel = document.getElementById('cohort-final-state');
      var school = getSelectedSchool();

      currentFinalSchoolName = school ? (school.schoolName || 'School') : 'School';
      currentFinalCohortCode = payload.cohort_code || '';

      upsertLocalCohortFromPayload(payload);

      setFinalScreenVisible(true);
      finalPanel.classList.add('is-pending');
      document.getElementById('final-cohort-code-display').textContent = payload.cohort_code || '—';

      toggleSetupScreenMode(true);
      setFinalLinksEnabled(false);

      var qrImage = document.getElementById('final-qr-image');
      if (qrImage) qrImage.style.display = 'none';

      startSetupProgress(function() {
        if (!activeCreationFlow) return;

        completeSetupAndShowDashboard(
          activeCreationFlow.result || {},
          activeCreationFlow.payload || payload,
          activeCreationFlow.timedOut
        );
        activeCreationFlow = null;
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function completeSetupAndShowDashboard(result, payload, timedOut) {
      /*
        End of the creation flow either way (ready or timed out) — release the
        lock here so the final screen's links are clickable again. Reached from
        the setup progress callback, which runs on both outcomes.
      */
      clearActionLock();
      setAdminPageBlocked(false);

      var finalStudentFormUrl =
        (result && (result.student_form_url || result.studentFormUrl)) ||
        payload.student_form_url;

      var finalStatusPageUrl =
        (result && (result.status_page_url || result.statusPageUrl)) ||
        payload.status_page_url;

      var finalCode =
        (result && (result.cohort_code || result.cohortCode || result.code)) ||
        payload.cohort_code;

      currentFinalStudentFormUrl = finalStudentFormUrl || '';
      currentFinalStatusPageUrl = finalStatusPageUrl || '';
      currentFinalCohortCode = finalCode || payload.cohort_code || '';
      currentFinalSchoolName = payload.school_name || (getSelectedSchool() && getSelectedSchool().schoolName) || 'School';

      var finalPanel = document.getElementById('cohort-final-state');

      stopSetupProgress(true);
      if (finalPanel) finalPanel.classList.remove('is-pending');
      toggleSetupScreenMode(false);
      setFinalScreenVisible(false);
      setFinalLinksEnabled(true);

      upsertLocalCohortFromPayload(Object.assign({}, payload, {
        cohort_code: currentFinalCohortCode,
        student_form_url: currentFinalStudentFormUrl,
        status_page_url: currentFinalStatusPageUrl
      }));
      renderManageCohorts();
      window.scrollTo({ top: 0, behavior: 'smooth' });

      if (timedOut) {
        setMessage('Your cohort was created. If it does not appear yet, refresh in a moment.');
      } else {
        setMessage('');
      }
    }

    function showFinalScreen(result, payload, timedOut) {
      var finalStudentFormUrl =
        (result && (result.student_form_url || result.studentFormUrl)) ||
        payload.student_form_url;

      var finalStatusPageUrl =
        (result && (result.status_page_url || result.statusPageUrl)) ||
        payload.status_page_url;

      var finalCode =
        (result && (result.cohort_code || result.cohortCode || result.code)) ||
        payload.cohort_code;

      currentFinalStudentFormUrl = finalStudentFormUrl || '';
      currentFinalStatusPageUrl = finalStatusPageUrl || '';
      currentFinalCohortCode = finalCode || payload.cohort_code || '';
      currentFinalSchoolName = payload.school_name || (getSelectedSchool() && getSelectedSchool().schoolName) || 'School';

      var finalPanel = document.getElementById('cohort-final-state');

      setFinalScreenVisible(true);
      document.getElementById('final-cohort-code-display').textContent = currentFinalCohortCode || '—';

      function revealFinalScreen() {
        stopSetupProgress(true);
        finalPanel.classList.remove('is-pending');
        toggleSetupScreenMode(false);
        setFinalScreenVisible(true);

        updateSuccessHero(
          'Success',
          'Cohort <span class="cohort-gradient-text-internal">Created!</span>',
          timedOut
            ? 'Your cohort was created. If a link does not open yet, wait another minute and refresh this page.'
            : 'Your cohort is ready. Open the student form, check the status page, or print the QR code for students.'
        );

        updateFinalPanelCopy(
          'Your cohort is live',
          "What's next?",
          timedOut
            ? 'If a link does not open yet, wait another minute and refresh this page.'
            : 'Share the student form with your cohort or monitor submissions on the status page.'
        );

        setFinalLinksEnabled(true);

        document.getElementById('final-student-form-button').onclick = function() {
          if (currentFinalStudentFormUrl) {
            window.open(currentFinalStudentFormUrl, '_blank');
          }
        };

        document.getElementById('final-status-page-button').onclick = function() {
          if (currentFinalStatusPageUrl) {
            window.open(currentFinalStatusPageUrl, '_blank');
          }
        };

        renderFinalQr(currentFinalStudentFormUrl, currentFinalSchoolName, currentFinalCohortCode);
        upsertLocalCohortFromPayload(payload);
        renderManageCohorts();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      if (finalPanel && finalPanel.classList.contains('is-pending')) {
        finishSetupProgress(revealFinalScreen);
      } else {
        stopSetupProgress();
        revealFinalScreen();
      }
    }

    function resetForm() {
      stopSetupProgress();
      document.getElementById('cohort-form').reset();
      currentStep = 1;
      currentCohortCode = '';
      parsedEmails = [];
      productCopies = {};
      selectedCampusHandles = [];
      selectedShipToCampusHandle = '';
      shipToChosenByAdmin = false;

      var copyHintNotice = document.getElementById('copy-hint-notice');
      if (copyHintNotice) copyHintNotice.style.display = 'none';

      currentFinalStudentFormUrl = '';
      currentFinalStatusPageUrl = '';
      currentFinalSchoolName = '';
      currentFinalCohortCode = '';

      if (CUSTOMER.name) {
        document.getElementById('admin_name').value = CUSTOMER.name;
      }

      if (CUSTOMER.email) {
        document.getElementById('admin_email').value = CUSTOMER.email;
      }

      syncAdminEmailAccountNotice();
      hydrateSchoolFromContext();
      updateEmailPreview();

      var searchInput = document.getElementById('product-search-input');
      if (searchInput) searchInput.value = '';

      document.getElementById('cohort-final-state').classList.remove('is-pending');
      toggleSetupScreenMode(false);
      setFinalScreenVisible(false);
      setMessage('');
      setEmailUploadStatus('');
      setFinalLinksEnabled(true);

      updateSuccessHero(
        'Success',
        'Cohort <span class="cohort-gradient-text-internal">Created!</span>',
        'Your cohort is ready. Open the student form, check the status page, or print the QR code for students.'
      );

      updateFinalPanelCopy(
        'Your cohort is live',
        "What's next?",
        'Share the student form with your cohort or monitor submissions on the status page.'
      );

      var qrImage = document.getElementById('final-qr-image');
      if (qrImage) qrImage.style.display = 'none';
      setDeadlineMin();
      goToStep(1);
      renderManageCohorts();
    }

    function setDeadlineMin() {
      var input = document.getElementById('deadline-date');
      if (!input) return;

      var now = new Date();
      var yyyy = now.getFullYear();
      var mm = String(now.getMonth() + 1).padStart(2, '0');
      var dd = String(now.getDate()).padStart(2, '0');
      input.min = yyyy + '-' + mm + '-' + dd;
    }

    function bindDeadlinePickerButton() {
      var button = document.getElementById('deadline-picker-button');
      var input = document.getElementById('deadline-date');

      if (!button || !input) return;

      button.addEventListener('click', function() {
        if (typeof input.showPicker === 'function') {
          input.showPicker();
        } else {
          input.focus();
          input.click();
        }
      });
    }

    /*
      2026-10-10 - listeners on the whole document are attached once, however
      many times init runs. The theme editor runs it again after redrawing the
      section (see the end of this file); without this guard one click on the
      reminders switch would be handled twice and flip it straight back.
    */
    var boundDocumentListeners = {};

    function onDocumentOnce(key, type, handler) {
      if (boundDocumentListeners[key]) return;
      boundDocumentListeners[key] = true;
      document.addEventListener(type, handler);
    }

    function bindEvents() {
      bindDraftBarHandlers();

      /* 2026-10-17 (owner) - the cross on "Letter not delivered" and "Mark as seen" on our team's notes. */
      onDocumentOnce('mail-dismiss', 'click', function(event) {
        var button = event.target.closest('[data-mail-dismiss]');
        if (!button || button.disabled || !editingCohortCode) return;
        event.preventDefault();
        dismissMailNotice(editingCohortCode, button.getAttribute('data-mail-dismiss') || '', button.getAttribute('data-mail-since') || '');
      });
      onDocumentOnce('team-notes-seen', 'click', function(event) {
        var button = event.target.closest('[data-team-notes-seen]');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        markTeamNotesSeen(button.getAttribute('data-team-notes-seen') || '', button.getAttribute('data-team-notes-at') || 0);
        refreshCohortAlertBadges();
      });
      var form = document.getElementById('cohort-form');

      document.getElementById('back-button').addEventListener('click', function() {
        goToStep(currentStep - 1);
      });

      document.getElementById('next-button').addEventListener('click', onNextClick);

      document.querySelectorAll('[data-step-tab]').forEach(function(tab) {
        tab.addEventListener('click', function() {
          var targetStep = Number(tab.dataset.stepTab);

          if (targetStep > currentStep) {
            for (var i = 1; i < targetStep; i += 1) {
              if (!validateStep(i)) {
                goToStep(i);
                return;
              }
            }
          }

          goToStep(targetStep);
        });
      });

      document.getElementById('product-search-input').addEventListener('input', renderProducts);
      document.getElementById('student-email-textarea').addEventListener('input', updateEmailPreview);

      var emailFileInput = document.getElementById('student-email-file');
      if (emailFileInput) {
        emailFileInput.addEventListener('change', function(event) {
          var file = event.target.files && event.target.files[0];
          if (file) handleEmailFileUpload(file);
          event.target.value = '';
        });
      }

      /*
        Campus cards are re-rendered on every change, so the listener lives on
        the container (delegation) instead of on each checkbox — otherwise
        every re-render would need to re-bind them.
      */
      var campusChoiceList = document.getElementById('campus-choice-list');
      if (campusChoiceList) {
        campusChoiceList.addEventListener('change', function(event) {
          var input = event.target;
          if (!input || input.getAttribute('data-choice') !== 'campus') return;
          onCampusSelectionChange(String(input.value || ''), input.checked);
        });
      }

      /* The ship-to buttons bind themselves each time they are drawn, in
         renderShipToCampusOptions — there is no long-lived control here to
         listen to any more. */

      ['admin_name', 'admin_email', 'cohort_label', 'deadline-date', 'personalize-order-checkbox'].forEach(function(id) {
        var element = document.getElementById(id);
        if (!element) return;
        element.addEventListener('input', updateSummary);
        element.addEventListener('change', updateSummary);
      });

      var adminEmailField = document.getElementById('admin_email');
      if (adminEmailField) {
        adminEmailField.addEventListener('input', syncAdminEmailAccountNotice);
        adminEmailField.addEventListener('change', syncAdminEmailAccountNotice);
        adminEmailField.addEventListener('blur', syncAdminEmailAccountNotice);
        syncAdminEmailAccountNotice();
      }

      document.querySelectorAll('[name="send_student_emails"], [name="personalize_order"]').forEach(function(input) {
        input.addEventListener('change', updateSummary);
      });

      document.querySelectorAll('[name="delivery_mode_display"]').forEach(function(input) {
        input.addEventListener('change', function() {
          syncDeliveryModeFields();
          toggleSchoolDeliveryAddressBox();
          updateSummary();
        });
      });

      syncDeliveryModeFields();
      toggleSchoolDeliveryAddressBox();

      form.addEventListener('submit', function(event) {
        event.preventDefault();

        /*
          2026-08-11 — a refusal must say something.

          "Create Cohort does nothing" has been reported four times, and each
          round cost a deploy to learn which check was refusing. A step that
          refuses silently is indistinguishable from a script that died, and the
          two need opposite fixes. Anything thrown from here now reaches the
          admin instead of the console they were never asked to open.
        */
        try {
          for (var step = 1; step <= 4; step += 1) {
            if (!validateStep(step)) {
              goToStep(step);

              var statusEl = document.getElementById('cohort-message');
              if (statusEl && !String(statusEl.textContent || '').trim()) {
                setMessage('Please finish step ' + step + ' before creating the cohort.');
              }

              return;
            }
          }
        } catch (validationError) {
          setMessage('Could not check the form: ' + (validationError && validationError.message ? validationError.message : 'unknown error'));
          return;
        }

        /*
          Last guard, for a form that was opened anyway (an old tab, a sign-out
          in another tab). Plain words: the visitor cannot fix a section setting.
        */
        if (mustSignInToCreate()) {
          setMessage('Please sign in to create a cohort. Your answers here will need to be entered again after signing in.');
          return;
        }

        if (!CREATE_WEBHOOK_URL) {
          setMessage('Creating a cohort is not available on this page right now. Please contact us and we will help.');
          if (window.console && console.warn) console.warn('Cohort admin: the create webhook URL is empty in the section settings.');
          return;
        }

        /*
          The demo's other ceiling: five cohorts per address. Counted here so
          the person is told before the press - the task behind this counts the
          same cohorts and refuses, and that refusal never reaches a browser
          (trap 3). Two counts of one rule, and the server's is the one that
          holds. Owner, 2026-09-15.
        */
        var demoLimitMessage = demoCohortLimitMessage();
        if (demoLimitMessage) {
          setMessage(demoLimitMessage);
          return;
        }

        refreshCohortCode(false);

        var button = document.getElementById('confirm-button');
        var payload = collectPayload();

        button.disabled = true;
        button.textContent = 'Creating cohort...';
        setMessage('');

        activeCreationFlow = {
          payload: payload,
          result: {},
          timedOut: true
        };

        /*
          Cohort creation gets the same lock as every other write (2026-08-02).
          Its Mechanic run is the longest and the least recoverable: if the POST
          is lost the cohort simply never exists, with no event in Mechanic at
          all. The lock both blocks the page and arms the beforeunload guard.
        */
        setAdminPageBlocked(true);
        writeActionLock('Creating cohort', CREATE_ACTION_LOCK_MS, {
          action: 'create',
          cohortCode: payload.cohort_code || ''
        });

        showCreatingState(payload);

        postJson(CREATE_WEBHOOK_URL, payload).then(function(result) {
          if (activeCreationFlow) {
            activeCreationFlow.result = result || {};
          }

          pollUntilCohortReady(payload.cohort_code, {
            studentFormUrl: (result && (result.student_form_url || result.studentFormUrl)) || payload.student_form_url,
            statusPageUrl: (result && (result.status_page_url || result.statusPageUrl)) || payload.status_page_url,
            expectedStudentCount: payload.students_count || parsedEmails.length
          }, function(timedOut) {
            if (activeCreationFlow) {
              activeCreationFlow.timedOut = timedOut;
            }

            button.disabled = false;
            button.textContent = 'Create Cohort';
          });
        }).catch(function(error) {
          if (isNetworkFetchError(error)) {
            recoverCohortCreation(payload, {}, function() {
              button.disabled = false;
              button.textContent = 'Create Cohort';
            });
            return;
          }

          activeCreationFlow = null;
          clearActionLock();
          setAdminPageBlocked(false);
          stopSetupProgress();
          setFinalScreenVisible(false);
          goToStep(5);
          setMessage(error && error.message ? error.message : 'Unable to create cohort.');
          button.disabled = false;
          button.textContent = 'Create Cohort';
        });
      });

      document.getElementById('create-another-button').addEventListener('click', resetForm);

      bindDeadlinePickerButton();
      renderManageCohorts();

      var manageList = document.getElementById('cohort-manage-list');
      if (manageList && !manageList.dataset.bound) {
        manageList.dataset.bound = '1';
        manageList.addEventListener('click', function(event) {
          var archiveButton = event.target.closest('[data-archive-cohort]');
          if (archiveButton) {
            event.preventDefault();
            archiveCohortFromDashboard(
              archiveButton.getAttribute('data-archive-cohort') || '',
              archiveButton
            );
            return;
          }

          var deleteLinkButton = event.target.closest('[data-delete-cohort]');
          if (deleteLinkButton) {
            event.preventDefault();
            deleteCohortFromManageList(
              deleteLinkButton.getAttribute('data-delete-cohort') || '',
              deleteLinkButton
            );
            return;
          }

          var viewStudentsButton = event.target.closest('[data-view-late-students]');
          if (viewStudentsButton) {
            event.preventDefault();
            var viewCohortCode = viewStudentsButton.getAttribute('data-cohort-code') || '';
            var viewLateBatchCode = viewStudentsButton.getAttribute('data-late-batch-code') || '';
            openCohortEmailEditor(viewCohortCode, {
              lateTrack: !!viewLateBatchCode,
              lateBatchCode: viewLateBatchCode,
              readOnly: true
            });
            return;
          }

          var editButton = event.target.closest('[data-edit-cohort]');
          if (!editButton) return;
          event.preventDefault();
          openCohortEmailEditor(editButton.getAttribute('data-edit-cohort') || '', {
            lateTrack: editButton.getAttribute('data-edit-late-track') === '1',
            lateBatchCode: editButton.getAttribute('data-late-batch-code') || ''
          });
        });
      }

      var editBackButton = document.getElementById('cohort-edit-back-button');
      if (editBackButton && !editBackButton.dataset.bound) {
        editBackButton.dataset.bound = '1';
        editBackButton.addEventListener('click', function() {
          editingCohortCode = '';
          editingLateStudentsTrack = false;
          editingLateBatchCode = '';
          editingReadOnly = false;
          var editPanel = document.getElementById('cohort-email-edit-panel');
          if (editPanel) editPanel.classList.remove('is-read-only');
          persistEmailEditState('');
          stopEmailPanelIdleSync();
          setManagePanelsVisible('manage');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }

      var addEmailsButton = document.getElementById('cohort-edit-add-emails-button');
      if (addEmailsButton && !addEmailsButton.dataset.bound) {
        addEmailsButton.dataset.bound = '1';
        addEmailsButton.addEventListener('click', promptAddNewRosterEmails);
      }

      /*
        The hint opens on hover and keyboard focus in CSS; a tap opens it on a
        phone, where there is no hover. A tap elsewhere or Escape closes it.
      */
      onDocumentOnce('tip-click', 'click', function(event) {
        var tipButton = event.target.closest ? event.target.closest('.cohort-tip-btn') : null;
        document.querySelectorAll('.cohort-tip.is-open').forEach(function(tip) {
          if (!tipButton || tip !== tipButton.parentNode) tip.classList.remove('is-open');
        });
        if (tipButton) tipButton.parentNode.classList.toggle('is-open');
      });
      onDocumentOnce('tip-escape', 'keydown', function(event) {
        if (event.key !== 'Escape') return;
        document.querySelectorAll('.cohort-tip.is-open').forEach(function(tip) {
          tip.classList.remove('is-open');
        });
      });

      var mailEmailsSwitch = document.getElementById('cohort-mail-emails');
      if (mailEmailsSwitch) {
        mailEmailsSwitch.addEventListener('click', function() {
          var cohort = findCohortByCode(editingCohortCode);
          if (!cohort) return;
          saveEmailSettings(cohort.cohortCode, !isSwitchOn(cohort.sendStudentEmails), isSwitchOn(cohort.autoReminders));
        });
      }
      /* 2026-10-09 - the reminders switch is drawn inside the reminders panel,
         which is redrawn often, so it is listened for on the document. */
      onDocumentOnce('reminders-switch', 'click', function(event) {
        var remindersSwitch = event.target && event.target.closest ? event.target.closest('#cohort-mail-reminders') : null;
        if (!remindersSwitch || remindersSwitch.disabled) return;
        var cohort = findCohortByCode(editingCohortCode);
        if (!cohort) return;
        saveEmailSettings(cohort.cohortCode, isSwitchOn(cohort.sendStudentEmails), !isSwitchOn(cohort.autoReminders));
      });

      var renameButton = document.getElementById('cohort-edit-rename-button');
      if (renameButton && !renameButton.dataset.bound) {
        renameButton.dataset.bound = '1';
        renameButton.addEventListener('click', function() {
          if (isEditingTitle()) saveTitleEdit();
          else startTitleEdit();
        });
      }

      var labelInput = document.getElementById('cohort-edit-label-input');
      if (labelInput && !labelInput.dataset.bound) {
        labelInput.dataset.bound = '1';
        /* A name is one line of text: a pasted line break becomes a space. */
        labelInput.addEventListener('input', function() {
          var oneLine = labelInput.value.split(String.fromCharCode(13)).join(' ').split(String.fromCharCode(10)).join(' ');
          if (oneLine !== labelInput.value) labelInput.value = oneLine;
          fitTitleField(labelInput);
        });
        labelInput.addEventListener('keydown', function(event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            saveTitleEdit();
          } else if (event.key === 'Escape') {
            event.preventDefault();
            endTitleEdit();
            if (renameButton) renameButton.focus();
          }
        });
      }

      var addEmailsModalCancel = document.getElementById('cohort-add-emails-modal-cancel');
      if (addEmailsModalCancel && !addEmailsModalCancel.dataset.bound) {
        addEmailsModalCancel.dataset.bound = '1';
        addEmailsModalCancel.addEventListener('click', closeAddEmailsModal);
      }

      var addEmailsModalConfirm = document.getElementById('cohort-add-emails-modal-confirm');
      if (addEmailsModalConfirm && !addEmailsModalConfirm.dataset.bound) {
        addEmailsModalConfirm.dataset.bound = '1';
        addEmailsModalConfirm.addEventListener('click', confirmAddNewRosterEmails);
      }

      var addEmailsModal = document.getElementById('cohort-add-emails-modal');
      if (addEmailsModal && !addEmailsModal.dataset.bound) {
        addEmailsModal.dataset.bound = '1';
        addEmailsModal.addEventListener('click', function(event) {
          if (event.target === addEmailsModal) {
            closeAddEmailsModal();
          }
        });
      }

      var showCreateButton = document.getElementById('cohort-show-create-button');
      if (showCreateButton && !showCreateButton.dataset.bound) {
        showCreateButton.dataset.bound = '1';
        if (mustSignInToCreate()) showCreateButton.textContent = 'Sign in to create a cohort';
        showCreateButton.addEventListener('click', function() {
          if (mustSignInToCreate()) {
            goToSignInToCreate();
            return;
          }
          setManagePanelsVisible('create');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }

      /*
        The way back out of the create form. Nothing is reset on the way out —
        this is a view switch, not a cancel — so an admin who changes their mind
        twice finds everything they typed still in place.
      */
      var createBackButton = document.getElementById('cohort-create-back-button');
      if (createBackButton && !createBackButton.dataset.bound) {
        createBackButton.dataset.bound = '1';
        createBackButton.addEventListener('click', function() {
          setManagePanelsVisible('manage');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    }

    function hydrateCohortRecordsFromLocalMeta() {
      MY_COHORTS = dedupeCohortsByCode(MY_COHORTS).map(function(cohort) {
        return enrichCohortRecord(cohort);
      });
    }

    function init() {
      bindInfoTips(document.querySelector('.cohort-admin-shell'));
      bindUnloadGuard();

      initialAccountEmail = String(getAccountEmailSync() || CUSTOMER.email || '').trim().toLowerCase();
      hydrateCohortRecordsFromLocalMeta();

      if (CUSTOMER.name) {
        document.getElementById('admin_name').value = CUSTOMER.name;
      }

      if (CUSTOMER.email) {
        document.getElementById('admin_email').value = CUSTOMER.email;
      }

      setDeadlineMin();
      hydrateSchoolFromContext();
      updateEmailPreview();
      bindEvents();

      onDocumentOnce('visibility-sync', 'visibilitychange', function() {
        if (document.hidden || !editingCohortCode || isEmailManagementDirty()) return;
        backgroundSyncEmailPanel(editingCohortCode);
      });

      goToStep(1);
      syncAdminEmailAccountNotice();

      resolveAccountEmail().then(function(email) {
        if (email) {
          initialAccountEmail = initialAccountEmail || String(email).trim().toLowerCase();
        }
        syncAdminEmailAccountNotice();
        renderManageCohorts();
        restoreEmailEditState();
        openEditorFromUrl();
        /*
          Last, so the cohort records are already hydrated and the finalize poll
          has real data to check against.
        */
        restoreActionLockUi();
        startDashboardIdleSync();
      });

      if (!SCHOOLS.length) {
        setMessage('No schools are available yet. Please make sure your schools are set up and published before creating a cohort.');
        return;
      }

      if (!getSelectedSchool()) {
        setMessage('School was not detected. Open this page with a school parameter, for example: ?school=mcc');
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    /*
      2026-10-10 (owner) - theme editor only. Changing a setting redraws the
      section, and this file is not run again by the browser, so the new copy
      sat there without its script and the open cohort was lost. This listener
      survives the redraw and starts the new copy; restoreEmailEditState then
      reopens the cohort that was open (kept in sessionStorage). The same
      approach as sections/catalog-flipbook.liquid and our-team.liquid.
    */
    document.addEventListener('shopify:section:load', function(event) {
      var sectionId = event.detail && event.detail.sectionId;
      var root = sectionId ? document.getElementById('shopify-section-' + sectionId) : null;
      if (root && root.querySelector('.cohort-admin-shell')) init();
    });
  })();
